var ec = Object.defineProperty, ic = Object.defineProperties;
var nc = Object.getOwnPropertyDescriptors;
var Fr = Object.getOwnPropertySymbols;
var sc = Object.prototype.hasOwnProperty, rc = Object.prototype.propertyIsEnumerable;
var as = (i, t, e) => t in i ? ec(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e, at = (i, t) => {
  for (var e in t || (t = {}))
    sc.call(t, e) && as(i, e, t[e]);
  if (Fr)
    for (var e of Fr(t))
      rc.call(t, e) && as(i, e, t[e]);
  return i;
}, ot = (i, t) => ic(i, nc(t));
var P = (i, t, e) => (as(i, typeof t != "symbol" ? t + "" : t, e), e);
var q = (i, t, e) => new Promise((n, s) => {
  var r = (l) => {
    try {
      o(e.next(l));
    } catch (c) {
      s(c);
    }
  }, a = (l) => {
    try {
      o(e.throw(l));
    } catch (c) {
      s(c);
    }
  }, o = (l) => l.done ? n(l.value) : Promise.resolve(l.value).then(r, a);
  o((e = e.apply(i, t)).next());
});
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const kn = window, Ks = kn.ShadowRoot && (kn.ShadyCSS === void 0 || kn.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, Zs = Symbol(), Lr = /* @__PURE__ */ new WeakMap();
let Po = class {
  constructor(t, e, n) {
    if (this._$cssResult$ = !0, n !== Zs)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (Ks && t === void 0) {
      const n = e !== void 0 && e.length === 1;
      n && (t = Lr.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), n && Lr.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const Bt = (i) => new Po(typeof i == "string" ? i : i + "", void 0, Zs), _t = (i, ...t) => {
  const e = i.length === 1 ? i[0] : t.reduce((n, s, r) => n + ((a) => {
    if (a._$cssResult$ === !0)
      return a.cssText;
    if (typeof a == "number")
      return a;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + a + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s) + i[r + 1], i[0]);
  return new Po(e, i, Zs);
}, ac = (i, t) => {
  Ks ? i.adoptedStyleSheets = t.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet) : t.forEach((e) => {
    const n = document.createElement("style"), s = kn.litNonce;
    s !== void 0 && n.setAttribute("nonce", s), n.textContent = e.cssText, i.appendChild(n);
  });
}, Nr = Ks ? (i) => i : (i) => i instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const n of t.cssRules)
    e += n.cssText;
  return Bt(e);
})(i) : i;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var os;
const In = window, zr = In.trustedTypes, oc = zr ? zr.emptyScript : "", Hr = In.reactiveElementPolyfillSupport, Ss = { toAttribute(i, t) {
  switch (t) {
    case Boolean:
      i = i ? oc : null;
      break;
    case Object:
    case Array:
      i = i == null ? i : JSON.stringify(i);
  }
  return i;
}, fromAttribute(i, t) {
  let e = i;
  switch (t) {
    case Boolean:
      e = i !== null;
      break;
    case Number:
      e = i === null ? null : Number(i);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(i);
      } catch (n) {
        e = null;
      }
  }
  return e;
} }, Mo = (i, t) => t !== i && (t == t || i == i), ls = { attribute: !0, type: String, converter: Ss, reflect: !1, hasChanged: Mo }, Ts = "finalized";
let Ke = class extends HTMLElement {
  constructor() {
    super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
  }
  static addInitializer(t) {
    var e;
    this.finalize(), ((e = this.h) !== null && e !== void 0 ? e : this.h = []).push(t);
  }
  static get observedAttributes() {
    this.finalize();
    const t = [];
    return this.elementProperties.forEach((e, n) => {
      const s = this._$Ep(n, e);
      s !== void 0 && (this._$Ev.set(s, n), t.push(s));
    }), t;
  }
  static createProperty(t, e = ls) {
    if (e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(t, e), !e.noAccessor && !this.prototype.hasOwnProperty(t)) {
      const n = typeof t == "symbol" ? Symbol() : "__" + t, s = this.getPropertyDescriptor(t, n, e);
      s !== void 0 && Object.defineProperty(this.prototype, t, s);
    }
  }
  static getPropertyDescriptor(t, e, n) {
    return { get() {
      return this[e];
    }, set(s) {
      const r = this[t];
      this[e] = s, this.requestUpdate(t, r, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) || ls;
  }
  static finalize() {
    if (this.hasOwnProperty(Ts))
      return !1;
    this[Ts] = !0;
    const t = Object.getPrototypeOf(this);
    if (t.finalize(), t.h !== void 0 && (this.h = [...t.h]), this.elementProperties = new Map(t.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const e = this.properties, n = [...Object.getOwnPropertyNames(e), ...Object.getOwnPropertySymbols(e)];
      for (const s of n)
        this.createProperty(s, e[s]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), !0;
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const n = new Set(t.flat(1 / 0).reverse());
      for (const s of n)
        e.unshift(Nr(s));
    } else
      t !== void 0 && e.push(Nr(t));
    return e;
  }
  static _$Ep(t, e) {
    const n = e.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  _$Eu() {
    var t;
    this._$E_ = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), (t = this.constructor.h) === null || t === void 0 || t.forEach((e) => e(this));
  }
  addController(t) {
    var e, n;
    ((e = this._$ES) !== null && e !== void 0 ? e : this._$ES = []).push(t), this.renderRoot !== void 0 && this.isConnected && ((n = t.hostConnected) === null || n === void 0 || n.call(t));
  }
  removeController(t) {
    var e;
    (e = this._$ES) === null || e === void 0 || e.splice(this._$ES.indexOf(t) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((t, e) => {
      this.hasOwnProperty(e) && (this._$Ei.set(e, this[e]), delete this[e]);
    });
  }
  createRenderRoot() {
    var t;
    const e = (t = this.shadowRoot) !== null && t !== void 0 ? t : this.attachShadow(this.constructor.shadowRootOptions);
    return ac(e, this.constructor.elementStyles), e;
  }
  connectedCallback() {
    var t;
    this.renderRoot === void 0 && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$ES) === null || t === void 0 || t.forEach((e) => {
      var n;
      return (n = e.hostConnected) === null || n === void 0 ? void 0 : n.call(e);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$ES) === null || t === void 0 || t.forEach((e) => {
      var n;
      return (n = e.hostDisconnected) === null || n === void 0 ? void 0 : n.call(e);
    });
  }
  attributeChangedCallback(t, e, n) {
    this._$AK(t, n);
  }
  _$EO(t, e, n = ls) {
    var s;
    const r = this.constructor._$Ep(t, n);
    if (r !== void 0 && n.reflect === !0) {
      const a = (((s = n.converter) === null || s === void 0 ? void 0 : s.toAttribute) !== void 0 ? n.converter : Ss).toAttribute(e, n.type);
      this._$El = t, a == null ? this.removeAttribute(r) : this.setAttribute(r, a), this._$El = null;
    }
  }
  _$AK(t, e) {
    var n;
    const s = this.constructor, r = s._$Ev.get(t);
    if (r !== void 0 && this._$El !== r) {
      const a = s.getPropertyOptions(r), o = typeof a.converter == "function" ? { fromAttribute: a.converter } : ((n = a.converter) === null || n === void 0 ? void 0 : n.fromAttribute) !== void 0 ? a.converter : Ss;
      this._$El = r, this[r] = o.fromAttribute(e, a.type), this._$El = null;
    }
  }
  requestUpdate(t, e, n) {
    let s = !0;
    t !== void 0 && (((n = n || this.constructor.getPropertyOptions(t)).hasChanged || Mo)(this[t], e) ? (this._$AL.has(t) || this._$AL.set(t, e), n.reflect === !0 && this._$El !== t && (this._$EC === void 0 && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(t, n))) : s = !1), !this.isUpdatePending && s && (this._$E_ = this._$Ej());
  }
  _$Ej() {
    return q(this, null, function* () {
      this.isUpdatePending = !0;
      try {
        yield this._$E_;
      } catch (e) {
        Promise.reject(e);
      }
      const t = this.scheduleUpdate();
      return t != null && (yield t), !this.isUpdatePending;
    });
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((s, r) => this[r] = s), this._$Ei = void 0);
    let e = !1;
    const n = this._$AL;
    try {
      e = this.shouldUpdate(n), e ? (this.willUpdate(n), (t = this._$ES) === null || t === void 0 || t.forEach((s) => {
        var r;
        return (r = s.hostUpdate) === null || r === void 0 ? void 0 : r.call(s);
      }), this.update(n)) : this._$Ek();
    } catch (s) {
      throw e = !1, this._$Ek(), s;
    }
    e && this._$AE(n);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var e;
    (e = this._$ES) === null || e === void 0 || e.forEach((n) => {
      var s;
      return (s = n.hostUpdated) === null || s === void 0 ? void 0 : s.call(n);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$Ek() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$EC !== void 0 && (this._$EC.forEach((e, n) => this._$EO(n, this[n], e)), this._$EC = void 0), this._$Ek();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
Ke[Ts] = !0, Ke.elementProperties = /* @__PURE__ */ new Map(), Ke.elementStyles = [], Ke.shadowRootOptions = { mode: "open" }, Hr == null || Hr({ ReactiveElement: Ke }), ((os = In.reactiveElementVersions) !== null && os !== void 0 ? os : In.reactiveElementVersions = []).push("1.6.3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var cs;
const En = window, Je = En.trustedTypes, Br = Je ? Je.createPolicy("lit-html", { createHTML: (i) => i }) : void 0, Os = "$lit$", ge = `lit$${(Math.random() + "").slice(9)}$`, So = "?" + ge, lc = `<${So}>`, Ne = document, Si = () => Ne.createComment(""), Ti = (i) => i === null || typeof i != "object" && typeof i != "function", To = Array.isArray, cc = (i) => To(i) || typeof (i == null ? void 0 : i[Symbol.iterator]) == "function", ds = `[ 	
\f\r]`, oi = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Wr = /-->/g, Ur = />/g, $e = RegExp(`>|${ds}(?:([^\\s"'>=/]+)(${ds}*=${ds}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), jr = /'/g, Vr = /"/g, Oo = /^(?:script|style|textarea|title)$/i, dc = (i) => (t, ...e) => ({ _$litType$: i, strings: t, values: e }), y = dc(1), ti = Symbol.for("lit-noChange"), yt = Symbol.for("lit-nothing"), Yr = /* @__PURE__ */ new WeakMap(), Ee = Ne.createTreeWalker(Ne, 129, null, !1);
function Ao(i, t) {
  if (!Array.isArray(i) || !i.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return Br !== void 0 ? Br.createHTML(t) : t;
}
const hc = (i, t) => {
  const e = i.length - 1, n = [];
  let s, r = t === 2 ? "<svg>" : "", a = oi;
  for (let o = 0; o < e; o++) {
    const l = i[o];
    let c, d, h = -1, u = 0;
    for (; u < l.length && (a.lastIndex = u, d = a.exec(l), d !== null); )
      u = a.lastIndex, a === oi ? d[1] === "!--" ? a = Wr : d[1] !== void 0 ? a = Ur : d[2] !== void 0 ? (Oo.test(d[2]) && (s = RegExp("</" + d[2], "g")), a = $e) : d[3] !== void 0 && (a = $e) : a === $e ? d[0] === ">" ? (a = s != null ? s : oi, h = -1) : d[1] === void 0 ? h = -2 : (h = a.lastIndex - d[2].length, c = d[1], a = d[3] === void 0 ? $e : d[3] === '"' ? Vr : jr) : a === Vr || a === jr ? a = $e : a === Wr || a === Ur ? a = oi : (a = $e, s = void 0);
    const f = a === $e && i[o + 1].startsWith("/>") ? " " : "";
    r += a === oi ? l + lc : h >= 0 ? (n.push(c), l.slice(0, h) + Os + l.slice(h) + ge + f) : l + ge + (h === -2 ? (n.push(void 0), o) : f);
  }
  return [Ao(i, r + (i[e] || "<?>") + (t === 2 ? "</svg>" : "")), n];
};
class Oi {
  constructor({ strings: t, _$litType$: e }, n) {
    let s;
    this.parts = [];
    let r = 0, a = 0;
    const o = t.length - 1, l = this.parts, [c, d] = hc(t, e);
    if (this.el = Oi.createElement(c, n), Ee.currentNode = this.el.content, e === 2) {
      const h = this.el.content, u = h.firstChild;
      u.remove(), h.append(...u.childNodes);
    }
    for (; (s = Ee.nextNode()) !== null && l.length < o; ) {
      if (s.nodeType === 1) {
        if (s.hasAttributes()) {
          const h = [];
          for (const u of s.getAttributeNames())
            if (u.endsWith(Os) || u.startsWith(ge)) {
              const f = d[a++];
              if (h.push(u), f !== void 0) {
                const g = s.getAttribute(f.toLowerCase() + Os).split(ge), m = /([.?@])?(.*)/.exec(f);
                l.push({ type: 1, index: r, name: m[2], strings: g, ctor: m[1] === "." ? fc : m[1] === "?" ? gc : m[1] === "@" ? mc : Gn });
              } else
                l.push({ type: 6, index: r });
            }
          for (const u of h)
            s.removeAttribute(u);
        }
        if (Oo.test(s.tagName)) {
          const h = s.textContent.split(ge), u = h.length - 1;
          if (u > 0) {
            s.textContent = Je ? Je.emptyScript : "";
            for (let f = 0; f < u; f++)
              s.append(h[f], Si()), Ee.nextNode(), l.push({ type: 2, index: ++r });
            s.append(h[u], Si());
          }
        }
      } else if (s.nodeType === 8)
        if (s.data === So)
          l.push({ type: 2, index: r });
        else {
          let h = -1;
          for (; (h = s.data.indexOf(ge, h + 1)) !== -1; )
            l.push({ type: 7, index: r }), h += ge.length - 1;
        }
      r++;
    }
  }
  static createElement(t, e) {
    const n = Ne.createElement("template");
    return n.innerHTML = t, n;
  }
}
function ei(i, t, e = i, n) {
  var s, r, a, o;
  if (t === ti)
    return t;
  let l = n !== void 0 ? (s = e._$Co) === null || s === void 0 ? void 0 : s[n] : e._$Cl;
  const c = Ti(t) ? void 0 : t._$litDirective$;
  return (l == null ? void 0 : l.constructor) !== c && ((r = l == null ? void 0 : l._$AO) === null || r === void 0 || r.call(l, !1), c === void 0 ? l = void 0 : (l = new c(i), l._$AT(i, e, n)), n !== void 0 ? ((a = (o = e)._$Co) !== null && a !== void 0 ? a : o._$Co = [])[n] = l : e._$Cl = l), l !== void 0 && (t = ei(i, l._$AS(i, t.values), l, n)), t;
}
class uc {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    var e;
    const { el: { content: n }, parts: s } = this._$AD, r = ((e = t == null ? void 0 : t.creationScope) !== null && e !== void 0 ? e : Ne).importNode(n, !0);
    Ee.currentNode = r;
    let a = Ee.nextNode(), o = 0, l = 0, c = s[0];
    for (; c !== void 0; ) {
      if (o === c.index) {
        let d;
        c.type === 2 ? d = new Qi(a, a.nextSibling, this, t) : c.type === 1 ? d = new c.ctor(a, c.name, c.strings, this, t) : c.type === 6 && (d = new vc(a, this, t)), this._$AV.push(d), c = s[++l];
      }
      o !== (c == null ? void 0 : c.index) && (a = Ee.nextNode(), o++);
    }
    return Ee.currentNode = Ne, r;
  }
  v(t) {
    let e = 0;
    for (const n of this._$AV)
      n !== void 0 && (n.strings !== void 0 ? (n._$AI(t, n, e), e += n.strings.length - 2) : n._$AI(t[e])), e++;
  }
}
class Qi {
  constructor(t, e, n, s) {
    var r;
    this.type = 2, this._$AH = yt, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = n, this.options = s, this._$Cp = (r = s == null ? void 0 : s.isConnected) === null || r === void 0 || r;
  }
  get _$AU() {
    var t, e;
    return (e = (t = this._$AM) === null || t === void 0 ? void 0 : t._$AU) !== null && e !== void 0 ? e : this._$Cp;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = ei(this, t, e), Ti(t) ? t === yt || t == null || t === "" ? (this._$AH !== yt && this._$AR(), this._$AH = yt) : t !== this._$AH && t !== ti && this._(t) : t._$litType$ !== void 0 ? this.g(t) : t.nodeType !== void 0 ? this.$(t) : cc(t) ? this.T(t) : this._(t);
  }
  k(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  $(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
  }
  _(t) {
    this._$AH !== yt && Ti(this._$AH) ? this._$AA.nextSibling.data = t : this.$(Ne.createTextNode(t)), this._$AH = t;
  }
  g(t) {
    var e;
    const { values: n, _$litType$: s } = t, r = typeof s == "number" ? this._$AC(t) : (s.el === void 0 && (s.el = Oi.createElement(Ao(s.h, s.h[0]), this.options)), s);
    if (((e = this._$AH) === null || e === void 0 ? void 0 : e._$AD) === r)
      this._$AH.v(n);
    else {
      const a = new uc(r, this), o = a.u(this.options);
      a.v(n), this.$(o), this._$AH = a;
    }
  }
  _$AC(t) {
    let e = Yr.get(t.strings);
    return e === void 0 && Yr.set(t.strings, e = new Oi(t)), e;
  }
  T(t) {
    To(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let n, s = 0;
    for (const r of t)
      s === e.length ? e.push(n = new Qi(this.k(Si()), this.k(Si()), this, this.options)) : n = e[s], n._$AI(r), s++;
    s < e.length && (this._$AR(n && n._$AB.nextSibling, s), e.length = s);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var n;
    for ((n = this._$AP) === null || n === void 0 || n.call(this, !1, !0, e); t && t !== this._$AB; ) {
      const s = t.nextSibling;
      t.remove(), t = s;
    }
  }
  setConnected(t) {
    var e;
    this._$AM === void 0 && (this._$Cp = t, (e = this._$AP) === null || e === void 0 || e.call(this, t));
  }
}
class Gn {
  constructor(t, e, n, s, r) {
    this.type = 1, this._$AH = yt, this._$AN = void 0, this.element = t, this.name = e, this._$AM = s, this.options = r, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = yt;
  }
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t, e = this, n, s) {
    const r = this.strings;
    let a = !1;
    if (r === void 0)
      t = ei(this, t, e, 0), a = !Ti(t) || t !== this._$AH && t !== ti, a && (this._$AH = t);
    else {
      const o = t;
      let l, c;
      for (t = r[0], l = 0; l < r.length - 1; l++)
        c = ei(this, o[n + l], e, l), c === ti && (c = this._$AH[l]), a || (a = !Ti(c) || c !== this._$AH[l]), c === yt ? t = yt : t !== yt && (t += (c != null ? c : "") + r[l + 1]), this._$AH[l] = c;
    }
    a && !s && this.j(t);
  }
  j(t) {
    t === yt ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t != null ? t : "");
  }
}
class fc extends Gn {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === yt ? void 0 : t;
  }
}
const pc = Je ? Je.emptyScript : "";
class gc extends Gn {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    t && t !== yt ? this.element.setAttribute(this.name, pc) : this.element.removeAttribute(this.name);
  }
}
class mc extends Gn {
  constructor(t, e, n, s, r) {
    super(t, e, n, s, r), this.type = 5;
  }
  _$AI(t, e = this) {
    var n;
    if ((t = (n = ei(this, t, e, 0)) !== null && n !== void 0 ? n : yt) === ti)
      return;
    const s = this._$AH, r = t === yt && s !== yt || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, a = t !== yt && (s === yt || r);
    r && this.element.removeEventListener(this.name, this, s), a && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e, n;
    typeof this._$AH == "function" ? this._$AH.call((n = (e = this.options) === null || e === void 0 ? void 0 : e.host) !== null && n !== void 0 ? n : this.element, t) : this._$AH.handleEvent(t);
  }
}
class vc {
  constructor(t, e, n) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    ei(this, t);
  }
}
const qr = En.litHtmlPolyfillSupport;
qr == null || qr(Oi, Qi), ((cs = En.litHtmlVersions) !== null && cs !== void 0 ? cs : En.litHtmlVersions = []).push("2.8.0");
const bc = (i, t, e) => {
  var n, s;
  const r = (n = e == null ? void 0 : e.renderBefore) !== null && n !== void 0 ? n : t;
  let a = r._$litPart$;
  if (a === void 0) {
    const o = (s = e == null ? void 0 : e.renderBefore) !== null && s !== void 0 ? s : null;
    r._$litPart$ = a = new Qi(t.insertBefore(Si(), o), o, void 0, e != null ? e : {});
  }
  return a._$AI(i), a;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var hs, us;
class _i extends Ke {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var t, e;
    const n = super.createRenderRoot();
    return (t = (e = this.renderOptions).renderBefore) !== null && t !== void 0 || (e.renderBefore = n.firstChild), n;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = bc(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this._$Do) === null || t === void 0 || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this._$Do) === null || t === void 0 || t.setConnected(!1);
  }
  render() {
    return ti;
  }
}
_i.finalized = !0, _i._$litElement$ = !0, (hs = globalThis.litElementHydrateSupport) === null || hs === void 0 || hs.call(globalThis, { LitElement: _i });
const Xr = globalThis.litElementPolyfillSupport;
Xr == null || Xr({ LitElement: _i });
((us = globalThis.litElementVersions) !== null && us !== void 0 ? us : globalThis.litElementVersions = []).push("3.3.3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const kt = (i) => (t) => typeof t == "function" ? ((e, n) => (customElements.define(e, n), n))(i, t) : ((e, n) => {
  const { kind: s, elements: r } = n;
  return { kind: s, elements: r, finisher(a) {
    customElements.define(e, a);
  } };
})(i, t);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const yc = (i, t) => t.kind === "method" && t.descriptor && !("value" in t.descriptor) ? ot(at({}, t), { finisher(e) {
  e.createProperty(t.key, i);
} }) : { kind: "field", key: Symbol(), placement: "own", descriptor: {}, originalKey: t.key, initializer() {
  typeof t.initializer == "function" && (this[t.key] = t.initializer.call(this));
}, finisher(e) {
  e.createProperty(t.key, i);
} }, xc = (i, t, e) => {
  t.constructor.createProperty(e, i);
};
function dt(i) {
  return (t, e) => e !== void 0 ? xc(i, t, e) : yc(i, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function R(i) {
  return dt(ot(at({}, i), { state: !0 }));
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const wc = ({ finisher: i, descriptor: t }) => (e, n) => {
  var s;
  if (n === void 0) {
    const r = (s = e.originalKey) !== null && s !== void 0 ? s : e.key, a = t != null ? { kind: "method", placement: "prototype", key: r, descriptor: t(e.key) } : ot(at({}, e), { key: r });
    return i != null && (a.finisher = function(o) {
      i(o, r);
    }), a;
  }
  {
    const r = e.constructor;
    t !== void 0 && Object.defineProperty(e, n, t(n)), i == null || i(r, n);
  }
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _c(i, t) {
  return wc({ descriptor: (e) => {
    const n = { get() {
      var s, r;
      return (r = (s = this.renderRoot) === null || s === void 0 ? void 0 : s.querySelector(i)) !== null && r !== void 0 ? r : null;
    }, enumerable: !0, configurable: !0 };
    if (t) {
      const s = typeof e == "symbol" ? Symbol() : "__" + e;
      n.get = function() {
        var r, a;
        return this[s] === void 0 && (this[s] = (a = (r = this.renderRoot) === null || r === void 0 ? void 0 : r.querySelector(i)) !== null && a !== void 0 ? a : null), this[s];
      };
    }
    return n;
  } });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var fs;
((fs = window.HTMLSlotElement) === null || fs === void 0 ? void 0 : fs.prototype.assignedElements) != null;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const kc = (i, ...t) => ({
  strTag: !0,
  strings: i,
  values: t
}), O = kc, Dc = (i) => typeof i != "string" && "strTag" in i, Cc = (i, t, e) => {
  let n = i[0];
  for (let s = 1; s < i.length; s++)
    n += t[e ? e[s - 1] : s - 1], n += i[s];
  return n;
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const $c = (i) => Dc(i) ? Cc(i.strings, i.values) : i;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Qr = "lit-localize-status";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class Pc {
  constructor(t) {
    this.__litLocalizeEventHandler = (e) => {
      e.detail.status === "ready" && this.host.requestUpdate();
    }, this.host = t;
  }
  hostConnected() {
    window.addEventListener(Qr, this.__litLocalizeEventHandler);
  }
  hostDisconnected() {
    window.removeEventListener(Qr, this.__litLocalizeEventHandler);
  }
}
const Mc = (i) => i.addController(new Pc(i)), Io = Mc;
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Sc = () => (i) => typeof i == "function" ? Oc(i) : Tc(i), Wt = Sc, Tc = ({ kind: i, elements: t }) => ({
  kind: i,
  elements: t,
  finisher(e) {
    e.addInitializer(Io);
  }
}), Oc = (i) => (i.addInitializer(Io), i);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class Ac {
  constructor() {
    this.settled = !1, this.promise = new Promise((t, e) => {
      this._resolve = t, this._reject = e;
    });
  }
  resolve(t) {
    this.settled = !0, this._resolve(t);
  }
  reject(t) {
    this.settled = !0, this._reject(t);
  }
}
/**
 * @license
 * Copyright 2014 Travis Webb
 * SPDX-License-Identifier: MIT
 */
for (let i = 0; i < 256; i++)
  (i >> 4 & 15).toString(16) + (i & 15).toString(16);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let Ic = new Ac();
Ic.resolve();
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let p = $c;
const Tt = _t`
  :host {
    display: block;
    font-family: var(--stock-font-family, Arial, sans-serif);
    padding: var(--stock-padding, 24px);
    border-radius: var(--stock-border-radius, 16px);
    box-shadow: var(--stock-box-shadow, 0 10px 25px rgba(0, 0, 0, 0.08));
    max-width: var(--stock-max-width, 100%);
    margin: 0 auto;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    background-color: var(--stock-background-color, #ffffff);
    color: var(--stock-text-color, #2c3e50);
    border: 1px solid var(--stock-border-color, rgba(230, 230, 230, 0.8));
    overflow: hidden;
  }



  /* Títulos y encabezados */
  h2, .section-title {
    font-size: var(--stock-title-font-size, 1.5rem);
    font-weight: var(--stock-title-weight, 700);
    margin-top: 0;
    margin-bottom: 1rem;
    color: var(--stock-title-color, #1e293b);
  }

  .section-title {
    font-size: var(--stock-section-title-font-size, 1.1rem);
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--stock-border-color, #e0e0e0);
  }

  /* Estados de carga y error */
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
    font-size: var(--stock-text-size, 15px);
    color: var(--stock-muted-color, #64748b);
    font-weight: 500;
    position: relative;
    text-align: center;
  }

  .loading::before {
    content: '';
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 12px;
    border: 3px solid var(--stock-accent-color, #3b82f6);
    border-radius: 50%;
    border-top-color: transparent;
    animation: spinner 0.8s linear infinite;
  }

  @keyframes spinner {
    to { transform: rotate(360deg); }
  }

  .error {
    color: var(--stock-error-color, #ef4444);
    padding: 16px;
    border: 1px solid var(--stock-error-border-color, rgba(239, 68, 68, 0.2));
    border-radius: 12px;
    font-size: var(--stock-small-text-size, 14px);
    font-weight: 500;
    background-color: var(--stock-error-background, rgba(239, 68, 68, 0.05));
    text-align: center;
    margin: 12px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .error::before {
    content: '⚠️';
    margin-right: 8px;
    font-size: 18px;
  }

  /* Contenedores de información */
  .info-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }

  .info-header {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--stock-divider-color, rgba(226, 232, 240, 0.8));
  }

  /* Imágenes de acciones */
  .stock-image {
    width: 64px;
    height: 64px;
    object-fit: contain;
    border-radius: 12px;
    background-color: var(--stock-image-bg, #f8fafc);
    padding: 8px;
    margin-right: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
  }

  /* Títulos de acciones */
  .stock-name {
    margin: 0;
    font-size: var(--stock-title-size, 22px);
    font-weight: var(--stock-title-weight, 700);
    color: var(--stock-title-color, #1e293b);
    letter-spacing: -0.01em;
  }

  .stock-symbol {
    color: var(--stock-muted-color, #64748b);
    margin: 6px 0 0;
    font-size: var(--stock-small-text-size, 15px);
    font-weight: 500;
    padding: 4px 10px;
    background-color: var(--stock-symbol-bg, rgba(226, 232, 240, 0.5));
    border-radius: 6px;
    display: inline-block;
  }

  /* Elementos detallados */
  .detail-item, .ratio-item {
    padding: 18px;
    background-color: var(--stock-detail-background, #f8fafc);
    border-radius: 12px;
    transition: all 0.3s ease;
    border: 1px solid var(--stock-detail-border, rgba(226, 232, 240, 0.6));
  }

  .detail-label, .ratio-label {
    font-weight: var(--stock-label-weight, 600);
    color: var(--stock-label-color, #475569);
    margin-bottom: 10px;
    font-size: var(--stock-label-size, 14px);
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .detail-value, .ratio-value {
    font-size: var(--stock-value-size, 16px);
    line-height: 1.6;
    color: var(--stock-value-color, #334155);
    font-weight: var(--stock-value-weight, 600);
  }

  /* Estilos específicos de ratios */
  .ratios-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 0.75rem;
  }

  .ratio-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
  }

  /* Colores de valores */
  .negative {
    color: var(--stock-negative-color, #d32f2f);
  }

  .positive {
    color: var(--stock-positive-color, #388e3c);
  }

  .high-debt, .warning {
    color: var(--stock-warning-color, #f57c00);
  }

  /* Enlaces */
  .website-link {
    color: var(--stock-link-color, #0d6efd);
    text-decoration: none;
  }

  .website-link:hover {
    text-decoration: underline;
  }

  /* Responsive */
  @media (max-width: 600px) {
    :host {
      padding: 16px;
    }

    .info-header {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .stock-image {
      margin: 0 auto 12px;
    }

    .ratios-grid {
      grid-template-columns: 1fr;
    }
  }
`;
var Ec = Object.defineProperty, Rc = Object.getOwnPropertyDescriptor, Gi = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Rc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Ec(t, e, s), s;
};
class ct {
  // static readonly API_BASE_URL = 'http://localhost:8000';  // Para desarrollo local
}
ct.API_BASE_URL = "https://portfolios-backend-service-65831155511.europe-west1.run.app";
class ce extends _i {
  constructor() {
    super(...arguments), this.locale = "", this.showHeader = !0, this.loading = !1, this.error = null, this.data = null;
  }
  /**
   * Se llama cuando el componente es añadido al DOM
   */
  connectedCallback() {
    super.connectedCallback(), this.shouldFetchData() && this.fetchData();
  }
  /**
   * Se llama cuando cambian las propiedades del componente
   */
  updated(t) {
    this.hasKeyPropertyChanged(t) && this.shouldFetchData() && this.fetchData(), (t.has("locale") || t.has("showHeader")) && this.requestUpdate();
  }
  /**
   * Formatea un valor decimal
   */
  formatDecimal(t, e = 2) {
    return t == null ? "-" : new Intl.NumberFormat(this.locale || "es", {
      minimumFractionDigits: e,
      maximumFractionDigits: e
    }).format(t);
  }
  /**
   * Formatea un valor como porcentaje
   */
  formatPercentage(t) {
    return t == null ? "-" : new Intl.NumberFormat(this.locale || "es", {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(t);
  }
  /**
   * Formatea un valor como moneda
   */
  formatCurrency(t, e = 2, n = "EUR") {
    return t == null ? "-" : new Intl.NumberFormat(this.locale || "es", {
      style: "currency",
      currency: n,
      minimumFractionDigits: e,
      maximumFractionDigits: e
    }).format(t);
  }
  /**
   * Formatea una fecha
   */
  formatDate(t) {
    if (!t)
      return "-";
    try {
      return new Date(t).toLocaleDateString(this.locale || "es");
    } catch (e) {
      return t;
    }
  }
  /**
   * Determina la clase CSS para un valor (positivo/negativo)
   */
  getValueClass(t) {
    return t == null ? "" : t < 0 ? "negative" : t > 0 ? "positive" : "";
  }
  /**
   * Renderiza el componente cuando está cargando
   */
  renderLoading() {
    return y`<div class="loading">${p("Cargando datos...")}</div>`;
  }
  /**
   * Renderiza el componente cuando hay un error
   */
  renderError() {
    return y`<div class="error">${this.error}</div>`;
  }
  /**
   * Renderiza el componente cuando no hay datos
   */
  renderNoData() {
    return y`<div>${this.getNoDataMessage()}</div>`;
  }
  /**
   * Renderiza el componente
   */
  render() {
    return this.loading ? this.renderLoading() : this.error ? this.renderError() : this.data ? this.renderContent() : this.renderNoData();
  }
}
ce.styles = Tt;
Gi([
  dt({ type: String })
], ce.prototype, "locale", 2);
Gi([
  dt({
    type: Boolean,
    converter: {
      fromAttribute: (i) => i === "false" ? !1 : i !== null
    },
    reflect: !0
  })
], ce.prototype, "showHeader", 2);
Gi([
  R()
], ce.prototype, "loading", 2);
Gi([
  R()
], ce.prototype, "error", 2);
Gi([
  R()
], ce.prototype, "data", 2);
var Fc = Object.defineProperty, Lc = Object.getOwnPropertyDescriptor, Js = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Lc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Fc(t, e, s), s;
};
class $t extends ce {
  constructor() {
    super(...arguments), this.symbol = "", this.locale = "", this.showHeader = !0;
  }
  /**
   * Datos de ratios financieros (alias para mantener compatibilidad)
   */
  get ratioData() {
    return this.data;
  }
  set ratioData(t) {
    this.data = t;
  }
  /**
   * Verifica si se debe obtener los datos
   */
  shouldFetchData() {
    return !!this.symbol;
  }
  /**
   * Verifica si una propiedad clave ha cambiado
   */
  hasKeyPropertyChanged(t) {
    return t.has("symbol") && !!this.symbol;
  }
  /**
   * Obtiene los datos de la API
   */
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol) {
        this.loading = !0, this.error = null;
        try {
          const t = yield fetch(`${ct.API_BASE_URL}/asset-data/financial-ratios-ttm?symbol=${encodeURIComponent(this.symbol)}`);
          if (!t.ok)
            throw new Error(`${p("Error", {
              desc: "Error message prefix when API request fails"
            })}: ${t.statusText}`);
          const e = yield t.json();
          this.processData(e);
        } catch (t) {
          this.error = t instanceof Error ? t.message : String(t), console.error(`Error fetching financial ratios: ${t}`);
        } finally {
          this.loading = !1;
        }
      }
    });
  }
  /**
   * Formatea un valor decimal
   */
  formatDecimal(t, e = 2) {
    return t == null ? "-" : new Intl.NumberFormat(this.locale || "es", {
      minimumFractionDigits: e,
      maximumFractionDigits: e
    }).format(t);
  }
  /**
   * Formatea un valor como porcentaje
   */
  formatPercentage(t) {
    return t == null ? "-" : new Intl.NumberFormat(this.locale || "es", {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(t);
  }
  /**
   * Formatea un valor como moneda
   */
  formatCurrency(t, e = 2, n = "USD") {
    return super.formatCurrency(t, e, n);
  }
  /**
   * Determina la clase CSS para un valor (positivo/negativo)
   */
  getValueClass(t) {
    return t == null ? "" : t < 0 ? "negative" : t > 0 ? "positive" : "";
  }
  /**
   * Renderiza el componente cuando está cargando
   */
  renderLoading() {
    return y`<div class="loading">${p("Cargando datos...")}</div>`;
  }
  /**
   * Renderiza el componente cuando hay un error
   */
  renderError() {
    return y`<div class="error">${this.error}</div>`;
  }
  /**
   * Renderiza el componente cuando no hay datos
   */
  renderNoData() {
    return y`<div>${p("No hay datos disponibles. Por favor, proporcione un símbolo de acción válido.")}</div>`;
  }
  /**
   * Renderiza el encabezado con información básica del stock
   * Este método es compartido por todos los componentes
   */
  renderHeader() {
    if (!this.showHeader)
      return y``;
    if (!this.ratioData)
      return this.symbol ? y`
        <div class="info-header">
          <div>
            <h3 class="stock-name">${this.symbol}</h3>
            <p class="stock-symbol">${this.symbol}</p>
          </div>
        </div>
      ` : y``;
    const { symbol: t } = this.ratioData;
    let e, n;
    return "name" in this.ratioData && (e = this.ratioData.name), "image" in this.ratioData && (n = this.ratioData.image), y`
      <div class="info-header">
        ${n ? y`<img class="stock-image" src="${n}" alt="${p(O`${e || t} logo`)}" onerror="this.style.display='none'" />` : ""}
        <div>
          <h3 class="stock-name">${e || t}</h3>
          <p class="stock-symbol">${t}</p>
        </div>
      </div>
    `;
  }
  /**
   * Renderiza el componente
   */
  render() {
    return this.loading ? this.renderLoading() : this.error ? this.renderError() : this.ratioData ? this.renderContent() : this.renderNoData();
  }
}
Js([
  dt({ type: String })
], $t.prototype, "symbol", 2);
Js([
  dt({ type: String })
], $t.prototype, "locale", 2);
Js([
  dt({
    type: Boolean,
    attribute: "show-header",
    converter: {
      fromAttribute: (i) => i === "false" || i === !1 ? !1 : i === "true" || i === !0 ? !0 : i !== null
    },
    reflect: !0
  })
], $t.prototype, "showHeader", 2);
var Nc = Object.defineProperty, zc = Object.getOwnPropertyDescriptor, tr = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? zc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Nc(t, e, s), s;
};
let Rn = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null, this.fetchInProgress = !1;
  }
  // No necesitamos declarar symbol, locale o showHeader ya que están en la clase base
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol && !(this.fetchInProgress || this.lastFetchedSymbol === this.symbol && this.ratioData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const i = ct.API_BASE_URL, t = yield fetch(`${i}/asset-data/stock-details?symbol=${encodeURIComponent(this.symbol)}`);
          if (!t.ok)
            throw new Error(p(O`Error al obtener datos: ${t.statusText}`, {
              desc: "Error message when API request fails"
            }));
          const e = yield t.json();
          this.processData(e), this.lastFetchedSymbol = this.symbol;
        } catch (i) {
          this.error = i instanceof Error ? i.message : p("Error desconocido"), console.error(p("Error al obtener datos:"), i);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  getNoDataMessage() {
    return p("No hay información disponible. Por favor, proporcione un símbolo de acción válido.");
  }
  formatCurrencyWithSymbol(i, t = "USD") {
    return new Intl.NumberFormat(this.locale || void 0, {
      style: "currency",
      currency: t
    }).format(i);
  }
  formatNumber(i) {
    return i === void 0 ? p("N/A") : new Intl.NumberFormat(this.locale || void 0).format(i);
  }
  formatPercentage(i) {
    return new Intl.NumberFormat(this.locale || void 0, {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(i / 100);
  }
  formatTimestamp(i) {
    if (!i)
      return "";
    const t = new Date(i);
    return new Intl.DateTimeFormat(this.locale || void 0, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).format(t);
  }
  formatLargeNumber(i) {
    if (i == null)
      return p("N/A");
    if (i >= 1e9) {
      const t = i / 1e9, e = new Intl.NumberFormat(this.locale || void 0, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(t);
      return p(O`${e} B`);
    }
    if (i >= 1e6) {
      const t = i / 1e6, e = new Intl.NumberFormat(this.locale || void 0, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(t);
      return p(O`${e} M`);
    }
    return this.formatNumber(i);
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const {
      symbol: i,
      name: t,
      sector: e,
      industry: n,
      marketCap: s,
      ipoDate: r,
      beta: a,
      dividend: o,
      lastDividend: l,
      website: c,
      isin: d,
      ceo: h,
      employees: u,
      country: f,
      address: g,
      currency: m,
      image: v
    } = this.ratioData;
    return y`
      <div class="info-container">
        ${this.showHeader ? y`
        <div class="info-header">
          ${v ? y`<img class="stock-image" src="${v}" alt="${p(O`${t} logo`)}" onerror="this.style.display='none'" />` : ""}
          <div>
            <h3 class="stock-name">${t}</h3>
            <p class="stock-symbol">${i}</p>
          </div>
        </div>
        ` : ""}

        ${d ? y`
          <div class="detail-item">
            <div class="detail-label">${p("ISIN")}</div>
            <div class="detail-value">${d}</div>
          </div>
        ` : ""}

        ${e ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Sector")}</div>
            <div class="detail-value">${e}</div>
          </div>
        ` : ""}

        ${n ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Industria")}</div>
            <div class="detail-value">${n}</div>
          </div>
        ` : ""}

        ${s ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Capitalización de mercado")}</div>
            <div class="detail-value">${this.formatLargeNumber(s)}</div>
          </div>
        ` : ""}

        ${a !== void 0 ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Beta")}</div>
            <div class="detail-value">${a.toFixed(2)}</div>
          </div>
        ` : ""}

        ${o !== void 0 ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Dividendo")}</div>
            <div class="detail-value">${this.formatPercentage(o)}</div>
          </div>
        ` : ""}

        ${l !== void 0 ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Último dividendo")}</div>
            <div class="detail-value">${this.formatCurrencyWithSymbol(l, m)}</div>
          </div>
        ` : ""}

        ${c ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Sitio web")}</div>
            <div class="detail-value">
              <a href="${c}" target="_blank" rel="noopener nofollow noreferrer" class="website-link" style="word-break: break-all; overflow-wrap: break-word;">${c}</a>
            </div>
          </div>
        ` : ""}

        ${h ? y`
          <div class="detail-item">
            <div class="detail-label">${p("CEO")}</div>
            <div class="detail-value">${h}</div>
          </div>
        ` : ""}

        ${u ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Empleados")}</div>
            <div class="detail-value">${this.formatNumber(u)}</div>
          </div>
        ` : ""}

        ${r ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Fecha de IPO")}</div>
            <div class="detail-value">${this.formatTimestamp(r)}</div>
          </div>
        ` : ""}

        ${f ? y`
          <div class="detail-item">
            <div class="detail-label">${p("País")}</div>
            <div class="detail-value">${f}</div>
          </div>
        ` : ""}

        ${g ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Dirección")}</div>
            <div class="detail-value">${g}</div>
          </div>
        ` : ""}
      </div>
    `;
  }
};
tr([
  R()
], Rn.prototype, "lastFetchedSymbol", 2);
tr([
  R()
], Rn.prototype, "fetchInProgress", 2);
Rn = tr([
  Wt(),
  kt("stock-info")
], Rn);
var Hc = Object.defineProperty, Bc = Object.getOwnPropertyDescriptor, er = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Bc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Hc(t, e, s), s;
};
let Ai = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol && !(this.fetchInProgress || this.lastFetchedSymbol === this.symbol && this.ratioData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const i = ct.API_BASE_URL, t = yield fetch(`${i}/asset-data/stock-details?symbol=${encodeURIComponent(this.symbol)}`);
          if (!t.ok)
            throw new Error(p(O`Error al obtener datos: ${t.statusText}`, {
              desc: "Error message when API request fails"
            }));
          const e = yield t.json();
          this.processData(e), this.lastFetchedSymbol = this.symbol;
        } catch (i) {
          this.error = i instanceof Error ? i.message : p("Error desconocido"), console.error(p("Error al obtener datos:"), i);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  getNoDataMessage() {
    return p("No hay descripción disponible. Por favor, proporcione un símbolo de acción válido.");
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const {
      description: i
    } = this.ratioData;
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        ${i ? y`
          <div class="detail-item">
            <div class="detail-label">${p("Descripción")}</div>
            <div class="detail-value">${i}</div>
          </div>
        ` : ""}
      </div>
    `;
  }
};
Ai.styles = _t`
    ${Bt(Tt)}

    .info-container {
      width: 100%;
      display: block;
    }

    /* Estos estilos específicos complementan los de shared-styles */
    .detail-item {
      width: 100%;
      display: block;
      box-sizing: border-box;
      margin-bottom: 16px;
    }

    .detail-value {
      font-weight: normal;
    }

    /* Asegurarse de que el contenedor de la descripción no tenga estilos que limiten el ancho */
    div[class^="detail"] {
      max-width: 100%;
      width: 100%;
      display: block;
      overflow: hidden; /* Previene desbordamiento */
    }
  `;
er([
  R()
], Ai.prototype, "lastFetchedSymbol", 2);
er([
  R()
], Ai.prototype, "fetchInProgress", 2);
Ai = er([
  Wt(),
  kt("stock-description")
], Ai);
var Wc = Object.defineProperty, Uc = Object.getOwnPropertyDescriptor, ir = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Uc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Wc(t, e, s), s;
};
let Ii = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      var i;
      if (this.symbol && !(this.fetchInProgress || this.lastFetchedSymbol === this.symbol && this.ratioData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const t = `${ct.API_BASE_URL}/asset-data/financial-ratios?symbol=${encodeURIComponent(this.symbol)}&limit=1&period=FY`, e = this.showHeader ? [
            fetch(t),
            fetch(`${ct.API_BASE_URL}/asset-data/stock-details?symbol=${encodeURIComponent(this.symbol)}`)
          ] : [fetch(t)], n = yield Promise.all(e);
          if (!n[0].ok)
            throw new Error(p(O`Error al obtener datos de deuda: ${n[0].statusText}`, {
              desc: "Error message when debt ratios API request fails"
            }));
          const s = yield n[0].json();
          if (!s || s.length === 0)
            throw new Error(p("No hay datos disponibles para este símbolo", {
              desc: "Error message when no data is available"
            }));
          if (this.showHeader && ((i = n[1]) != null && i.ok)) {
            const r = yield n[1].json();
            this.processData(ot(at({}, s[0]), {
              name: r == null ? void 0 : r.name,
              image: r == null ? void 0 : r.image
            }));
          } else
            this.processData(s[0]);
          this.lastFetchedSymbol = this.symbol;
        } catch (t) {
          this.error = t instanceof Error ? t.message : p("Error desconocido");
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando ratios de deuda...")}</div>`;
  }
  getNoDataMessage() {
    return p("No hay datos de ratios de deuda disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  getDebtValueClass(i, t) {
    if (t == null)
      return "";
    switch (i) {
      case "debt":
        return t > 1 ? "high-debt" : t < 0.3 ? "positive" : "";
      case "coverage":
        return t < 1 ? "negative" : t > 3 ? "positive" : "";
      default:
        return t < 0 ? "negative" : t > 0 ? "positive" : "";
    }
  }
  renderDebtRatioItem(i, t, e = "") {
    if (t == null)
      return y``;
    const n = this.getDebtValueClass(e, t), s = e === "coverage" ? this.formatDecimal(t) : this.formatPercentage(t);
    return y`
      <div class="ratio-item">
        <div class="ratio-label">${i}</div>
        <div class="ratio-value ${n}">${s}</div>
      </div>
    `;
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const i = this.ratioData;
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        ${i.fiscalYear ? y`
          <div class="period-info">
            <span class="fiscal-year">${p(O`Año Fiscal: ${i.fiscalYear}`)}</span>
            ${i.period ? y`<span class="period">${p(O`Periodo: ${i.period}`)}</span>` : ""}
            ${i.date ? y`<span class="date">${p(O`Fecha cierre fiscal: ${new Date(i.date).toLocaleDateString(this.locale || "es")}`)}</span>` : ""}
          </div>
        ` : ""}

        <div class="ratios-grid">
          ${this.renderDebtRatioItem(p("Deuda/Activos"), i.debtToAssetsRatio, "debt")}
          ${this.renderDebtRatioItem(p("Deuda/Patrimonio"), i.debtToEquityRatio, "debt")}
          ${this.renderDebtRatioItem(p("Deuda/Capital"), i.debtToCapitalRatio, "debt")}
          ${this.renderDebtRatioItem(p("Deuda a Largo Plazo/Capital"), i.longTermDebtToCapitalRatio, "debt")}
          ${this.renderDebtRatioItem(p("Apalancamiento Financiero"), i.financialLeverageRatio, "debt")}
          ${this.renderDebtRatioItem(p("Cobertura de Intereses"), i.interestCoverageRatio, "coverage")}
          ${this.renderDebtRatioItem(p("Cobertura de Servicio de Deuda"), i.debtServiceCoverageRatio, "coverage")}
          ${this.renderDebtRatioItem(p("Deuda/Capitalización de Mercado"), i.debtToMarketCap, "debt")}
        </div>
      </div>
    `;
  }
};
Ii.styles = _t`
    ${Bt(Tt)}

    /* Estilos adicionales específicos para este componente */
    .info-container {
      width: 100%;
      display: block;
    }

    .ratios-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 1rem;
      margin-top: 20px;
    }

    .period-info {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin: 10px 0 20px;
      font-size: 14px;
      color: var(--text-secondary-color, #666);
      background-color: var(--info-bg-color, #f5f5f5);
      padding: 8px 12px;
      border-radius: 4px;
      border-left: 3px solid var(--primary-color, #4285f4);
    }

    .period-info span {
      display: inline-flex;
      align-items: center;
    }

    .fiscal-year {
      font-weight: 500;
    }

    @media (max-width: 600px) {
      .period-info {
        flex-direction: column;
        gap: 6px;
      }
    }
  `;
ir([
  R()
], Ii.prototype, "lastFetchedSymbol", 2);
ir([
  R()
], Ii.prototype, "fetchInProgress", 2);
Ii = ir([
  kt("stock-debt-ratios")
], Ii);
var jc = Object.defineProperty, Vc = Object.getOwnPropertyDescriptor, nr = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Vc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && jc(t, e, s), s;
};
let Ei = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      var i;
      if (this.symbol && !(this.fetchInProgress || this.lastFetchedSymbol === this.symbol && this.ratioData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const t = `${ct.API_BASE_URL}/asset-data/financial-ratios?symbol=${encodeURIComponent(this.symbol)}&limit=1&period=FY`, e = this.showHeader ? [
            fetch(t),
            fetch(`${ct.API_BASE_URL}/asset-data/stock-details?symbol=${encodeURIComponent(this.symbol)}`)
          ] : [fetch(t)], n = yield Promise.all(e);
          if (!n[0].ok)
            throw new Error(p(O`Error al obtener datos de liquidez: ${n[0].statusText}`, {
              desc: "Error message when liquidity ratios API request fails"
            }));
          const s = yield n[0].json();
          if (!s || s.length === 0)
            throw new Error(p("No hay datos disponibles para este símbolo", {
              desc: "Error message when no data is available"
            }));
          if (this.showHeader && ((i = n[1]) != null && i.ok)) {
            const r = yield n[1].json();
            this.processData(ot(at({}, s[0]), {
              name: r == null ? void 0 : r.name,
              image: r == null ? void 0 : r.image
            }));
          } else
            this.processData(s[0]);
          this.lastFetchedSymbol = this.symbol;
        } catch (t) {
          this.error = t instanceof Error ? t.message : p("Error desconocido");
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando ratios de liquidez...")}</div>`;
  }
  getNoDataMessage() {
    return p("No hay datos de ratios de liquidez disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  getLiquidityValueClass(i, t = "currentRatio") {
    if (i == null)
      return "";
    switch (t) {
      case "currentRatio":
        return i < 1.2 ? "negative" : i > 2 ? "positive" : "";
      case "quickRatio":
        return i < 1 ? "negative" : i > 1.5 ? "positive" : "";
      case "cashRatio":
        return i < 0.5 ? "negative" : i > 1 ? "positive" : "";
      case "solvencyRatio":
        return i < 0.2 ? "negative" : i > 0.4 ? "positive" : "";
      default:
        return i < 1 ? "negative" : i > 1.5 ? "positive" : "";
    }
  }
  renderLiquidityRatioItem(i, t) {
    if (t == null)
      return y``;
    const e = this.getLiquidityValueClass(t), n = this.formatDecimal(t);
    return y`
      <div class="ratio-item">
        <div class="ratio-label">${i}</div>
        <div class="ratio-value ${e}">${n}</div>
      </div>
    `;
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const i = this.ratioData;
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        ${i.fiscalYear ? y`
          <div class="period-info">
            <span class="fiscal-year">${p(O`Año Fiscal: ${i.fiscalYear}`)}</span>
            ${i.period ? y`<span class="period">${p(O`Periodo: ${i.period}`)}</span>` : ""}
            ${i.date ? y`<span class="date">${p(O`Fecha cierre fiscal: ${new Date(i.date).toLocaleDateString(this.locale || "es")}`)}</span>` : ""}
          </div>
        ` : ""}

        <div class="ratios-grid">
          ${this.renderLiquidityRatioItem(p("Ratio Actual"), i.currentRatio)}
          ${this.renderLiquidityRatioItem(p("Ratio Rápido"), i.quickRatio)}
          ${this.renderLiquidityRatioItem(p("Ratio de Efectivo"), i.cashRatio)}
          ${this.renderLiquidityRatioItem(p("Ratio de Solvencia"), i.solvencyRatio)}
        </div>
      </div>
    `;
  }
};
Ei.styles = _t`
    ${Bt(Tt)}

    /* Estilos adicionales específicos para este componente */
    .info-container {
      width: 100%;
      display: block;
    }

    .ratios-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 1rem;
      margin-top: 20px;
    }

    .period-info {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin: 10px 0 20px;
      font-size: 14px;
      color: var(--text-secondary-color, #666);
      background-color: var(--info-bg-color, #f5f5f5);
      padding: 8px 12px;
      border-radius: 4px;
      border-left: 3px solid var(--primary-color, #4285f4);
    }

    .period-info span {
      display: inline-flex;
      align-items: center;
    }

    .fiscal-year {
      font-weight: 500;
    }

    @media (max-width: 600px) {
      .period-info {
        flex-direction: column;
        gap: 6px;
      }
    }
  `;
nr([
  R()
], Ei.prototype, "lastFetchedSymbol", 2);
nr([
  R()
], Ei.prototype, "fetchInProgress", 2);
Ei = nr([
  kt("stock-liquidity-ratios")
], Ei);
var Yc = Object.defineProperty, qc = Object.getOwnPropertyDescriptor, sr = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? qc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Yc(t, e, s), s;
};
let Ri = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      var i;
      if (this.symbol && !(this.fetchInProgress || this.lastFetchedSymbol === this.symbol && this.ratioData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const t = `${ct.API_BASE_URL}/asset-data/financial-ratios?symbol=${encodeURIComponent(this.symbol)}&limit=1&period=FY`, e = this.showHeader ? [
            fetch(t),
            fetch(`${ct.API_BASE_URL}/asset-data/stock-details?symbol=${encodeURIComponent(this.symbol)}`)
          ] : [fetch(t)], n = yield Promise.all(e);
          if (!n[0].ok)
            throw new Error(p(O`Error al obtener datos de flujo de efectivo: ${n[0].statusText}`, {
              desc: "Error message when cashflow ratios API request fails"
            }));
          const s = yield n[0].json();
          if (!s || s.length === 0)
            throw new Error(p("No hay datos disponibles para este símbolo", {
              desc: "Error message when no data is available"
            }));
          if (this.showHeader && ((i = n[1]) != null && i.ok)) {
            const r = yield n[1].json();
            this.processData(ot(at({}, s[0]), {
              name: r == null ? void 0 : r.name,
              image: r == null ? void 0 : r.image
            }));
          } else
            this.processData(s[0]);
          this.lastFetchedSymbol = this.symbol;
        } catch (t) {
          this.error = t instanceof Error ? t.message : p("Error desconocido");
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando ratios de flujo de efectivo...")}</div>`;
  }
  getNoDataMessage() {
    return p("No hay datos de ratios de flujo de efectivo disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const i = this.ratioData;
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        ${i.fiscalYear ? y`
          <div class="period-info">
            <span class="fiscal-year">${p(O`Año Fiscal: ${i.fiscalYear}`)}</span>
            ${i.period ? y`<span class="period">${p(O`Periodo: ${i.period}`)}</span>` : ""}
            ${i.date ? y`<span class="date">${p(O`Fecha cierre fiscal: ${new Date(i.date).toLocaleDateString(this.locale || "es")}`)}</span>` : ""}
          </div>
        ` : ""}

        <div class="ratios-grid">
          ${this.renderRatioItem(p("Ratio de Flujo de Efectivo Operativo"), i.operatingCashFlowRatio)}
          ${this.renderRatioItem(p("Flujo de Efectivo Operativo/Ventas"), i.operatingCashFlowSalesRatio, !0)}
          ${this.renderRatioItem(p("Flujo de Efectivo Libre/Flujo Operativo"), i.freeCashFlowOperatingCashFlowRatio, !0)}
          ${this.renderRatioItem(p("Cobertura de Flujo de Operaciones a Corto Plazo"), i.shortTermOperatingCashFlowCoverageRatio)}
          ${this.renderRatioItem(p("Cobertura de Flujo de Efectivo Operativo"), i.operatingCashFlowCoverageRatio)}
          ${this.renderRatioItem(p("Cobertura de Gastos de Capital"), i.capitalExpenditureCoverageRatio)}
        </div>
      </div>
    `;
  }
  formatDecimal(i, t = 2) {
    return i == null ? "-" : new Intl.NumberFormat("es", {
      minimumFractionDigits: t,
      maximumFractionDigits: t
    }).format(i);
  }
  formatPercentage(i) {
    return i == null ? "-" : new Intl.NumberFormat("es", {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(i);
  }
  renderRatioItem(i, t, e = !1) {
    if (t == null)
      return y``;
    const n = t < 0 ? "negative" : t > 0 ? "positive" : "", s = e ? this.formatPercentage(t) : this.formatDecimal(t);
    return y`
      <div class="ratio-item">
        <div class="ratio-label">${i}</div>
        <div class="ratio-value ${n}">${s}</div>
      </div>
    `;
  }
};
Ri.styles = _t`
    ${Bt(Tt)}

    /* Estilos adicionales específicos para este componente */
    .info-container {
      width: 100%;
      display: block;
    }

    .ratios-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 1rem;
      margin-top: 20px;
    }

    .period-info {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin: 10px 0 20px;
      font-size: 14px;
      color: var(--text-secondary-color, #666);
      background-color: var(--info-bg-color, #f5f5f5);
      padding: 8px 12px;
      border-radius: 4px;
      border-left: 3px solid var(--primary-color, #4285f4);
    }

    .period-info span {
      display: inline-flex;
      align-items: center;
    }

    .fiscal-year {
      font-weight: 500;
    }

    @media (max-width: 600px) {
      .period-info {
        flex-direction: column;
        gap: 6px;
      }
    }
  `;
sr([
  R()
], Ri.prototype, "lastFetchedSymbol", 2);
sr([
  R()
], Ri.prototype, "fetchInProgress", 2);
Ri = sr([
  kt("stock-cashflow-ratios")
], Ri);
var Xc = Object.defineProperty, Qc = Object.getOwnPropertyDescriptor, rr = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Qc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Xc(t, e, s), s;
};
let Fi = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null, this.fetchInProgress = !1;
  }
  /**
   * Implementación del método abstracto getNoDataMessage
   */
  getNoDataMessage() {
    return p("No hay datos de métricas por acción disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  /**
   * Obtiene los datos de ratios financieros
   */
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol && !(this.fetchInProgress || this.lastFetchedSymbol === this.symbol && this.ratioData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const i = `${ct.API_BASE_URL}/asset-data/financial-ratios?symbol=${encodeURIComponent(this.symbol)}&limit=1&period=FY`, t = yield fetch(i);
          if (!t.ok)
            throw new Error(`Error: ${t.statusText}`);
          const e = yield t.json();
          if (!e || e.length === 0)
            throw new Error(p("No hay datos disponibles para este símbolo", {
              desc: "Error message when no data is available"
            }));
          this.processData(e[0]), this.lastFetchedSymbol = this.symbol;
        } catch (i) {
          this.error = i instanceof Error ? i.message : String(i), console.error(`Error fetching metrics per share: ${i}`);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando métricas por acción...")}</div>`;
  }
  renderNoData() {
    return y`<div>${this.getNoDataMessage()}</div>`;
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const i = this.ratioData;
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        ${i.fiscalYear ? y`
          <div class="period-info">
            <span class="fiscal-year">${p(O`Año Fiscal: ${i.fiscalYear}`)}</span>
            ${i.period ? y`<span class="period">${p(O`Periodo: ${i.period}`)}</span>` : ""}
            ${i.date ? y`<span class="date">${p(O`Fecha cierre fiscal: ${new Date(i.date).toLocaleDateString(this.locale || "es")}`)}</span>` : ""}
          </div>
        ` : ""}

        <div class="ratios-grid">
          ${this.renderRatioItem(p("Ingresos por Acción"), i.revenuePerShare, i.reportedCurrency)}
          ${this.renderRatioItem(p("Beneficio Neto por Acción"), i.netIncomePerShare, i.reportedCurrency)}
          ${this.renderRatioItem(p("Flujo de Efectivo Operativo por Acción"), i.operatingCashFlowPerShare, i.reportedCurrency)}
          ${this.renderRatioItem(p("Flujo de Efectivo Libre por Acción"), i.freeCashFlowPerShare, i.reportedCurrency)}
          ${this.renderRatioItem(p("Efectivo por Acción"), i.cashPerShare, i.reportedCurrency)}
          ${this.renderRatioItem(p("Valor Contable por Acción"), i.bookValuePerShare, i.reportedCurrency)}
          ${this.renderRatioItem(p("Valor Contable Tangible por Acción"), i.tangibleBookValuePerShare, i.reportedCurrency)}
          ${this.renderRatioItem(p("Patrimonio por Acción"), i.shareholdersEquityPerShare, i.reportedCurrency)}
        </div>
      </div>
    `;
  }
  renderRatioItem(i, t, e = "USD") {
    if (t == null)
      return y``;
    const n = t < 0 ? "negative" : t > 0 ? "positive" : "", s = this.formatCurrency(t, 2, e);
    return y`
      <div class="ratio-item">
        <div class="ratio-label">${i}</div>
        <div class="ratio-value ${n}">${s}</div>
      </div>
    `;
  }
};
Fi.styles = _t`
    ${Bt(Tt)}

    /* Estilos adicionales específicos para este componente */
    .info-container {
      width: 100%;
      display: block;
    }

    .ratios-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 1rem;
      margin-top: 20px;
    }

    .period-info {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin: 10px 0 20px;
      font-size: 14px;
      color: var(--text-secondary-color, #666);
      background-color: var(--info-bg-color, #f5f5f5);
      padding: 8px 12px;
      border-radius: 4px;
      border-left: 3px solid var(--primary-color, #4285f4);
    }

    .period-info span {
      display: inline-flex;
      align-items: center;
    }

    .fiscal-year {
      font-weight: 500;
    }

    @media (max-width: 600px) {
      .period-info {
        flex-direction: column;
        gap: 6px;
      }
    }
  `;
rr([
  R()
], Fi.prototype, "lastFetchedSymbol", 2);
rr([
  R()
], Fi.prototype, "fetchInProgress", 2);
Fi = rr([
  kt("stock-metrics-per-share")
], Fi);
var Gc = Object.defineProperty, Kc = Object.getOwnPropertyDescriptor, Eo = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Kc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Gc(t, e, s), s;
};
let Fn = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null;
  }
  /**
   * Implementación del método abstracto getNoDataMessage
   */
  getNoDataMessage() {
    return p("No hay datos de márgenes de rentabilidad disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  /**
   * Obtiene los datos de ratios financieros
   */
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol) {
        this.loading = !0, this.error = null;
        try {
          const i = `${ct.API_BASE_URL}/asset-data/financial-ratios?symbol=${encodeURIComponent(this.symbol)}&limit=1&period=FY`, t = yield fetch(i);
          if (!t.ok)
            throw new Error(`Error: ${t.statusText}`);
          const e = yield t.json();
          if (!e || e.length === 0)
            throw new Error(p("No hay datos disponibles para este símbolo", {
              desc: "Error message when no data is available"
            }));
          this.processData(e[0]), this.lastFetchedSymbol = this.symbol;
        } catch (i) {
          this.error = i instanceof Error ? i.message : String(i), console.error(`Error fetching profitability margins: ${i}`);
        } finally {
          this.loading = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando márgenes de rentabilidad...")}</div>`;
  }
  renderNoData() {
    return y`<div>${p("No hay datos de márgenes de rentabilidad disponibles. Por favor, proporcione un símbolo de acción válido.")}</div>`;
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const i = this.ratioData;
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        ${i.fiscalYear ? y`
          <div class="period-info">
            <span class="fiscal-year">${p(O`Año Fiscal: ${i.fiscalYear}`)}</span>
            ${i.period ? y`<span class="period">${p(O`Periodo: ${i.period}`)}</span>` : ""}
            ${i.date ? y`<span class="date">${p(O`Fecha cierre fiscal: ${new Date(i.date).toLocaleDateString(this.locale || "es")}`)}</span>` : ""}
          </div>
        ` : ""}

        <div class="ratios-grid">
          ${this.renderRatioItem(p("Margen de Beneficio Bruto"), i.grossProfitMargin, !0)}
          ${this.renderRatioItem(p("Margen EBIT"), i.ebitMargin, !0)}
          ${this.renderRatioItem(p("Margen EBITDA"), i.ebitdaMargin, !0)}
          ${this.renderRatioItem(p("Margen de Beneficio Operativo"), i.operatingProfitMargin, !0)}
          ${this.renderRatioItem(p("Margen de Beneficio antes de Impuestos"), i.pretaxProfitMargin, !0)}
          ${this.renderRatioItem(p("Margen de Operaciones Continuas"), i.continuousOperationsProfitMargin, !0)}
          ${this.renderRatioItem(p("Margen de Beneficio Neto"), i.netProfitMargin, !0)}
          ${this.renderRatioItem(p("Margen de Línea de Fondo"), i.bottomLineProfitMargin, !0)}
        </div>
      </div>
    `;
  }
  /**
   * Renderiza un elemento de ratio básico
   */
  renderRatioItem(i, t, e = !1) {
    if (t == null)
      return y``;
    const n = this.getValueClass(t), s = e ? this.formatPercentage(t) : this.formatDecimal(t);
    return y`
      <div class="ratio-item">
        <div class="ratio-label">${i}</div>
        <div class="ratio-value ${n}">${s}</div>
      </div>
    `;
  }
};
Fn.styles = _t`
    ${Bt(Tt)}

    /* Estilos adicionales específicos para este componente */
    .info-container {
      width: 100%;
      display: block;
    }

    .ratios-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 1rem;
      margin-top: 20px;
    }

    .period-info {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin: 10px 0 20px;
      font-size: 14px;
      color: var(--text-secondary-color, #666);
      background-color: var(--info-bg-color, #f5f5f5);
      padding: 8px 12px;
      border-radius: 4px;
      border-left: 3px solid var(--primary-color, #4285f4);
    }

    .period-info span {
      display: inline-flex;
      align-items: center;
    }

    .fiscal-year {
      font-weight: 500;
    }

    @media (max-width: 600px) {
      .period-info {
        flex-direction: column;
        gap: 6px;
      }
    }
  `;
Eo([
  R()
], Fn.prototype, "lastFetchedSymbol", 2);
Fn = Eo([
  kt("stock-profitability-margins")
], Fn);
var Zc = Object.defineProperty, Jc = Object.getOwnPropertyDescriptor, Ki = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Jc(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Zc(t, e, s), s;
};
let ze = class extends $t {
  constructor() {
    super(...arguments), this.stockData = null, this.quoteData = null, this.lastFetchedSymbol = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol && !(this.fetchInProgress || this.lastFetchedSymbol === this.symbol && this.stockData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const i = ct.API_BASE_URL, [t, e] = yield Promise.all([
            fetch(`${i}/asset-data/stock-details?symbol=${encodeURIComponent(this.symbol)}`),
            fetch(`${i}/asset-data/quote?symbol=${encodeURIComponent(this.symbol)}`)
          ]);
          if (!t.ok)
            throw new Error(p(O`Error al obtener datos básicos: ${t.statusText}`, {
              desc: "Error message when stock API request fails"
            }));
          if (!e.ok)
            throw new Error(p(O`Error al obtener cotización: ${e.statusText}`, {
              desc: "Error message when quote API request fails"
            }));
          const [n, s] = yield Promise.all([
            t.json(),
            e.json()
          ]);
          this.stockData = n, this.quoteData = s, this.processData(ot(at({}, n), { quoteData: s })), this.lastFetchedSymbol = this.symbol;
        } catch (i) {
          this.error = i instanceof Error ? i.message : p("Error desconocido"), console.error(p("Error al obtener datos:"), i);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  getNoDataMessage() {
    return p("No hay datos de cotización disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  formatPercentage(i) {
    return new Intl.NumberFormat(this.locale || void 0, {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(i / 100);
  }
  formatNumber(i, t = {}) {
    return new Intl.NumberFormat(this.locale || void 0, t).format(i);
  }
  formatTimestamp(i) {
    if (!i)
      return "";
    const t = new Date(i * 1e3);
    return new Intl.DateTimeFormat(this.locale || void 0, {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZoneName: "short"
    }).format(t);
  }
  determinarEstadoDatos(i, t) {
    const e = Date.now() / 1e3, n = Math.floor((e - i) / 60), s = 14 * 24 * 60;
    return n > s ? p("Deslistada") : t ? (n < 2, p("Mercado abierto")) : p("Mercado cerrado");
  }
  renderContent() {
    var u, f, g, m, v, b, x, w;
    if (!this.stockData)
      return null;
    const { symbol: i, name: t, image: e, exchange: n } = this.stockData, s = ((u = this.quoteData) == null ? void 0 : u.price) !== void 0 && ((f = this.quoteData) == null ? void 0 : f.price) !== null ? this.quoteData.price : this.stockData.price, r = ((g = this.quoteData) == null ? void 0 : g.change) !== void 0 && ((m = this.quoteData) == null ? void 0 : m.change) !== null ? this.quoteData.change : this.stockData.change, a = ((v = this.quoteData) == null ? void 0 : v.changePercentage) !== void 0 && ((b = this.quoteData) == null ? void 0 : b.changePercentage) !== null ? this.quoteData.changePercentage : this.stockData.changePercentage, o = (x = this.quoteData) == null ? void 0 : x.timestamp, l = (w = this.quoteData) == null ? void 0 : w.isMarketOpen, c = r >= 0 ? "positive" : "negative", d = r >= 0 ? "+" : "", h = o ? this.determinarEstadoDatos(o, l) : null;
    return y`
      <div class="quote-card">
        <div class="quote-card-header">
          <div class="stock-image-container">
            ${e ? y`<img class="stock-image" src="${e}" alt="${p(O`${t} logo`)}" onerror="this.closest('.stock-image-container' ).style.display='none'" />` : y`<div class="stock-image-placeholder"></div>`}
          </div>

          <div class="name-container">
            <h3 class="stock-name">${t}</h3>
            <p class="stock-symbol-container"><span class="stock-symbol">${i}</span> &#xb7 ${n}</p>
          </div>
        </div>
        <div class="quote-card-body">
          <div class="price-container">
            <p class="stock-price">
              <span class="stock-price-number">${this.formatNumber(s)}</span>&nbsp;<span class="stock-price-currency">${this.stockData.currency || ""}</span>
            </p>
            <p class="stock-price-change">
              <span class="stock-change ${c}">
                <svg width="13" height="14" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.33331 14.5V2.25L1.08331 7.5L0.333313 6.84L6.83331 0.339996L13.3333 6.84L12.5833 7.5L7.33331 2.25V14.5H6.33331Z" fill="currentColor"/>
                </svg>
                ${this.formatPercentage(a)}
              </span>&nbsp;<span class="stock-change-number ${c}">${d} ${this.formatNumber(r)} Hoy</span>
            </p>
          </div>

          ${o ? y`
            <p class="stock-timestamp">
              ${h ? y`
                <span class="data-state ${h === p("Mercado cerrado") || h === p("Deslistada") ? "closed" : "active"}">
                 ${h === p("Mercado cerrado") || h === p("Deslistada") ? y`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.47189 9.44607C4.47189 9.91185 4.65692 10.3586 4.98627 10.6879C5.31563 11.0173 5.76233 11.2023 6.22811 11.2023C6.69389 11.2023 7.14059 11.0173 7.46994 10.6879C7.7993 10.3586 7.98433 9.91185 7.98433 9.44607V8.86067H10.0859C10.3101 8.86067 10.4225 8.86067 10.5133 8.83022C10.5986 8.80133 10.6762 8.75312 10.7398 8.68935C10.8035 8.62559 10.8516 8.54798 10.8803 8.46259C10.9114 8.37127 10.9114 8.25887 10.9114 8.0329C10.9114 7.93397 10.9114 7.88479 10.9032 7.83738C10.8887 7.74874 10.8541 7.66461 10.8019 7.59151C10.7738 7.55228 10.7387 7.51716 10.669 7.4475L10.4407 7.21919C10.4043 7.18274 10.3754 7.13947 10.3557 7.09186C10.336 7.04425 10.3259 6.99323 10.326 6.9417V4M8.5 1.5C7.63592 0.664978 6.76624 0.664978 6.22811 0.664978C5.68997 0.664978 5.1571 0.770972 4.65993 0.976908C4.16276 1.18284 3.71101 1.48469 3.33049 1.86521C2.94997 2.24573 2.64813 2.69747 2.44219 3.19465C2.23626 3.69182 2.13026 4.22469 2.13026 4.76282V6.9417C2.1303 6.99323 2.12019 7.04425 2.1005 7.09186C2.08081 7.13947 2.05194 7.18274 2.01552 7.21919L1.78722 7.4475C1.71697 7.51774 1.68243 7.55228 1.65491 7.59092C1.60224 7.66409 1.56718 7.74843 1.55247 7.83738C1.54486 7.88421 1.54486 7.93397 1.54486 8.0329C1.54486 8.25887 1.54486 8.37127 1.5753 8.46259M11.4968 0.664978L0.666748 11.495" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>` : y`<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.15473 9.96881V10.5566C8.15473 11.0243 7.96894 11.4728 7.63824 11.8035C7.30753 12.1342 6.85901 12.32 6.39132 12.32C5.92364 12.32 5.47511 12.1342 5.1444 11.8035C4.8137 11.4728 4.62791 11.0243 4.62791 10.5566V9.96881M8.15473 9.96881H4.62791M8.15473 9.96881H10.2649C10.4901 9.96881 10.6029 9.96881 10.694 9.93824C10.7797 9.90923 10.8576 9.86082 10.9215 9.79679C10.9854 9.73276 11.0337 9.65484 11.0626 9.5691C11.0937 9.4774 11.0937 9.36455 11.0937 9.13765C11.0937 9.03832 11.0937 8.98894 11.0855 8.94133C11.071 8.85232 11.0362 8.76785 10.9838 8.69445C10.9556 8.65507 10.9203 8.6198 10.8504 8.54985L10.6211 8.32061C10.5846 8.28401 10.5556 8.24057 10.5358 8.19276C10.5161 8.14496 10.5059 8.09372 10.5059 8.04199V5.85419C10.5059 5.31385 10.3995 4.7788 10.1927 4.2796C9.98595 3.78039 9.68287 3.3268 9.30079 2.94472C8.91872 2.56264 8.46512 2.25956 7.96592 2.05278C7.46671 1.846 6.93166 1.73958 6.39132 1.73958C5.85098 1.73958 5.31593 1.846 4.81673 2.05278C4.31752 2.25956 3.86393 2.56264 3.48185 2.94472C3.09977 3.3268 2.79669 3.78039 2.58991 4.2796C2.38313 4.7788 2.27671 5.31385 2.27671 5.85419V8.04199C2.27674 8.09372 2.26659 8.14496 2.24682 8.19276C2.22705 8.24057 2.19806 8.28401 2.1615 8.32061L1.93225 8.54985C1.86172 8.62039 1.82704 8.65507 1.79941 8.69386C1.74652 8.76733 1.71132 8.85202 1.69655 8.94133C1.6889 8.98835 1.6889 9.03832 1.6889 9.13765C1.6889 9.36455 1.6889 9.4774 1.71947 9.5691C1.74847 9.65497 1.79693 9.73297 1.86107 9.79701C1.9252 9.86104 2.00328 9.90938 2.0892 9.93824C2.18031 9.96881 2.29258 9.96881 2.5177 9.96881H4.62791M9.9293 1.16C10.7398 1.77097 11.3783 2.5814 11.7826 3.51239M2.85393 1.16C2.04319 1.77089 1.40448 2.58133 1 3.51239" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg> `}
                  ${h}
                </span> ` : ""}
              ${p("Act.:")} ${this.formatTimestamp(o)}
            </p>
          ` : ""}
        </div>
      </div>
    `;
  }
};
ze.styles = _t`
    :host {
      display: block;
      container-type: inline-size;
      container-name: quote-card;
      width: 100%;
      min-width: 0;
      font-family: var(--stock-font-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif);
      --quote-placeholder-bg: #e2e8f0;
      --quote-text-color: var(--stock-text-color, #383d43);
      --quote-light-gray-bg: var(--stock-light-gray-bg, #f0f0f0);
      --quote-price-color: var(--stock-text-color, #0f172a);
      --quote-positive-color: var(--stock-success-color, #00856F);
      --quote-positive-bg: var(--stock-success-bg, rgba(0, 133, 111, 0.15));
      --quote-negative-color: var(--stock-danger-color, #E91101);
      --quote-negative-bg: var(--stock-danger-bg, rgba(233, 17, 1, 0.15));
      --quote-timestamp-color: var(--stock-muted-color, #5A6773);
      --quote-font-size-basis: var(--stock-font-size-basis, 18px);
      --quote-font-size-xl: 1.944em;  /* 35px */
      --quote-font-size-xl-small: 1.444em;  /* 26px */
      --quote-font-size-lg: 1.556em;  /* 28px */
      --quote-font-size-lg-small: 1.278em;  /* 23px */
      --quote-font-size-md: 1.167em;  /* 21px */
      --quote-font-size-md-small: 0.889em;  /* 16px */
      --quote-font-size-sm: 0.778em;  /* 14px */
      background: none;
      padding: 0;
      margin: 0;
      box-sizing: border-box;
    }

    .quote-card {
      display: grid;
      gap: 16px;
      align-items: center;
      margin: 0;
      width: 100%;
      min-width: 0;
      font-size: var(--quote-font-size-basis);
      border: none;
      box-sizing: border-box;
      color: var(--quote-text-color);
    }

    .quote-card-header {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .stock-image-container {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .stock-image {
      width: 50px;
      height: 50px;
      border-radius: 8px;
      object-fit: contain;
      background-color: var(--quote-light-gray-bg);
    }

    .stock-image-placeholder {
      width: 72px;
      height: 72px;
      border-radius: 8px;
      background-color: var(--quote-placeholder-bg);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .name-container {
      padding-right: 8px;
    }

    .stock-name {
      margin: 0;
      font-size: var(--quote-font-size-lg-small);
      font-weight: 600;
      color: var(--quote-text-color);
      line-height: 1.2;
    }

    .stock-symbol-container {
      margin-bottom: 0;
    }

    .stock-symbol {
      margin: 2px 0 0;
      display: inline-block;
      font-size: var(--quote-font-size-basis);
      font-weight: 500;
      color: var(--quote-text-color);
      background-color: var(--quote-light-gray-bg);
      padding: 2px 8px;
      border-radius: 4px;
    }

    .price-container {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 16px;
      margin-bottom: 16px;
    }

    .stock-price {
      margin: 0;
      font-weight: 700;
      color: var(--quote-price-color);
    }

    .stock-price-number {
      font-size: var(--quote-font-size-xl-small);
    }

    .stock-price-currency {
      font-size: var(--quote-font-size-md-small);
    }

    .stock-price-change {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.2;
    }

    .stock-change {
      padding: 12px 16px;
      border-radius: 4px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }

    .stock-change.positive {
      color: var(--quote-positive-color);
      background-color: var(--quote-positive-bg);
    }

    .stock-change.negative {
      color: var(--quote-negative-color);
      background-color: var(--quote-negative-bg);
    }

    .stock-change.negative svg {
      transform: rotate(180deg);
    }

    .stock-change-number.positive {
      color: var(--quote-positive-color);
    }

    .stock-change-number.negative {
      color: var(--quote-negative-color);
    }

    .stock-timestamp {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      margin: 0;
      font-size: var(--quote-font-size-sm);
      color: var(--quote-timestamp-color);
    }

    .data-state {
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }

    .estado-icon {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      margin-right: 4px;
      display: inline-block;
    }

    .data-state.closed {
      color: var(--quote-negative-color);
    }

    .data-state.active {
      color: var(--quote-positive-color);
    }

    @container quote-card (min-width: 600px) {
      .quote-card {
        grid-template-columns: auto  1fr auto;
        grid-template-areas: "header bar body";
        gap: 30px;
      }

      .quote-card::before {
        content: '';
        display: block;
        grid-area: bar;
        margin: 0 auto;
        width: 1px;
        height: 29px;
        background-color: var(--quote-text-color);
      }

      .quote-card-header {
        grid-area: header;
      }

      .quote-card-body {
        grid-area: body;
      }

      .stock-image {
        width: 104px;
        height: 104px;
      }

      .stock-name {
        font-size: var(--quote-font-size-lg);
      }

      .stock-symbol {
        font-size: var(--quote-font-size-md);
      }

      .price-container {
        flex-direction: row;
        align-items: center;
      }

      .stock-price-number {
        font-size: var(--quote-font-size-xl);
      }

      .stock-price-currency {
        font-size: var(--quote-font-size-md);
      }

      .stock-timestamp {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }
  `;
Ki([
  R()
], ze.prototype, "stockData", 2);
Ki([
  R()
], ze.prototype, "quoteData", 2);
Ki([
  R()
], ze.prototype, "lastFetchedSymbol", 2);
Ki([
  R()
], ze.prototype, "fetchInProgress", 2);
ze = Ki([
  Wt(),
  kt("stock-quote-card")
], ze);
var td = Object.defineProperty, ed = Object.getOwnPropertyDescriptor, Ro = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? ed(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && td(t, e, s), s;
};
let Ln = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null;
  }
  /**
   * Implementación del método abstracto getNoDataMessage
   */
  getNoDataMessage() {
    return p("No hay datos de ratios disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  /**
   * Obtiene los datos de ratios financieros
   */
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol) {
        this.loading = !0, this.error = null;
        try {
          const i = `${ct.API_BASE_URL}/asset-data/financial-ratios?symbol=${encodeURIComponent(this.symbol)}&limit=1&period=FY`, t = yield fetch(i);
          if (!t.ok)
            throw new Error(`Error: ${t.statusText}`);
          const e = yield t.json();
          if (!e || e.length === 0)
            throw new Error(p("No hay datos disponibles para este símbolo", {
              desc: "Error message when no data is available"
            }));
          this.processData(e[0]), this.lastFetchedSymbol = this.symbol;
        } catch (i) {
          this.error = i instanceof Error ? i.message : String(i), console.error(`Error fetching ratios: ${i}`);
        } finally {
          this.loading = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  processData(i) {
    this.ratioData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando información del periodo...")}</div>`;
  }
  renderNoData() {
    return y`<div>${p("No hay datos del periodo disponibles. Por favor, proporcione un símbolo de acción válido.")}</div>`;
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const i = this.ratioData;
    return y`
      <div class="period-container">
        ${this.showHeader ? this.renderHeader() : ""}

        <div class="period-info">
          ${i.fiscalYear ? y`
            <div class="period-info-item fiscal-year">
              <span class="period-info-label">${p("Año Fiscal:")}</span>
              <span>${i.fiscalYear}</span>
            </div>
          ` : ""}

          ${i.period ? y`
            <div class="period-info-item period">
              <span class="period-info-label">${p("Periodo:")}</span>
              <span>${i.period}</span>
            </div>
          ` : ""}

          ${i.date ? y`
            <div class="period-info-item date">
              <span class="period-info-label">${p("Fecha:")}</span>
              <span>${new Date(i.date).toLocaleDateString(this.locale || "es")}</span>
            </div>
          ` : ""}

          ${i.reportedCurrency ? y`
            <div class="period-info-item currency">
              <span class="period-info-label">${p("Moneda:")}</span>
              <span>${i.reportedCurrency}</span>
            </div>
          ` : ""}
        </div>
      </div>
    `;
  }
};
Ln.styles = _t`
    ${Bt(Tt)}

    .period-container {
      width: 100%;
      display: block;
    }

    .period-info {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin: 10px 0;
      font-size: 14px;
      color: var(--text-secondary-color, #666);
      background-color: var(--info-bg-color, #f5f5f5);
      padding: 12px 16px;
      border-radius: 8px;
      border-left: 3px solid var(--primary-color, #4285f4);
    }

    .period-info-item {
      display: inline-flex;
      align-items: center;
      padding: 4px 8px;
      background-color: var(--stock-detail-background, #f8fafc);
      border-radius: 6px;
      border: 1px solid var(--stock-detail-border, rgba(226, 232, 240, 0.6));
    }

    .period-info-label {
      font-weight: 600;
      margin-right: 6px;
    }

    .fiscal-year {
      font-weight: 500;
    }

    @media (max-width: 600px) {
      .period-info {
        flex-direction: column;
        gap: 6px;
      }
    }
  `;
Ro([
  R()
], Ln.prototype, "lastFetchedSymbol", 2);
Ln = Ro([
  kt("stock-ratios-period")
], Ln);
var id = Object.defineProperty, nd = Object.getOwnPropertyDescriptor, ar = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? nd(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && id(t, e, s), s;
};
let Li = class extends $t {
  constructor() {
    super(...arguments), this.lastFetchedSymbol = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol && !(this.fetchInProgress || this.lastFetchedSymbol === this.symbol && this.ratioData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const i = ct.API_BASE_URL, [t, e] = yield Promise.all([
            fetch(`${i}/asset-data/stock-details?symbol=${encodeURIComponent(this.symbol)}`),
            fetch(`${i}/asset-data/financial-ratios?symbol=${encodeURIComponent(this.symbol)}&limit=1&period=FY`)
          ]);
          if (!t.ok)
            throw new Error(p(O`Error al obtener datos básicos: ${t.statusText}`, {
              desc: "Error message when stock details API request fails",
              id: "stock-faq.error.stock-details"
            }));
          if (!e.ok)
            throw new Error(p(O`Error al obtener ratios financieros: ${e.statusText}`, {
              desc: "Error message when financial ratios API request fails",
              id: "stock-faq.error.financial-ratios"
            }));
          const n = yield t.json(), s = yield e.json(), r = Array.isArray(s) && s.length > 0 ? s[0] : s, a = {
            symbol: n.symbol || this.symbol,
            name: n.name || this.symbol,
            currentPrice: n.currentPrice || n.price,
            exchange: n.exchange || n.exchangeName,
            ticker: n.symbol || this.symbol,
            lastDividend: n.lastDividend || n.dividend,
            marketCap: n.marketCap,
            earningsPerShare: (r == null ? void 0 : r.netIncomePerShare) || (r == null ? void 0 : r.earningsPerShare) || (r == null ? void 0 : r.eps),
            fiscalYear: r == null ? void 0 : r.fiscalYear,
            currency: n.currency || "USD",
            image: n.image,
            paysDividends: n.lastDividend && n.lastDividend > 0 || n.dividend && n.dividend > 0
          };
          this.processData(a), this.lastFetchedSymbol = this.symbol;
        } catch (i) {
          this.error = i instanceof Error ? i.message : p("Error desconocido"), console.error(p("Error al obtener datos:"), i);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol && this.fetchData();
  }
  // Limpiar el schema cuando el componente se desconecte
  disconnectedCallback() {
    if (super.disconnectedCallback(), this.symbol) {
      const i = document.querySelector(`script[type="application/ld+json"][data-stock-faq="${this.symbol}"]`);
      i && i.remove();
    }
  }
  processData(i) {
    this.ratioData = i;
  }
  getNoDataMessage() {
    return p("No hay datos disponibles para el FAQ. Por favor, proporcione un símbolo de acción válido.");
  }
  formatLargeNumber(i) {
    if (i == null)
      return p("N/A");
    if (i >= 1e9) {
      const t = i / 1e9, e = new Intl.NumberFormat(this.locale || "es", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(t);
      return p(O`${e} B`);
    }
    if (i >= 1e6) {
      const t = i / 1e6, e = new Intl.NumberFormat(this.locale || "es", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(t);
      return p(O`${e} M`);
    }
    return new Intl.NumberFormat(this.locale || "es").format(i);
  }
  renderContent() {
    if (!this.ratioData)
      return null;
    const {
      name: i,
      currentPrice: t,
      exchange: e,
      ticker: n,
      lastDividend: s,
      marketCap: r,
      earningsPerShare: a,
      fiscalYear: o,
      currency: l,
      paysDividends: c
    } = this.ratioData;
    return this.insertSchemaInDOM(), y`
      <div class="faq-container">
        ${this.renderHeader()}

        <!-- Pregunta 1: Cotización actual -->
        <div class="faq-item">
          <h3 class="faq-question">
            ${p(O`¿Cuál es la cotización de ${i} hoy?`)}
          </h3>
          <div class="faq-answer">
            ${t ? y`
              ${p(O`El precio actual de las acciones de ${i} es de`)}
              <span class="currency-value">
                ${this.formatCurrency(t, 2, l)}
              </span>.
            ` : y`
              ${p(O`El precio actual de ${i} no está disponible en este momento.`)}
            `}
          </div>
        </div>

        <!-- Pregunta 2: Bolsa de valores -->
        <div class="faq-item">
          <h3 class="faq-question">
            ${p(O`¿En qué bolsa de valores cotiza ${i}?`)}
          </h3>
          <div class="faq-answer">
            ${e ? y`
              ${p(O`Las acciones de ${i} cotizan en la bolsa de valores`)}
              <span class="highlight-value">${e}</span>.
            ` : y`
              ${p(O`La información sobre la bolsa de valores donde cotiza ${i} no está disponible.`)}
            `}
          </div>
        </div>

        <!-- Pregunta 3: Símbolo bursátil -->
        <div class="faq-item">
          <h3 class="faq-question">
            ${p(O`¿Cuál es el símbolo bursátil (Ticker) de ${i}?`)}
          </h3>
          <div class="faq-answer">
            ${p(O`El símbolo bursátil de ${i} es`)}
            <span class="highlight-value">"${n}"</span>.
          </div>
        </div>

        <!-- Pregunta 4: Dividendos -->
        <div class="faq-item">
          <h3 class="faq-question">
            ${p(O`¿Paga ${i} dividendos? ¿Cuál fue el último dividendo de ${i}?`)}
          </h3>
          <div class="faq-answer">
            ${c && s ? y`
              ${p(O`El último dividendo de ${i} fue de`)}
              <span class="currency-value">
                ${this.formatCurrency(s, 4, l)}
              </span>.
            ` : y`
              <span class="no-dividends">
                ${p(O`${i} no paga dividendos.`)}
              </span>
            `}
          </div>
        </div>

        <!-- Pregunta 5: Capitalización de mercado -->
        <div class="faq-item">
          <h3 class="faq-question">
            ${p(O`¿Cuál es la Capitalización de Mercado de ${i}?`)}
          </h3>
          <div class="faq-answer">
            ${r ? y`
              ${p(O`La capitalización de mercado de ${i} es`)}
              <span class="highlight-value">
                ${this.formatCurrency(r, 0, l)}
                (${this.formatLargeNumber(r)})
              </span>.
            ` : y`
              ${p(O`La capitalización de mercado de ${i} no está disponible.`)}
            `}
          </div>
        </div>

        <!-- Pregunta 6: Beneficio Neto por Acción -->
        <div class="faq-item">
          <h3 class="faq-question">
            ${p(O`¿Cuál es el Beneficio Neto por Acción de ${i}?`)}
          </h3>
          <div class="faq-answer">
            ${a != null ? y`
              ${p(O`El BPA de ${i} es`)}
              <span class="highlight-value ${this.getValueClass(a)}">
                ${this.formatCurrency(a, 2, l)}
              </span>${o ? y` (${o})` : ""}.
            ` : y`
              ${p(O`El Beneficio Neto por Acción de ${i} no está disponible.`)}
            `}
          </div>
        </div>
      </div>
    `;
  }
  insertSchemaInDOM() {
    if (!this.ratioData)
      return;
    const {
      name: i,
      currentPrice: t,
      exchange: e,
      ticker: n,
      lastDividend: s,
      marketCap: r,
      earningsPerShare: a,
      fiscalYear: o,
      currency: l,
      paysDividends: c
    } = this.ratioData, d = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: `¿Cuál es la cotización de ${i} hoy?`,
          acceptedAnswer: {
            "@type": "Answer",
            text: t ? `El precio actual de las acciones de ${i} es de ${this.formatCurrency(t, 2, l)}.` : `El precio actual de ${i} no está disponible en este momento.`
          }
        },
        {
          "@type": "Question",
          name: `¿En qué bolsa de valores cotiza ${i}?`,
          acceptedAnswer: {
            "@type": "Answer",
            text: e ? `Las acciones de ${i} cotizan en la bolsa de valores ${e}.` : `La información sobre la bolsa de valores donde cotiza ${i} no está disponible.`
          }
        },
        {
          "@type": "Question",
          name: `¿Cuál es el símbolo bursátil (Ticker) de ${i}?`,
          acceptedAnswer: {
            "@type": "Answer",
            text: `El símbolo bursátil de ${i} es "${n}".`
          }
        },
        {
          "@type": "Question",
          name: `¿Paga ${i} dividendos? ¿Cuál fue el último dividendo de ${i}?`,
          acceptedAnswer: {
            "@type": "Answer",
            text: c && s ? `El último dividendo de ${i} fue de ${this.formatCurrency(s, 4, l)}.` : `${i} no paga dividendos.`
          }
        },
        {
          "@type": "Question",
          name: `¿Cuál es la Capitalización de Mercado de ${i}?`,
          acceptedAnswer: {
            "@type": "Answer",
            text: r ? `La capitalización de mercado de ${i} es ${this.formatCurrency(r, 0, l)} (${this.formatLargeNumber(r)}).` : `La capitalización de mercado de ${i} no está disponible.`
          }
        },
        {
          "@type": "Question",
          name: `¿Cuál es el Beneficio Neto por Acción de ${i}?`,
          acceptedAnswer: {
            "@type": "Answer",
            text: a != null ? `El BPA de ${i} es ${this.formatCurrency(a, 2, l)}${o ? ` (${o})` : ""}.` : `El Beneficio Neto por Acción de ${i} no está disponible.`
          }
        }
      ]
    }, h = document.querySelector(`script[type="application/ld+json"][data-stock-faq="${this.symbol}"]`);
    h && h.remove();
    const u = document.createElement("script");
    u.type = "application/ld+json", u.setAttribute("data-stock-faq", this.symbol || ""), u.textContent = JSON.stringify(d, null, 2), document.head.appendChild(u);
  }
};
Li.styles = _t`
    ${Bt(Tt)}

    .faq-container {
      width: 100%;
      display: block;
    }

    .faq-title {
      font-size: var(--stock-title-font-size, 1.5rem);
      font-weight: var(--stock-title-weight, 700);
      margin-top: 0;
      margin-bottom: 1.5rem;
      color: var(--stock-title-color, #1e293b);
      border-bottom: 2px solid var(--stock-accent-color, #3b82f6);
      padding-bottom: 0.5rem;
    }

    .faq-item {
      margin-bottom: 1.5rem;
      padding: 1rem;
      background-color: var(--stock-detail-background, #f8fafc);
      border-radius: 12px;
      border: 1px solid var(--stock-detail-border, rgba(226, 232, 240, 0.6));
      transition: all 0.3s ease;
    }

    .faq-item:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }

    .faq-question {
      font-size: var(--stock-label-size, 1.1rem);
      font-weight: var(--stock-label-weight, 600);
      color: var(--stock-label-color, #475569);
      margin-bottom: 0.75rem;
      line-height: 1.4;
    }

    .faq-answer {
      font-size: var(--stock-value-size, 16px);
      line-height: 1.6;
      color: var(--stock-value-color, #334155);
      font-weight: var(--stock-value-weight, 500);
    }

    .highlight-value {
      font-weight: 700;
      color: var(--stock-accent-color, #3b82f6);
    }

    .currency-value {
      font-weight: 700;
      color: var(--stock-positive-color, #388e3c);
    }

    .no-dividends {
      color: var(--stock-warning-color, #f57c00);
      font-weight: 600;
    }
  `;
ar([
  R()
], Li.prototype, "lastFetchedSymbol", 2);
ar([
  R()
], Li.prototype, "fetchInProgress", 2);
Li = ar([
  Wt(),
  kt("stock-faq")
], Li);
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function Zi(i) {
  return i + 0.5 | 0;
}
const me = (i, t, e) => Math.max(Math.min(i, e), t);
function mi(i) {
  return me(Zi(i * 2.55), 0, 255);
}
function xe(i) {
  return me(Zi(i * 255), 0, 255);
}
function se(i) {
  return me(Zi(i / 2.55) / 100, 0, 1);
}
function Gr(i) {
  return me(Zi(i * 100), 0, 100);
}
const Ht = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, As = [..."0123456789ABCDEF"], sd = (i) => As[i & 15], rd = (i) => As[(i & 240) >> 4] + As[i & 15], ln = (i) => (i & 240) >> 4 === (i & 15), ad = (i) => ln(i.r) && ln(i.g) && ln(i.b) && ln(i.a);
function od(i) {
  var t = i.length, e;
  return i[0] === "#" && (t === 4 || t === 5 ? e = {
    r: 255 & Ht[i[1]] * 17,
    g: 255 & Ht[i[2]] * 17,
    b: 255 & Ht[i[3]] * 17,
    a: t === 5 ? Ht[i[4]] * 17 : 255
  } : (t === 7 || t === 9) && (e = {
    r: Ht[i[1]] << 4 | Ht[i[2]],
    g: Ht[i[3]] << 4 | Ht[i[4]],
    b: Ht[i[5]] << 4 | Ht[i[6]],
    a: t === 9 ? Ht[i[7]] << 4 | Ht[i[8]] : 255
  })), e;
}
const ld = (i, t) => i < 255 ? t(i) : "";
function cd(i) {
  var t = ad(i) ? sd : rd;
  return i ? "#" + t(i.r) + t(i.g) + t(i.b) + ld(i.a, t) : void 0;
}
const dd = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Fo(i, t, e) {
  const n = t * Math.min(e, 1 - e), s = (r, a = (r + i / 30) % 12) => e - n * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [s(0), s(8), s(4)];
}
function hd(i, t, e) {
  const n = (s, r = (s + i / 60) % 6) => e - e * t * Math.max(Math.min(r, 4 - r, 1), 0);
  return [n(5), n(3), n(1)];
}
function ud(i, t, e) {
  const n = Fo(i, 1, 0.5);
  let s;
  for (t + e > 1 && (s = 1 / (t + e), t *= s, e *= s), s = 0; s < 3; s++)
    n[s] *= 1 - t - e, n[s] += t;
  return n;
}
function fd(i, t, e, n, s) {
  return i === s ? (t - e) / n + (t < e ? 6 : 0) : t === s ? (e - i) / n + 2 : (i - t) / n + 4;
}
function or(i) {
  const e = i.r / 255, n = i.g / 255, s = i.b / 255, r = Math.max(e, n, s), a = Math.min(e, n, s), o = (r + a) / 2;
  let l, c, d;
  return r !== a && (d = r - a, c = o > 0.5 ? d / (2 - r - a) : d / (r + a), l = fd(e, n, s, d, r), l = l * 60 + 0.5), [l | 0, c || 0, o];
}
function lr(i, t, e, n) {
  return (Array.isArray(t) ? i(t[0], t[1], t[2]) : i(t, e, n)).map(xe);
}
function cr(i, t, e) {
  return lr(Fo, i, t, e);
}
function pd(i, t, e) {
  return lr(ud, i, t, e);
}
function gd(i, t, e) {
  return lr(hd, i, t, e);
}
function Lo(i) {
  return (i % 360 + 360) % 360;
}
function md(i) {
  const t = dd.exec(i);
  let e = 255, n;
  if (!t)
    return;
  t[5] !== n && (e = t[6] ? mi(+t[5]) : xe(+t[5]));
  const s = Lo(+t[2]), r = +t[3] / 100, a = +t[4] / 100;
  return t[1] === "hwb" ? n = pd(s, r, a) : t[1] === "hsv" ? n = gd(s, r, a) : n = cr(s, r, a), {
    r: n[0],
    g: n[1],
    b: n[2],
    a: e
  };
}
function vd(i, t) {
  var e = or(i);
  e[0] = Lo(e[0] + t), e = cr(e), i.r = e[0], i.g = e[1], i.b = e[2];
}
function bd(i) {
  if (!i)
    return;
  const t = or(i), e = t[0], n = Gr(t[1]), s = Gr(t[2]);
  return i.a < 255 ? `hsla(${e}, ${n}%, ${s}%, ${se(i.a)})` : `hsl(${e}, ${n}%, ${s}%)`;
}
const Kr = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Zr = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function yd() {
  const i = {}, t = Object.keys(Zr), e = Object.keys(Kr);
  let n, s, r, a, o;
  for (n = 0; n < t.length; n++) {
    for (a = o = t[n], s = 0; s < e.length; s++)
      r = e[s], o = o.replace(r, Kr[r]);
    r = parseInt(Zr[a], 16), i[o] = [r >> 16 & 255, r >> 8 & 255, r & 255];
  }
  return i;
}
let cn;
function xd(i) {
  cn || (cn = yd(), cn.transparent = [0, 0, 0, 0]);
  const t = cn[i.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const wd = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function _d(i) {
  const t = wd.exec(i);
  let e = 255, n, s, r;
  if (t) {
    if (t[7] !== n) {
      const a = +t[7];
      e = t[8] ? mi(a) : me(a * 255, 0, 255);
    }
    return n = +t[1], s = +t[3], r = +t[5], n = 255 & (t[2] ? mi(n) : me(n, 0, 255)), s = 255 & (t[4] ? mi(s) : me(s, 0, 255)), r = 255 & (t[6] ? mi(r) : me(r, 0, 255)), {
      r: n,
      g: s,
      b: r,
      a: e
    };
  }
}
function kd(i) {
  return i && (i.a < 255 ? `rgba(${i.r}, ${i.g}, ${i.b}, ${se(i.a)})` : `rgb(${i.r}, ${i.g}, ${i.b})`);
}
const ps = (i) => i <= 31308e-7 ? i * 12.92 : Math.pow(i, 1 / 2.4) * 1.055 - 0.055, qe = (i) => i <= 0.04045 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4);
function Dd(i, t, e) {
  const n = qe(se(i.r)), s = qe(se(i.g)), r = qe(se(i.b));
  return {
    r: xe(ps(n + e * (qe(se(t.r)) - n))),
    g: xe(ps(s + e * (qe(se(t.g)) - s))),
    b: xe(ps(r + e * (qe(se(t.b)) - r))),
    a: i.a + e * (t.a - i.a)
  };
}
function dn(i, t, e) {
  if (i) {
    let n = or(i);
    n[t] = Math.max(0, Math.min(n[t] + n[t] * e, t === 0 ? 360 : 1)), n = cr(n), i.r = n[0], i.g = n[1], i.b = n[2];
  }
}
function No(i, t) {
  return i && Object.assign(t || {}, i);
}
function Jr(i) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(i) ? i.length >= 3 && (t = { r: i[0], g: i[1], b: i[2], a: 255 }, i.length > 3 && (t.a = xe(i[3]))) : (t = No(i, { r: 0, g: 0, b: 0, a: 1 }), t.a = xe(t.a)), t;
}
function Cd(i) {
  return i.charAt(0) === "r" ? _d(i) : md(i);
}
class Ni {
  constructor(t) {
    if (t instanceof Ni)
      return t;
    const e = typeof t;
    let n;
    e === "object" ? n = Jr(t) : e === "string" && (n = od(t) || xd(t) || Cd(t)), this._rgb = n, this._valid = !!n;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = No(this._rgb);
    return t && (t.a = se(t.a)), t;
  }
  set rgb(t) {
    this._rgb = Jr(t);
  }
  rgbString() {
    return this._valid ? kd(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? cd(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? bd(this._rgb) : void 0;
  }
  mix(t, e) {
    if (t) {
      const n = this.rgb, s = t.rgb;
      let r;
      const a = e === r ? 0.5 : e, o = 2 * a - 1, l = n.a - s.a, c = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      r = 1 - c, n.r = 255 & c * n.r + r * s.r + 0.5, n.g = 255 & c * n.g + r * s.g + 0.5, n.b = 255 & c * n.b + r * s.b + 0.5, n.a = a * n.a + (1 - a) * s.a, this.rgb = n;
    }
    return this;
  }
  interpolate(t, e) {
    return t && (this._rgb = Dd(this._rgb, t._rgb, e)), this;
  }
  clone() {
    return new Ni(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = xe(t), this;
  }
  clearer(t) {
    const e = this._rgb;
    return e.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, e = Zi(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = e, this;
  }
  opaquer(t) {
    const e = this._rgb;
    return e.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return dn(this._rgb, 2, t), this;
  }
  darken(t) {
    return dn(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return dn(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return dn(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return vd(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function ee() {
}
const $d = (() => {
  let i = 0;
  return () => i++;
})();
function B(i) {
  return i == null;
}
function et(i) {
  if (Array.isArray && Array.isArray(i))
    return !0;
  const t = Object.prototype.toString.call(i);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function W(i) {
  return i !== null && Object.prototype.toString.call(i) === "[object Object]";
}
function ht(i) {
  return (typeof i == "number" || i instanceof Number) && isFinite(+i);
}
function Rt(i, t) {
  return ht(i) ? i : t;
}
function N(i, t) {
  return typeof i == "undefined" ? t : i;
}
const Pd = (i, t) => typeof i == "string" && i.endsWith("%") ? parseFloat(i) / 100 : +i / t, zo = (i, t) => typeof i == "string" && i.endsWith("%") ? parseFloat(i) / 100 * t : +i;
function tt(i, t, e) {
  if (i && typeof i.call == "function")
    return i.apply(e, t);
}
function K(i, t, e, n) {
  let s, r, a;
  if (et(i))
    if (r = i.length, n)
      for (s = r - 1; s >= 0; s--)
        t.call(e, i[s], s);
    else
      for (s = 0; s < r; s++)
        t.call(e, i[s], s);
  else if (W(i))
    for (a = Object.keys(i), r = a.length, s = 0; s < r; s++)
      t.call(e, i[a[s]], a[s]);
}
function Nn(i, t) {
  let e, n, s, r;
  if (!i || !t || i.length !== t.length)
    return !1;
  for (e = 0, n = i.length; e < n; ++e)
    if (s = i[e], r = t[e], s.datasetIndex !== r.datasetIndex || s.index !== r.index)
      return !1;
  return !0;
}
function zn(i) {
  if (et(i))
    return i.map(zn);
  if (W(i)) {
    const t = /* @__PURE__ */ Object.create(null), e = Object.keys(i), n = e.length;
    let s = 0;
    for (; s < n; ++s)
      t[e[s]] = zn(i[e[s]]);
    return t;
  }
  return i;
}
function Ho(i) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(i) === -1;
}
function Md(i, t, e, n) {
  if (!Ho(i))
    return;
  const s = t[i], r = e[i];
  W(s) && W(r) ? zi(s, r, n) : t[i] = zn(r);
}
function zi(i, t, e) {
  const n = et(t) ? t : [
    t
  ], s = n.length;
  if (!W(i))
    return i;
  e = e || {};
  const r = e.merger || Md;
  let a;
  for (let o = 0; o < s; ++o) {
    if (a = n[o], !W(a))
      continue;
    const l = Object.keys(a);
    for (let c = 0, d = l.length; c < d; ++c)
      r(l[c], i, a, e);
  }
  return i;
}
function ki(i, t) {
  return zi(i, t, {
    merger: Sd
  });
}
function Sd(i, t, e) {
  if (!Ho(i))
    return;
  const n = t[i], s = e[i];
  W(n) && W(s) ? ki(n, s) : Object.prototype.hasOwnProperty.call(t, i) || (t[i] = zn(s));
}
const ta = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (i) => i,
  // default resolvers
  x: (i) => i.x,
  y: (i) => i.y
};
function Td(i) {
  const t = i.split("."), e = [];
  let n = "";
  for (const s of t)
    n += s, n.endsWith("\\") ? n = n.slice(0, -1) + "." : (e.push(n), n = "");
  return e;
}
function Od(i) {
  const t = Td(i);
  return (e) => {
    for (const n of t) {
      if (n === "")
        break;
      e = e && e[n];
    }
    return e;
  };
}
function we(i, t) {
  return (ta[t] || (ta[t] = Od(t)))(i);
}
function dr(i) {
  return i.charAt(0).toUpperCase() + i.slice(1);
}
const Hi = (i) => typeof i != "undefined", _e = (i) => typeof i == "function", ea = (i, t) => {
  if (i.size !== t.size)
    return !1;
  for (const e of i)
    if (!t.has(e))
      return !1;
  return !0;
};
function Ad(i) {
  return i.type === "mouseup" || i.type === "click" || i.type === "contextmenu";
}
const nt = Math.PI, it = 2 * nt, Id = it + nt, Hn = Number.POSITIVE_INFINITY, Ed = nt / 180, ft = nt / 2, Pe = nt / 4, ia = nt * 2 / 3, ve = Math.log10, Kt = Math.sign;
function Di(i, t, e) {
  return Math.abs(i - t) < e;
}
function na(i) {
  const t = Math.round(i);
  i = Di(i, t, i / 1e3) ? t : i;
  const e = Math.pow(10, Math.floor(ve(i))), n = i / e;
  return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * e;
}
function Rd(i) {
  const t = [], e = Math.sqrt(i);
  let n;
  for (n = 1; n < e; n++)
    i % n === 0 && (t.push(n), t.push(i / n));
  return e === (e | 0) && t.push(e), t.sort((s, r) => s - r).pop(), t;
}
function Fd(i) {
  return typeof i == "symbol" || typeof i == "object" && i !== null && !(Symbol.toPrimitive in i || "toString" in i || "valueOf" in i);
}
function ii(i) {
  return !Fd(i) && !isNaN(parseFloat(i)) && isFinite(i);
}
function Ld(i, t) {
  const e = Math.round(i);
  return e - t <= i && e + t >= i;
}
function Bo(i, t, e) {
  let n, s, r;
  for (n = 0, s = i.length; n < s; n++)
    r = i[n][e], isNaN(r) || (t.min = Math.min(t.min, r), t.max = Math.max(t.max, r));
}
function Ut(i) {
  return i * (nt / 180);
}
function hr(i) {
  return i * (180 / nt);
}
function sa(i) {
  if (!ht(i))
    return;
  let t = 1, e = 0;
  for (; Math.round(i * t) / t !== i; )
    t *= 10, e++;
  return e;
}
function Wo(i, t) {
  const e = t.x - i.x, n = t.y - i.y, s = Math.sqrt(e * e + n * n);
  let r = Math.atan2(n, e);
  return r < -0.5 * nt && (r += it), {
    angle: r,
    distance: s
  };
}
function Is(i, t) {
  return Math.sqrt(Math.pow(t.x - i.x, 2) + Math.pow(t.y - i.y, 2));
}
function Nd(i, t) {
  return (i - t + Id) % it - nt;
}
function Ft(i) {
  return (i % it + it) % it;
}
function Bi(i, t, e, n) {
  const s = Ft(i), r = Ft(t), a = Ft(e), o = Ft(r - s), l = Ft(a - s), c = Ft(s - r), d = Ft(s - a);
  return s === r || s === a || n && r === a || o > l && c < d;
}
function wt(i, t, e) {
  return Math.max(t, Math.min(e, i));
}
function zd(i) {
  return wt(i, -32768, 32767);
}
function re(i, t, e, n = 1e-6) {
  return i >= Math.min(t, e) - n && i <= Math.max(t, e) + n;
}
function ur(i, t, e) {
  e = e || ((a) => i[a] < t);
  let n = i.length - 1, s = 0, r;
  for (; n - s > 1; )
    r = s + n >> 1, e(r) ? s = r : n = r;
  return {
    lo: s,
    hi: n
  };
}
const ae = (i, t, e, n) => ur(i, e, n ? (s) => {
  const r = i[s][t];
  return r < e || r === e && i[s + 1][t] === e;
} : (s) => i[s][t] < e), Hd = (i, t, e) => ur(i, e, (n) => i[n][t] >= e);
function Bd(i, t, e) {
  let n = 0, s = i.length;
  for (; n < s && i[n] < t; )
    n++;
  for (; s > n && i[s - 1] > e; )
    s--;
  return n > 0 || s < i.length ? i.slice(n, s) : i;
}
const Uo = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function Wd(i, t) {
  if (i._chartjs) {
    i._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(i, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), Uo.forEach((e) => {
    const n = "_onData" + dr(e), s = i[e];
    Object.defineProperty(i, e, {
      configurable: !0,
      enumerable: !1,
      value(...r) {
        const a = s.apply(this, r);
        return i._chartjs.listeners.forEach((o) => {
          typeof o[n] == "function" && o[n](...r);
        }), a;
      }
    });
  });
}
function ra(i, t) {
  const e = i._chartjs;
  if (!e)
    return;
  const n = e.listeners, s = n.indexOf(t);
  s !== -1 && n.splice(s, 1), !(n.length > 0) && (Uo.forEach((r) => {
    delete i[r];
  }), delete i._chartjs);
}
function jo(i) {
  const t = new Set(i);
  return t.size === i.length ? i : Array.from(t);
}
const Vo = function() {
  return typeof window == "undefined" ? function(i) {
    return i();
  } : window.requestAnimationFrame;
}();
function Yo(i, t) {
  let e = [], n = !1;
  return function(...s) {
    e = s, n || (n = !0, Vo.call(window, () => {
      n = !1, i.apply(t, e);
    }));
  };
}
function Ud(i, t) {
  let e;
  return function(...n) {
    return t ? (clearTimeout(e), e = setTimeout(i, t, n)) : i.apply(this, n), t;
  };
}
const fr = (i) => i === "start" ? "left" : i === "end" ? "right" : "center", Pt = (i, t, e) => i === "start" ? t : i === "end" ? e : (t + e) / 2, jd = (i, t, e, n) => i === (n ? "left" : "right") ? e : i === "center" ? (t + e) / 2 : t;
function qo(i, t, e) {
  const n = t.length;
  let s = 0, r = n;
  if (i._sorted) {
    const { iScale: a, vScale: o, _parsed: l } = i, c = i.dataset && i.dataset.options ? i.dataset.options.spanGaps : null, d = a.axis, { min: h, max: u, minDefined: f, maxDefined: g } = a.getUserBounds();
    if (f) {
      if (s = Math.min(
        // @ts-expect-error Need to type _parsed
        ae(l, d, h).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        e ? n : ae(t, d, a.getPixelForValue(h)).lo
      ), c) {
        const m = l.slice(0, s + 1).reverse().findIndex((v) => !B(v[o.axis]));
        s -= Math.max(0, m);
      }
      s = wt(s, 0, n - 1);
    }
    if (g) {
      let m = Math.max(
        // @ts-expect-error Need to type _parsed
        ae(l, a.axis, u, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        e ? 0 : ae(t, d, a.getPixelForValue(u), !0).hi + 1
      );
      if (c) {
        const v = l.slice(m - 1).findIndex((b) => !B(b[o.axis]));
        m += Math.max(0, v);
      }
      r = wt(m, s, n) - s;
    } else
      r = n - s;
  }
  return {
    start: s,
    count: r
  };
}
function Xo(i) {
  const { xScale: t, yScale: e, _scaleRanges: n } = i, s = {
    xmin: t.min,
    xmax: t.max,
    ymin: e.min,
    ymax: e.max
  };
  if (!n)
    return i._scaleRanges = s, !0;
  const r = n.xmin !== t.min || n.xmax !== t.max || n.ymin !== e.min || n.ymax !== e.max;
  return Object.assign(n, s), r;
}
const hn = (i) => i === 0 || i === 1, aa = (i, t, e) => -(Math.pow(2, 10 * (i -= 1)) * Math.sin((i - t) * it / e)), oa = (i, t, e) => Math.pow(2, -10 * i) * Math.sin((i - t) * it / e) + 1, Ci = {
  linear: (i) => i,
  easeInQuad: (i) => i * i,
  easeOutQuad: (i) => -i * (i - 2),
  easeInOutQuad: (i) => (i /= 0.5) < 1 ? 0.5 * i * i : -0.5 * (--i * (i - 2) - 1),
  easeInCubic: (i) => i * i * i,
  easeOutCubic: (i) => (i -= 1) * i * i + 1,
  easeInOutCubic: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i : 0.5 * ((i -= 2) * i * i + 2),
  easeInQuart: (i) => i * i * i * i,
  easeOutQuart: (i) => -((i -= 1) * i * i * i - 1),
  easeInOutQuart: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i * i : -0.5 * ((i -= 2) * i * i * i - 2),
  easeInQuint: (i) => i * i * i * i * i,
  easeOutQuint: (i) => (i -= 1) * i * i * i * i + 1,
  easeInOutQuint: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i * i * i : 0.5 * ((i -= 2) * i * i * i * i + 2),
  easeInSine: (i) => -Math.cos(i * ft) + 1,
  easeOutSine: (i) => Math.sin(i * ft),
  easeInOutSine: (i) => -0.5 * (Math.cos(nt * i) - 1),
  easeInExpo: (i) => i === 0 ? 0 : Math.pow(2, 10 * (i - 1)),
  easeOutExpo: (i) => i === 1 ? 1 : -Math.pow(2, -10 * i) + 1,
  easeInOutExpo: (i) => hn(i) ? i : i < 0.5 ? 0.5 * Math.pow(2, 10 * (i * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (i * 2 - 1)) + 2),
  easeInCirc: (i) => i >= 1 ? i : -(Math.sqrt(1 - i * i) - 1),
  easeOutCirc: (i) => Math.sqrt(1 - (i -= 1) * i),
  easeInOutCirc: (i) => (i /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - i * i) - 1) : 0.5 * (Math.sqrt(1 - (i -= 2) * i) + 1),
  easeInElastic: (i) => hn(i) ? i : aa(i, 0.075, 0.3),
  easeOutElastic: (i) => hn(i) ? i : oa(i, 0.075, 0.3),
  easeInOutElastic(i) {
    return hn(i) ? i : i < 0.5 ? 0.5 * aa(i * 2, 0.1125, 0.45) : 0.5 + 0.5 * oa(i * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(i) {
    return i * i * ((1.70158 + 1) * i - 1.70158);
  },
  easeOutBack(i) {
    return (i -= 1) * i * ((1.70158 + 1) * i + 1.70158) + 1;
  },
  easeInOutBack(i) {
    let t = 1.70158;
    return (i /= 0.5) < 1 ? 0.5 * (i * i * (((t *= 1.525) + 1) * i - t)) : 0.5 * ((i -= 2) * i * (((t *= 1.525) + 1) * i + t) + 2);
  },
  easeInBounce: (i) => 1 - Ci.easeOutBounce(1 - i),
  easeOutBounce(i) {
    return i < 1 / 2.75 ? 7.5625 * i * i : i < 2 / 2.75 ? 7.5625 * (i -= 1.5 / 2.75) * i + 0.75 : i < 2.5 / 2.75 ? 7.5625 * (i -= 2.25 / 2.75) * i + 0.9375 : 7.5625 * (i -= 2.625 / 2.75) * i + 0.984375;
  },
  easeInOutBounce: (i) => i < 0.5 ? Ci.easeInBounce(i * 2) * 0.5 : Ci.easeOutBounce(i * 2 - 1) * 0.5 + 0.5
};
function pr(i) {
  if (i && typeof i == "object") {
    const t = i.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function la(i) {
  return pr(i) ? i : new Ni(i);
}
function gs(i) {
  return pr(i) ? i : new Ni(i).saturate(0.5).darken(0.1).hexString();
}
const Vd = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], Yd = [
  "color",
  "borderColor",
  "backgroundColor"
];
function qd(i) {
  i.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), i.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), i.set("animations", {
    colors: {
      type: "color",
      properties: Yd
    },
    numbers: {
      type: "number",
      properties: Vd
    }
  }), i.describe("animations", {
    _fallback: "animation"
  }), i.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function Xd(i) {
  i.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const ca = /* @__PURE__ */ new Map();
function Qd(i, t) {
  t = t || {};
  const e = i + JSON.stringify(t);
  let n = ca.get(e);
  return n || (n = new Intl.NumberFormat(i, t), ca.set(e, n)), n;
}
function Ji(i, t, e) {
  return Qd(t, e).format(i);
}
const Qo = {
  values(i) {
    return et(i) ? i : "" + i;
  },
  numeric(i, t, e) {
    if (i === 0)
      return "0";
    const n = this.chart.options.locale;
    let s, r = i;
    if (e.length > 1) {
      const c = Math.max(Math.abs(e[0].value), Math.abs(e[e.length - 1].value));
      (c < 1e-4 || c > 1e15) && (s = "scientific"), r = Gd(i, e);
    }
    const a = ve(Math.abs(r)), o = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), l = {
      notation: s,
      minimumFractionDigits: o,
      maximumFractionDigits: o
    };
    return Object.assign(l, this.options.ticks.format), Ji(i, n, l);
  },
  logarithmic(i, t, e) {
    if (i === 0)
      return "0";
    const n = e[t].significand || i / Math.pow(10, Math.floor(ve(i)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(n) || t > 0.8 * e.length ? Qo.numeric.call(this, i, t, e) : "";
  }
};
function Gd(i, t) {
  let e = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(e) >= 1 && i !== Math.floor(i) && (e = i - Math.floor(i)), e;
}
var Kn = {
  formatters: Qo
};
function Kd(i) {
  i.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, e) => e.lineWidth,
      tickColor: (t, e) => e.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Kn.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), i.route("scale.ticks", "color", "", "color"), i.route("scale.grid", "color", "", "borderColor"), i.route("scale.border", "color", "", "borderColor"), i.route("scale.title", "color", "", "color"), i.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), i.describe("scales", {
    _fallback: "scale"
  }), i.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const He = /* @__PURE__ */ Object.create(null), Es = /* @__PURE__ */ Object.create(null);
function $i(i, t) {
  if (!t)
    return i;
  const e = t.split(".");
  for (let n = 0, s = e.length; n < s; ++n) {
    const r = e[n];
    i = i[r] || (i[r] = /* @__PURE__ */ Object.create(null));
  }
  return i;
}
function ms(i, t, e) {
  return typeof t == "string" ? zi($i(i, t), e) : zi($i(i, ""), t);
}
class Zd {
  constructor(t, e) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (n) => n.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (n, s) => gs(s.backgroundColor), this.hoverBorderColor = (n, s) => gs(s.borderColor), this.hoverColor = (n, s) => gs(s.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(e);
  }
  set(t, e) {
    return ms(this, t, e);
  }
  get(t) {
    return $i(this, t);
  }
  describe(t, e) {
    return ms(Es, t, e);
  }
  override(t, e) {
    return ms(He, t, e);
  }
  route(t, e, n, s) {
    const r = $i(this, t), a = $i(this, n), o = "_" + e;
    Object.defineProperties(r, {
      [o]: {
        value: r[e],
        writable: !0
      },
      [e]: {
        enumerable: !0,
        get() {
          const l = this[o], c = a[s];
          return W(l) ? Object.assign({}, c, l) : N(l, c);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((e) => e(this));
  }
}
var st = /* @__PURE__ */ new Zd({
  _scriptable: (i) => !i.startsWith("on"),
  _indexable: (i) => i !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  qd,
  Xd,
  Kd
]);
function Jd(i) {
  return !i || B(i.size) || B(i.family) ? null : (i.style ? i.style + " " : "") + (i.weight ? i.weight + " " : "") + i.size + "px " + i.family;
}
function Bn(i, t, e, n, s) {
  let r = t[s];
  return r || (r = t[s] = i.measureText(s).width, e.push(s)), r > n && (n = r), n;
}
function th(i, t, e, n) {
  n = n || {};
  let s = n.data = n.data || {}, r = n.garbageCollect = n.garbageCollect || [];
  n.font !== t && (s = n.data = {}, r = n.garbageCollect = [], n.font = t), i.save(), i.font = t;
  let a = 0;
  const o = e.length;
  let l, c, d, h, u;
  for (l = 0; l < o; l++)
    if (h = e[l], h != null && !et(h))
      a = Bn(i, s, r, a, h);
    else if (et(h))
      for (c = 0, d = h.length; c < d; c++)
        u = h[c], u != null && !et(u) && (a = Bn(i, s, r, a, u));
  i.restore();
  const f = r.length / 2;
  if (f > e.length) {
    for (l = 0; l < f; l++)
      delete s[r[l]];
    r.splice(0, f);
  }
  return a;
}
function Me(i, t, e) {
  const n = i.currentDevicePixelRatio, s = e !== 0 ? Math.max(e / 2, 0.5) : 0;
  return Math.round((t - s) * n) / n + s;
}
function da(i, t) {
  !t && !i || (t = t || i.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, i.width, i.height), t.restore());
}
function Rs(i, t, e, n) {
  Go(i, t, e, n, null);
}
function Go(i, t, e, n, s) {
  let r, a, o, l, c, d, h, u;
  const f = t.pointStyle, g = t.rotation, m = t.radius;
  let v = (g || 0) * Ed;
  if (f && typeof f == "object" && (r = f.toString(), r === "[object HTMLImageElement]" || r === "[object HTMLCanvasElement]")) {
    i.save(), i.translate(e, n), i.rotate(v), i.drawImage(f, -f.width / 2, -f.height / 2, f.width, f.height), i.restore();
    return;
  }
  if (!(isNaN(m) || m <= 0)) {
    switch (i.beginPath(), f) {
      default:
        s ? i.ellipse(e, n, s / 2, m, 0, 0, it) : i.arc(e, n, m, 0, it), i.closePath();
        break;
      case "triangle":
        d = s ? s / 2 : m, i.moveTo(e + Math.sin(v) * d, n - Math.cos(v) * m), v += ia, i.lineTo(e + Math.sin(v) * d, n - Math.cos(v) * m), v += ia, i.lineTo(e + Math.sin(v) * d, n - Math.cos(v) * m), i.closePath();
        break;
      case "rectRounded":
        c = m * 0.516, l = m - c, a = Math.cos(v + Pe) * l, h = Math.cos(v + Pe) * (s ? s / 2 - c : l), o = Math.sin(v + Pe) * l, u = Math.sin(v + Pe) * (s ? s / 2 - c : l), i.arc(e - h, n - o, c, v - nt, v - ft), i.arc(e + u, n - a, c, v - ft, v), i.arc(e + h, n + o, c, v, v + ft), i.arc(e - u, n + a, c, v + ft, v + nt), i.closePath();
        break;
      case "rect":
        if (!g) {
          l = Math.SQRT1_2 * m, d = s ? s / 2 : l, i.rect(e - d, n - l, 2 * d, 2 * l);
          break;
        }
        v += Pe;
      case "rectRot":
        h = Math.cos(v) * (s ? s / 2 : m), a = Math.cos(v) * m, o = Math.sin(v) * m, u = Math.sin(v) * (s ? s / 2 : m), i.moveTo(e - h, n - o), i.lineTo(e + u, n - a), i.lineTo(e + h, n + o), i.lineTo(e - u, n + a), i.closePath();
        break;
      case "crossRot":
        v += Pe;
      case "cross":
        h = Math.cos(v) * (s ? s / 2 : m), a = Math.cos(v) * m, o = Math.sin(v) * m, u = Math.sin(v) * (s ? s / 2 : m), i.moveTo(e - h, n - o), i.lineTo(e + h, n + o), i.moveTo(e + u, n - a), i.lineTo(e - u, n + a);
        break;
      case "star":
        h = Math.cos(v) * (s ? s / 2 : m), a = Math.cos(v) * m, o = Math.sin(v) * m, u = Math.sin(v) * (s ? s / 2 : m), i.moveTo(e - h, n - o), i.lineTo(e + h, n + o), i.moveTo(e + u, n - a), i.lineTo(e - u, n + a), v += Pe, h = Math.cos(v) * (s ? s / 2 : m), a = Math.cos(v) * m, o = Math.sin(v) * m, u = Math.sin(v) * (s ? s / 2 : m), i.moveTo(e - h, n - o), i.lineTo(e + h, n + o), i.moveTo(e + u, n - a), i.lineTo(e - u, n + a);
        break;
      case "line":
        a = s ? s / 2 : Math.cos(v) * m, o = Math.sin(v) * m, i.moveTo(e - a, n - o), i.lineTo(e + a, n + o);
        break;
      case "dash":
        i.moveTo(e, n), i.lineTo(e + Math.cos(v) * (s ? s / 2 : m), n + Math.sin(v) * m);
        break;
      case !1:
        i.closePath();
        break;
    }
    i.fill(), t.borderWidth > 0 && i.stroke();
  }
}
function oe(i, t, e) {
  return e = e || 0.5, !t || i && i.x > t.left - e && i.x < t.right + e && i.y > t.top - e && i.y < t.bottom + e;
}
function Zn(i, t) {
  i.save(), i.beginPath(), i.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), i.clip();
}
function Jn(i) {
  i.restore();
}
function eh(i, t, e, n, s) {
  if (!t)
    return i.lineTo(e.x, e.y);
  if (s === "middle") {
    const r = (t.x + e.x) / 2;
    i.lineTo(r, t.y), i.lineTo(r, e.y);
  } else
    s === "after" != !!n ? i.lineTo(t.x, e.y) : i.lineTo(e.x, t.y);
  i.lineTo(e.x, e.y);
}
function ih(i, t, e, n) {
  if (!t)
    return i.lineTo(e.x, e.y);
  i.bezierCurveTo(n ? t.cp1x : t.cp2x, n ? t.cp1y : t.cp2y, n ? e.cp2x : e.cp1x, n ? e.cp2y : e.cp1y, e.x, e.y);
}
function nh(i, t) {
  t.translation && i.translate(t.translation[0], t.translation[1]), B(t.rotation) || i.rotate(t.rotation), t.color && (i.fillStyle = t.color), t.textAlign && (i.textAlign = t.textAlign), t.textBaseline && (i.textBaseline = t.textBaseline);
}
function sh(i, t, e, n, s) {
  if (s.strikethrough || s.underline) {
    const r = i.measureText(n), a = t - r.actualBoundingBoxLeft, o = t + r.actualBoundingBoxRight, l = e - r.actualBoundingBoxAscent, c = e + r.actualBoundingBoxDescent, d = s.strikethrough ? (l + c) / 2 : c;
    i.strokeStyle = i.fillStyle, i.beginPath(), i.lineWidth = s.decorationWidth || 2, i.moveTo(a, d), i.lineTo(o, d), i.stroke();
  }
}
function rh(i, t) {
  const e = i.fillStyle;
  i.fillStyle = t.color, i.fillRect(t.left, t.top, t.width, t.height), i.fillStyle = e;
}
function Be(i, t, e, n, s, r = {}) {
  const a = et(t) ? t : [
    t
  ], o = r.strokeWidth > 0 && r.strokeColor !== "";
  let l, c;
  for (i.save(), i.font = s.string, nh(i, r), l = 0; l < a.length; ++l)
    c = a[l], r.backdrop && rh(i, r.backdrop), o && (r.strokeColor && (i.strokeStyle = r.strokeColor), B(r.strokeWidth) || (i.lineWidth = r.strokeWidth), i.strokeText(c, e, n, r.maxWidth)), i.fillText(c, e, n, r.maxWidth), sh(i, e, n, c, r), n += Number(s.lineHeight);
  i.restore();
}
function Wi(i, t) {
  const { x: e, y: n, w: s, h: r, radius: a } = t;
  i.arc(e + a.topLeft, n + a.topLeft, a.topLeft, 1.5 * nt, nt, !0), i.lineTo(e, n + r - a.bottomLeft), i.arc(e + a.bottomLeft, n + r - a.bottomLeft, a.bottomLeft, nt, ft, !0), i.lineTo(e + s - a.bottomRight, n + r), i.arc(e + s - a.bottomRight, n + r - a.bottomRight, a.bottomRight, ft, 0, !0), i.lineTo(e + s, n + a.topRight), i.arc(e + s - a.topRight, n + a.topRight, a.topRight, 0, -ft, !0), i.lineTo(e + a.topLeft, n);
}
const ah = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, oh = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function lh(i, t) {
  const e = ("" + i).match(ah);
  if (!e || e[1] === "normal")
    return t * 1.2;
  switch (i = +e[2], e[3]) {
    case "px":
      return i;
    case "%":
      i /= 100;
      break;
  }
  return t * i;
}
const ch = (i) => +i || 0;
function gr(i, t) {
  const e = {}, n = W(t), s = n ? Object.keys(t) : t, r = W(i) ? n ? (a) => N(i[a], i[t[a]]) : (a) => i[a] : () => i;
  for (const a of s)
    e[a] = ch(r(a));
  return e;
}
function Ko(i) {
  return gr(i, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Fe(i) {
  return gr(i, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function St(i) {
  const t = Ko(i);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function vt(i, t) {
  i = i || {}, t = t || st.font;
  let e = N(i.size, t.size);
  typeof e == "string" && (e = parseInt(e, 10));
  let n = N(i.style, t.style);
  n && !("" + n).match(oh) && (console.warn('Invalid font style specified: "' + n + '"'), n = void 0);
  const s = {
    family: N(i.family, t.family),
    lineHeight: lh(N(i.lineHeight, t.lineHeight), e),
    size: e,
    style: n,
    weight: N(i.weight, t.weight),
    string: ""
  };
  return s.string = Jd(s), s;
}
function vi(i, t, e, n) {
  let s = !0, r, a, o;
  for (r = 0, a = i.length; r < a; ++r)
    if (o = i[r], o !== void 0 && (t !== void 0 && typeof o == "function" && (o = o(t), s = !1), e !== void 0 && et(o) && (o = o[e % o.length], s = !1), o !== void 0))
      return n && !s && (n.cacheable = !1), o;
}
function dh(i, t, e) {
  const { min: n, max: s } = i, r = zo(t, (s - n) / 2), a = (o, l) => e && o === 0 ? 0 : o + l;
  return {
    min: a(n, -Math.abs(r)),
    max: a(s, r)
  };
}
function ke(i, t) {
  return Object.assign(Object.create(i), t);
}
function mr(i, t = [
  ""
], e, n, s = () => i[0]) {
  const r = e || i;
  typeof n == "undefined" && (n = el("_fallback", i));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: i,
    _rootScopes: r,
    _fallback: n,
    _getTarget: s,
    override: (o) => mr([
      o,
      ...i
    ], t, r, n)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, l) {
      return delete o[l], delete o._keys, delete i[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, l) {
      return Jo(o, l, () => bh(l, t, i, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, l) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(i[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(o, l) {
      return ua(o).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(o) {
      return ua(o);
    },
    /**
    * A trap for setting property values.
    */
    set(o, l, c) {
      const d = o._storage || (o._storage = s());
      return o[l] = d[l] = c, delete o._keys, !0;
    }
  });
}
function ni(i, t, e, n) {
  const s = {
    _cacheable: !1,
    _proxy: i,
    _context: t,
    _subProxy: e,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: Zo(i, n),
    setContext: (r) => ni(i, r, e, n),
    override: (r) => ni(i.override(r), t, e, n)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(r, a) {
      return delete r[a], delete i[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(r, a, o) {
      return Jo(r, a, () => uh(r, a, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(r, a) {
      return r._descriptors.allKeys ? Reflect.has(i, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(i, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(i);
    },
    /**
    * A trap for the in operator.
    */
    has(r, a) {
      return Reflect.has(i, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(i);
    },
    /**
    * A trap for setting property values.
    */
    set(r, a, o) {
      return i[a] = o, delete r[a], !0;
    }
  });
}
function Zo(i, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: e = t.scriptable, _indexable: n = t.indexable, _allKeys: s = t.allKeys } = i;
  return {
    allKeys: s,
    scriptable: e,
    indexable: n,
    isScriptable: _e(e) ? e : () => e,
    isIndexable: _e(n) ? n : () => n
  };
}
const hh = (i, t) => i ? i + dr(t) : t, vr = (i, t) => W(t) && i !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function Jo(i, t, e) {
  if (Object.prototype.hasOwnProperty.call(i, t) || t === "constructor")
    return i[t];
  const n = e();
  return i[t] = n, n;
}
function uh(i, t, e) {
  const { _proxy: n, _context: s, _subProxy: r, _descriptors: a } = i;
  let o = n[t];
  return _e(o) && a.isScriptable(t) && (o = fh(t, o, i, e)), et(o) && o.length && (o = ph(t, o, i, a.isIndexable)), vr(t, o) && (o = ni(o, s, r && r[t], a)), o;
}
function fh(i, t, e, n) {
  const { _proxy: s, _context: r, _subProxy: a, _stack: o } = e;
  if (o.has(i))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + i);
  o.add(i);
  let l = t(r, a || n);
  return o.delete(i), vr(i, l) && (l = br(s._scopes, s, i, l)), l;
}
function ph(i, t, e, n) {
  const { _proxy: s, _context: r, _subProxy: a, _descriptors: o } = e;
  if (typeof r.index != "undefined" && n(i))
    return t[r.index % t.length];
  if (W(t[0])) {
    const l = t, c = s._scopes.filter((d) => d !== l);
    t = [];
    for (const d of l) {
      const h = br(c, s, i, d);
      t.push(ni(h, r, a && a[i], o));
    }
  }
  return t;
}
function tl(i, t, e) {
  return _e(i) ? i(t, e) : i;
}
const gh = (i, t) => i === !0 ? t : typeof i == "string" ? we(t, i) : void 0;
function mh(i, t, e, n, s) {
  for (const r of t) {
    const a = gh(e, r);
    if (a) {
      i.add(a);
      const o = tl(a._fallback, e, s);
      if (typeof o != "undefined" && o !== e && o !== n)
        return o;
    } else if (a === !1 && typeof n != "undefined" && e !== n)
      return null;
  }
  return !1;
}
function br(i, t, e, n) {
  const s = t._rootScopes, r = tl(t._fallback, e, n), a = [
    ...i,
    ...s
  ], o = /* @__PURE__ */ new Set();
  o.add(n);
  let l = ha(o, a, e, r || e, n);
  return l === null || typeof r != "undefined" && r !== e && (l = ha(o, a, r, l, n), l === null) ? !1 : mr(Array.from(o), [
    ""
  ], s, r, () => vh(t, e, n));
}
function ha(i, t, e, n, s) {
  for (; e; )
    e = mh(i, t, e, n, s);
  return e;
}
function vh(i, t, e) {
  const n = i._getTarget();
  t in n || (n[t] = {});
  const s = n[t];
  return et(s) && W(e) ? e : s || {};
}
function bh(i, t, e, n) {
  let s;
  for (const r of t)
    if (s = el(hh(r, i), e), typeof s != "undefined")
      return vr(i, s) ? br(e, n, i, s) : s;
}
function el(i, t) {
  for (const e of t) {
    if (!e)
      continue;
    const n = e[i];
    if (typeof n != "undefined")
      return n;
  }
}
function ua(i) {
  let t = i._keys;
  return t || (t = i._keys = yh(i._scopes)), t;
}
function yh(i) {
  const t = /* @__PURE__ */ new Set();
  for (const e of i)
    for (const n of Object.keys(e).filter((s) => !s.startsWith("_")))
      t.add(n);
  return Array.from(t);
}
function il(i, t, e, n) {
  const { iScale: s } = i, { key: r = "r" } = this._parsing, a = new Array(n);
  let o, l, c, d;
  for (o = 0, l = n; o < l; ++o)
    c = o + e, d = t[c], a[o] = {
      r: s.parse(we(d, r), c)
    };
  return a;
}
const xh = Number.EPSILON || 1e-14, si = (i, t) => t < i.length && !i[t].skip && i[t], nl = (i) => i === "x" ? "y" : "x";
function wh(i, t, e, n) {
  const s = i.skip ? t : i, r = t, a = e.skip ? t : e, o = Is(r, s), l = Is(a, r);
  let c = o / (o + l), d = l / (o + l);
  c = isNaN(c) ? 0 : c, d = isNaN(d) ? 0 : d;
  const h = n * c, u = n * d;
  return {
    previous: {
      x: r.x - h * (a.x - s.x),
      y: r.y - h * (a.y - s.y)
    },
    next: {
      x: r.x + u * (a.x - s.x),
      y: r.y + u * (a.y - s.y)
    }
  };
}
function _h(i, t, e) {
  const n = i.length;
  let s, r, a, o, l, c = si(i, 0);
  for (let d = 0; d < n - 1; ++d)
    if (l = c, c = si(i, d + 1), !(!l || !c)) {
      if (Di(t[d], 0, xh)) {
        e[d] = e[d + 1] = 0;
        continue;
      }
      s = e[d] / t[d], r = e[d + 1] / t[d], o = Math.pow(s, 2) + Math.pow(r, 2), !(o <= 9) && (a = 3 / Math.sqrt(o), e[d] = s * a * t[d], e[d + 1] = r * a * t[d]);
    }
}
function kh(i, t, e = "x") {
  const n = nl(e), s = i.length;
  let r, a, o, l = si(i, 0);
  for (let c = 0; c < s; ++c) {
    if (a = o, o = l, l = si(i, c + 1), !o)
      continue;
    const d = o[e], h = o[n];
    a && (r = (d - a[e]) / 3, o[`cp1${e}`] = d - r, o[`cp1${n}`] = h - r * t[c]), l && (r = (l[e] - d) / 3, o[`cp2${e}`] = d + r, o[`cp2${n}`] = h + r * t[c]);
  }
}
function Dh(i, t = "x") {
  const e = nl(t), n = i.length, s = Array(n).fill(0), r = Array(n);
  let a, o, l, c = si(i, 0);
  for (a = 0; a < n; ++a)
    if (o = l, l = c, c = si(i, a + 1), !!l) {
      if (c) {
        const d = c[t] - l[t];
        s[a] = d !== 0 ? (c[e] - l[e]) / d : 0;
      }
      r[a] = o ? c ? Kt(s[a - 1]) !== Kt(s[a]) ? 0 : (s[a - 1] + s[a]) / 2 : s[a - 1] : s[a];
    }
  _h(i, s, r), kh(i, r, t);
}
function un(i, t, e) {
  return Math.max(Math.min(i, e), t);
}
function Ch(i, t) {
  let e, n, s, r, a, o = oe(i[0], t);
  for (e = 0, n = i.length; e < n; ++e)
    a = r, r = o, o = e < n - 1 && oe(i[e + 1], t), r && (s = i[e], a && (s.cp1x = un(s.cp1x, t.left, t.right), s.cp1y = un(s.cp1y, t.top, t.bottom)), o && (s.cp2x = un(s.cp2x, t.left, t.right), s.cp2y = un(s.cp2y, t.top, t.bottom)));
}
function $h(i, t, e, n, s) {
  let r, a, o, l;
  if (t.spanGaps && (i = i.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    Dh(i, s);
  else {
    let c = n ? i[i.length - 1] : i[0];
    for (r = 0, a = i.length; r < a; ++r)
      o = i[r], l = wh(c, o, i[Math.min(r + 1, a - (n ? 0 : 1)) % a], t.tension), o.cp1x = l.previous.x, o.cp1y = l.previous.y, o.cp2x = l.next.x, o.cp2y = l.next.y, c = o;
  }
  t.capBezierPoints && Ch(i, e);
}
function yr() {
  return typeof window != "undefined" && typeof document != "undefined";
}
function xr(i) {
  let t = i.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function Wn(i, t, e) {
  let n;
  return typeof i == "string" ? (n = parseInt(i, 10), i.indexOf("%") !== -1 && (n = n / 100 * t.parentNode[e])) : n = i, n;
}
const ts = (i) => i.ownerDocument.defaultView.getComputedStyle(i, null);
function Ph(i, t) {
  return ts(i).getPropertyValue(t);
}
const Mh = [
  "top",
  "right",
  "bottom",
  "left"
];
function Le(i, t, e) {
  const n = {};
  e = e ? "-" + e : "";
  for (let s = 0; s < 4; s++) {
    const r = Mh[s];
    n[r] = parseFloat(i[t + "-" + r + e]) || 0;
  }
  return n.width = n.left + n.right, n.height = n.top + n.bottom, n;
}
const Sh = (i, t, e) => (i > 0 || t > 0) && (!e || !e.shadowRoot);
function Th(i, t) {
  const e = i.touches, n = e && e.length ? e[0] : i, { offsetX: s, offsetY: r } = n;
  let a = !1, o, l;
  if (Sh(s, r, i.target))
    o = s, l = r;
  else {
    const c = t.getBoundingClientRect();
    o = n.clientX - c.left, l = n.clientY - c.top, a = !0;
  }
  return {
    x: o,
    y: l,
    box: a
  };
}
function Oe(i, t) {
  if ("native" in i)
    return i;
  const { canvas: e, currentDevicePixelRatio: n } = t, s = ts(e), r = s.boxSizing === "border-box", a = Le(s, "padding"), o = Le(s, "border", "width"), { x: l, y: c, box: d } = Th(i, e), h = a.left + (d && o.left), u = a.top + (d && o.top);
  let { width: f, height: g } = t;
  return r && (f -= a.width + o.width, g -= a.height + o.height), {
    x: Math.round((l - h) / f * e.width / n),
    y: Math.round((c - u) / g * e.height / n)
  };
}
function Oh(i, t, e) {
  let n, s;
  if (t === void 0 || e === void 0) {
    const r = i && xr(i);
    if (!r)
      t = i.clientWidth, e = i.clientHeight;
    else {
      const a = r.getBoundingClientRect(), o = ts(r), l = Le(o, "border", "width"), c = Le(o, "padding");
      t = a.width - c.width - l.width, e = a.height - c.height - l.height, n = Wn(o.maxWidth, r, "clientWidth"), s = Wn(o.maxHeight, r, "clientHeight");
    }
  }
  return {
    width: t,
    height: e,
    maxWidth: n || Hn,
    maxHeight: s || Hn
  };
}
const fn = (i) => Math.round(i * 10) / 10;
function Ah(i, t, e, n) {
  const s = ts(i), r = Le(s, "margin"), a = Wn(s.maxWidth, i, "clientWidth") || Hn, o = Wn(s.maxHeight, i, "clientHeight") || Hn, l = Oh(i, t, e);
  let { width: c, height: d } = l;
  if (s.boxSizing === "content-box") {
    const u = Le(s, "border", "width"), f = Le(s, "padding");
    c -= f.width + u.width, d -= f.height + u.height;
  }
  return c = Math.max(0, c - r.width), d = Math.max(0, n ? c / n : d - r.height), c = fn(Math.min(c, a, l.maxWidth)), d = fn(Math.min(d, o, l.maxHeight)), c && !d && (d = fn(c / 2)), (t !== void 0 || e !== void 0) && n && l.height && d > l.height && (d = l.height, c = fn(Math.floor(d * n))), {
    width: c,
    height: d
  };
}
function fa(i, t, e) {
  const n = t || 1, s = Math.floor(i.height * n), r = Math.floor(i.width * n);
  i.height = Math.floor(i.height), i.width = Math.floor(i.width);
  const a = i.canvas;
  return a.style && (e || !a.style.height && !a.style.width) && (a.style.height = `${i.height}px`, a.style.width = `${i.width}px`), i.currentDevicePixelRatio !== n || a.height !== s || a.width !== r ? (i.currentDevicePixelRatio = n, a.height = s, a.width = r, i.ctx.setTransform(n, 0, 0, n, 0, 0), !0) : !1;
}
const Ih = function() {
  let i = !1;
  try {
    const t = {
      get passive() {
        return i = !0, !1;
      }
    };
    yr() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch (t) {
  }
  return i;
}();
function pa(i, t) {
  const e = Ph(i, t), n = e && e.match(/^(\d+)(\.\d+)?px$/);
  return n ? +n[1] : void 0;
}
function Ae(i, t, e, n) {
  return {
    x: i.x + e * (t.x - i.x),
    y: i.y + e * (t.y - i.y)
  };
}
function Eh(i, t, e, n) {
  return {
    x: i.x + e * (t.x - i.x),
    y: n === "middle" ? e < 0.5 ? i.y : t.y : n === "after" ? e < 1 ? i.y : t.y : e > 0 ? t.y : i.y
  };
}
function Rh(i, t, e, n) {
  const s = {
    x: i.cp2x,
    y: i.cp2y
  }, r = {
    x: t.cp1x,
    y: t.cp1y
  }, a = Ae(i, s, e), o = Ae(s, r, e), l = Ae(r, t, e), c = Ae(a, o, e), d = Ae(o, l, e);
  return Ae(c, d, e);
}
const Fh = function(i, t) {
  return {
    x(e) {
      return i + i + t - e;
    },
    setWidth(e) {
      t = e;
    },
    textAlign(e) {
      return e === "center" ? e : e === "right" ? "left" : "right";
    },
    xPlus(e, n) {
      return e - n;
    },
    leftForLtr(e, n) {
      return e - n;
    }
  };
}, Lh = function() {
  return {
    x(i) {
      return i;
    },
    setWidth(i) {
    },
    textAlign(i) {
      return i;
    },
    xPlus(i, t) {
      return i + t;
    },
    leftForLtr(i, t) {
      return i;
    }
  };
};
function Ze(i, t, e) {
  return i ? Fh(t, e) : Lh();
}
function sl(i, t) {
  let e, n;
  (t === "ltr" || t === "rtl") && (e = i.canvas.style, n = [
    e.getPropertyValue("direction"),
    e.getPropertyPriority("direction")
  ], e.setProperty("direction", t, "important"), i.prevTextDirection = n);
}
function rl(i, t) {
  t !== void 0 && (delete i.prevTextDirection, i.canvas.style.setProperty("direction", t[0], t[1]));
}
function al(i) {
  return i === "angle" ? {
    between: Bi,
    compare: Nd,
    normalize: Ft
  } : {
    between: re,
    compare: (t, e) => t - e,
    normalize: (t) => t
  };
}
function ga({ start: i, end: t, count: e, loop: n, style: s }) {
  return {
    start: i % e,
    end: t % e,
    loop: n && (t - i + 1) % e === 0,
    style: s
  };
}
function Nh(i, t, e) {
  const { property: n, start: s, end: r } = e, { between: a, normalize: o } = al(n), l = t.length;
  let { start: c, end: d, loop: h } = i, u, f;
  if (h) {
    for (c += l, d += l, u = 0, f = l; u < f && a(o(t[c % l][n]), s, r); ++u)
      c--, d--;
    c %= l, d %= l;
  }
  return d < c && (d += l), {
    start: c,
    end: d,
    loop: h,
    style: i.style
  };
}
function ol(i, t, e) {
  if (!e)
    return [
      i
    ];
  const { property: n, start: s, end: r } = e, a = t.length, { compare: o, between: l, normalize: c } = al(n), { start: d, end: h, loop: u, style: f } = Nh(i, t, e), g = [];
  let m = !1, v = null, b, x, w;
  const k = () => l(s, w, b) && o(s, w) !== 0, _ = () => o(r, b) === 0 || l(r, w, b), D = () => m || k(), C = () => !m || _();
  for (let $ = d, T = d; $ <= h; ++$)
    x = t[$ % a], !x.skip && (b = c(x[n]), b !== w && (m = l(b, s, r), v === null && D() && (v = o(b, s) === 0 ? $ : T), v !== null && C() && (g.push(ga({
      start: v,
      end: $,
      loop: u,
      count: a,
      style: f
    })), v = null), T = $, w = b));
  return v !== null && g.push(ga({
    start: v,
    end: h,
    loop: u,
    count: a,
    style: f
  })), g;
}
function ll(i, t) {
  const e = [], n = i.segments;
  for (let s = 0; s < n.length; s++) {
    const r = ol(n[s], i.points, t);
    r.length && e.push(...r);
  }
  return e;
}
function zh(i, t, e, n) {
  let s = 0, r = t - 1;
  if (e && !n)
    for (; s < t && !i[s].skip; )
      s++;
  for (; s < t && i[s].skip; )
    s++;
  for (s %= t, e && (r += s); r > s && i[r % t].skip; )
    r--;
  return r %= t, {
    start: s,
    end: r
  };
}
function Hh(i, t, e, n) {
  const s = i.length, r = [];
  let a = t, o = i[t], l;
  for (l = t + 1; l <= e; ++l) {
    const c = i[l % s];
    c.skip || c.stop ? o.skip || (n = !1, r.push({
      start: t % s,
      end: (l - 1) % s,
      loop: n
    }), t = a = c.stop ? l : null) : (a = l, o.skip && (t = l)), o = c;
  }
  return a !== null && r.push({
    start: t % s,
    end: a % s,
    loop: n
  }), r;
}
function Bh(i, t) {
  const e = i.points, n = i.options.spanGaps, s = e.length;
  if (!s)
    return [];
  const r = !!i._loop, { start: a, end: o } = zh(e, s, r, n);
  if (n === !0)
    return ma(i, [
      {
        start: a,
        end: o,
        loop: r
      }
    ], e, t);
  const l = o < a ? o + s : o, c = !!i._fullLoop && a === 0 && o === s - 1;
  return ma(i, Hh(e, a, l, c), e, t);
}
function ma(i, t, e, n) {
  return !n || !n.setContext || !e ? t : Wh(i, t, e, n);
}
function Wh(i, t, e, n) {
  const s = i._chart.getContext(), r = va(i.options), { _datasetIndex: a, options: { spanGaps: o } } = i, l = e.length, c = [];
  let d = r, h = t[0].start, u = h;
  function f(g, m, v, b) {
    const x = o ? -1 : 1;
    if (g !== m) {
      for (g += l; e[g % l].skip; )
        g -= x;
      for (; e[m % l].skip; )
        m += x;
      g % l !== m % l && (c.push({
        start: g % l,
        end: m % l,
        loop: v,
        style: b
      }), d = b, h = m % l);
    }
  }
  for (const g of t) {
    h = o ? h : g.start;
    let m = e[h % l], v;
    for (u = h + 1; u <= g.end; u++) {
      const b = e[u % l];
      v = va(n.setContext(ke(s, {
        type: "segment",
        p0: m,
        p1: b,
        p0DataIndex: (u - 1) % l,
        p1DataIndex: u % l,
        datasetIndex: a
      }))), Uh(v, d) && f(h, u - 1, g.loop, d), m = b, d = v;
    }
    h < u - 1 && f(h, u - 1, g.loop, d);
  }
  return c;
}
function va(i) {
  return {
    backgroundColor: i.backgroundColor,
    borderCapStyle: i.borderCapStyle,
    borderDash: i.borderDash,
    borderDashOffset: i.borderDashOffset,
    borderJoinStyle: i.borderJoinStyle,
    borderWidth: i.borderWidth,
    borderColor: i.borderColor
  };
}
function Uh(i, t) {
  if (!t)
    return !1;
  const e = [], n = function(s, r) {
    return pr(r) ? (e.includes(r) || e.push(r), e.indexOf(r)) : r;
  };
  return JSON.stringify(i, n) !== JSON.stringify(t, n);
}
/*!
 * Chart.js v4.4.8
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class jh {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, n, s) {
    const r = e.listeners[s], a = e.duration;
    r.forEach((o) => o({
      chart: t,
      initial: e.initial,
      numSteps: a,
      currentStep: Math.min(n - e.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Vo.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((n, s) => {
      if (!n.running || !n.items.length)
        return;
      const r = n.items;
      let a = r.length - 1, o = !1, l;
      for (; a >= 0; --a)
        l = r[a], l._active ? (l._total > n.duration && (n.duration = l._total), l.tick(t), o = !0) : (r[a] = r[r.length - 1], r.pop());
      o && (s.draw(), this._notify(s, n, t, "progress")), r.length || (n.running = !1, this._notify(s, n, t, "complete"), n.initial = !1), e += r.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let n = e.get(t);
    return n || (n = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, n)), n;
  }
  listen(t, e, n) {
    this._getAnims(t).listeners[e].push(n);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((n, s) => Math.max(n, s._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const n = e.items;
    let s = n.length - 1;
    for (; s >= 0; --s)
      n[s].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var ie = /* @__PURE__ */ new jh();
const ba = "transparent", Vh = {
  boolean(i, t, e) {
    return e > 0.5 ? t : i;
  },
  color(i, t, e) {
    const n = la(i || ba), s = n.valid && la(t || ba);
    return s && s.valid ? s.mix(n, e).hexString() : t;
  },
  number(i, t, e) {
    return i + (t - i) * e;
  }
};
class Yh {
  constructor(t, e, n, s) {
    const r = e[n];
    s = vi([
      t.to,
      s,
      r,
      t.from
    ]);
    const a = vi([
      t.from,
      r,
      s
    ]);
    this._active = !0, this._fn = t.fn || Vh[t.type || typeof a], this._easing = Ci[t.easing] || Ci.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = n, this._from = a, this._to = s, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, n) {
    if (this._active) {
      this._notify(!1);
      const s = this._target[this._prop], r = n - this._start, a = this._duration - r;
      this._start = n, this._duration = Math.floor(Math.max(a, t.duration)), this._total += r, this._loop = !!t.loop, this._to = vi([
        t.to,
        e,
        s,
        t.from
      ]), this._from = vi([
        t.from,
        s,
        e
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, n = this._duration, s = this._prop, r = this._from, a = this._loop, o = this._to;
    let l;
    if (this._active = r !== o && (a || e < n), !this._active) {
      this._target[s] = o, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[s] = r;
      return;
    }
    l = e / n % 2, l = a && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[s] = this._fn(r, o, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, n) => {
      t.push({
        res: e,
        rej: n
      });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", n = this._promises || [];
    for (let s = 0; s < n.length; s++)
      n[s][e]();
  }
}
class cl {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!W(t))
      return;
    const e = Object.keys(st.animation), n = this._properties;
    Object.getOwnPropertyNames(t).forEach((s) => {
      const r = t[s];
      if (!W(r))
        return;
      const a = {};
      for (const o of e)
        a[o] = r[o];
      (et(r.properties) && r.properties || [
        s
      ]).forEach((o) => {
        (o === s || !n.has(o)) && n.set(o, a);
      });
    });
  }
  _animateOptions(t, e) {
    const n = e.options, s = Xh(t, n);
    if (!s)
      return [];
    const r = this._createAnimations(s, n);
    return n.$shared && qh(t.options.$animations, n).then(() => {
      t.options = n;
    }, () => {
    }), r;
  }
  _createAnimations(t, e) {
    const n = this._properties, s = [], r = t.$animations || (t.$animations = {}), a = Object.keys(e), o = Date.now();
    let l;
    for (l = a.length - 1; l >= 0; --l) {
      const c = a[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        s.push(...this._animateOptions(t, e));
        continue;
      }
      const d = e[c];
      let h = r[c];
      const u = n.get(c);
      if (h)
        if (u && h.active()) {
          h.update(u, d, o);
          continue;
        } else
          h.cancel();
      if (!u || !u.duration) {
        t[c] = d;
        continue;
      }
      r[c] = h = new Yh(u, t, c, d), s.push(h);
    }
    return s;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const n = this._createAnimations(t, e);
    if (n.length)
      return ie.add(this._chart, n), !0;
  }
}
function qh(i, t) {
  const e = [], n = Object.keys(t);
  for (let s = 0; s < n.length; s++) {
    const r = i[n[s]];
    r && r.active() && e.push(r.wait());
  }
  return Promise.all(e);
}
function Xh(i, t) {
  if (!t)
    return;
  let e = i.options;
  if (!e) {
    i.options = t;
    return;
  }
  return e.$shared && (i.options = e = Object.assign({}, e, {
    $shared: !1,
    $animations: {}
  })), e;
}
function ya(i, t) {
  const e = i && i.options || {}, n = e.reverse, s = e.min === void 0 ? t : 0, r = e.max === void 0 ? t : 0;
  return {
    start: n ? r : s,
    end: n ? s : r
  };
}
function Qh(i, t, e) {
  if (e === !1)
    return !1;
  const n = ya(i, e), s = ya(t, e);
  return {
    top: s.end,
    right: n.end,
    bottom: s.start,
    left: n.start
  };
}
function Gh(i) {
  let t, e, n, s;
  return W(i) ? (t = i.top, e = i.right, n = i.bottom, s = i.left) : t = e = n = s = i, {
    top: t,
    right: e,
    bottom: n,
    left: s,
    disabled: i === !1
  };
}
function dl(i, t) {
  const e = [], n = i._getSortedDatasetMetas(t);
  let s, r;
  for (s = 0, r = n.length; s < r; ++s)
    e.push(n[s].index);
  return e;
}
function xa(i, t, e, n = {}) {
  const s = i.keys, r = n.mode === "single";
  let a, o, l, c;
  if (t === null)
    return;
  let d = !1;
  for (a = 0, o = s.length; a < o; ++a) {
    if (l = +s[a], l === e) {
      if (d = !0, n.all)
        continue;
      break;
    }
    c = i.values[l], ht(c) && (r || t === 0 || Kt(t) === Kt(c)) && (t += c);
  }
  return !d && !n.all ? 0 : t;
}
function Kh(i, t) {
  const { iScale: e, vScale: n } = t, s = e.axis === "x" ? "x" : "y", r = n.axis === "x" ? "x" : "y", a = Object.keys(i), o = new Array(a.length);
  let l, c, d;
  for (l = 0, c = a.length; l < c; ++l)
    d = a[l], o[l] = {
      [s]: d,
      [r]: i[d]
    };
  return o;
}
function vs(i, t) {
  const e = i && i.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function Zh(i, t, e) {
  return `${i.id}.${t.id}.${e.stack || e.type}`;
}
function Jh(i) {
  const { min: t, max: e, minDefined: n, maxDefined: s } = i.getUserBounds();
  return {
    min: n ? t : Number.NEGATIVE_INFINITY,
    max: s ? e : Number.POSITIVE_INFINITY
  };
}
function tu(i, t, e) {
  const n = i[t] || (i[t] = {});
  return n[e] || (n[e] = {});
}
function wa(i, t, e, n) {
  for (const s of t.getMatchingVisibleMetas(n).reverse()) {
    const r = i[s.index];
    if (e && r > 0 || !e && r < 0)
      return s.index;
  }
  return null;
}
function _a(i, t) {
  const { chart: e, _cachedMeta: n } = i, s = e._stacks || (e._stacks = {}), { iScale: r, vScale: a, index: o } = n, l = r.axis, c = a.axis, d = Zh(r, a, n), h = t.length;
  let u;
  for (let f = 0; f < h; ++f) {
    const g = t[f], { [l]: m, [c]: v } = g, b = g._stacks || (g._stacks = {});
    u = b[c] = tu(s, d, m), u[o] = v, u._top = wa(u, a, !0, n.type), u._bottom = wa(u, a, !1, n.type);
    const x = u._visualValues || (u._visualValues = {});
    x[o] = v;
  }
}
function bs(i, t) {
  const e = i.scales;
  return Object.keys(e).filter((n) => e[n].axis === t).shift();
}
function eu(i, t) {
  return ke(i, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function iu(i, t, e) {
  return ke(i, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function li(i, t) {
  const e = i.controller.index, n = i.vScale && i.vScale.axis;
  if (n) {
    t = t || i._parsed;
    for (const s of t) {
      const r = s._stacks;
      if (!r || r[n] === void 0 || r[n][e] === void 0)
        return;
      delete r[n][e], r[n]._visualValues !== void 0 && r[n]._visualValues[e] !== void 0 && delete r[n]._visualValues[e];
    }
  }
}
const ys = (i) => i === "reset" || i === "none", ka = (i, t) => t ? i : Object.assign({}, i), nu = (i, t, e) => i && !t.hidden && t._stacked && {
  keys: dl(e, !0),
  values: null
};
class jt {
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = vs(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && li(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, n = this.getDataset(), s = (h, u, f, g) => h === "x" ? u : h === "r" ? g : f, r = e.xAxisID = N(n.xAxisID, bs(t, "x")), a = e.yAxisID = N(n.yAxisID, bs(t, "y")), o = e.rAxisID = N(n.rAxisID, bs(t, "r")), l = e.indexAxis, c = e.iAxisID = s(l, r, a, o), d = e.vAxisID = s(l, a, r, o);
    e.xScale = this.getScaleForId(r), e.yScale = this.getScaleForId(a), e.rScale = this.getScaleForId(o), e.iScale = this.getScaleForId(c), e.vScale = this.getScaleForId(d);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && ra(this._data, this), t._stacked && li(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), n = this._data;
    if (W(e)) {
      const s = this._cachedMeta;
      this._data = Kh(e, s);
    } else if (n !== e) {
      if (n) {
        ra(n, this);
        const s = this._cachedMeta;
        li(s), s._parsed = [];
      }
      e && Object.isExtensible(e) && Wd(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, n = this.getDataset();
    let s = !1;
    this._dataCheck();
    const r = e._stacked;
    e._stacked = vs(e.vScale, e), e.stack !== n.stack && (s = !0, li(e), e.stack = n.stack), this._resyncElements(t), (s || r !== e._stacked) && (_a(this, e._parsed), e._stacked = vs(e.vScale, e));
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), n = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(n, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: n, _data: s } = this, { iScale: r, _stacked: a } = n, o = r.axis;
    let l = t === 0 && e === s.length ? !0 : n._sorted, c = t > 0 && n._parsed[t - 1], d, h, u;
    if (this._parsing === !1)
      n._parsed = s, n._sorted = !0, u = s;
    else {
      et(s[t]) ? u = this.parseArrayData(n, s, t, e) : W(s[t]) ? u = this.parseObjectData(n, s, t, e) : u = this.parsePrimitiveData(n, s, t, e);
      const f = () => h[o] === null || c && h[o] < c[o];
      for (d = 0; d < e; ++d)
        n._parsed[d + t] = h = u[d], l && (f() && (l = !1), c = h);
      n._sorted = l;
    }
    a && _a(this, u);
  }
  parsePrimitiveData(t, e, n, s) {
    const { iScale: r, vScale: a } = t, o = r.axis, l = a.axis, c = r.getLabels(), d = r === a, h = new Array(s);
    let u, f, g;
    for (u = 0, f = s; u < f; ++u)
      g = u + n, h[u] = {
        [o]: d || r.parse(c[g], g),
        [l]: a.parse(e[g], g)
      };
    return h;
  }
  parseArrayData(t, e, n, s) {
    const { xScale: r, yScale: a } = t, o = new Array(s);
    let l, c, d, h;
    for (l = 0, c = s; l < c; ++l)
      d = l + n, h = e[d], o[l] = {
        x: r.parse(h[0], d),
        y: a.parse(h[1], d)
      };
    return o;
  }
  parseObjectData(t, e, n, s) {
    const { xScale: r, yScale: a } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(s);
    let d, h, u, f;
    for (d = 0, h = s; d < h; ++d)
      u = d + n, f = e[u], c[d] = {
        x: r.parse(we(f, o), u),
        y: a.parse(we(f, l), u)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, n) {
    const s = this.chart, r = this._cachedMeta, a = e[t.axis], o = {
      keys: dl(s, !0),
      values: e._stacks[t.axis]._visualValues
    };
    return xa(o, a, r.index, {
      mode: n
    });
  }
  updateRangeFromParsed(t, e, n, s) {
    const r = n[e.axis];
    let a = r === null ? NaN : r;
    const o = s && n._stacks[e.axis];
    s && o && (s.values = o, a = xa(s, r, this._cachedMeta.index)), t.min = Math.min(t.min, a), t.max = Math.max(t.max, a);
  }
  getMinMax(t, e) {
    const n = this._cachedMeta, s = n._parsed, r = n._sorted && t === n.iScale, a = s.length, o = this._getOtherScale(t), l = nu(e, n, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: d, max: h } = Jh(o);
    let u, f;
    function g() {
      f = s[u];
      const m = f[o.axis];
      return !ht(f[t.axis]) || d > m || h < m;
    }
    for (u = 0; u < a && !(!g() && (this.updateRangeFromParsed(c, t, f, l), r)); ++u)
      ;
    if (r) {
      for (u = a - 1; u >= 0; --u)
        if (!g()) {
          this.updateRangeFromParsed(c, t, f, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, n = [];
    let s, r, a;
    for (s = 0, r = e.length; s < r; ++s)
      a = e[s][t.axis], ht(a) && n.push(a);
    return n;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = e.iScale, s = e.vScale, r = this.getParsed(t);
    return {
      label: n ? "" + n.getLabelForValue(r[n.axis]) : "",
      value: s ? "" + s.getLabelForValue(r[s.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = Gh(N(this.options.clip, Qh(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, n = this._cachedMeta, s = n.data || [], r = e.chartArea, a = [], o = this._drawStart || 0, l = this._drawCount || s.length - o, c = this.options.drawActiveElementsOnTop;
    let d;
    for (n.dataset && n.dataset.draw(t, r, o, l), d = o; d < o + l; ++d) {
      const h = s[d];
      h.hidden || (h.active && c ? a.push(h) : h.draw(t, r));
    }
    for (d = 0; d < a.length; ++d)
      a[d].draw(t, r);
  }
  getStyle(t, e) {
    const n = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(n) : this.resolveDataElementOptions(t || 0, n);
  }
  getContext(t, e, n) {
    const s = this.getDataset();
    let r;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[t];
      r = a.$context || (a.$context = iu(this.getContext(), t, a)), r.parsed = this.getParsed(t), r.raw = s.data[t], r.index = r.dataIndex = t;
    } else
      r = this.$context || (this.$context = eu(this.chart.getContext(), this.index)), r.dataset = s, r.index = r.datasetIndex = this.index;
    return r.active = !!e, r.mode = n, r;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", n) {
    const s = e === "active", r = this._cachedDataOpts, a = t + "-" + e, o = r[a], l = this.enableOptionSharing && Hi(n);
    if (o)
      return ka(o, l);
    const c = this.chart.config, d = c.datasetElementScopeKeys(this._type, t), h = s ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], u = c.getOptionScopes(this.getDataset(), d), f = Object.keys(st.elements[t]), g = () => this.getContext(n, s, e), m = c.resolveNamedOptions(u, f, g, h);
    return m.$shared && (m.$shared = l, r[a] = Object.freeze(ka(m, l))), m;
  }
  _resolveAnimations(t, e, n) {
    const s = this.chart, r = this._cachedDataOpts, a = `animation-${e}`, o = r[a];
    if (o)
      return o;
    let l;
    if (s.options.animation !== !1) {
      const d = this.chart.config, h = d.datasetAnimationScopeKeys(this._type, e), u = d.getOptionScopes(this.getDataset(), h);
      l = d.createResolver(u, this.getContext(t, n, e));
    }
    const c = new cl(s, l && l.animations);
    return l && l._cacheable && (r[a] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || ys(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const n = this.resolveDataElementOptions(t, e), s = this._sharedOptions, r = this.getSharedOptions(n), a = this.includeOptions(e, r) || r !== s;
    return this.updateSharedOptions(r, e, n), {
      sharedOptions: r,
      includeOptions: a
    };
  }
  updateElement(t, e, n, s) {
    ys(s) ? Object.assign(t, n) : this._resolveAnimations(e, s).update(t, n);
  }
  updateSharedOptions(t, e, n) {
    t && !ys(e) && this._resolveAnimations(void 0, e).update(t, n);
  }
  _setStyle(t, e, n, s) {
    t.active = s;
    const r = this.getStyle(e, s);
    this._resolveAnimations(e, n, s).update(t, {
      options: !s && this.getSharedOptions(r) || r
    });
  }
  removeHoverStyle(t, e, n) {
    this._setStyle(t, n, "active", !1);
  }
  setHoverStyle(t, e, n) {
    this._setStyle(t, n, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, n = this._cachedMeta.data;
    for (const [o, l, c] of this._syncList)
      this[o](l, c);
    this._syncList = [];
    const s = n.length, r = e.length, a = Math.min(r, s);
    a && this.parse(0, a), r > s ? this._insertElements(s, r - s, t) : r < s && this._removeElements(r, s - r);
  }
  _insertElements(t, e, n = !0) {
    const s = this._cachedMeta, r = s.data, a = t + e;
    let o;
    const l = (c) => {
      for (c.length += e, o = c.length - 1; o >= a; o--)
        c[o] = c[o - e];
    };
    for (l(r), o = t; o < a; ++o)
      r[o] = new this.dataElementType();
    this._parsing && l(s._parsed), this.parse(t, e), n && this.updateElements(r, t, e, "reset");
  }
  updateElements(t, e, n, s) {
  }
  _removeElements(t, e) {
    const n = this._cachedMeta;
    if (this._parsing) {
      const s = n._parsed.splice(t, e);
      n._stacked && li(n, s);
    }
    n.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, n, s] = t;
      this[e](n, s);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, e) {
    e && this._sync([
      "_removeElements",
      t,
      e
    ]);
    const n = arguments.length - 2;
    n && this._sync([
      "_insertElements",
      t,
      n
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
P(jt, "defaults", {}), P(jt, "datasetElementType", null), P(jt, "dataElementType", null);
function su(i, t) {
  if (!i._cache.$bar) {
    const e = i.getMatchingVisibleMetas(t);
    let n = [];
    for (let s = 0, r = e.length; s < r; s++)
      n = n.concat(e[s].controller.getAllParsedValues(i));
    i._cache.$bar = jo(n.sort((s, r) => s - r));
  }
  return i._cache.$bar;
}
function ru(i) {
  const t = i.iScale, e = su(t, i.type);
  let n = t._length, s, r, a, o;
  const l = () => {
    a === 32767 || a === -32768 || (Hi(o) && (n = Math.min(n, Math.abs(a - o) || n)), o = a);
  };
  for (s = 0, r = e.length; s < r; ++s)
    a = t.getPixelForValue(e[s]), l();
  for (o = void 0, s = 0, r = t.ticks.length; s < r; ++s)
    a = t.getPixelForTick(s), l();
  return n;
}
function au(i, t, e, n) {
  const s = e.barThickness;
  let r, a;
  return B(s) ? (r = t.min * e.categoryPercentage, a = e.barPercentage) : (r = s * n, a = 1), {
    chunk: r / n,
    ratio: a,
    start: t.pixels[i] - r / 2
  };
}
function ou(i, t, e, n) {
  const s = t.pixels, r = s[i];
  let a = i > 0 ? s[i - 1] : null, o = i < s.length - 1 ? s[i + 1] : null;
  const l = e.categoryPercentage;
  a === null && (a = r - (o === null ? t.end - t.start : o - r)), o === null && (o = r + r - a);
  const c = r - (r - Math.min(a, o)) / 2 * l;
  return {
    chunk: Math.abs(o - a) / 2 * l / n,
    ratio: e.barPercentage,
    start: c
  };
}
function lu(i, t, e, n) {
  const s = e.parse(i[0], n), r = e.parse(i[1], n), a = Math.min(s, r), o = Math.max(s, r);
  let l = a, c = o;
  Math.abs(a) > Math.abs(o) && (l = o, c = a), t[e.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: s,
    end: r,
    min: a,
    max: o
  };
}
function hl(i, t, e, n) {
  return et(i) ? lu(i, t, e, n) : t[e.axis] = e.parse(i, n), t;
}
function Da(i, t, e, n) {
  const s = i.iScale, r = i.vScale, a = s.getLabels(), o = s === r, l = [];
  let c, d, h, u;
  for (c = e, d = e + n; c < d; ++c)
    u = t[c], h = {}, h[s.axis] = o || s.parse(a[c], c), l.push(hl(u, h, r, c));
  return l;
}
function xs(i) {
  return i && i.barStart !== void 0 && i.barEnd !== void 0;
}
function cu(i, t, e) {
  return i !== 0 ? Kt(i) : (t.isHorizontal() ? 1 : -1) * (t.min >= e ? 1 : -1);
}
function du(i) {
  let t, e, n, s, r;
  return i.horizontal ? (t = i.base > i.x, e = "left", n = "right") : (t = i.base < i.y, e = "bottom", n = "top"), t ? (s = "end", r = "start") : (s = "start", r = "end"), {
    start: e,
    end: n,
    reverse: t,
    top: s,
    bottom: r
  };
}
function hu(i, t, e, n) {
  let s = t.borderSkipped;
  const r = {};
  if (!s) {
    i.borderSkipped = r;
    return;
  }
  if (s === !0) {
    i.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: a, end: o, reverse: l, top: c, bottom: d } = du(i);
  s === "middle" && e && (i.enableBorderRadius = !0, (e._top || 0) === n ? s = c : (e._bottom || 0) === n ? s = d : (r[Ca(d, a, o, l)] = !0, s = c)), r[Ca(s, a, o, l)] = !0, i.borderSkipped = r;
}
function Ca(i, t, e, n) {
  return n ? (i = uu(i, t, e), i = $a(i, e, t)) : i = $a(i, t, e), i;
}
function uu(i, t, e) {
  return i === t ? e : i === e ? t : i;
}
function $a(i, t, e) {
  return i === "start" ? t : i === "end" ? e : i;
}
function fu(i, { inflateAmount: t }, e) {
  i.inflateAmount = t === "auto" ? e === 1 ? 0.33 : 0 : t;
}
class Dn extends jt {
  parsePrimitiveData(t, e, n, s) {
    return Da(t, e, n, s);
  }
  parseArrayData(t, e, n, s) {
    return Da(t, e, n, s);
  }
  parseObjectData(t, e, n, s) {
    const { iScale: r, vScale: a } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = r.axis === "x" ? o : l, d = a.axis === "x" ? o : l, h = [];
    let u, f, g, m;
    for (u = n, f = n + s; u < f; ++u)
      m = e[u], g = {}, g[r.axis] = r.parse(we(m, c), u), h.push(hl(we(m, d), g, a, u));
    return h;
  }
  updateRangeFromParsed(t, e, n, s) {
    super.updateRangeFromParsed(t, e, n, s);
    const r = n._custom;
    r && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, r.min), t.max = Math.max(t.max, r.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { iScale: n, vScale: s } = e, r = this.getParsed(t), a = r._custom, o = xs(a) ? "[" + a.start + ", " + a.end + "]" : "" + s.getLabelForValue(r[s.axis]);
    return {
      label: "" + n.getLabelForValue(r[n.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const e = this._cachedMeta;
    this.updateElements(e.data, 0, e.data.length, t);
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", { index: a, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), c = o.isHorizontal(), d = this._getRuler(), { sharedOptions: h, includeOptions: u } = this._getSharedOptions(e, s);
    for (let f = e; f < e + n; f++) {
      const g = this.getParsed(f), m = r || B(g[o.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(f), v = this._calculateBarIndexPixels(f, d), b = (g._stacks || {})[o.axis], x = {
        horizontal: c,
        base: m.base,
        enableBorderRadius: !b || xs(g._custom) || a === b._top || a === b._bottom,
        x: c ? m.head : v.center,
        y: c ? v.center : m.head,
        height: c ? v.size : Math.abs(m.size),
        width: c ? Math.abs(m.size) : v.size
      };
      u && (x.options = h || this.resolveDataElementOptions(f, t[f].active ? "active" : s));
      const w = x.options || t[f].options;
      hu(x, w, b, a), fu(x, w, d.ratio), this.updateElement(t[f], f, x, s);
    }
  }
  _getStacks(t, e) {
    const { iScale: n } = this._cachedMeta, s = n.getMatchingVisibleMetas(this._type).filter((d) => d.controller.options.grouped), r = n.options.stacked, a = [], o = this._cachedMeta.controller.getParsed(e), l = o && o[n.axis], c = (d) => {
      const h = d._parsed.find((f) => f[n.axis] === l), u = h && h[d.vScale.axis];
      if (B(u) || isNaN(u))
        return !0;
    };
    for (const d of s)
      if (!(e !== void 0 && c(d)) && ((r === !1 || a.indexOf(d.stack) === -1 || r === void 0 && d.stack === void 0) && a.push(d.stack), d.index === t))
        break;
    return a.length || a.push(void 0), a;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, e, n) {
    const s = this._getStacks(t, n), r = e !== void 0 ? s.indexOf(e) : -1;
    return r === -1 ? s.length - 1 : r;
  }
  _getRuler() {
    const t = this.options, e = this._cachedMeta, n = e.iScale, s = [];
    let r, a;
    for (r = 0, a = e.data.length; r < a; ++r)
      s.push(n.getPixelForValue(this.getParsed(r)[n.axis], r));
    const o = t.barThickness;
    return {
      min: o || ru(e),
      pixels: s,
      start: n._startPixel,
      end: n._endPixel,
      stackCount: this._getStackCount(),
      scale: n,
      grouped: t.grouped,
      ratio: o ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: e, _stacked: n, index: s }, options: { base: r, minBarLength: a } } = this, o = r || 0, l = this.getParsed(t), c = l._custom, d = xs(c);
    let h = l[e.axis], u = 0, f = n ? this.applyStack(e, l, n) : h, g, m;
    f !== h && (u = f - h, f = h), d && (h = c.barStart, f = c.barEnd - c.barStart, h !== 0 && Kt(h) !== Kt(c.barEnd) && (u = 0), u += h);
    const v = !B(r) && !d ? r : u;
    let b = e.getPixelForValue(v);
    if (this.chart.getDataVisibility(t) ? g = e.getPixelForValue(u + f) : g = b, m = g - b, Math.abs(m) < a) {
      m = cu(m, e, o) * a, h === o && (b -= m / 2);
      const x = e.getPixelForDecimal(0), w = e.getPixelForDecimal(1), k = Math.min(x, w), _ = Math.max(x, w);
      b = Math.max(Math.min(b, _), k), g = b + m, n && !d && (l._stacks[e.axis]._visualValues[s] = e.getValueForPixel(g) - e.getValueForPixel(b));
    }
    if (b === e.getPixelForValue(o)) {
      const x = Kt(m) * e.getLineWidthForValue(o) / 2;
      b += x, m -= x;
    }
    return {
      size: m,
      base: b,
      head: g,
      center: g + m / 2
    };
  }
  _calculateBarIndexPixels(t, e) {
    const n = e.scale, s = this.options, r = s.skipNull, a = N(s.maxBarThickness, 1 / 0);
    let o, l;
    if (e.grouped) {
      const c = r ? this._getStackCount(t) : e.stackCount, d = s.barThickness === "flex" ? ou(t, e, s, c) : au(t, e, s, c), h = this._getStackIndex(this.index, this._cachedMeta.stack, r ? t : void 0);
      o = d.start + d.chunk * h + d.chunk / 2, l = Math.min(a, d.chunk * d.ratio);
    } else
      o = n.getPixelForValue(this.getParsed(t)[n.axis], t), l = Math.min(a, e.min * e.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, e = t.vScale, n = t.data, s = n.length;
    let r = 0;
    for (; r < s; ++r)
      this.getParsed(r)[e.axis] !== null && !n[r].hidden && n[r].draw(this._ctx);
  }
}
P(Dn, "id", "bar"), P(Dn, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), P(Dn, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class Cn extends jt {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, e, n, s) {
    const r = super.parsePrimitiveData(t, e, n, s);
    for (let a = 0; a < r.length; a++)
      r[a]._custom = this.resolveDataElementOptions(a + n).radius;
    return r;
  }
  parseArrayData(t, e, n, s) {
    const r = super.parseArrayData(t, e, n, s);
    for (let a = 0; a < r.length; a++) {
      const o = e[n + a];
      r[a]._custom = N(o[2], this.resolveDataElementOptions(a + n).radius);
    }
    return r;
  }
  parseObjectData(t, e, n, s) {
    const r = super.parseObjectData(t, e, n, s);
    for (let a = 0; a < r.length; a++) {
      const o = e[n + a];
      r[a]._custom = N(o && o.r && +o.r, this.resolveDataElementOptions(a + n).radius);
    }
    return r;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let e = 0;
    for (let n = t.length - 1; n >= 0; --n)
      e = Math.max(e, t[n].size(this.resolveDataElementOptions(n)) / 2);
    return e > 0 && e;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = this.chart.data.labels || [], { xScale: s, yScale: r } = e, a = this.getParsed(t), o = s.getLabelForValue(a.x), l = r.getLabelForValue(a.y), c = a._custom;
    return {
      label: n[t] || "",
      value: "(" + o + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta.data;
    this.updateElements(e, 0, e.length, t);
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", { iScale: a, vScale: o } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(e, s), d = a.axis, h = o.axis;
    for (let u = e; u < e + n; u++) {
      const f = t[u], g = !r && this.getParsed(u), m = {}, v = m[d] = r ? a.getPixelForDecimal(0.5) : a.getPixelForValue(g[d]), b = m[h] = r ? o.getBasePixel() : o.getPixelForValue(g[h]);
      m.skip = isNaN(v) || isNaN(b), c && (m.options = l || this.resolveDataElementOptions(u, f.active ? "active" : s), r && (m.options.radius = 0)), this.updateElement(f, u, m, s);
    }
  }
  resolveDataElementOptions(t, e) {
    const n = this.getParsed(t);
    let s = super.resolveDataElementOptions(t, e);
    s.$shared && (s = Object.assign({}, s, {
      $shared: !1
    }));
    const r = s.radius;
    return e !== "active" && (s.radius = 0), s.radius += N(n && n._custom, r), s;
  }
}
P(Cn, "id", "bubble"), P(Cn, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), P(Cn, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function pu(i, t, e) {
  let n = 1, s = 1, r = 0, a = 0;
  if (t < it) {
    const o = i, l = o + t, c = Math.cos(o), d = Math.sin(o), h = Math.cos(l), u = Math.sin(l), f = (w, k, _) => Bi(w, o, l, !0) ? 1 : Math.max(k, k * e, _, _ * e), g = (w, k, _) => Bi(w, o, l, !0) ? -1 : Math.min(k, k * e, _, _ * e), m = f(0, c, h), v = f(ft, d, u), b = g(nt, c, h), x = g(nt + ft, d, u);
    n = (m - b) / 2, s = (v - x) / 2, r = -(m + b) / 2, a = -(v + x) / 2;
  }
  return {
    ratioX: n,
    ratioY: s,
    offsetX: r,
    offsetY: a
  };
}
class Re extends jt {
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const n = this.getDataset().data, s = this._cachedMeta;
    if (this._parsing === !1)
      s._parsed = n;
    else {
      let r = (l) => +n[l];
      if (W(n[t])) {
        const { key: l = "value" } = this._parsing;
        r = (c) => +we(n[c], l);
      }
      let a, o;
      for (a = t, o = t + e; a < o; ++a)
        s._parsed[a] = r(a);
    }
  }
  _getRotation() {
    return Ut(this.options.rotation - 90);
  }
  _getCircumference() {
    return Ut(this.options.circumference);
  }
  _getRotationExtents() {
    let t = it, e = -it;
    for (let n = 0; n < this.chart.data.datasets.length; ++n)
      if (this.chart.isDatasetVisible(n) && this.chart.getDatasetMeta(n).type === this._type) {
        const s = this.chart.getDatasetMeta(n).controller, r = s._getRotation(), a = s._getCircumference();
        t = Math.min(t, r), e = Math.max(e, r + a);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: n } = e, s = this._cachedMeta, r = s.data, a = this.getMaxBorderWidth() + this.getMaxOffset(r) + this.options.spacing, o = Math.max((Math.min(n.width, n.height) - a) / 2, 0), l = Math.min(Pd(this.options.cutout, o), 1), c = this._getRingWeight(this.index), { circumference: d, rotation: h } = this._getRotationExtents(), { ratioX: u, ratioY: f, offsetX: g, offsetY: m } = pu(h, d, l), v = (n.width - a) / u, b = (n.height - a) / f, x = Math.max(Math.min(v, b) / 2, 0), w = zo(this.options.radius, x), k = Math.max(w * l, 0), _ = (w - k) / this._getVisibleDatasetWeightTotal();
    this.offsetX = g * w, this.offsetY = m * w, s.total = this.calculateTotal(), this.outerRadius = w - _ * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - _ * c, 0), this.updateElements(r, 0, r.length, t);
  }
  _circumference(t, e) {
    const n = this.options, s = this._cachedMeta, r = this._getCircumference();
    return e && n.animation.animateRotate || !this.chart.getDataVisibility(t) || s._parsed[t] === null || s.data[t].hidden ? 0 : this.calculateCircumference(s._parsed[t] * r / it);
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", a = this.chart, o = a.chartArea, c = a.options.animation, d = (o.left + o.right) / 2, h = (o.top + o.bottom) / 2, u = r && c.animateScale, f = u ? 0 : this.innerRadius, g = u ? 0 : this.outerRadius, { sharedOptions: m, includeOptions: v } = this._getSharedOptions(e, s);
    let b = this._getRotation(), x;
    for (x = 0; x < e; ++x)
      b += this._circumference(x, r);
    for (x = e; x < e + n; ++x) {
      const w = this._circumference(x, r), k = t[x], _ = {
        x: d + this.offsetX,
        y: h + this.offsetY,
        startAngle: b,
        endAngle: b + w,
        circumference: w,
        outerRadius: g,
        innerRadius: f
      };
      v && (_.options = m || this.resolveDataElementOptions(x, k.active ? "active" : s)), b += w, this.updateElement(k, x, _, s);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let n = 0, s;
    for (s = 0; s < e.length; s++) {
      const r = t._parsed[s];
      r !== null && !isNaN(r) && this.chart.getDataVisibility(s) && !e[s].hidden && (n += Math.abs(r));
    }
    return n;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? it * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = this.chart, s = n.data.labels || [], r = Ji(e._parsed[t], n.options.locale);
    return {
      label: s[t] || "",
      value: r
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const n = this.chart;
    let s, r, a, o, l;
    if (!t) {
      for (s = 0, r = n.data.datasets.length; s < r; ++s)
        if (n.isDatasetVisible(s)) {
          a = n.getDatasetMeta(s), t = a.data, o = a.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (s = 0, r = t.length; s < r; ++s)
      l = o.resolveDataElementOptions(s), l.borderAlign !== "inner" && (e = Math.max(e, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let n = 0, s = t.length; n < s; ++n) {
      const r = this.resolveDataElementOptions(n);
      e = Math.max(e, r.offset || 0, r.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let n = 0; n < t; ++n)
      this.chart.isDatasetVisible(n) && (e += this._getRingWeight(n));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(N(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
P(Re, "id", "doughnut"), P(Re, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), P(Re, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), P(Re, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: n, color: s } } = t.legend.options;
            return e.labels.map((r, a) => {
              const l = t.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: r,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: s,
                lineWidth: l.borderWidth,
                pointStyle: n,
                hidden: !t.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, n) {
        n.chart.toggleDataVisibility(e.index), n.chart.update();
      }
    }
  }
});
class $n extends jt {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const e = this._cachedMeta, { dataset: n, data: s = [], _dataset: r } = e, a = this.chart._animationsDisabled;
    let { start: o, count: l } = qo(e, s, a);
    this._drawStart = o, this._drawCount = l, Xo(e) && (o = 0, l = s.length), n._chart = this.chart, n._datasetIndex = this.index, n._decimated = !!r._decimated, n.points = s;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(n, void 0, {
      animated: !a,
      options: c
    }, t), this.updateElements(s, o, l, t);
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: d, includeOptions: h } = this._getSharedOptions(e, s), u = a.axis, f = o.axis, { spanGaps: g, segment: m } = this.options, v = ii(g) ? g : Number.POSITIVE_INFINITY, b = this.chart._animationsDisabled || r || s === "none", x = e + n, w = t.length;
    let k = e > 0 && this.getParsed(e - 1);
    for (let _ = 0; _ < w; ++_) {
      const D = t[_], C = b ? D : {};
      if (_ < e || _ >= x) {
        C.skip = !0;
        continue;
      }
      const $ = this.getParsed(_), T = B($[f]), E = C[u] = a.getPixelForValue($[u], _), L = C[f] = r || T ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, $, l) : $[f], _);
      C.skip = isNaN(E) || isNaN(L) || T, C.stop = _ > 0 && Math.abs($[u] - k[u]) > v, m && (C.parsed = $, C.raw = c.data[_]), h && (C.options = d || this.resolveDataElementOptions(_, D.active ? "active" : s)), b || this.updateElement(D, _, C, s), k = $;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.dataset, n = e.options && e.options.borderWidth || 0, s = t.data || [];
    if (!s.length)
      return n;
    const r = s[0].size(this.resolveDataElementOptions(0)), a = s[s.length - 1].size(this.resolveDataElementOptions(s.length - 1));
    return Math.max(n, r, a) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
P($n, "id", "line"), P($n, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), P($n, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class Pi extends jt {
  constructor(t, e) {
    super(t, e), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = this.chart, s = n.data.labels || [], r = Ji(e._parsed[t].r, n.options.locale);
    return {
      label: s[t] || "",
      value: r
    };
  }
  parseObjectData(t, e, n, s) {
    return il.bind(this)(t, e, n, s);
  }
  update(t) {
    const e = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(e, 0, e.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, e = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((n, s) => {
      const r = this.getParsed(s).r;
      !isNaN(r) && this.chart.getDataVisibility(s) && (r < e.min && (e.min = r), r > e.max && (e.max = r));
    }), e;
  }
  _updateRadius() {
    const t = this.chart, e = t.chartArea, n = t.options, s = Math.min(e.right - e.left, e.bottom - e.top), r = Math.max(s / 2, 0), a = Math.max(n.cutoutPercentage ? r / 100 * n.cutoutPercentage : 1, 0), o = (r - a) / t.getVisibleDatasetCount();
    this.outerRadius = r - o * this.index, this.innerRadius = this.outerRadius - o;
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", a = this.chart, l = a.options.animation, c = this._cachedMeta.rScale, d = c.xCenter, h = c.yCenter, u = c.getIndexAngle(0) - 0.5 * nt;
    let f = u, g;
    const m = 360 / this.countVisibleElements();
    for (g = 0; g < e; ++g)
      f += this._computeAngle(g, s, m);
    for (g = e; g < e + n; g++) {
      const v = t[g];
      let b = f, x = f + this._computeAngle(g, s, m), w = a.getDataVisibility(g) ? c.getDistanceFromCenterForValue(this.getParsed(g).r) : 0;
      f = x, r && (l.animateScale && (w = 0), l.animateRotate && (b = x = u));
      const k = {
        x: d,
        y: h,
        innerRadius: 0,
        outerRadius: w,
        startAngle: b,
        endAngle: x,
        options: this.resolveDataElementOptions(g, v.active ? "active" : s)
      };
      this.updateElement(v, g, k, s);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let e = 0;
    return t.data.forEach((n, s) => {
      !isNaN(this.getParsed(s).r) && this.chart.getDataVisibility(s) && e++;
    }), e;
  }
  _computeAngle(t, e, n) {
    return this.chart.getDataVisibility(t) ? Ut(this.resolveDataElementOptions(t, e).angle || n) : 0;
  }
}
P(Pi, "id", "polarArea"), P(Pi, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), P(Pi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: n, color: s } } = t.legend.options;
            return e.labels.map((r, a) => {
              const l = t.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: r,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: s,
                lineWidth: l.borderWidth,
                pointStyle: n,
                hidden: !t.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, n) {
        n.chart.toggleDataVisibility(e.index), n.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class Fs extends Re {
}
P(Fs, "id", "pie"), P(Fs, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class Pn extends jt {
  getLabelAndValue(t) {
    const e = this._cachedMeta.vScale, n = this.getParsed(t);
    return {
      label: e.getLabels()[t],
      value: "" + e.getLabelForValue(n[e.axis])
    };
  }
  parseObjectData(t, e, n, s) {
    return il.bind(this)(t, e, n, s);
  }
  update(t) {
    const e = this._cachedMeta, n = e.dataset, s = e.data || [], r = e.iScale.getLabels();
    if (n.points = s, t !== "resize") {
      const a = this.resolveDatasetElementOptions(t);
      this.options.showLine || (a.borderWidth = 0);
      const o = {
        _loop: !0,
        _fullLoop: r.length === s.length,
        options: a
      };
      this.updateElement(n, void 0, o, t);
    }
    this.updateElements(s, 0, s.length, t);
  }
  updateElements(t, e, n, s) {
    const r = this._cachedMeta.rScale, a = s === "reset";
    for (let o = e; o < e + n; o++) {
      const l = t[o], c = this.resolveDataElementOptions(o, l.active ? "active" : s), d = r.getPointPositionForValue(o, this.getParsed(o).r), h = a ? r.xCenter : d.x, u = a ? r.yCenter : d.y, f = {
        x: h,
        y: u,
        angle: d.angle,
        skip: isNaN(h) || isNaN(u),
        options: c
      };
      this.updateElement(l, o, f, s);
    }
  }
}
P(Pn, "id", "radar"), P(Pn, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), P(Pn, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class Mn extends jt {
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = this.chart.data.labels || [], { xScale: s, yScale: r } = e, a = this.getParsed(t), o = s.getLabelForValue(a.x), l = r.getLabelForValue(a.y);
    return {
      label: n[t] || "",
      value: "(" + o + ", " + l + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta, { data: n = [] } = e, s = this.chart._animationsDisabled;
    let { start: r, count: a } = qo(e, n, s);
    if (this._drawStart = r, this._drawCount = a, Xo(e) && (r = 0, a = n.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: o, _dataset: l } = e;
      o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!l._decimated, o.points = n;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(o, void 0, {
        animated: !s,
        options: c
      }, t);
    } else
      this.datasetElementType && (delete e.dataset, this.datasetElementType = !1);
    this.updateElements(n, r, a, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, d = this.resolveDataElementOptions(e, s), h = this.getSharedOptions(d), u = this.includeOptions(s, h), f = a.axis, g = o.axis, { spanGaps: m, segment: v } = this.options, b = ii(m) ? m : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || r || s === "none";
    let w = e > 0 && this.getParsed(e - 1);
    for (let k = e; k < e + n; ++k) {
      const _ = t[k], D = this.getParsed(k), C = x ? _ : {}, $ = B(D[g]), T = C[f] = a.getPixelForValue(D[f], k), E = C[g] = r || $ ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, D, l) : D[g], k);
      C.skip = isNaN(T) || isNaN(E) || $, C.stop = k > 0 && Math.abs(D[f] - w[f]) > b, v && (C.parsed = D, C.raw = c.data[k]), u && (C.options = h || this.resolveDataElementOptions(k, _.active ? "active" : s)), x || this.updateElement(_, k, C, s), w = D;
    }
    this.updateSharedOptions(h, s, d);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.data || [];
    if (!this.options.showLine) {
      let o = 0;
      for (let l = e.length - 1; l >= 0; --l)
        o = Math.max(o, e[l].size(this.resolveDataElementOptions(l)) / 2);
      return o > 0 && o;
    }
    const n = t.dataset, s = n.options && n.options.borderWidth || 0;
    if (!e.length)
      return s;
    const r = e[0].size(this.resolveDataElementOptions(0)), a = e[e.length - 1].size(this.resolveDataElementOptions(e.length - 1));
    return Math.max(s, r, a) / 2;
  }
}
P(Mn, "id", "scatter"), P(Mn, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), P(Mn, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var gu = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: Dn,
  BubbleController: Cn,
  DoughnutController: Re,
  LineController: $n,
  PieController: Fs,
  PolarAreaController: Pi,
  RadarController: Pn,
  ScatterController: Mn
});
function Se() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class wr {
  constructor(t) {
    P(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(wr.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Se();
  }
  parse() {
    return Se();
  }
  format() {
    return Se();
  }
  add() {
    return Se();
  }
  diff() {
    return Se();
  }
  startOf() {
    return Se();
  }
  endOf() {
    return Se();
  }
}
var ul = {
  _date: wr
};
function mu(i, t, e, n) {
  const { controller: s, data: r, _sorted: a } = i, o = s._cachedMeta.iScale, l = i.dataset && i.dataset.options ? i.dataset.options.spanGaps : null;
  if (o && t === o.axis && t !== "r" && a && r.length) {
    const c = o._reversePixels ? Hd : ae;
    if (n) {
      if (s._sharedOptions) {
        const d = r[0], h = typeof d.getRange == "function" && d.getRange(t);
        if (h) {
          const u = c(r, t, e - h), f = c(r, t, e + h);
          return {
            lo: u.lo,
            hi: f.hi
          };
        }
      }
    } else {
      const d = c(r, t, e);
      if (l) {
        const { vScale: h } = s._cachedMeta, { _parsed: u } = i, f = u.slice(0, d.lo + 1).reverse().findIndex((m) => !B(m[h.axis]));
        d.lo -= Math.max(0, f);
        const g = u.slice(d.hi).findIndex((m) => !B(m[h.axis]));
        d.hi += Math.max(0, g);
      }
      return d;
    }
  }
  return {
    lo: 0,
    hi: r.length - 1
  };
}
function tn(i, t, e, n, s) {
  const r = i.getSortedVisibleDatasetMetas(), a = e[t];
  for (let o = 0, l = r.length; o < l; ++o) {
    const { index: c, data: d } = r[o], { lo: h, hi: u } = mu(r[o], t, a, s);
    for (let f = h; f <= u; ++f) {
      const g = d[f];
      g.skip || n(g, c, f);
    }
  }
}
function vu(i) {
  const t = i.indexOf("x") !== -1, e = i.indexOf("y") !== -1;
  return function(n, s) {
    const r = t ? Math.abs(n.x - s.x) : 0, a = e ? Math.abs(n.y - s.y) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(a, 2));
  };
}
function ws(i, t, e, n, s) {
  const r = [];
  return !s && !i.isPointInArea(t) || tn(i, e, t, function(o, l, c) {
    !s && !oe(o, i.chartArea, 0) || o.inRange(t.x, t.y, n) && r.push({
      element: o,
      datasetIndex: l,
      index: c
    });
  }, !0), r;
}
function bu(i, t, e, n) {
  let s = [];
  function r(a, o, l) {
    const { startAngle: c, endAngle: d } = a.getProps([
      "startAngle",
      "endAngle"
    ], n), { angle: h } = Wo(a, {
      x: t.x,
      y: t.y
    });
    Bi(h, c, d) && s.push({
      element: a,
      datasetIndex: o,
      index: l
    });
  }
  return tn(i, e, t, r), s;
}
function yu(i, t, e, n, s, r) {
  let a = [];
  const o = vu(e);
  let l = Number.POSITIVE_INFINITY;
  function c(d, h, u) {
    const f = d.inRange(t.x, t.y, s);
    if (n && !f)
      return;
    const g = d.getCenterPoint(s);
    if (!(!!r || i.isPointInArea(g)) && !f)
      return;
    const v = o(t, g);
    v < l ? (a = [
      {
        element: d,
        datasetIndex: h,
        index: u
      }
    ], l = v) : v === l && a.push({
      element: d,
      datasetIndex: h,
      index: u
    });
  }
  return tn(i, e, t, c), a;
}
function _s(i, t, e, n, s, r) {
  return !r && !i.isPointInArea(t) ? [] : e === "r" && !n ? bu(i, t, e, s) : yu(i, t, e, n, s, r);
}
function Pa(i, t, e, n, s) {
  const r = [], a = e === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return tn(i, e, t, (l, c, d) => {
    l[a] && l[a](t[e], s) && (r.push({
      element: l,
      datasetIndex: c,
      index: d
    }), o = o || l.inRange(t.x, t.y, s));
  }), n && !o ? [] : r;
}
var xu = {
  evaluateInteractionItems: tn,
  modes: {
    index(i, t, e, n) {
      const s = Oe(t, i), r = e.axis || "x", a = e.includeInvisible || !1, o = e.intersect ? ws(i, s, r, n, a) : _s(i, s, r, !1, n, a), l = [];
      return o.length ? (i.getSortedVisibleDatasetMetas().forEach((c) => {
        const d = o[0].index, h = c.data[d];
        h && !h.skip && l.push({
          element: h,
          datasetIndex: c.index,
          index: d
        });
      }), l) : [];
    },
    dataset(i, t, e, n) {
      const s = Oe(t, i), r = e.axis || "xy", a = e.includeInvisible || !1;
      let o = e.intersect ? ws(i, s, r, n, a) : _s(i, s, r, !1, n, a);
      if (o.length > 0) {
        const l = o[0].datasetIndex, c = i.getDatasetMeta(l).data;
        o = [];
        for (let d = 0; d < c.length; ++d)
          o.push({
            element: c[d],
            datasetIndex: l,
            index: d
          });
      }
      return o;
    },
    point(i, t, e, n) {
      const s = Oe(t, i), r = e.axis || "xy", a = e.includeInvisible || !1;
      return ws(i, s, r, n, a);
    },
    nearest(i, t, e, n) {
      const s = Oe(t, i), r = e.axis || "xy", a = e.includeInvisible || !1;
      return _s(i, s, r, e.intersect, n, a);
    },
    x(i, t, e, n) {
      const s = Oe(t, i);
      return Pa(i, s, "x", e.intersect, n);
    },
    y(i, t, e, n) {
      const s = Oe(t, i);
      return Pa(i, s, "y", e.intersect, n);
    }
  }
};
const fl = [
  "left",
  "top",
  "right",
  "bottom"
];
function ci(i, t) {
  return i.filter((e) => e.pos === t);
}
function Ma(i, t) {
  return i.filter((e) => fl.indexOf(e.pos) === -1 && e.box.axis === t);
}
function di(i, t) {
  return i.sort((e, n) => {
    const s = t ? n : e, r = t ? e : n;
    return s.weight === r.weight ? s.index - r.index : s.weight - r.weight;
  });
}
function wu(i) {
  const t = [];
  let e, n, s, r, a, o;
  for (e = 0, n = (i || []).length; e < n; ++e)
    s = i[e], { position: r, options: { stack: a, stackWeight: o = 1 } } = s, t.push({
      index: e,
      box: s,
      pos: r,
      horizontal: s.isHorizontal(),
      weight: s.weight,
      stack: a && r + a,
      stackWeight: o
    });
  return t;
}
function _u(i) {
  const t = {};
  for (const e of i) {
    const { stack: n, pos: s, stackWeight: r } = e;
    if (!n || !fl.includes(s))
      continue;
    const a = t[n] || (t[n] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += r;
  }
  return t;
}
function ku(i, t) {
  const e = _u(i), { vBoxMaxWidth: n, hBoxMaxHeight: s } = t;
  let r, a, o;
  for (r = 0, a = i.length; r < a; ++r) {
    o = i[r];
    const { fullSize: l } = o.box, c = e[o.stack], d = c && o.stackWeight / c.weight;
    o.horizontal ? (o.width = d ? d * n : l && t.availableWidth, o.height = s) : (o.width = n, o.height = d ? d * s : l && t.availableHeight);
  }
  return e;
}
function Du(i) {
  const t = wu(i), e = di(t.filter((c) => c.box.fullSize), !0), n = di(ci(t, "left"), !0), s = di(ci(t, "right")), r = di(ci(t, "top"), !0), a = di(ci(t, "bottom")), o = Ma(t, "x"), l = Ma(t, "y");
  return {
    fullSize: e,
    leftAndTop: n.concat(r),
    rightAndBottom: s.concat(l).concat(a).concat(o),
    chartArea: ci(t, "chartArea"),
    vertical: n.concat(s).concat(l),
    horizontal: r.concat(a).concat(o)
  };
}
function Sa(i, t, e, n) {
  return Math.max(i[e], t[e]) + Math.max(i[n], t[n]);
}
function pl(i, t) {
  i.top = Math.max(i.top, t.top), i.left = Math.max(i.left, t.left), i.bottom = Math.max(i.bottom, t.bottom), i.right = Math.max(i.right, t.right);
}
function Cu(i, t, e, n) {
  const { pos: s, box: r } = e, a = i.maxPadding;
  if (!W(s)) {
    e.size && (i[s] -= e.size);
    const h = n[e.stack] || {
      size: 0,
      count: 1
    };
    h.size = Math.max(h.size, e.horizontal ? r.height : r.width), e.size = h.size / h.count, i[s] += e.size;
  }
  r.getPadding && pl(a, r.getPadding());
  const o = Math.max(0, t.outerWidth - Sa(a, i, "left", "right")), l = Math.max(0, t.outerHeight - Sa(a, i, "top", "bottom")), c = o !== i.w, d = l !== i.h;
  return i.w = o, i.h = l, e.horizontal ? {
    same: c,
    other: d
  } : {
    same: d,
    other: c
  };
}
function $u(i) {
  const t = i.maxPadding;
  function e(n) {
    const s = Math.max(t[n] - i[n], 0);
    return i[n] += s, s;
  }
  i.y += e("top"), i.x += e("left"), e("right"), e("bottom");
}
function Pu(i, t) {
  const e = t.maxPadding;
  function n(s) {
    const r = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return s.forEach((a) => {
      r[a] = Math.max(t[a], e[a]);
    }), r;
  }
  return n(i ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function bi(i, t, e, n) {
  const s = [];
  let r, a, o, l, c, d;
  for (r = 0, a = i.length, c = 0; r < a; ++r) {
    o = i[r], l = o.box, l.update(o.width || t.w, o.height || t.h, Pu(o.horizontal, t));
    const { same: h, other: u } = Cu(t, e, o, n);
    c |= h && s.length, d = d || u, l.fullSize || s.push(o);
  }
  return c && bi(s, t, e, n) || d;
}
function pn(i, t, e, n, s) {
  i.top = e, i.left = t, i.right = t + n, i.bottom = e + s, i.width = n, i.height = s;
}
function Ta(i, t, e, n) {
  const s = e.padding;
  let { x: r, y: a } = t;
  for (const o of i) {
    const l = o.box, c = n[o.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, d = o.stackWeight / c.weight || 1;
    if (o.horizontal) {
      const h = t.w * d, u = c.size || l.height;
      Hi(c.start) && (a = c.start), l.fullSize ? pn(l, s.left, a, e.outerWidth - s.right - s.left, u) : pn(l, t.left + c.placed, a, h, u), c.start = a, c.placed += h, a = l.bottom;
    } else {
      const h = t.h * d, u = c.size || l.width;
      Hi(c.start) && (r = c.start), l.fullSize ? pn(l, r, s.top, u, e.outerHeight - s.bottom - s.top) : pn(l, r, t.top + c.placed, u, h), c.start = r, c.placed += h, r = l.right;
    }
  }
  t.x = r, t.y = a;
}
var Mt = {
  addBox(i, t) {
    i.boxes || (i.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(e) {
            t.draw(e);
          }
        }
      ];
    }, i.boxes.push(t);
  },
  removeBox(i, t) {
    const e = i.boxes ? i.boxes.indexOf(t) : -1;
    e !== -1 && i.boxes.splice(e, 1);
  },
  configure(i, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(i, t, e, n) {
    if (!i)
      return;
    const s = St(i.options.layout.padding), r = Math.max(t - s.width, 0), a = Math.max(e - s.height, 0), o = Du(i.boxes), l = o.vertical, c = o.horizontal;
    K(i.boxes, (m) => {
      typeof m.beforeLayout == "function" && m.beforeLayout();
    });
    const d = l.reduce((m, v) => v.box.options && v.box.options.display === !1 ? m : m + 1, 0) || 1, h = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: s,
      availableWidth: r,
      availableHeight: a,
      vBoxMaxWidth: r / 2 / d,
      hBoxMaxHeight: a / 2
    }), u = Object.assign({}, s);
    pl(u, St(n));
    const f = Object.assign({
      maxPadding: u,
      w: r,
      h: a,
      x: s.left,
      y: s.top
    }, s), g = ku(l.concat(c), h);
    bi(o.fullSize, f, h, g), bi(l, f, h, g), bi(c, f, h, g) && bi(l, f, h, g), $u(f), Ta(o.leftAndTop, f, h, g), f.x += f.w, f.y += f.h, Ta(o.rightAndBottom, f, h, g), i.chartArea = {
      left: f.left,
      top: f.top,
      right: f.left + f.w,
      bottom: f.top + f.h,
      height: f.h,
      width: f.w
    }, K(o.chartArea, (m) => {
      const v = m.box;
      Object.assign(v, i.chartArea), v.update(f.w, f.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class gl {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, n) {
  }
  removeEventListener(t, e, n) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, n, s) {
    return e = Math.max(0, e || t.width), n = n || t.height, {
      width: e,
      height: Math.max(0, s ? Math.floor(e / s) : n)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class Mu extends gl {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Sn = "$chartjs", Su = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Oa = (i) => i === null || i === "";
function Tu(i, t) {
  const e = i.style, n = i.getAttribute("height"), s = i.getAttribute("width");
  if (i[Sn] = {
    initial: {
      height: n,
      width: s,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", Oa(s)) {
    const r = pa(i, "width");
    r !== void 0 && (i.width = r);
  }
  if (Oa(n))
    if (i.style.height === "")
      i.height = i.width / (t || 2);
    else {
      const r = pa(i, "height");
      r !== void 0 && (i.height = r);
    }
  return i;
}
const ml = Ih ? {
  passive: !0
} : !1;
function Ou(i, t, e) {
  i && i.addEventListener(t, e, ml);
}
function Au(i, t, e) {
  i && i.canvas && i.canvas.removeEventListener(t, e, ml);
}
function Iu(i, t) {
  const e = Su[i.type] || i.type, { x: n, y: s } = Oe(i, t);
  return {
    type: e,
    chart: t,
    native: i,
    x: n !== void 0 ? n : null,
    y: s !== void 0 ? s : null
  };
}
function Un(i, t) {
  for (const e of i)
    if (e === t || e.contains(t))
      return !0;
}
function Eu(i, t, e) {
  const n = i.canvas, s = new MutationObserver((r) => {
    let a = !1;
    for (const o of r)
      a = a || Un(o.addedNodes, n), a = a && !Un(o.removedNodes, n);
    a && e();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
function Ru(i, t, e) {
  const n = i.canvas, s = new MutationObserver((r) => {
    let a = !1;
    for (const o of r)
      a = a || Un(o.removedNodes, n), a = a && !Un(o.addedNodes, n);
    a && e();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
const Ui = /* @__PURE__ */ new Map();
let Aa = 0;
function vl() {
  const i = window.devicePixelRatio;
  i !== Aa && (Aa = i, Ui.forEach((t, e) => {
    e.currentDevicePixelRatio !== i && t();
  }));
}
function Fu(i, t) {
  Ui.size || window.addEventListener("resize", vl), Ui.set(i, t);
}
function Lu(i) {
  Ui.delete(i), Ui.size || window.removeEventListener("resize", vl);
}
function Nu(i, t, e) {
  const n = i.canvas, s = n && xr(n);
  if (!s)
    return;
  const r = Yo((o, l) => {
    const c = s.clientWidth;
    e(o, l), c < s.clientWidth && e();
  }, window), a = new ResizeObserver((o) => {
    const l = o[0], c = l.contentRect.width, d = l.contentRect.height;
    c === 0 && d === 0 || r(c, d);
  });
  return a.observe(s), Fu(i, r), a;
}
function ks(i, t, e) {
  e && e.disconnect(), t === "resize" && Lu(i);
}
function zu(i, t, e) {
  const n = i.canvas, s = Yo((r) => {
    i.ctx !== null && e(Iu(r, i));
  }, i);
  return Ou(n, t, s), s;
}
class Hu extends gl {
  acquireContext(t, e) {
    const n = t && t.getContext && t.getContext("2d");
    return n && n.canvas === t ? (Tu(t, e), n) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[Sn])
      return !1;
    const n = e[Sn].initial;
    [
      "height",
      "width"
    ].forEach((r) => {
      const a = n[r];
      B(a) ? e.removeAttribute(r) : e.setAttribute(r, a);
    });
    const s = n.style || {};
    return Object.keys(s).forEach((r) => {
      e.style[r] = s[r];
    }), e.width = e.width, delete e[Sn], !0;
  }
  addEventListener(t, e, n) {
    this.removeEventListener(t, e);
    const s = t.$proxies || (t.$proxies = {}), a = {
      attach: Eu,
      detach: Ru,
      resize: Nu
    }[e] || zu;
    s[e] = a(t, e, n);
  }
  removeEventListener(t, e) {
    const n = t.$proxies || (t.$proxies = {}), s = n[e];
    if (!s)
      return;
    ({
      attach: ks,
      detach: ks,
      resize: ks
    }[e] || Au)(t, e, s), n[e] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, n, s) {
    return Ah(t, e, n, s);
  }
  isAttached(t) {
    const e = t && xr(t);
    return !!(e && e.isConnected);
  }
}
function Bu(i) {
  return !yr() || typeof OffscreenCanvas != "undefined" && i instanceof OffscreenCanvas ? Mu : Hu;
}
class Vt {
  constructor() {
    P(this, "x");
    P(this, "y");
    P(this, "active", !1);
    P(this, "options");
    P(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: e, y: n } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: n
    };
  }
  hasValue() {
    return ii(this.x) && ii(this.y);
  }
  getProps(t, e) {
    const n = this.$animations;
    if (!e || !n)
      return this;
    const s = {};
    return t.forEach((r) => {
      s[r] = n[r] && n[r].active() ? n[r]._to : this[r];
    }), s;
  }
}
P(Vt, "defaults", {}), P(Vt, "defaultRoutes");
function Wu(i, t) {
  const e = i.options.ticks, n = Uu(i), s = Math.min(e.maxTicksLimit || n, n), r = e.major.enabled ? Vu(t) : [], a = r.length, o = r[0], l = r[a - 1], c = [];
  if (a > s)
    return Yu(t, c, r, a / s), c;
  const d = ju(r, t, s);
  if (a > 0) {
    let h, u;
    const f = a > 1 ? Math.round((l - o) / (a - 1)) : null;
    for (gn(t, c, d, B(f) ? 0 : o - f, o), h = 0, u = a - 1; h < u; h++)
      gn(t, c, d, r[h], r[h + 1]);
    return gn(t, c, d, l, B(f) ? t.length : l + f), c;
  }
  return gn(t, c, d), c;
}
function Uu(i) {
  const t = i.options.offset, e = i._tickSize(), n = i._length / e + (t ? 0 : 1), s = i._maxLength / e;
  return Math.floor(Math.min(n, s));
}
function ju(i, t, e) {
  const n = qu(i), s = t.length / e;
  if (!n)
    return Math.max(s, 1);
  const r = Rd(n);
  for (let a = 0, o = r.length - 1; a < o; a++) {
    const l = r[a];
    if (l > s)
      return l;
  }
  return Math.max(s, 1);
}
function Vu(i) {
  const t = [];
  let e, n;
  for (e = 0, n = i.length; e < n; e++)
    i[e].major && t.push(e);
  return t;
}
function Yu(i, t, e, n) {
  let s = 0, r = e[0], a;
  for (n = Math.ceil(n), a = 0; a < i.length; a++)
    a === r && (t.push(i[a]), s++, r = e[s * n]);
}
function gn(i, t, e, n, s) {
  const r = N(n, 0), a = Math.min(N(s, i.length), i.length);
  let o = 0, l, c, d;
  for (e = Math.ceil(e), s && (l = s - n, e = l / Math.floor(l / e)), d = r; d < 0; )
    o++, d = Math.round(r + o * e);
  for (c = Math.max(r, 0); c < a; c++)
    c === d && (t.push(i[c]), o++, d = Math.round(r + o * e));
}
function qu(i) {
  const t = i.length;
  let e, n;
  if (t < 2)
    return !1;
  for (n = i[0], e = 1; e < t; ++e)
    if (i[e] - i[e - 1] !== n)
      return !1;
  return n;
}
const Xu = (i) => i === "left" ? "right" : i === "right" ? "left" : i, Ia = (i, t, e) => t === "top" || t === "left" ? i[t] + e : i[t] - e, Ea = (i, t) => Math.min(t || i, i);
function Ra(i, t) {
  const e = [], n = i.length / t, s = i.length;
  let r = 0;
  for (; r < s; r += n)
    e.push(i[Math.floor(r)]);
  return e;
}
function Qu(i, t, e) {
  const n = i.ticks.length, s = Math.min(t, n - 1), r = i._startPixel, a = i._endPixel, o = 1e-6;
  let l = i.getPixelForTick(s), c;
  if (!(e && (n === 1 ? c = Math.max(l - r, a - l) : t === 0 ? c = (i.getPixelForTick(1) - l) / 2 : c = (l - i.getPixelForTick(s - 1)) / 2, l += s < t ? c : -c, l < r - o || l > a + o)))
    return l;
}
function Gu(i, t) {
  K(i, (e) => {
    const n = e.gc, s = n.length / 2;
    let r;
    if (s > t) {
      for (r = 0; r < s; ++r)
        delete e.data[n[r]];
      n.splice(0, s);
    }
  });
}
function hi(i) {
  return i.drawTicks ? i.tickLength : 0;
}
function Fa(i, t) {
  if (!i.display)
    return 0;
  const e = vt(i.font, t), n = St(i.padding);
  return (et(i.text) ? i.text.length : 1) * e.lineHeight + n.height;
}
function Ku(i, t) {
  return ke(i, {
    scale: t,
    type: "scale"
  });
}
function Zu(i, t, e) {
  return ke(i, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function Ju(i, t, e) {
  let n = fr(i);
  return (e && t !== "right" || !e && t === "right") && (n = Xu(n)), n;
}
function tf(i, t, e, n) {
  const { top: s, left: r, bottom: a, right: o, chart: l } = i, { chartArea: c, scales: d } = l;
  let h = 0, u, f, g;
  const m = a - s, v = o - r;
  if (i.isHorizontal()) {
    if (f = Pt(n, r, o), W(e)) {
      const b = Object.keys(e)[0], x = e[b];
      g = d[b].getPixelForValue(x) + m - t;
    } else
      e === "center" ? g = (c.bottom + c.top) / 2 + m - t : g = Ia(i, e, t);
    u = o - r;
  } else {
    if (W(e)) {
      const b = Object.keys(e)[0], x = e[b];
      f = d[b].getPixelForValue(x) - v + t;
    } else
      e === "center" ? f = (c.left + c.right) / 2 - v + t : f = Ia(i, e, t);
    g = Pt(n, a, s), h = e === "left" ? -ft : ft;
  }
  return {
    titleX: f,
    titleY: g,
    maxWidth: u,
    rotation: h
  };
}
class Ye extends Vt {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: n, _suggestedMax: s } = this;
    return t = Rt(t, Number.POSITIVE_INFINITY), e = Rt(e, Number.NEGATIVE_INFINITY), n = Rt(n, Number.POSITIVE_INFINITY), s = Rt(s, Number.NEGATIVE_INFINITY), {
      min: Rt(t, n),
      max: Rt(e, s),
      minDefined: ht(t),
      maxDefined: ht(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: n, minDefined: s, maxDefined: r } = this.getUserBounds(), a;
    if (s && r)
      return {
        min: e,
        max: n
      };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, c = o.length; l < c; ++l)
      a = o[l].controller.getMinMax(this, t), s || (e = Math.min(e, a.min)), r || (n = Math.max(n, a.max));
    return e = r && e > n ? n : e, n = s && e > n ? e : n, {
      min: Rt(e, Rt(n, e)),
      max: Rt(n, Rt(e, n))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    tt(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, e, n) {
    const { beginAtZero: s, grace: r, ticks: a } = this.options, o = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = n = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, n), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + n.left + n.right : this.height + n.top + n.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = dh(this, r, s), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? Ra(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = Wu(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, n;
    this.isHorizontal() ? (e = this.left, n = this.right) : (e = this.top, n = this.bottom, t = !t), this._startPixel = e, this._endPixel = n, this._reversePixels = t, this._length = n - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    tt(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    tt(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    tt(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), tt(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    tt(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let n, s, r;
    for (n = 0, s = t.length; n < s; n++)
      r = t[n], r.label = tt(e.callback, [
        r.value,
        n,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    tt(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    tt(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, n = Ea(this.ticks.length, t.ticks.maxTicksLimit), s = e.minRotation || 0, r = e.maxRotation;
    let a = s, o, l, c;
    if (!this._isVisible() || !e.display || s >= r || n <= 1 || !this.isHorizontal()) {
      this.labelRotation = s;
      return;
    }
    const d = this._getLabelSizes(), h = d.widest.width, u = d.highest.height, f = wt(this.chart.width - h, 0, this.maxWidth);
    o = t.offset ? this.maxWidth / n : f / (n - 1), h + 6 > o && (o = f / (n - (t.offset ? 0.5 : 1)), l = this.maxHeight - hi(t.grid) - e.padding - Fa(t.title, this.chart.options.font), c = Math.sqrt(h * h + u * u), a = hr(Math.min(Math.asin(wt((d.highest.height + 6) / o, -1, 1)), Math.asin(wt(l / c, -1, 1)) - Math.asin(wt(u / c, -1, 1)))), a = Math.max(s, Math.min(r, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    tt(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    tt(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: n, title: s, grid: r } } = this, a = this._isVisible(), o = this.isHorizontal();
    if (a) {
      const l = Fa(s, e.options.font);
      if (o ? (t.width = this.maxWidth, t.height = hi(r) + l) : (t.height = this.maxHeight, t.width = hi(r) + l), n.display && this.ticks.length) {
        const { first: c, last: d, widest: h, highest: u } = this._getLabelSizes(), f = n.padding * 2, g = Ut(this.labelRotation), m = Math.cos(g), v = Math.sin(g);
        if (o) {
          const b = n.mirror ? 0 : v * h.width + m * u.height;
          t.height = Math.min(this.maxHeight, t.height + b + f);
        } else {
          const b = n.mirror ? 0 : m * h.width + v * u.height;
          t.width = Math.min(this.maxWidth, t.width + b + f);
        }
        this._calculatePadding(c, d, v, m);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, n, s) {
    const { ticks: { align: r, padding: a }, position: o } = this.options, l = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const d = this.getPixelForTick(0) - this.left, h = this.right - this.getPixelForTick(this.ticks.length - 1);
      let u = 0, f = 0;
      l ? c ? (u = s * t.width, f = n * e.height) : (u = n * t.height, f = s * e.width) : r === "start" ? f = e.width : r === "end" ? u = t.width : r !== "inner" && (u = t.width / 2, f = e.width / 2), this.paddingLeft = Math.max((u - d + a) * this.width / (this.width - d), 0), this.paddingRight = Math.max((f - h + a) * this.width / (this.width - h), 0);
    } else {
      let d = e.height / 2, h = t.height / 2;
      r === "start" ? (d = 0, h = t.height) : r === "end" && (d = e.height, h = 0), this.paddingTop = d + a, this.paddingBottom = h + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    tt(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, n;
    for (e = 0, n = t.length; e < n; e++)
      B(t[e].label) && (t.splice(e, 1), n--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let n = this.ticks;
      e < n.length && (n = Ra(n, e)), this._labelSizes = t = this._computeLabelSizes(n, n.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, e, n) {
    const { ctx: s, _longestTextCache: r } = this, a = [], o = [], l = Math.floor(e / Ea(e, n));
    let c = 0, d = 0, h, u, f, g, m, v, b, x, w, k, _;
    for (h = 0; h < e; h += l) {
      if (g = t[h].label, m = this._resolveTickFontOptions(h), s.font = v = m.string, b = r[v] = r[v] || {
        data: {},
        gc: []
      }, x = m.lineHeight, w = k = 0, !B(g) && !et(g))
        w = Bn(s, b.data, b.gc, w, g), k = x;
      else if (et(g))
        for (u = 0, f = g.length; u < f; ++u)
          _ = g[u], !B(_) && !et(_) && (w = Bn(s, b.data, b.gc, w, _), k += x);
      a.push(w), o.push(k), c = Math.max(w, c), d = Math.max(k, d);
    }
    Gu(r, e);
    const D = a.indexOf(c), C = o.indexOf(d), $ = (T) => ({
      width: a[T] || 0,
      height: o[T] || 0
    });
    return {
      first: $(0),
      last: $(e - 1),
      widest: $(D),
      highest: $(C),
      widths: a,
      heights: o
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return zd(this._alignToPixels ? Me(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const n = e[t];
      return n.$context || (n.$context = Zu(this.getContext(), t, n));
    }
    return this.$context || (this.$context = Ku(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = Ut(this.labelRotation), n = Math.abs(Math.cos(e)), s = Math.abs(Math.sin(e)), r = this._getLabelSizes(), a = t.autoSkipPadding || 0, o = r ? r.widest.width + a : 0, l = r ? r.highest.height + a : 0;
    return this.isHorizontal() ? l * n > o * s ? o / n : l / s : l * s < o * n ? l / n : o / s;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, n = this.chart, s = this.options, { grid: r, position: a, border: o } = s, l = r.offset, c = this.isHorizontal(), h = this.ticks.length + (l ? 1 : 0), u = hi(r), f = [], g = o.setContext(this.getContext()), m = g.display ? g.width : 0, v = m / 2, b = function(H) {
      return Me(n, H, m);
    };
    let x, w, k, _, D, C, $, T, E, L, z, rt;
    if (a === "top")
      x = b(this.bottom), C = this.bottom - u, T = x - v, L = b(t.top) + v, rt = t.bottom;
    else if (a === "bottom")
      x = b(this.top), L = t.top, rt = b(t.bottom) - v, C = x + v, T = this.top + u;
    else if (a === "left")
      x = b(this.right), D = this.right - u, $ = x - v, E = b(t.left) + v, z = t.right;
    else if (a === "right")
      x = b(this.left), E = t.left, z = b(t.right) - v, D = x + v, $ = this.left + u;
    else if (e === "x") {
      if (a === "center")
        x = b((t.top + t.bottom) / 2 + 0.5);
      else if (W(a)) {
        const H = Object.keys(a)[0], Q = a[H];
        x = b(this.chart.scales[H].getPixelForValue(Q));
      }
      L = t.top, rt = t.bottom, C = x + v, T = C + u;
    } else if (e === "y") {
      if (a === "center")
        x = b((t.left + t.right) / 2);
      else if (W(a)) {
        const H = Object.keys(a)[0], Q = a[H];
        x = b(this.chart.scales[H].getPixelForValue(Q));
      }
      D = x - v, $ = D - u, E = t.left, z = t.right;
    }
    const Dt = N(s.ticks.maxTicksLimit, h), F = Math.max(1, Math.ceil(h / Dt));
    for (w = 0; w < h; w += F) {
      const H = this.getContext(w), Q = r.setContext(H), Et = o.setContext(H), mt = Q.lineWidth, de = Q.color, he = Et.dash || [], Lt = Et.dashOffset, ue = Q.tickWidth, Nt = Q.tickColor, fe = Q.tickBorderDash || [], Yt = Q.tickBorderDashOffset;
      k = Qu(this, w, l), k !== void 0 && (_ = Me(n, k, mt), c ? D = $ = E = z = _ : C = T = L = rt = _, f.push({
        tx1: D,
        ty1: C,
        tx2: $,
        ty2: T,
        x1: E,
        y1: L,
        x2: z,
        y2: rt,
        width: mt,
        color: de,
        borderDash: he,
        borderDashOffset: Lt,
        tickWidth: ue,
        tickColor: Nt,
        tickBorderDash: fe,
        tickBorderDashOffset: Yt
      }));
    }
    return this._ticksLength = h, this._borderValue = x, f;
  }
  _computeLabelItems(t) {
    const e = this.axis, n = this.options, { position: s, ticks: r } = n, a = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: c, padding: d, mirror: h } = r, u = hi(n.grid), f = u + d, g = h ? -d : f, m = -Ut(this.labelRotation), v = [];
    let b, x, w, k, _, D, C, $, T, E, L, z, rt = "middle";
    if (s === "top")
      D = this.bottom - g, C = this._getXAxisLabelAlignment();
    else if (s === "bottom")
      D = this.top + g, C = this._getXAxisLabelAlignment();
    else if (s === "left") {
      const F = this._getYAxisLabelAlignment(u);
      C = F.textAlign, _ = F.x;
    } else if (s === "right") {
      const F = this._getYAxisLabelAlignment(u);
      C = F.textAlign, _ = F.x;
    } else if (e === "x") {
      if (s === "center")
        D = (t.top + t.bottom) / 2 + f;
      else if (W(s)) {
        const F = Object.keys(s)[0], H = s[F];
        D = this.chart.scales[F].getPixelForValue(H) + f;
      }
      C = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (s === "center")
        _ = (t.left + t.right) / 2 - f;
      else if (W(s)) {
        const F = Object.keys(s)[0], H = s[F];
        _ = this.chart.scales[F].getPixelForValue(H);
      }
      C = this._getYAxisLabelAlignment(u).textAlign;
    }
    e === "y" && (l === "start" ? rt = "top" : l === "end" && (rt = "bottom"));
    const Dt = this._getLabelSizes();
    for (b = 0, x = o.length; b < x; ++b) {
      w = o[b], k = w.label;
      const F = r.setContext(this.getContext(b));
      $ = this.getPixelForTick(b) + r.labelOffset, T = this._resolveTickFontOptions(b), E = T.lineHeight, L = et(k) ? k.length : 1;
      const H = L / 2, Q = F.color, Et = F.textStrokeColor, mt = F.textStrokeWidth;
      let de = C;
      a ? (_ = $, C === "inner" && (b === x - 1 ? de = this.options.reverse ? "left" : "right" : b === 0 ? de = this.options.reverse ? "right" : "left" : de = "center"), s === "top" ? c === "near" || m !== 0 ? z = -L * E + E / 2 : c === "center" ? z = -Dt.highest.height / 2 - H * E + E : z = -Dt.highest.height + E / 2 : c === "near" || m !== 0 ? z = E / 2 : c === "center" ? z = Dt.highest.height / 2 - H * E : z = Dt.highest.height - L * E, h && (z *= -1), m !== 0 && !F.showLabelBackdrop && (_ += E / 2 * Math.sin(m))) : (D = $, z = (1 - L) * E / 2);
      let he;
      if (F.showLabelBackdrop) {
        const Lt = St(F.backdropPadding), ue = Dt.heights[b], Nt = Dt.widths[b];
        let fe = z - Lt.top, Yt = 0 - Lt.left;
        switch (rt) {
          case "middle":
            fe -= ue / 2;
            break;
          case "bottom":
            fe -= ue;
            break;
        }
        switch (C) {
          case "center":
            Yt -= Nt / 2;
            break;
          case "right":
            Yt -= Nt;
            break;
          case "inner":
            b === x - 1 ? Yt -= Nt : b > 0 && (Yt -= Nt / 2);
            break;
        }
        he = {
          left: Yt,
          top: fe,
          width: Nt + Lt.width,
          height: ue + Lt.height,
          color: F.backdropColor
        };
      }
      v.push({
        label: k,
        font: T,
        textOffset: z,
        options: {
          rotation: m,
          color: Q,
          strokeColor: Et,
          strokeWidth: mt,
          textAlign: de,
          textBaseline: rt,
          translation: [
            _,
            D
          ],
          backdrop: he
        }
      });
    }
    return v;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-Ut(this.labelRotation))
      return t === "top" ? "left" : "right";
    let s = "center";
    return e.align === "start" ? s = "left" : e.align === "end" ? s = "right" : e.align === "inner" && (s = "inner"), s;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: n, mirror: s, padding: r } } = this.options, a = this._getLabelSizes(), o = t + r, l = a.widest.width;
    let c, d;
    return e === "left" ? s ? (d = this.right + r, n === "near" ? c = "left" : n === "center" ? (c = "center", d += l / 2) : (c = "right", d += l)) : (d = this.right - o, n === "near" ? c = "right" : n === "center" ? (c = "center", d -= l / 2) : (c = "left", d = this.left)) : e === "right" ? s ? (d = this.left + r, n === "near" ? c = "right" : n === "center" ? (c = "center", d -= l / 2) : (c = "left", d -= l)) : (d = this.left + o, n === "near" ? c = "left" : n === "center" ? (c = "center", d += l / 2) : (c = "right", d = this.right)) : c = "right", {
      textAlign: c,
      x: d
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (e === "top" || e === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: n, top: s, width: r, height: a } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(n, s, r, a), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const s = this.ticks.findIndex((r) => r.value === t);
    return s >= 0 ? e.setContext(this.getContext(s)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, n = this.ctx, s = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let r, a;
    const o = (l, c, d) => {
      !d.width || !d.color || (n.save(), n.lineWidth = d.width, n.strokeStyle = d.color, n.setLineDash(d.borderDash || []), n.lineDashOffset = d.borderDashOffset, n.beginPath(), n.moveTo(l.x, l.y), n.lineTo(c.x, c.y), n.stroke(), n.restore());
    };
    if (e.display)
      for (r = 0, a = s.length; r < a; ++r) {
        const l = s[r];
        e.drawOnChartArea && o({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), e.drawTicks && o({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { border: n, grid: s } } = this, r = n.setContext(this.getContext()), a = n.display ? r.width : 0;
    if (!a)
      return;
    const o = s.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, d, h, u;
    this.isHorizontal() ? (c = Me(t, this.left, a) - a / 2, d = Me(t, this.right, o) + o / 2, h = u = l) : (h = Me(t, this.top, a) - a / 2, u = Me(t, this.bottom, o) + o / 2, c = d = l), e.save(), e.lineWidth = r.width, e.strokeStyle = r.color, e.beginPath(), e.moveTo(c, h), e.lineTo(d, u), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const n = this.ctx, s = this._computeLabelArea();
    s && Zn(n, s);
    const r = this.getLabelItems(t);
    for (const a of r) {
      const o = a.options, l = a.font, c = a.label, d = a.textOffset;
      Be(n, c, 0, d, l, o);
    }
    s && Jn(n);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: n, reverse: s } } = this;
    if (!n.display)
      return;
    const r = vt(n.font), a = St(n.padding), o = n.align;
    let l = r.lineHeight / 2;
    e === "bottom" || e === "center" || W(e) ? (l += a.bottom, et(n.text) && (l += r.lineHeight * (n.text.length - 1))) : l += a.top;
    const { titleX: c, titleY: d, maxWidth: h, rotation: u } = tf(this, l, e, o);
    Be(t, n.text, 0, 0, r, {
      color: n.color,
      maxWidth: h,
      rotation: u,
      textAlign: Ju(o, e, s),
      textBaseline: "middle",
      translation: [
        c,
        d
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, n = N(t.grid && t.grid.z, -1), s = N(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Ye.prototype.draw ? [
      {
        z: e,
        draw: (r) => {
          this.draw(r);
        }
      }
    ] : [
      {
        z: n,
        draw: (r) => {
          this.drawBackground(), this.drawGrid(r), this.drawTitle();
        }
      },
      {
        z: s,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: e,
        draw: (r) => {
          this.drawLabels(r);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), n = this.axis + "AxisID", s = [];
    let r, a;
    for (r = 0, a = e.length; r < a; ++r) {
      const o = e[r];
      o[n] === this.id && (!t || o.type === t) && s.push(o);
    }
    return s;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return vt(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class mn {
  constructor(t, e, n) {
    this.type = t, this.scope = e, this.override = n, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let n;
    sf(e) && (n = this.register(e));
    const s = this.items, r = t.id, a = this.scope + "." + r;
    if (!r)
      throw new Error("class does not have id: " + t);
    return r in s || (s[r] = t, ef(t, a, n), this.override && st.override(t.id, t.overrides)), a;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, n = t.id, s = this.scope;
    n in e && delete e[n], s && n in st[s] && (delete st[s][n], this.override && delete He[n]);
  }
}
function ef(i, t, e) {
  const n = zi(/* @__PURE__ */ Object.create(null), [
    e ? st.get(e) : {},
    st.get(t),
    i.defaults
  ]);
  st.set(t, n), i.defaultRoutes && nf(t, i.defaultRoutes), i.descriptors && st.describe(t, i.descriptors);
}
function nf(i, t) {
  Object.keys(t).forEach((e) => {
    const n = e.split("."), s = n.pop(), r = [
      i
    ].concat(n).join("."), a = t[e].split("."), o = a.pop(), l = a.join(".");
    st.route(r, s, l, o);
  });
}
function sf(i) {
  return "id" in i && "defaults" in i;
}
class rf {
  constructor() {
    this.controllers = new mn(jt, "datasets", !0), this.elements = new mn(Vt, "elements"), this.plugins = new mn(Object, "plugins"), this.scales = new mn(Ye, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, n) {
    [
      ...e
    ].forEach((s) => {
      const r = n || this._getRegistryForType(s);
      n || r.isForType(s) || r === this.plugins && s.id ? this._exec(t, r, s) : K(s, (a) => {
        const o = n || this._getRegistryForType(a);
        this._exec(t, o, a);
      });
    });
  }
  _exec(t, e, n) {
    const s = dr(t);
    tt(n["before" + s], [], n), e[t](n), tt(n["after" + s], [], n);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const n = this._typedRegistries[e];
      if (n.isForType(t))
        return n;
    }
    return this.plugins;
  }
  _get(t, e, n) {
    const s = e.get(t);
    if (s === void 0)
      throw new Error('"' + t + '" is not a registered ' + n + ".");
    return s;
  }
}
var Xt = /* @__PURE__ */ new rf();
class af {
  constructor() {
    this._init = [];
  }
  notify(t, e, n, s) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const r = s ? this._descriptors(t).filter(s) : this._descriptors(t), a = this._notify(r, t, e, n);
    return e === "afterDestroy" && (this._notify(r, t, "stop"), this._notify(this._init, t, "uninstall")), a;
  }
  _notify(t, e, n, s) {
    s = s || {};
    for (const r of t) {
      const a = r.plugin, o = a[n], l = [
        e,
        s,
        r.options
      ];
      if (tt(o, l, a) === !1 && s.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    B(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const n = t && t.config, s = N(n.options && n.options.plugins, {}), r = of(n);
    return s === !1 && !e ? [] : cf(t, r, s, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], n = this._cache, s = (r, a) => r.filter((o) => !a.some((l) => o.plugin.id === l.plugin.id));
    this._notify(s(e, n), t, "stop"), this._notify(s(n, e), t, "start");
  }
}
function of(i) {
  const t = {}, e = [], n = Object.keys(Xt.plugins.items);
  for (let r = 0; r < n.length; r++)
    e.push(Xt.getPlugin(n[r]));
  const s = i.plugins || [];
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    e.indexOf(a) === -1 && (e.push(a), t[a.id] = !0);
  }
  return {
    plugins: e,
    localIds: t
  };
}
function lf(i, t) {
  return !t && i === !1 ? null : i === !0 ? {} : i;
}
function cf(i, { plugins: t, localIds: e }, n, s) {
  const r = [], a = i.getContext();
  for (const o of t) {
    const l = o.id, c = lf(n[l], s);
    c !== null && r.push({
      plugin: o,
      options: df(i.config, {
        plugin: o,
        local: e[l]
      }, c, a)
    });
  }
  return r;
}
function df(i, { plugin: t, local: e }, n, s) {
  const r = i.pluginScopeKeys(t), a = i.getOptionScopes(n, r);
  return e && t.defaults && a.push(t.defaults), i.createResolver(a, s, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Ls(i, t) {
  const e = st.datasets[i] || {};
  return ((t.datasets || {})[i] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function hf(i, t) {
  let e = i;
  return i === "_index_" ? e = t : i === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function uf(i, t) {
  return i === t ? "_index_" : "_value_";
}
function La(i) {
  if (i === "x" || i === "y" || i === "r")
    return i;
}
function ff(i) {
  if (i === "top" || i === "bottom")
    return "x";
  if (i === "left" || i === "right")
    return "y";
}
function Ns(i, ...t) {
  if (La(i))
    return i;
  for (const e of t) {
    const n = e.axis || ff(e.position) || i.length > 1 && La(i[0].toLowerCase());
    if (n)
      return n;
  }
  throw new Error(`Cannot determine type of '${i}' axis. Please provide 'axis' or 'position' option.`);
}
function Na(i, t, e) {
  if (e[t + "AxisID"] === i)
    return {
      axis: t
    };
}
function pf(i, t) {
  if (t.data && t.data.datasets) {
    const e = t.data.datasets.filter((n) => n.xAxisID === i || n.yAxisID === i);
    if (e.length)
      return Na(i, "x", e[0]) || Na(i, "y", e[0]);
  }
  return {};
}
function gf(i, t) {
  const e = He[i.type] || {
    scales: {}
  }, n = t.scales || {}, s = Ls(i.type, t), r = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach((a) => {
    const o = n[a];
    if (!W(o))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (o._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const l = Ns(a, o, pf(a, i), st.scales[o.type]), c = uf(l, s), d = e.scales || {};
    r[a] = ki(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      o,
      d[l],
      d[c]
    ]);
  }), i.data.datasets.forEach((a) => {
    const o = a.type || i.type, l = a.indexAxis || Ls(o, t), d = (He[o] || {}).scales || {};
    Object.keys(d).forEach((h) => {
      const u = hf(h, l), f = a[u + "AxisID"] || u;
      r[f] = r[f] || /* @__PURE__ */ Object.create(null), ki(r[f], [
        {
          axis: u
        },
        n[f],
        d[h]
      ]);
    });
  }), Object.keys(r).forEach((a) => {
    const o = r[a];
    ki(o, [
      st.scales[o.type],
      st.scale
    ]);
  }), r;
}
function bl(i) {
  const t = i.options || (i.options = {});
  t.plugins = N(t.plugins, {}), t.scales = gf(i, t);
}
function yl(i) {
  return i = i || {}, i.datasets = i.datasets || [], i.labels = i.labels || [], i;
}
function mf(i) {
  return i = i || {}, i.data = yl(i.data), bl(i), i;
}
const za = /* @__PURE__ */ new Map(), xl = /* @__PURE__ */ new Set();
function vn(i, t) {
  let e = za.get(i);
  return e || (e = t(), za.set(i, e), xl.add(e)), e;
}
const ui = (i, t, e) => {
  const n = we(t, e);
  n !== void 0 && i.add(n);
};
class vf {
  constructor(t) {
    this._config = mf(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = yl(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), bl(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return vn(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, e) {
    return vn(`${t}.transition.${e}`, () => [
      [
        `datasets.${t}.transitions.${e}`,
        `transitions.${e}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, e) {
    return vn(`${t}-${e}`, () => [
      [
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const e = t.id, n = this.type;
    return vn(`${n}-plugin-${e}`, () => [
      [
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, e) {
    const n = this._scopeCache;
    let s = n.get(t);
    return (!s || e) && (s = /* @__PURE__ */ new Map(), n.set(t, s)), s;
  }
  getOptionScopes(t, e, n) {
    const { options: s, type: r } = this, a = this._cachedScopes(t, n), o = a.get(e);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    e.forEach((d) => {
      t && (l.add(t), d.forEach((h) => ui(l, t, h))), d.forEach((h) => ui(l, s, h)), d.forEach((h) => ui(l, He[r] || {}, h)), d.forEach((h) => ui(l, st, h)), d.forEach((h) => ui(l, Es, h));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), xl.has(e) && a.set(e, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      He[e] || {},
      st.datasets[e] || {},
      {
        type: e
      },
      st,
      Es
    ];
  }
  resolveNamedOptions(t, e, n, s = [
    ""
  ]) {
    const r = {
      $shared: !0
    }, { resolver: a, subPrefixes: o } = Ha(this._resolverCache, t, s);
    let l = a;
    if (yf(a, e)) {
      r.$shared = !1, n = _e(n) ? n() : n;
      const c = this.createResolver(t, n, o);
      l = ni(a, n, c);
    }
    for (const c of e)
      r[c] = l[c];
    return r;
  }
  createResolver(t, e, n = [
    ""
  ], s) {
    const { resolver: r } = Ha(this._resolverCache, t, n);
    return W(e) ? ni(r, e, void 0, s) : r;
  }
}
function Ha(i, t, e) {
  let n = i.get(t);
  n || (n = /* @__PURE__ */ new Map(), i.set(t, n));
  const s = e.join();
  let r = n.get(s);
  return r || (r = {
    resolver: mr(t, e),
    subPrefixes: e.filter((o) => !o.toLowerCase().includes("hover"))
  }, n.set(s, r)), r;
}
const bf = (i) => W(i) && Object.getOwnPropertyNames(i).some((t) => _e(i[t]));
function yf(i, t) {
  const { isScriptable: e, isIndexable: n } = Zo(i);
  for (const s of t) {
    const r = e(s), a = n(s), o = (a || r) && i[s];
    if (r && (_e(o) || bf(o)) || a && et(o))
      return !0;
  }
  return !1;
}
var xf = "4.4.8";
const wf = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Ba(i, t) {
  return i === "top" || i === "bottom" || wf.indexOf(i) === -1 && t === "x";
}
function Wa(i, t) {
  return function(e, n) {
    return e[i] === n[i] ? e[t] - n[t] : e[i] - n[i];
  };
}
function Ua(i) {
  const t = i.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), tt(e && e.onComplete, [
    i
  ], t);
}
function _f(i) {
  const t = i.chart, e = t.options.animation;
  tt(e && e.onProgress, [
    i
  ], t);
}
function wl(i) {
  return yr() && typeof i == "string" ? i = document.getElementById(i) : i && i.length && (i = i[0]), i && i.canvas && (i = i.canvas), i;
}
const Tn = {}, ja = (i) => {
  const t = wl(i);
  return Object.values(Tn).filter((e) => e.canvas === t).pop();
};
function kf(i, t, e) {
  const n = Object.keys(i);
  for (const s of n) {
    const r = +s;
    if (r >= t) {
      const a = i[s];
      delete i[s], (e > 0 || r > t) && (i[r + e] = a);
    }
  }
}
function Df(i, t, e, n) {
  return !e || i.type === "mouseout" ? null : n ? t : i;
}
function bn(i, t, e) {
  return i.options.clip ? i[e] : t[e];
}
function Cf(i, t) {
  const { xScale: e, yScale: n } = i;
  return e && n ? {
    left: bn(e, t, "left"),
    right: bn(e, t, "right"),
    top: bn(n, t, "top"),
    bottom: bn(n, t, "bottom")
  } : t;
}
class xt {
  static register(...t) {
    Xt.add(...t), Va();
  }
  static unregister(...t) {
    Xt.remove(...t), Va();
  }
  constructor(t, e) {
    const n = this.config = new vf(e), s = wl(t), r = ja(s);
    if (r)
      throw new Error("Canvas is already in use. Chart with ID '" + r.id + "' must be destroyed before the canvas with ID '" + r.canvas.id + "' can be reused.");
    const a = n.createResolver(n.chartOptionScopes(), this.getContext());
    this.platform = new (n.platform || Bu(s))(), this.platform.updateConfig(n);
    const o = this.platform.acquireContext(s, a.aspectRatio), l = o && o.canvas, c = l && l.height, d = l && l.width;
    if (this.id = $d(), this.ctx = o, this.canvas = l, this.width = d, this.height = c, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new af(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = Ud((h) => this.update(h), a.resizeDelay || 0), this._dataChanges = [], Tn[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    ie.listen(this, "complete", Ua), ie.listen(this, "progress", _f), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: n, height: s, _aspectRatio: r } = this;
    return B(t) ? e && r ? r : s ? n / s : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Xt;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : fa(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return da(this.canvas, this.ctx), this;
  }
  stop() {
    return ie.stop(this), this;
  }
  resize(t, e) {
    ie.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: e
    } : this._resize(t, e);
  }
  _resize(t, e) {
    const n = this.options, s = this.canvas, r = n.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(s, t, e, r), o = n.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, fa(this, o, !0) && (this.notifyPlugins("resize", {
      size: a
    }), tt(n.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const e = this.options.scales || {};
    K(e, (n, s) => {
      n.id = s;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, n = this.scales, s = Object.keys(n).reduce((a, o) => (a[o] = !1, a), {});
    let r = [];
    e && (r = r.concat(Object.keys(e).map((a) => {
      const o = e[a], l = Ns(a, o), c = l === "r", d = l === "x";
      return {
        options: o,
        dposition: c ? "chartArea" : d ? "bottom" : "left",
        dtype: c ? "radialLinear" : d ? "category" : "linear"
      };
    }))), K(r, (a) => {
      const o = a.options, l = o.id, c = Ns(l, o), d = N(o.type, a.dtype);
      (o.position === void 0 || Ba(o.position, c) !== Ba(a.dposition)) && (o.position = a.dposition), s[l] = !0;
      let h = null;
      if (l in n && n[l].type === d)
        h = n[l];
      else {
        const u = Xt.getScale(d);
        h = new u({
          id: l,
          type: d,
          ctx: this.ctx,
          chart: this
        }), n[h.id] = h;
      }
      h.init(o, t);
    }), K(s, (a, o) => {
      a || delete n[o];
    }), K(n, (a) => {
      Mt.configure(this, a, a.options), Mt.addBox(this, a);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, n = t.length;
    if (t.sort((s, r) => s.index - r.index), n > e) {
      for (let s = e; s < n; ++s)
        this._destroyDatasetMeta(s);
      t.splice(e, n - e);
    }
    this._sortedMetasets = t.slice(0).sort(Wa("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((n, s) => {
      e.filter((r) => r === n._dataset).length === 0 && this._destroyDatasetMeta(s);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let n, s;
    for (this._removeUnreferencedMetasets(), n = 0, s = e.length; n < s; n++) {
      const r = e[n];
      let a = this.getDatasetMeta(n);
      const o = r.type || this.config.type;
      if (a.type && a.type !== o && (this._destroyDatasetMeta(n), a = this.getDatasetMeta(n)), a.type = o, a.indexAxis = r.indexAxis || Ls(o, this.options), a.order = r.order || 0, a.index = n, a.label = "" + r.label, a.visible = this.isDatasetVisible(n), a.controller)
        a.controller.updateIndex(n), a.controller.linkScales();
      else {
        const l = Xt.getController(o), { datasetElementType: c, dataElementType: d } = st.datasets[o];
        Object.assign(l, {
          dataElementType: Xt.getElement(d),
          datasetElementType: c && Xt.getElement(c)
        }), a.controller = new l(this, n), t.push(a.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    K(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const n = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), s = this._animationsDisabled = !n.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const r = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let c = 0, d = this.data.datasets.length; c < d; c++) {
      const { controller: h } = this.getDatasetMeta(c), u = !s && r.indexOf(h) === -1;
      h.buildOrUpdateElements(u), a = Math.max(+h.getMaxOverflow(), a);
    }
    a = this._minPadding = n.layout.autoPadding ? a : 0, this._updateLayout(a), s || K(r, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(Wa("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    K(this.scales, (t) => {
      Mt.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), n = new Set(t.events);
    (!ea(e, n) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: n, start: s, count: r } of e) {
      const a = n === "_removeElements" ? -r : r;
      kf(t, s, a);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, n = (r) => new Set(t.filter((a) => a[0] === r).map((a, o) => o + "," + a.splice(1).join(","))), s = n(0);
    for (let r = 1; r < e; r++)
      if (!ea(s, n(r)))
        return;
    return Array.from(s).map((r) => r.split(",")).map((r) => ({
      method: r[1],
      start: +r[2],
      count: +r[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Mt.update(this, this.width, this.height, t);
    const e = this.chartArea, n = e.width <= 0 || e.height <= 0;
    this._layers = [], K(this.boxes, (s) => {
      n && s.position === "chartArea" || (s.configure && s.configure(), this._layers.push(...s._layers()));
    }, this), this._layers.forEach((s, r) => {
      s._idx = r;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let e = 0, n = this.data.datasets.length; e < n; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, n = this.data.datasets.length; e < n; ++e)
        this._updateDataset(e, _e(t) ? t({
          datasetIndex: e
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, e) {
    const n = this.getDatasetMeta(t), s = {
      meta: n,
      index: t,
      mode: e,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", s) !== !1 && (n.controller._update(e), s.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", s));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (ie.has(this) ? this.attached && !ie.running(this) && ie.start(this) : (this.draw(), Ua({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: n, height: s } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(n, s);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, n = [];
    let s, r;
    for (s = 0, r = e.length; s < r; ++s) {
      const a = e[s];
      (!t || a.visible) && n.push(a);
    }
    return n;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, n = t._clip, s = !n.disabled, r = Cf(t, this.chartArea), a = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", a) !== !1 && (s && Zn(e, {
      left: n.left === !1 ? 0 : r.left - n.left,
      right: n.right === !1 ? this.width : r.right + n.right,
      top: n.top === !1 ? 0 : r.top - n.top,
      bottom: n.bottom === !1 ? this.height : r.bottom + n.bottom
    }), t.controller.draw(), s && Jn(e), a.cancelable = !1, this.notifyPlugins("afterDatasetDraw", a));
  }
  isPointInArea(t) {
    return oe(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, n, s) {
    const r = xu.modes[e];
    return typeof r == "function" ? r(this, t, n, s) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], n = this._metasets;
    let s = n.filter((r) => r && r._dataset === e).pop();
    return s || (s = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, n.push(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = ke(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const n = this.getDatasetMeta(t);
    return typeof n.hidden == "boolean" ? !n.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const n = this.getDatasetMeta(t);
    n.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, n) {
    const s = n ? "show" : "hide", r = this.getDatasetMeta(t), a = r.controller._resolveAnimations(void 0, s);
    Hi(e) ? (r.data[e].hidden = !n, this.update()) : (this.setDatasetVisibility(t, n), a.update(r, {
      visible: n
    }), this.update((o) => o.datasetIndex === t ? s : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), ie.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), da(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), delete Tn[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, n = (r, a) => {
      e.addEventListener(this, r, a), t[r] = a;
    }, s = (r, a, o) => {
      r.offsetX = a, r.offsetY = o, this._eventHandler(r);
    };
    K(this.options.events, (r) => n(r, s));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, n = (l, c) => {
      e.addEventListener(this, l, c), t[l] = c;
    }, s = (l, c) => {
      t[l] && (e.removeEventListener(this, l, c), delete t[l]);
    }, r = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let a;
    const o = () => {
      s("attach", o), this.attached = !0, this.resize(), n("resize", r), n("detach", a);
    };
    a = () => {
      this.attached = !1, s("resize", r), this._stop(), this._resize(0, 0), n("attach", o);
    }, e.isAttached(this.canvas) ? o() : a();
  }
  unbindEvents() {
    K(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, K(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, n) {
    const s = n ? "set" : "remove";
    let r, a, o, l;
    for (e === "dataset" && (r = this.getDatasetMeta(t[0].datasetIndex), r.controller["_" + s + "DatasetHoverStyle"]()), o = 0, l = t.length; o < l; ++o) {
      a = t[o];
      const c = a && this.getDatasetMeta(a.datasetIndex).controller;
      c && c[s + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], n = t.map(({ datasetIndex: r, index: a }) => {
      const o = this.getDatasetMeta(r);
      if (!o)
        throw new Error("No dataset found at index " + r);
      return {
        datasetIndex: r,
        element: o.data[a],
        index: a
      };
    });
    !Nn(n, e) && (this._active = n, this._lastEvent = null, this._updateHoverStyles(n, e));
  }
  notifyPlugins(t, e, n) {
    return this._plugins.notify(this, t, e, n);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((e) => e.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, e, n) {
    const s = this.options.hover, r = (l, c) => l.filter((d) => !c.some((h) => d.datasetIndex === h.datasetIndex && d.index === h.index)), a = r(e, t), o = n ? t : r(t, e);
    a.length && this.updateHoverStyle(a, s.mode, !1), o.length && s.mode && this.updateHoverStyle(o, s.mode, !0);
  }
  _eventHandler(t, e) {
    const n = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, s = (a) => (a.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", n, s) === !1)
      return;
    const r = this._handleEvent(t, e, n.inChartArea);
    return n.cancelable = !1, this.notifyPlugins("afterEvent", n, s), (r || n.changed) && this.render(), this;
  }
  _handleEvent(t, e, n) {
    const { _active: s = [], options: r } = this, a = e, o = this._getActiveElements(t, s, n, a), l = Ad(t), c = Df(t, this._lastEvent, n, l);
    n && (this._lastEvent = null, tt(r.onHover, [
      t,
      o,
      this
    ], this), l && tt(r.onClick, [
      t,
      o,
      this
    ], this));
    const d = !Nn(o, s);
    return (d || e) && (this._active = o, this._updateHoverStyles(o, s, e)), this._lastEvent = c, d;
  }
  _getActiveElements(t, e, n, s) {
    if (t.type === "mouseout")
      return [];
    if (!n)
      return e;
    const r = this.options.hover;
    return this.getElementsAtEventForMode(t, r.mode, r, s);
  }
}
P(xt, "defaults", st), P(xt, "instances", Tn), P(xt, "overrides", He), P(xt, "registry", Xt), P(xt, "version", xf), P(xt, "getChart", ja);
function Va() {
  return K(xt.instances, (i) => i._plugins.invalidate());
}
function $f(i, t, e) {
  const { startAngle: n, pixelMargin: s, x: r, y: a, outerRadius: o, innerRadius: l } = t;
  let c = s / o;
  i.beginPath(), i.arc(r, a, o, n - c, e + c), l > s ? (c = s / l, i.arc(r, a, l, e + c, n - c, !0)) : i.arc(r, a, s, e + ft, n - ft), i.closePath(), i.clip();
}
function Pf(i) {
  return gr(i, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function Mf(i, t, e, n) {
  const s = Pf(i.options.borderRadius), r = (e - t) / 2, a = Math.min(r, n * t / 2), o = (l) => {
    const c = (e - Math.min(r, l)) * n / 2;
    return wt(l, 0, Math.min(r, c));
  };
  return {
    outerStart: o(s.outerStart),
    outerEnd: o(s.outerEnd),
    innerStart: wt(s.innerStart, 0, a),
    innerEnd: wt(s.innerEnd, 0, a)
  };
}
function Xe(i, t, e, n) {
  return {
    x: e + i * Math.cos(t),
    y: n + i * Math.sin(t)
  };
}
function jn(i, t, e, n, s, r) {
  const { x: a, y: o, startAngle: l, pixelMargin: c, innerRadius: d } = t, h = Math.max(t.outerRadius + n + e - c, 0), u = d > 0 ? d + n + e + c : 0;
  let f = 0;
  const g = s - l;
  if (n) {
    const F = d > 0 ? d - n : 0, H = h > 0 ? h - n : 0, Q = (F + H) / 2, Et = Q !== 0 ? g * Q / (Q + n) : g;
    f = (g - Et) / 2;
  }
  const m = Math.max(1e-3, g * h - e / nt) / h, v = (g - m) / 2, b = l + v + f, x = s - v - f, { outerStart: w, outerEnd: k, innerStart: _, innerEnd: D } = Mf(t, u, h, x - b), C = h - w, $ = h - k, T = b + w / C, E = x - k / $, L = u + _, z = u + D, rt = b + _ / L, Dt = x - D / z;
  if (i.beginPath(), r) {
    const F = (T + E) / 2;
    if (i.arc(a, o, h, T, F), i.arc(a, o, h, F, E), k > 0) {
      const mt = Xe($, E, a, o);
      i.arc(mt.x, mt.y, k, E, x + ft);
    }
    const H = Xe(z, x, a, o);
    if (i.lineTo(H.x, H.y), D > 0) {
      const mt = Xe(z, Dt, a, o);
      i.arc(mt.x, mt.y, D, x + ft, Dt + Math.PI);
    }
    const Q = (x - D / u + (b + _ / u)) / 2;
    if (i.arc(a, o, u, x - D / u, Q, !0), i.arc(a, o, u, Q, b + _ / u, !0), _ > 0) {
      const mt = Xe(L, rt, a, o);
      i.arc(mt.x, mt.y, _, rt + Math.PI, b - ft);
    }
    const Et = Xe(C, b, a, o);
    if (i.lineTo(Et.x, Et.y), w > 0) {
      const mt = Xe(C, T, a, o);
      i.arc(mt.x, mt.y, w, b - ft, T);
    }
  } else {
    i.moveTo(a, o);
    const F = Math.cos(T) * h + a, H = Math.sin(T) * h + o;
    i.lineTo(F, H);
    const Q = Math.cos(E) * h + a, Et = Math.sin(E) * h + o;
    i.lineTo(Q, Et);
  }
  i.closePath();
}
function Sf(i, t, e, n, s) {
  const { fullCircles: r, startAngle: a, circumference: o } = t;
  let l = t.endAngle;
  if (r) {
    jn(i, t, e, n, l, s);
    for (let c = 0; c < r; ++c)
      i.fill();
    isNaN(o) || (l = a + (o % it || it));
  }
  return jn(i, t, e, n, l, s), i.fill(), l;
}
function Tf(i, t, e, n, s) {
  const { fullCircles: r, startAngle: a, circumference: o, options: l } = t, { borderWidth: c, borderJoinStyle: d, borderDash: h, borderDashOffset: u } = l, f = l.borderAlign === "inner";
  if (!c)
    return;
  i.setLineDash(h || []), i.lineDashOffset = u, f ? (i.lineWidth = c * 2, i.lineJoin = d || "round") : (i.lineWidth = c, i.lineJoin = d || "bevel");
  let g = t.endAngle;
  if (r) {
    jn(i, t, e, n, g, s);
    for (let m = 0; m < r; ++m)
      i.stroke();
    isNaN(o) || (g = a + (o % it || it));
  }
  f && $f(i, t, g), r || (jn(i, t, e, n, g, s), i.stroke());
}
class yi extends Vt {
  constructor(e) {
    super();
    P(this, "circumference");
    P(this, "endAngle");
    P(this, "fullCircles");
    P(this, "innerRadius");
    P(this, "outerRadius");
    P(this, "pixelMargin");
    P(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, e && Object.assign(this, e);
  }
  inRange(e, n, s) {
    const r = this.getProps([
      "x",
      "y"
    ], s), { angle: a, distance: o } = Wo(r, {
      x: e,
      y: n
    }), { startAngle: l, endAngle: c, innerRadius: d, outerRadius: h, circumference: u } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], s), f = (this.options.spacing + this.options.borderWidth) / 2, g = N(u, c - l), m = Bi(a, l, c) && l !== c, v = g >= it || m, b = re(o, d + f, h + f);
    return v && b;
  }
  getCenterPoint(e) {
    const { x: n, y: s, startAngle: r, endAngle: a, innerRadius: o, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], e), { offset: c, spacing: d } = this.options, h = (r + a) / 2, u = (o + l + d + c) / 2;
    return {
      x: n + Math.cos(h) * u,
      y: s + Math.sin(h) * u
    };
  }
  tooltipPosition(e) {
    return this.getCenterPoint(e);
  }
  draw(e) {
    const { options: n, circumference: s } = this, r = (n.offset || 0) / 4, a = (n.spacing || 0) / 2, o = n.circular;
    if (this.pixelMargin = n.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = s > it ? Math.floor(s / it) : 0, s === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    e.save();
    const l = (this.startAngle + this.endAngle) / 2;
    e.translate(Math.cos(l) * r, Math.sin(l) * r);
    const c = 1 - Math.sin(Math.min(nt, s || 0)), d = r * c;
    e.fillStyle = n.backgroundColor, e.strokeStyle = n.borderColor, Sf(e, this, d, a, o), Tf(e, this, d, a, o), e.restore();
  }
}
P(yi, "id", "arc"), P(yi, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), P(yi, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), P(yi, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash"
});
function _l(i, t, e = t) {
  i.lineCap = N(e.borderCapStyle, t.borderCapStyle), i.setLineDash(N(e.borderDash, t.borderDash)), i.lineDashOffset = N(e.borderDashOffset, t.borderDashOffset), i.lineJoin = N(e.borderJoinStyle, t.borderJoinStyle), i.lineWidth = N(e.borderWidth, t.borderWidth), i.strokeStyle = N(e.borderColor, t.borderColor);
}
function Of(i, t, e) {
  i.lineTo(e.x, e.y);
}
function Af(i) {
  return i.stepped ? eh : i.tension || i.cubicInterpolationMode === "monotone" ? ih : Of;
}
function kl(i, t, e = {}) {
  const n = i.length, { start: s = 0, end: r = n - 1 } = e, { start: a, end: o } = t, l = Math.max(s, a), c = Math.min(r, o), d = s < a && r < a || s > o && r > o;
  return {
    count: n,
    start: l,
    loop: t.loop,
    ilen: c < l && !d ? n + c - l : c - l
  };
}
function If(i, t, e, n) {
  const { points: s, options: r } = t, { count: a, start: o, loop: l, ilen: c } = kl(s, e, n), d = Af(r);
  let { move: h = !0, reverse: u } = n || {}, f, g, m;
  for (f = 0; f <= c; ++f)
    g = s[(o + (u ? c - f : f)) % a], !g.skip && (h ? (i.moveTo(g.x, g.y), h = !1) : d(i, m, g, u, r.stepped), m = g);
  return l && (g = s[(o + (u ? c : 0)) % a], d(i, m, g, u, r.stepped)), !!l;
}
function Ef(i, t, e, n) {
  const s = t.points, { count: r, start: a, ilen: o } = kl(s, e, n), { move: l = !0, reverse: c } = n || {};
  let d = 0, h = 0, u, f, g, m, v, b;
  const x = (k) => (a + (c ? o - k : k)) % r, w = () => {
    m !== v && (i.lineTo(d, v), i.lineTo(d, m), i.lineTo(d, b));
  };
  for (l && (f = s[x(0)], i.moveTo(f.x, f.y)), u = 0; u <= o; ++u) {
    if (f = s[x(u)], f.skip)
      continue;
    const k = f.x, _ = f.y, D = k | 0;
    D === g ? (_ < m ? m = _ : _ > v && (v = _), d = (h * d + k) / ++h) : (w(), i.lineTo(k, _), g = D, h = 0, m = v = _), b = _;
  }
  w();
}
function zs(i) {
  const t = i.options, e = t.borderDash && t.borderDash.length;
  return !i._decimated && !i._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !e ? Ef : If;
}
function Rf(i) {
  return i.stepped ? Eh : i.tension || i.cubicInterpolationMode === "monotone" ? Rh : Ae;
}
function Ff(i, t, e, n) {
  let s = t._path;
  s || (s = t._path = new Path2D(), t.path(s, e, n) && s.closePath()), _l(i, t.options), i.stroke(s);
}
function Lf(i, t, e, n) {
  const { segments: s, options: r } = t, a = zs(t);
  for (const o of s)
    _l(i, r, o.style), i.beginPath(), a(i, t, o, {
      start: e,
      end: e + n - 1
    }) && i.closePath(), i.stroke();
}
const Nf = typeof Path2D == "function";
function zf(i, t, e, n) {
  Nf && !t.options.segment ? Ff(i, t, e, n) : Lf(i, t, e, n);
}
class be extends Vt {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, e) {
    const n = this.options;
    if ((n.tension || n.cubicInterpolationMode === "monotone") && !n.stepped && !this._pointsUpdated) {
      const s = n.spanGaps ? this._loop : this._fullLoop;
      $h(this._points, n, t, s, e), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = Bh(this, this.options.segment));
  }
  first() {
    const t = this.segments, e = this.points;
    return t.length && e[t[0].start];
  }
  last() {
    const t = this.segments, e = this.points, n = t.length;
    return n && e[t[n - 1].end];
  }
  interpolate(t, e) {
    const n = this.options, s = t[e], r = this.points, a = ll(this, {
      property: e,
      start: s,
      end: s
    });
    if (!a.length)
      return;
    const o = [], l = Rf(n);
    let c, d;
    for (c = 0, d = a.length; c < d; ++c) {
      const { start: h, end: u } = a[c], f = r[h], g = r[u];
      if (f === g) {
        o.push(f);
        continue;
      }
      const m = Math.abs((s - f[e]) / (g[e] - f[e])), v = l(f, g, m, n.stepped);
      v[e] = t[e], o.push(v);
    }
    return o.length === 1 ? o[0] : o;
  }
  pathSegment(t, e, n) {
    return zs(this)(t, this, e, n);
  }
  path(t, e, n) {
    const s = this.segments, r = zs(this);
    let a = this._loop;
    e = e || 0, n = n || this.points.length - e;
    for (const o of s)
      a &= r(t, this, o, {
        start: e,
        end: e + n - 1
      });
    return !!a;
  }
  draw(t, e, n, s) {
    const r = this.options || {};
    (this.points || []).length && r.borderWidth && (t.save(), zf(t, this, n, s), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
P(be, "id", "line"), P(be, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), P(be, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), P(be, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function Ya(i, t, e, n) {
  const s = i.options, { [e]: r } = i.getProps([
    e
  ], n);
  return Math.abs(t - r) < s.radius + s.hitRadius;
}
class On extends Vt {
  constructor(e) {
    super();
    P(this, "parsed");
    P(this, "skip");
    P(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, e && Object.assign(this, e);
  }
  inRange(e, n, s) {
    const r = this.options, { x: a, y: o } = this.getProps([
      "x",
      "y"
    ], s);
    return Math.pow(e - a, 2) + Math.pow(n - o, 2) < Math.pow(r.hitRadius + r.radius, 2);
  }
  inXRange(e, n) {
    return Ya(this, e, "x", n);
  }
  inYRange(e, n) {
    return Ya(this, e, "y", n);
  }
  getCenterPoint(e) {
    const { x: n, y: s } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: s
    };
  }
  size(e) {
    e = e || this.options || {};
    let n = e.radius || 0;
    n = Math.max(n, n && e.hoverRadius || 0);
    const s = n && e.borderWidth || 0;
    return (n + s) * 2;
  }
  draw(e, n) {
    const s = this.options;
    this.skip || s.radius < 0.1 || !oe(this, n, this.size(s) / 2) || (e.strokeStyle = s.borderColor, e.lineWidth = s.borderWidth, e.fillStyle = s.backgroundColor, Rs(e, s, this.x, this.y));
  }
  getRange() {
    const e = this.options || {};
    return e.radius + e.hitRadius;
  }
}
P(On, "id", "point"), /**
* @type {any}
*/
P(On, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
P(On, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Dl(i, t) {
  const { x: e, y: n, base: s, width: r, height: a } = i.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let o, l, c, d, h;
  return i.horizontal ? (h = a / 2, o = Math.min(e, s), l = Math.max(e, s), c = n - h, d = n + h) : (h = r / 2, o = e - h, l = e + h, c = Math.min(n, s), d = Math.max(n, s)), {
    left: o,
    top: c,
    right: l,
    bottom: d
  };
}
function ye(i, t, e, n) {
  return i ? 0 : wt(t, e, n);
}
function Hf(i, t, e) {
  const n = i.options.borderWidth, s = i.borderSkipped, r = Ko(n);
  return {
    t: ye(s.top, r.top, 0, e),
    r: ye(s.right, r.right, 0, t),
    b: ye(s.bottom, r.bottom, 0, e),
    l: ye(s.left, r.left, 0, t)
  };
}
function Bf(i, t, e) {
  const { enableBorderRadius: n } = i.getProps([
    "enableBorderRadius"
  ]), s = i.options.borderRadius, r = Fe(s), a = Math.min(t, e), o = i.borderSkipped, l = n || W(s);
  return {
    topLeft: ye(!l || o.top || o.left, r.topLeft, 0, a),
    topRight: ye(!l || o.top || o.right, r.topRight, 0, a),
    bottomLeft: ye(!l || o.bottom || o.left, r.bottomLeft, 0, a),
    bottomRight: ye(!l || o.bottom || o.right, r.bottomRight, 0, a)
  };
}
function Wf(i) {
  const t = Dl(i), e = t.right - t.left, n = t.bottom - t.top, s = Hf(i, e / 2, n / 2), r = Bf(i, e / 2, n / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: e,
      h: n,
      radius: r
    },
    inner: {
      x: t.left + s.l,
      y: t.top + s.t,
      w: e - s.l - s.r,
      h: n - s.t - s.b,
      radius: {
        topLeft: Math.max(0, r.topLeft - Math.max(s.t, s.l)),
        topRight: Math.max(0, r.topRight - Math.max(s.t, s.r)),
        bottomLeft: Math.max(0, r.bottomLeft - Math.max(s.b, s.l)),
        bottomRight: Math.max(0, r.bottomRight - Math.max(s.b, s.r))
      }
    }
  };
}
function Ds(i, t, e, n) {
  const s = t === null, r = e === null, o = i && !(s && r) && Dl(i, n);
  return o && (s || re(t, o.left, o.right)) && (r || re(e, o.top, o.bottom));
}
function Uf(i) {
  return i.topLeft || i.topRight || i.bottomLeft || i.bottomRight;
}
function jf(i, t) {
  i.rect(t.x, t.y, t.w, t.h);
}
function Cs(i, t, e = {}) {
  const n = i.x !== e.x ? -t : 0, s = i.y !== e.y ? -t : 0, r = (i.x + i.w !== e.x + e.w ? t : 0) - n, a = (i.y + i.h !== e.y + e.h ? t : 0) - s;
  return {
    x: i.x + n,
    y: i.y + s,
    w: i.w + r,
    h: i.h + a,
    radius: i.radius
  };
}
class An extends Vt {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: e, options: { borderColor: n, backgroundColor: s } } = this, { inner: r, outer: a } = Wf(this), o = Uf(a.radius) ? Wi : jf;
    t.save(), (a.w !== r.w || a.h !== r.h) && (t.beginPath(), o(t, Cs(a, e, r)), t.clip(), o(t, Cs(r, -e, a)), t.fillStyle = n, t.fill("evenodd")), t.beginPath(), o(t, Cs(r, e)), t.fillStyle = s, t.fill(), t.restore();
  }
  inRange(t, e, n) {
    return Ds(this, t, e, n);
  }
  inXRange(t, e) {
    return Ds(this, t, null, e);
  }
  inYRange(t, e) {
    return Ds(this, null, t, e);
  }
  getCenterPoint(t) {
    const { x: e, y: n, base: s, horizontal: r } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: r ? (e + s) / 2 : e,
      y: r ? n : (n + s) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
P(An, "id", "bar"), P(An, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), P(An, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var Vf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: yi,
  BarElement: An,
  LineElement: be,
  PointElement: On
});
const Hs = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], qa = /* @__PURE__ */ Hs.map((i) => i.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function Cl(i) {
  return Hs[i % Hs.length];
}
function $l(i) {
  return qa[i % qa.length];
}
function Yf(i, t) {
  return i.borderColor = Cl(t), i.backgroundColor = $l(t), ++t;
}
function qf(i, t) {
  return i.backgroundColor = i.data.map(() => Cl(t++)), t;
}
function Xf(i, t) {
  return i.backgroundColor = i.data.map(() => $l(t++)), t;
}
function Qf(i) {
  let t = 0;
  return (e, n) => {
    const s = i.getDatasetMeta(n).controller;
    s instanceof Re ? t = qf(e, t) : s instanceof Pi ? t = Xf(e, t) : s && (t = Yf(e, t));
  };
}
function Xa(i) {
  let t;
  for (t in i)
    if (i[t].borderColor || i[t].backgroundColor)
      return !0;
  return !1;
}
function Gf(i) {
  return i && (i.borderColor || i.backgroundColor);
}
function Kf() {
  return st.borderColor !== "rgba(0,0,0,0.1)" || st.backgroundColor !== "rgba(0,0,0,0.1)";
}
var Zf = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(i, t, e) {
    if (!e.enabled)
      return;
    const { data: { datasets: n }, options: s } = i.config, { elements: r } = s, a = Xa(n) || Gf(s) || r && Xa(r) || Kf();
    if (!e.forceOverride && a)
      return;
    const o = Qf(i);
    n.forEach(o);
  }
};
function Jf(i, t, e, n, s) {
  const r = s.samples || n;
  if (r >= e)
    return i.slice(t, t + e);
  const a = [], o = (e - 2) / (r - 2);
  let l = 0;
  const c = t + e - 1;
  let d = t, h, u, f, g, m;
  for (a[l++] = i[d], h = 0; h < r - 2; h++) {
    let v = 0, b = 0, x;
    const w = Math.floor((h + 1) * o) + 1 + t, k = Math.min(Math.floor((h + 2) * o) + 1, e) + t, _ = k - w;
    for (x = w; x < k; x++)
      v += i[x].x, b += i[x].y;
    v /= _, b /= _;
    const D = Math.floor(h * o) + 1 + t, C = Math.min(Math.floor((h + 1) * o) + 1, e) + t, { x: $, y: T } = i[d];
    for (f = g = -1, x = D; x < C; x++)
      g = 0.5 * Math.abs(($ - v) * (i[x].y - T) - ($ - i[x].x) * (b - T)), g > f && (f = g, u = i[x], m = x);
    a[l++] = u, d = m;
  }
  return a[l++] = i[c], a;
}
function tp(i, t, e, n) {
  let s = 0, r = 0, a, o, l, c, d, h, u, f, g, m;
  const v = [], b = t + e - 1, x = i[t].x, k = i[b].x - x;
  for (a = t; a < t + e; ++a) {
    o = i[a], l = (o.x - x) / k * n, c = o.y;
    const _ = l | 0;
    if (_ === d)
      c < g ? (g = c, h = a) : c > m && (m = c, u = a), s = (r * s + o.x) / ++r;
    else {
      const D = a - 1;
      if (!B(h) && !B(u)) {
        const C = Math.min(h, u), $ = Math.max(h, u);
        C !== f && C !== D && v.push(ot(at({}, i[C]), {
          x: s
        })), $ !== f && $ !== D && v.push(ot(at({}, i[$]), {
          x: s
        }));
      }
      a > 0 && D !== f && v.push(i[D]), v.push(o), d = _, r = 0, g = m = c, h = u = f = a;
    }
  }
  return v;
}
function Pl(i) {
  if (i._decimated) {
    const t = i._data;
    delete i._decimated, delete i._data, Object.defineProperty(i, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function Qa(i) {
  i.data.datasets.forEach((t) => {
    Pl(t);
  });
}
function ep(i, t) {
  const e = t.length;
  let n = 0, s;
  const { iScale: r } = i, { min: a, max: o, minDefined: l, maxDefined: c } = r.getUserBounds();
  return l && (n = wt(ae(t, r.axis, a).lo, 0, e - 1)), c ? s = wt(ae(t, r.axis, o).hi + 1, n, e) - n : s = e - n, {
    start: n,
    count: s
  };
}
var ip = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (i, t, e) => {
    if (!e.enabled) {
      Qa(i);
      return;
    }
    const n = i.width;
    i.data.datasets.forEach((s, r) => {
      const { _data: a, indexAxis: o } = s, l = i.getDatasetMeta(r), c = a || s.data;
      if (vi([
        o,
        i.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const d = i.scales[l.xAxisID];
      if (d.type !== "linear" && d.type !== "time" || i.options.parsing)
        return;
      let { start: h, count: u } = ep(l, c);
      const f = e.threshold || 4 * n;
      if (u <= f) {
        Pl(s);
        return;
      }
      B(a) && (s._data = c, delete s.data, Object.defineProperty(s, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(m) {
          this._data = m;
        }
      }));
      let g;
      switch (e.algorithm) {
        case "lttb":
          g = Jf(c, h, u, n, e);
          break;
        case "min-max":
          g = tp(c, h, u, n);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${e.algorithm}'`);
      }
      s._decimated = g;
    });
  },
  destroy(i) {
    Qa(i);
  }
};
function np(i, t, e) {
  const n = i.segments, s = i.points, r = t.points, a = [];
  for (const o of n) {
    let { start: l, end: c } = o;
    c = _r(l, c, s);
    const d = Bs(e, s[l], s[c], o.loop);
    if (!t.segments) {
      a.push({
        source: o,
        target: d,
        start: s[l],
        end: s[c]
      });
      continue;
    }
    const h = ll(t, d);
    for (const u of h) {
      const f = Bs(e, r[u.start], r[u.end], u.loop), g = ol(o, s, f);
      for (const m of g)
        a.push({
          source: m,
          target: u,
          start: {
            [e]: Ga(d, f, "start", Math.max)
          },
          end: {
            [e]: Ga(d, f, "end", Math.min)
          }
        });
    }
  }
  return a;
}
function Bs(i, t, e, n) {
  if (n)
    return;
  let s = t[i], r = e[i];
  return i === "angle" && (s = Ft(s), r = Ft(r)), {
    property: i,
    start: s,
    end: r
  };
}
function sp(i, t) {
  const { x: e = null, y: n = null } = i || {}, s = t.points, r = [];
  return t.segments.forEach(({ start: a, end: o }) => {
    o = _r(a, o, s);
    const l = s[a], c = s[o];
    n !== null ? (r.push({
      x: l.x,
      y: n
    }), r.push({
      x: c.x,
      y: n
    })) : e !== null && (r.push({
      x: e,
      y: l.y
    }), r.push({
      x: e,
      y: c.y
    }));
  }), r;
}
function _r(i, t, e) {
  for (; t > i; t--) {
    const n = e[t];
    if (!isNaN(n.x) && !isNaN(n.y))
      break;
  }
  return t;
}
function Ga(i, t, e, n) {
  return i && t ? n(i[e], t[e]) : i ? i[e] : t ? t[e] : 0;
}
function Ml(i, t) {
  let e = [], n = !1;
  return et(i) ? (n = !0, e = i) : e = sp(i, t), e.length ? new be({
    points: e,
    options: {
      tension: 0
    },
    _loop: n,
    _fullLoop: n
  }) : null;
}
function Ka(i) {
  return i && i.fill !== !1;
}
function rp(i, t, e) {
  let s = i[t].fill;
  const r = [
    t
  ];
  let a;
  if (!e)
    return s;
  for (; s !== !1 && r.indexOf(s) === -1; ) {
    if (!ht(s))
      return s;
    if (a = i[s], !a)
      return !1;
    if (a.visible)
      return s;
    r.push(s), s = a.fill;
  }
  return !1;
}
function ap(i, t, e) {
  const n = dp(i);
  if (W(n))
    return isNaN(n.value) ? !1 : n;
  let s = parseFloat(n);
  return ht(s) && Math.floor(s) === s ? op(n[0], t, s, e) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(n) >= 0 && n;
}
function op(i, t, e, n) {
  return (i === "-" || i === "+") && (e = t + e), e === t || e < 0 || e >= n ? !1 : e;
}
function lp(i, t) {
  let e = null;
  return i === "start" ? e = t.bottom : i === "end" ? e = t.top : W(i) ? e = t.getPixelForValue(i.value) : t.getBasePixel && (e = t.getBasePixel()), e;
}
function cp(i, t, e) {
  let n;
  return i === "start" ? n = e : i === "end" ? n = t.options.reverse ? t.min : t.max : W(i) ? n = i.value : n = t.getBaseValue(), n;
}
function dp(i) {
  const t = i.options, e = t.fill;
  let n = N(e && e.target, e);
  return n === void 0 && (n = !!t.backgroundColor), n === !1 || n === null ? !1 : n === !0 ? "origin" : n;
}
function hp(i) {
  const { scale: t, index: e, line: n } = i, s = [], r = n.segments, a = n.points, o = up(t, e);
  o.push(Ml({
    x: null,
    y: t.bottom
  }, n));
  for (let l = 0; l < r.length; l++) {
    const c = r[l];
    for (let d = c.start; d <= c.end; d++)
      fp(s, a[d], o);
  }
  return new be({
    points: s,
    options: {}
  });
}
function up(i, t) {
  const e = [], n = i.getMatchingVisibleMetas("line");
  for (let s = 0; s < n.length; s++) {
    const r = n[s];
    if (r.index === t)
      break;
    r.hidden || e.unshift(r.dataset);
  }
  return e;
}
function fp(i, t, e) {
  const n = [];
  for (let s = 0; s < e.length; s++) {
    const r = e[s], { first: a, last: o, point: l } = pp(r, t, "x");
    if (!(!l || a && o)) {
      if (a)
        n.unshift(l);
      else if (i.push(l), !o)
        break;
    }
  }
  i.push(...n);
}
function pp(i, t, e) {
  const n = i.interpolate(t, e);
  if (!n)
    return {};
  const s = n[e], r = i.segments, a = i.points;
  let o = !1, l = !1;
  for (let c = 0; c < r.length; c++) {
    const d = r[c], h = a[d.start][e], u = a[d.end][e];
    if (re(s, h, u)) {
      o = s === h, l = s === u;
      break;
    }
  }
  return {
    first: o,
    last: l,
    point: n
  };
}
class Sl {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, e, n) {
    const { x: s, y: r, radius: a } = this;
    return e = e || {
      start: 0,
      end: it
    }, t.arc(s, r, a, e.end, e.start, !0), !n.bounds;
  }
  interpolate(t) {
    const { x: e, y: n, radius: s } = this, r = t.angle;
    return {
      x: e + Math.cos(r) * s,
      y: n + Math.sin(r) * s,
      angle: r
    };
  }
}
function gp(i) {
  const { chart: t, fill: e, line: n } = i;
  if (ht(e))
    return mp(t, e);
  if (e === "stack")
    return hp(i);
  if (e === "shape")
    return !0;
  const s = vp(i);
  return s instanceof Sl ? s : Ml(s, n);
}
function mp(i, t) {
  const e = i.getDatasetMeta(t);
  return e && i.isDatasetVisible(t) ? e.dataset : null;
}
function vp(i) {
  return (i.scale || {}).getPointPositionForValue ? yp(i) : bp(i);
}
function bp(i) {
  const { scale: t = {}, fill: e } = i, n = lp(e, t);
  if (ht(n)) {
    const s = t.isHorizontal();
    return {
      x: s ? n : null,
      y: s ? null : n
    };
  }
  return null;
}
function yp(i) {
  const { scale: t, fill: e } = i, n = t.options, s = t.getLabels().length, r = n.reverse ? t.max : t.min, a = cp(e, t, r), o = [];
  if (n.grid.circular) {
    const l = t.getPointPositionForValue(0, r);
    return new Sl({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(a)
    });
  }
  for (let l = 0; l < s; ++l)
    o.push(t.getPointPositionForValue(l, a));
  return o;
}
function $s(i, t, e) {
  const n = gp(t), { line: s, scale: r, axis: a } = t, o = s.options, l = o.fill, c = o.backgroundColor, { above: d = c, below: h = c } = l || {};
  n && s.points.length && (Zn(i, e), xp(i, {
    line: s,
    target: n,
    above: d,
    below: h,
    area: e,
    scale: r,
    axis: a
  }), Jn(i));
}
function xp(i, t) {
  const { line: e, target: n, above: s, below: r, area: a, scale: o } = t, l = e._loop ? "angle" : t.axis;
  i.save(), l === "x" && r !== s && (Za(i, n, a.top), Ja(i, {
    line: e,
    target: n,
    color: s,
    scale: o,
    property: l
  }), i.restore(), i.save(), Za(i, n, a.bottom)), Ja(i, {
    line: e,
    target: n,
    color: r,
    scale: o,
    property: l
  }), i.restore();
}
function Za(i, t, e) {
  const { segments: n, points: s } = t;
  let r = !0, a = !1;
  i.beginPath();
  for (const o of n) {
    const { start: l, end: c } = o, d = s[l], h = s[_r(l, c, s)];
    r ? (i.moveTo(d.x, d.y), r = !1) : (i.lineTo(d.x, e), i.lineTo(d.x, d.y)), a = !!t.pathSegment(i, o, {
      move: a
    }), a ? i.closePath() : i.lineTo(h.x, e);
  }
  i.lineTo(t.first().x, e), i.closePath(), i.clip();
}
function Ja(i, t) {
  const { line: e, target: n, property: s, color: r, scale: a } = t, o = np(e, n, s);
  for (const { source: l, target: c, start: d, end: h } of o) {
    const { style: { backgroundColor: u = r } = {} } = l, f = n !== !0;
    i.save(), i.fillStyle = u, wp(i, a, f && Bs(s, d, h)), i.beginPath();
    const g = !!e.pathSegment(i, l);
    let m;
    if (f) {
      g ? i.closePath() : to(i, n, h, s);
      const v = !!n.pathSegment(i, c, {
        move: g,
        reverse: !0
      });
      m = g && v, m || to(i, n, d, s);
    }
    i.closePath(), i.fill(m ? "evenodd" : "nonzero"), i.restore();
  }
}
function wp(i, t, e) {
  const { top: n, bottom: s } = t.chart.chartArea, { property: r, start: a, end: o } = e || {};
  r === "x" && (i.beginPath(), i.rect(a, n, o - a, s - n), i.clip());
}
function to(i, t, e, n) {
  const s = t.interpolate(e, n);
  s && i.lineTo(s.x, s.y);
}
var _p = {
  id: "filler",
  afterDatasetsUpdate(i, t, e) {
    const n = (i.data.datasets || []).length, s = [];
    let r, a, o, l;
    for (a = 0; a < n; ++a)
      r = i.getDatasetMeta(a), o = r.dataset, l = null, o && o.options && o instanceof be && (l = {
        visible: i.isDatasetVisible(a),
        index: a,
        fill: ap(o, a, n),
        chart: i,
        axis: r.controller.options.indexAxis,
        scale: r.vScale,
        line: o
      }), r.$filler = l, s.push(l);
    for (a = 0; a < n; ++a)
      l = s[a], !(!l || l.fill === !1) && (l.fill = rp(s, a, e.propagate));
  },
  beforeDraw(i, t, e) {
    const n = e.drawTime === "beforeDraw", s = i.getSortedVisibleDatasetMetas(), r = i.chartArea;
    for (let a = s.length - 1; a >= 0; --a) {
      const o = s[a].$filler;
      o && (o.line.updateControlPoints(r, o.axis), n && o.fill && $s(i.ctx, o, r));
    }
  },
  beforeDatasetsDraw(i, t, e) {
    if (e.drawTime !== "beforeDatasetsDraw")
      return;
    const n = i.getSortedVisibleDatasetMetas();
    for (let s = n.length - 1; s >= 0; --s) {
      const r = n[s].$filler;
      Ka(r) && $s(i.ctx, r, i.chartArea);
    }
  },
  beforeDatasetDraw(i, t, e) {
    const n = t.meta.$filler;
    !Ka(n) || e.drawTime !== "beforeDatasetDraw" || $s(i.ctx, n, i.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const eo = (i, t) => {
  let { boxHeight: e = t, boxWidth: n = t } = i;
  return i.usePointStyle && (e = Math.min(e, t), n = i.pointStyleWidth || Math.min(n, t)), {
    boxWidth: n,
    boxHeight: e,
    itemHeight: Math.max(t, e)
  };
}, kp = (i, t) => i !== null && t !== null && i.datasetIndex === t.datasetIndex && i.index === t.index;
class io extends Vt {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e, n) {
    this.maxWidth = t, this.maxHeight = e, this._margins = n, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let e = tt(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (e = e.filter((n) => t.filter(n, this.chart.data))), t.sort && (e = e.sort((n, s) => t.sort(n, s, this.chart.data))), this.options.reverse && e.reverse(), this.legendItems = e;
  }
  fit() {
    const { options: t, ctx: e } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const n = t.labels, s = vt(n.font), r = s.size, a = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = eo(n, r);
    let c, d;
    e.font = s.string, this.isHorizontal() ? (c = this.maxWidth, d = this._fitRows(a, r, o, l) + 10) : (d = this.maxHeight, c = this._fitCols(a, s, o, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(d, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, e, n, s) {
    const { ctx: r, maxWidth: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], d = s + o;
    let h = t;
    r.textAlign = "left", r.textBaseline = "middle";
    let u = -1, f = -d;
    return this.legendItems.forEach((g, m) => {
      const v = n + e / 2 + r.measureText(g.text).width;
      (m === 0 || c[c.length - 1] + v + 2 * o > a) && (h += d, c[c.length - (m > 0 ? 0 : 1)] = 0, f += d, u++), l[m] = {
        left: 0,
        top: f,
        row: u,
        width: v,
        height: s
      }, c[c.length - 1] += v + o;
    }), h;
  }
  _fitCols(t, e, n, s) {
    const { ctx: r, maxHeight: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], d = a - t;
    let h = o, u = 0, f = 0, g = 0, m = 0;
    return this.legendItems.forEach((v, b) => {
      const { itemWidth: x, itemHeight: w } = Dp(n, e, r, v, s);
      b > 0 && f + w + 2 * o > d && (h += u + o, c.push({
        width: u,
        height: f
      }), g += u + o, m++, u = f = 0), l[b] = {
        left: g,
        top: f,
        col: m,
        width: x,
        height: w
      }, u = Math.max(u, x), f += w + o;
    }), h += u, c.push({
      width: u,
      height: f
    }), h;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: e, options: { align: n, labels: { padding: s }, rtl: r } } = this, a = Ze(r, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = Pt(n, this.left + s, this.right - this.lineWidths[o]);
      for (const c of e)
        o !== c.row && (o = c.row, l = Pt(n, this.left + s, this.right - this.lineWidths[o])), c.top += this.top + t + s, c.left = a.leftForLtr(a.x(l), c.width), l += c.width + s;
    } else {
      let o = 0, l = Pt(n, this.top + t + s, this.bottom - this.columnSizes[o].height);
      for (const c of e)
        c.col !== o && (o = c.col, l = Pt(n, this.top + t + s, this.bottom - this.columnSizes[o].height)), c.top = l, c.left += this.left + s, c.left = a.leftForLtr(a.x(c.left), c.width), l += c.height + s;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Zn(t, this), this._draw(), Jn(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: e, lineWidths: n, ctx: s } = this, { align: r, labels: a } = t, o = st.color, l = Ze(t.rtl, this.left, this.width), c = vt(a.font), { padding: d } = a, h = c.size, u = h / 2;
    let f;
    this.drawTitle(), s.textAlign = l.textAlign("left"), s.textBaseline = "middle", s.lineWidth = 0.5, s.font = c.string;
    const { boxWidth: g, boxHeight: m, itemHeight: v } = eo(a, h), b = function(D, C, $) {
      if (isNaN(g) || g <= 0 || isNaN(m) || m < 0)
        return;
      s.save();
      const T = N($.lineWidth, 1);
      if (s.fillStyle = N($.fillStyle, o), s.lineCap = N($.lineCap, "butt"), s.lineDashOffset = N($.lineDashOffset, 0), s.lineJoin = N($.lineJoin, "miter"), s.lineWidth = T, s.strokeStyle = N($.strokeStyle, o), s.setLineDash(N($.lineDash, [])), a.usePointStyle) {
        const E = {
          radius: m * Math.SQRT2 / 2,
          pointStyle: $.pointStyle,
          rotation: $.rotation,
          borderWidth: T
        }, L = l.xPlus(D, g / 2), z = C + u;
        Go(s, E, L, z, a.pointStyleWidth && g);
      } else {
        const E = C + Math.max((h - m) / 2, 0), L = l.leftForLtr(D, g), z = Fe($.borderRadius);
        s.beginPath(), Object.values(z).some((rt) => rt !== 0) ? Wi(s, {
          x: L,
          y: E,
          w: g,
          h: m,
          radius: z
        }) : s.rect(L, E, g, m), s.fill(), T !== 0 && s.stroke();
      }
      s.restore();
    }, x = function(D, C, $) {
      Be(s, $.text, D, C + v / 2, c, {
        strikethrough: $.hidden,
        textAlign: l.textAlign($.textAlign)
      });
    }, w = this.isHorizontal(), k = this._computeTitleHeight();
    w ? f = {
      x: Pt(r, this.left + d, this.right - n[0]),
      y: this.top + d + k,
      line: 0
    } : f = {
      x: this.left + d,
      y: Pt(r, this.top + k + d, this.bottom - e[0].height),
      line: 0
    }, sl(this.ctx, t.textDirection);
    const _ = v + d;
    this.legendItems.forEach((D, C) => {
      s.strokeStyle = D.fontColor, s.fillStyle = D.fontColor;
      const $ = s.measureText(D.text).width, T = l.textAlign(D.textAlign || (D.textAlign = a.textAlign)), E = g + u + $;
      let L = f.x, z = f.y;
      l.setWidth(this.width), w ? C > 0 && L + E + d > this.right && (z = f.y += _, f.line++, L = f.x = Pt(r, this.left + d, this.right - n[f.line])) : C > 0 && z + _ > this.bottom && (L = f.x = L + e[f.line].width + d, f.line++, z = f.y = Pt(r, this.top + k + d, this.bottom - e[f.line].height));
      const rt = l.x(L);
      if (b(rt, z, D), L = jd(T, L + g + u, w ? L + E : this.right, t.rtl), x(l.x(L), z, D), w)
        f.x += E + d;
      else if (typeof D.text != "string") {
        const Dt = c.lineHeight;
        f.y += Tl(D, Dt) + d;
      } else
        f.y += _;
    }), rl(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, e = t.title, n = vt(e.font), s = St(e.padding);
    if (!e.display)
      return;
    const r = Ze(t.rtl, this.left, this.width), a = this.ctx, o = e.position, l = n.size / 2, c = s.top + l;
    let d, h = this.left, u = this.width;
    if (this.isHorizontal())
      u = Math.max(...this.lineWidths), d = this.top + c, h = Pt(t.align, h, this.right - u);
    else {
      const g = this.columnSizes.reduce((m, v) => Math.max(m, v.height), 0);
      d = c + Pt(t.align, this.top, this.bottom - g - t.labels.padding - this._computeTitleHeight());
    }
    const f = Pt(o, h, h + u);
    a.textAlign = r.textAlign(fr(o)), a.textBaseline = "middle", a.strokeStyle = e.color, a.fillStyle = e.color, a.font = n.string, Be(a, e.text, f, d, n);
  }
  _computeTitleHeight() {
    const t = this.options.title, e = vt(t.font), n = St(t.padding);
    return t.display ? e.lineHeight + n.height : 0;
  }
  _getLegendItemAt(t, e) {
    let n, s, r;
    if (re(t, this.left, this.right) && re(e, this.top, this.bottom)) {
      for (r = this.legendHitBoxes, n = 0; n < r.length; ++n)
        if (s = r[n], re(t, s.left, s.left + s.width) && re(e, s.top, s.top + s.height))
          return this.legendItems[n];
    }
    return null;
  }
  handleEvent(t) {
    const e = this.options;
    if (!Pp(t.type, e))
      return;
    const n = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const s = this._hoveredItem, r = kp(s, n);
      s && !r && tt(e.onLeave, [
        t,
        s,
        this
      ], this), this._hoveredItem = n, n && !r && tt(e.onHover, [
        t,
        n,
        this
      ], this);
    } else
      n && tt(e.onClick, [
        t,
        n,
        this
      ], this);
  }
}
function Dp(i, t, e, n, s) {
  const r = Cp(n, i, t, e), a = $p(s, n, t.lineHeight);
  return {
    itemWidth: r,
    itemHeight: a
  };
}
function Cp(i, t, e, n) {
  let s = i.text;
  return s && typeof s != "string" && (s = s.reduce((r, a) => r.length > a.length ? r : a)), t + e.size / 2 + n.measureText(s).width;
}
function $p(i, t, e) {
  let n = i;
  return typeof t.text != "string" && (n = Tl(t, e)), n;
}
function Tl(i, t) {
  const e = i.text ? i.text.length : 0;
  return t * e;
}
function Pp(i, t) {
  return !!((i === "mousemove" || i === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (i === "click" || i === "mouseup"));
}
var Mp = {
  id: "legend",
  _element: io,
  start(i, t, e) {
    const n = i.legend = new io({
      ctx: i.ctx,
      options: e,
      chart: i
    });
    Mt.configure(i, n, e), Mt.addBox(i, n);
  },
  stop(i) {
    Mt.removeBox(i, i.legend), delete i.legend;
  },
  beforeUpdate(i, t, e) {
    const n = i.legend;
    Mt.configure(i, n, e), n.options = e;
  },
  afterUpdate(i) {
    const t = i.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(i, t) {
    t.replay || i.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(i, t, e) {
      const n = t.datasetIndex, s = e.chart;
      s.isDatasetVisible(n) ? (s.hide(n), t.hidden = !0) : (s.show(n), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (i) => i.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(i) {
        const t = i.data.datasets, { labels: { usePointStyle: e, pointStyle: n, textAlign: s, color: r, useBorderRadius: a, borderRadius: o } } = i.legend.options;
        return i._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(e ? 0 : void 0), d = St(c.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: r,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (d.width + d.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: n || c.pointStyle,
            rotation: c.rotation,
            textAlign: s || c.textAlign,
            borderRadius: a && (o || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (i) => i.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (i) => !i.startsWith("on"),
    labels: {
      _scriptable: (i) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(i)
    }
  }
};
class kr extends Vt {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e) {
    const n = this.options;
    if (this.left = 0, this.top = 0, !n.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = e;
    const s = et(n.text) ? n.text.length : 1;
    this._padding = St(n.padding);
    const r = s * vt(n.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = r : this.width = r;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: e, left: n, bottom: s, right: r, options: a } = this, o = a.align;
    let l = 0, c, d, h;
    return this.isHorizontal() ? (d = Pt(o, n, r), h = e + t, c = r - n) : (a.position === "left" ? (d = n + t, h = Pt(o, s, e), l = nt * -0.5) : (d = r - t, h = Pt(o, e, s), l = nt * 0.5), c = s - e), {
      titleX: d,
      titleY: h,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, e = this.options;
    if (!e.display)
      return;
    const n = vt(e.font), r = n.lineHeight / 2 + this._padding.top, { titleX: a, titleY: o, maxWidth: l, rotation: c } = this._drawArgs(r);
    Be(t, e.text, 0, 0, n, {
      color: e.color,
      maxWidth: l,
      rotation: c,
      textAlign: fr(e.align),
      textBaseline: "middle",
      translation: [
        a,
        o
      ]
    });
  }
}
function Sp(i, t) {
  const e = new kr({
    ctx: i.ctx,
    options: t,
    chart: i
  });
  Mt.configure(i, e, t), Mt.addBox(i, e), i.titleBlock = e;
}
var Tp = {
  id: "title",
  _element: kr,
  start(i, t, e) {
    Sp(i, e);
  },
  stop(i) {
    const t = i.titleBlock;
    Mt.removeBox(i, t), delete i.titleBlock;
  },
  beforeUpdate(i, t, e) {
    const n = i.titleBlock;
    Mt.configure(i, n, e), n.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const yn = /* @__PURE__ */ new WeakMap();
var Op = {
  id: "subtitle",
  start(i, t, e) {
    const n = new kr({
      ctx: i.ctx,
      options: e,
      chart: i
    });
    Mt.configure(i, n, e), Mt.addBox(i, n), yn.set(i, n);
  },
  stop(i) {
    Mt.removeBox(i, yn.get(i)), yn.delete(i);
  },
  beforeUpdate(i, t, e) {
    const n = yn.get(i);
    Mt.configure(i, n, e), n.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const xi = {
  average(i) {
    if (!i.length)
      return !1;
    let t, e, n = /* @__PURE__ */ new Set(), s = 0, r = 0;
    for (t = 0, e = i.length; t < e; ++t) {
      const o = i[t].element;
      if (o && o.hasValue()) {
        const l = o.tooltipPosition();
        n.add(l.x), s += l.y, ++r;
      }
    }
    return r === 0 || n.size === 0 ? !1 : {
      x: [
        ...n
      ].reduce((o, l) => o + l) / n.size,
      y: s / r
    };
  },
  nearest(i, t) {
    if (!i.length)
      return !1;
    let e = t.x, n = t.y, s = Number.POSITIVE_INFINITY, r, a, o;
    for (r = 0, a = i.length; r < a; ++r) {
      const l = i[r].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), d = Is(t, c);
        d < s && (s = d, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      e = l.x, n = l.y;
    }
    return {
      x: e,
      y: n
    };
  }
};
function qt(i, t) {
  return t && (et(t) ? Array.prototype.push.apply(i, t) : i.push(t)), i;
}
function ne(i) {
  return (typeof i == "string" || i instanceof String) && i.indexOf(`
`) > -1 ? i.split(`
`) : i;
}
function Ap(i, t) {
  const { element: e, datasetIndex: n, index: s } = t, r = i.getDatasetMeta(n).controller, { label: a, value: o } = r.getLabelAndValue(s);
  return {
    chart: i,
    label: a,
    parsed: r.getParsed(s),
    raw: i.data.datasets[n].data[s],
    formattedValue: o,
    dataset: r.getDataset(),
    dataIndex: s,
    datasetIndex: n,
    element: e
  };
}
function no(i, t) {
  const e = i.chart.ctx, { body: n, footer: s, title: r } = i, { boxWidth: a, boxHeight: o } = t, l = vt(t.bodyFont), c = vt(t.titleFont), d = vt(t.footerFont), h = r.length, u = s.length, f = n.length, g = St(t.padding);
  let m = g.height, v = 0, b = n.reduce((k, _) => k + _.before.length + _.lines.length + _.after.length, 0);
  if (b += i.beforeBody.length + i.afterBody.length, h && (m += h * c.lineHeight + (h - 1) * t.titleSpacing + t.titleMarginBottom), b) {
    const k = t.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    m += f * k + (b - f) * l.lineHeight + (b - 1) * t.bodySpacing;
  }
  u && (m += t.footerMarginTop + u * d.lineHeight + (u - 1) * t.footerSpacing);
  let x = 0;
  const w = function(k) {
    v = Math.max(v, e.measureText(k).width + x);
  };
  return e.save(), e.font = c.string, K(i.title, w), e.font = l.string, K(i.beforeBody.concat(i.afterBody), w), x = t.displayColors ? a + 2 + t.boxPadding : 0, K(n, (k) => {
    K(k.before, w), K(k.lines, w), K(k.after, w);
  }), x = 0, e.font = d.string, K(i.footer, w), e.restore(), v += g.width, {
    width: v,
    height: m
  };
}
function Ip(i, t) {
  const { y: e, height: n } = t;
  return e < n / 2 ? "top" : e > i.height - n / 2 ? "bottom" : "center";
}
function Ep(i, t, e, n) {
  const { x: s, width: r } = n, a = e.caretSize + e.caretPadding;
  if (i === "left" && s + r + a > t.width || i === "right" && s - r - a < 0)
    return !0;
}
function Rp(i, t, e, n) {
  const { x: s, width: r } = e, { width: a, chartArea: { left: o, right: l } } = i;
  let c = "center";
  return n === "center" ? c = s <= (o + l) / 2 ? "left" : "right" : s <= r / 2 ? c = "left" : s >= a - r / 2 && (c = "right"), Ep(c, i, t, e) && (c = "center"), c;
}
function so(i, t, e) {
  const n = e.yAlign || t.yAlign || Ip(i, e);
  return {
    xAlign: e.xAlign || t.xAlign || Rp(i, t, e, n),
    yAlign: n
  };
}
function Fp(i, t) {
  let { x: e, width: n } = i;
  return t === "right" ? e -= n : t === "center" && (e -= n / 2), e;
}
function Lp(i, t, e) {
  let { y: n, height: s } = i;
  return t === "top" ? n += e : t === "bottom" ? n -= s + e : n -= s / 2, n;
}
function ro(i, t, e, n) {
  const { caretSize: s, caretPadding: r, cornerRadius: a } = i, { xAlign: o, yAlign: l } = e, c = s + r, { topLeft: d, topRight: h, bottomLeft: u, bottomRight: f } = Fe(a);
  let g = Fp(t, o);
  const m = Lp(t, l, c);
  return l === "center" ? o === "left" ? g += c : o === "right" && (g -= c) : o === "left" ? g -= Math.max(d, u) + s : o === "right" && (g += Math.max(h, f) + s), {
    x: wt(g, 0, n.width - t.width),
    y: wt(m, 0, n.height - t.height)
  };
}
function xn(i, t, e) {
  const n = St(e.padding);
  return t === "center" ? i.x + i.width / 2 : t === "right" ? i.x + i.width - n.right : i.x + n.left;
}
function ao(i) {
  return qt([], ne(i));
}
function Np(i, t, e) {
  return ke(i, {
    tooltip: t,
    tooltipItems: e,
    type: "tooltip"
  });
}
function oo(i, t) {
  const e = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return e ? i.override(e) : i;
}
const Ol = {
  beforeTitle: ee,
  title(i) {
    if (i.length > 0) {
      const t = i[0], e = t.chart.data.labels, n = e ? e.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (n > 0 && t.dataIndex < n)
        return e[t.dataIndex];
    }
    return "";
  },
  afterTitle: ee,
  beforeBody: ee,
  beforeLabel: ee,
  label(i) {
    if (this && this.options && this.options.mode === "dataset")
      return i.label + ": " + i.formattedValue || i.formattedValue;
    let t = i.dataset.label || "";
    t && (t += ": ");
    const e = i.formattedValue;
    return B(e) || (t += e), t;
  },
  labelColor(i) {
    const e = i.chart.getDatasetMeta(i.datasetIndex).controller.getStyle(i.dataIndex);
    return {
      borderColor: e.borderColor,
      backgroundColor: e.backgroundColor,
      borderWidth: e.borderWidth,
      borderDash: e.borderDash,
      borderDashOffset: e.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(i) {
    const e = i.chart.getDatasetMeta(i.datasetIndex).controller.getStyle(i.dataIndex);
    return {
      pointStyle: e.pointStyle,
      rotation: e.rotation
    };
  },
  afterLabel: ee,
  afterBody: ee,
  beforeFooter: ee,
  footer: ee,
  afterFooter: ee
};
function At(i, t, e, n) {
  const s = i[t].call(e, n);
  return typeof s == "undefined" ? Ol[t].call(e, n) : s;
}
class Ws extends Vt {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const e = this.chart, n = this.options.setContext(this.getContext()), s = n.enabled && e.options.animation && n.animations, r = new cl(this.chart, s);
    return s._cacheable && (this._cachedAnimations = Object.freeze(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = Np(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, e) {
    const { callbacks: n } = e, s = At(n, "beforeTitle", this, t), r = At(n, "title", this, t), a = At(n, "afterTitle", this, t);
    let o = [];
    return o = qt(o, ne(s)), o = qt(o, ne(r)), o = qt(o, ne(a)), o;
  }
  getBeforeBody(t, e) {
    return ao(At(e.callbacks, "beforeBody", this, t));
  }
  getBody(t, e) {
    const { callbacks: n } = e, s = [];
    return K(t, (r) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, o = oo(n, r);
      qt(a.before, ne(At(o, "beforeLabel", this, r))), qt(a.lines, At(o, "label", this, r)), qt(a.after, ne(At(o, "afterLabel", this, r))), s.push(a);
    }), s;
  }
  getAfterBody(t, e) {
    return ao(At(e.callbacks, "afterBody", this, t));
  }
  getFooter(t, e) {
    const { callbacks: n } = e, s = At(n, "beforeFooter", this, t), r = At(n, "footer", this, t), a = At(n, "afterFooter", this, t);
    let o = [];
    return o = qt(o, ne(s)), o = qt(o, ne(r)), o = qt(o, ne(a)), o;
  }
  _createItems(t) {
    const e = this._active, n = this.chart.data, s = [], r = [], a = [];
    let o = [], l, c;
    for (l = 0, c = e.length; l < c; ++l)
      o.push(Ap(this.chart, e[l]));
    return t.filter && (o = o.filter((d, h, u) => t.filter(d, h, u, n))), t.itemSort && (o = o.sort((d, h) => t.itemSort(d, h, n))), K(o, (d) => {
      const h = oo(t.callbacks, d);
      s.push(At(h, "labelColor", this, d)), r.push(At(h, "labelPointStyle", this, d)), a.push(At(h, "labelTextColor", this, d));
    }), this.labelColors = s, this.labelPointStyles = r, this.labelTextColors = a, this.dataPoints = o, o;
  }
  update(t, e) {
    const n = this.options.setContext(this.getContext()), s = this._active;
    let r, a = [];
    if (!s.length)
      this.opacity !== 0 && (r = {
        opacity: 0
      });
    else {
      const o = xi[n.position].call(this, s, this._eventPosition);
      a = this._createItems(n), this.title = this.getTitle(a, n), this.beforeBody = this.getBeforeBody(a, n), this.body = this.getBody(a, n), this.afterBody = this.getAfterBody(a, n), this.footer = this.getFooter(a, n);
      const l = this._size = no(this, n), c = Object.assign({}, o, l), d = so(this.chart, n, c), h = ro(n, c, d, this.chart);
      this.xAlign = d.xAlign, this.yAlign = d.yAlign, r = {
        opacity: 1,
        x: h.x,
        y: h.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, r && this._resolveAnimations().update(this, r), t && n.external && n.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: e
    });
  }
  drawCaret(t, e, n, s) {
    const r = this.getCaretPosition(t, n, s);
    e.lineTo(r.x1, r.y1), e.lineTo(r.x2, r.y2), e.lineTo(r.x3, r.y3);
  }
  getCaretPosition(t, e, n) {
    const { xAlign: s, yAlign: r } = this, { caretSize: a, cornerRadius: o } = n, { topLeft: l, topRight: c, bottomLeft: d, bottomRight: h } = Fe(o), { x: u, y: f } = t, { width: g, height: m } = e;
    let v, b, x, w, k, _;
    return r === "center" ? (k = f + m / 2, s === "left" ? (v = u, b = v - a, w = k + a, _ = k - a) : (v = u + g, b = v + a, w = k - a, _ = k + a), x = v) : (s === "left" ? b = u + Math.max(l, d) + a : s === "right" ? b = u + g - Math.max(c, h) - a : b = this.caretX, r === "top" ? (w = f, k = w - a, v = b - a, x = b + a) : (w = f + m, k = w + a, v = b + a, x = b - a), _ = w), {
      x1: v,
      x2: b,
      x3: x,
      y1: w,
      y2: k,
      y3: _
    };
  }
  drawTitle(t, e, n) {
    const s = this.title, r = s.length;
    let a, o, l;
    if (r) {
      const c = Ze(n.rtl, this.x, this.width);
      for (t.x = xn(this, n.titleAlign, n), e.textAlign = c.textAlign(n.titleAlign), e.textBaseline = "middle", a = vt(n.titleFont), o = n.titleSpacing, e.fillStyle = n.titleColor, e.font = a.string, l = 0; l < r; ++l)
        e.fillText(s[l], c.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + o, l + 1 === r && (t.y += n.titleMarginBottom - o);
    }
  }
  _drawColorBox(t, e, n, s, r) {
    const a = this.labelColors[n], o = this.labelPointStyles[n], { boxHeight: l, boxWidth: c } = r, d = vt(r.bodyFont), h = xn(this, "left", r), u = s.x(h), f = l < d.lineHeight ? (d.lineHeight - l) / 2 : 0, g = e.y + f;
    if (r.usePointStyle) {
      const m = {
        radius: Math.min(c, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, v = s.leftForLtr(u, c) + c / 2, b = g + l / 2;
      t.strokeStyle = r.multiKeyBackground, t.fillStyle = r.multiKeyBackground, Rs(t, m, v, b), t.strokeStyle = a.borderColor, t.fillStyle = a.backgroundColor, Rs(t, m, v, b);
    } else {
      t.lineWidth = W(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, t.strokeStyle = a.borderColor, t.setLineDash(a.borderDash || []), t.lineDashOffset = a.borderDashOffset || 0;
      const m = s.leftForLtr(u, c), v = s.leftForLtr(s.xPlus(u, 1), c - 2), b = Fe(a.borderRadius);
      Object.values(b).some((x) => x !== 0) ? (t.beginPath(), t.fillStyle = r.multiKeyBackground, Wi(t, {
        x: m,
        y: g,
        w: c,
        h: l,
        radius: b
      }), t.fill(), t.stroke(), t.fillStyle = a.backgroundColor, t.beginPath(), Wi(t, {
        x: v,
        y: g + 1,
        w: c - 2,
        h: l - 2,
        radius: b
      }), t.fill()) : (t.fillStyle = r.multiKeyBackground, t.fillRect(m, g, c, l), t.strokeRect(m, g, c, l), t.fillStyle = a.backgroundColor, t.fillRect(v, g + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[n];
  }
  drawBody(t, e, n) {
    const { body: s } = this, { bodySpacing: r, bodyAlign: a, displayColors: o, boxHeight: l, boxWidth: c, boxPadding: d } = n, h = vt(n.bodyFont);
    let u = h.lineHeight, f = 0;
    const g = Ze(n.rtl, this.x, this.width), m = function($) {
      e.fillText($, g.x(t.x + f), t.y + u / 2), t.y += u + r;
    }, v = g.textAlign(a);
    let b, x, w, k, _, D, C;
    for (e.textAlign = a, e.textBaseline = "middle", e.font = h.string, t.x = xn(this, v, n), e.fillStyle = n.bodyColor, K(this.beforeBody, m), f = o && v !== "right" ? a === "center" ? c / 2 + d : c + 2 + d : 0, k = 0, D = s.length; k < D; ++k) {
      for (b = s[k], x = this.labelTextColors[k], e.fillStyle = x, K(b.before, m), w = b.lines, o && w.length && (this._drawColorBox(e, t, k, g, n), u = Math.max(h.lineHeight, l)), _ = 0, C = w.length; _ < C; ++_)
        m(w[_]), u = h.lineHeight;
      K(b.after, m);
    }
    f = 0, u = h.lineHeight, K(this.afterBody, m), t.y -= r;
  }
  drawFooter(t, e, n) {
    const s = this.footer, r = s.length;
    let a, o;
    if (r) {
      const l = Ze(n.rtl, this.x, this.width);
      for (t.x = xn(this, n.footerAlign, n), t.y += n.footerMarginTop, e.textAlign = l.textAlign(n.footerAlign), e.textBaseline = "middle", a = vt(n.footerFont), e.fillStyle = n.footerColor, e.font = a.string, o = 0; o < r; ++o)
        e.fillText(s[o], l.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + n.footerSpacing;
    }
  }
  drawBackground(t, e, n, s) {
    const { xAlign: r, yAlign: a } = this, { x: o, y: l } = t, { width: c, height: d } = n, { topLeft: h, topRight: u, bottomLeft: f, bottomRight: g } = Fe(s.cornerRadius);
    e.fillStyle = s.backgroundColor, e.strokeStyle = s.borderColor, e.lineWidth = s.borderWidth, e.beginPath(), e.moveTo(o + h, l), a === "top" && this.drawCaret(t, e, n, s), e.lineTo(o + c - u, l), e.quadraticCurveTo(o + c, l, o + c, l + u), a === "center" && r === "right" && this.drawCaret(t, e, n, s), e.lineTo(o + c, l + d - g), e.quadraticCurveTo(o + c, l + d, o + c - g, l + d), a === "bottom" && this.drawCaret(t, e, n, s), e.lineTo(o + f, l + d), e.quadraticCurveTo(o, l + d, o, l + d - f), a === "center" && r === "left" && this.drawCaret(t, e, n, s), e.lineTo(o, l + h), e.quadraticCurveTo(o, l, o + h, l), e.closePath(), e.fill(), s.borderWidth > 0 && e.stroke();
  }
  _updateAnimationTarget(t) {
    const e = this.chart, n = this.$animations, s = n && n.x, r = n && n.y;
    if (s || r) {
      const a = xi[t.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const o = this._size = no(this, t), l = Object.assign({}, a, this._size), c = so(e, t, l), d = ro(t, l, c, e);
      (s._to !== d.x || r._to !== d.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = o.width, this.height = o.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, d));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const e = this.options.setContext(this.getContext());
    let n = this.opacity;
    if (!n)
      return;
    this._updateAnimationTarget(e);
    const s = {
      width: this.width,
      height: this.height
    }, r = {
      x: this.x,
      y: this.y
    };
    n = Math.abs(n) < 1e-3 ? 0 : n;
    const a = St(e.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    e.enabled && o && (t.save(), t.globalAlpha = n, this.drawBackground(r, t, s, e), sl(t, e.textDirection), r.y += a.top, this.drawTitle(r, t, e), this.drawBody(r, t, e), this.drawFooter(r, t, e), rl(t, e.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, e) {
    const n = this._active, s = t.map(({ datasetIndex: o, index: l }) => {
      const c = this.chart.getDatasetMeta(o);
      if (!c)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: c.data[l],
        index: l
      };
    }), r = !Nn(n, s), a = this._positionChanged(s, e);
    (r || a) && (this._active = s, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, e, n = !0) {
    if (e && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const s = this.options, r = this._active || [], a = this._getActiveElements(t, r, e, n), o = this._positionChanged(a, t), l = e || !Nn(a, r) || o;
    return l && (this._active = a, (s.enabled || s.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, e))), l;
  }
  _getActiveElements(t, e, n, s) {
    const r = this.options;
    if (t.type === "mouseout")
      return [];
    if (!s)
      return e.filter((o) => this.chart.data.datasets[o.datasetIndex] && this.chart.getDatasetMeta(o.datasetIndex).controller.getParsed(o.index) !== void 0);
    const a = this.chart.getElementsAtEventForMode(t, r.mode, r, n);
    return r.reverse && a.reverse(), a;
  }
  _positionChanged(t, e) {
    const { caretX: n, caretY: s, options: r } = this, a = xi[r.position].call(this, t, e);
    return a !== !1 && (n !== a.x || s !== a.y);
  }
}
P(Ws, "positioners", xi);
var zp = {
  id: "tooltip",
  _element: Ws,
  positioners: xi,
  afterInit(i, t, e) {
    e && (i.tooltip = new Ws({
      chart: i,
      options: e
    }));
  },
  beforeUpdate(i, t, e) {
    i.tooltip && i.tooltip.initialize(e);
  },
  reset(i, t, e) {
    i.tooltip && i.tooltip.initialize(e);
  },
  afterDraw(i) {
    const t = i.tooltip;
    if (t && t._willRender()) {
      const e = {
        tooltip: t
      };
      if (i.notifyPlugins("beforeTooltipDraw", ot(at({}, e), {
        cancelable: !0
      })) === !1)
        return;
      t.draw(i.ctx), i.notifyPlugins("afterTooltipDraw", e);
    }
  },
  afterEvent(i, t) {
    if (i.tooltip) {
      const e = t.replay;
      i.tooltip.handleEvent(t.event, e, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (i, t) => t.bodyFont.size,
    boxWidth: (i, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Ol
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (i) => i !== "filter" && i !== "itemSort" && i !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, Hp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: Zf,
  Decimation: ip,
  Filler: _p,
  Legend: Mp,
  SubTitle: Op,
  Title: Tp,
  Tooltip: zp
});
const Bp = (i, t, e, n) => (typeof t == "string" ? (e = i.push(t) - 1, n.unshift({
  index: e,
  label: t
})) : isNaN(t) && (e = null), e);
function Wp(i, t, e, n) {
  const s = i.indexOf(t);
  if (s === -1)
    return Bp(i, t, e, n);
  const r = i.lastIndexOf(t);
  return s !== r ? e : s;
}
const Up = (i, t) => i === null ? null : wt(Math.round(i), 0, t);
function lo(i) {
  const t = this.getLabels();
  return i >= 0 && i < t.length ? t[i] : i;
}
class Us extends Ye {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const e = this._addedLabels;
    if (e.length) {
      const n = this.getLabels();
      for (const { index: s, label: r } of e)
        n[s] === r && n.splice(s, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, e) {
    if (B(t))
      return null;
    const n = this.getLabels();
    return e = isFinite(e) && n[e] === t ? e : Wp(n, t, N(e, t), this._addedLabels), Up(e, n.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let { min: n, max: s } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (n = 0), e || (s = this.getLabels().length - 1)), this.min = n, this.max = s;
  }
  buildTicks() {
    const t = this.min, e = this.max, n = this.options.offset, s = [];
    let r = this.getLabels();
    r = t === 0 && e === r.length - 1 ? r : r.slice(t, e + 1), this._valueRange = Math.max(r.length - (n ? 0 : 1), 1), this._startValue = this.min - (n ? 0.5 : 0);
    for (let a = t; a <= e; a++)
      s.push({
        value: a
      });
    return s;
  }
  getLabelForValue(t) {
    return lo.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
P(Us, "id", "category"), P(Us, "defaults", {
  ticks: {
    callback: lo
  }
});
function jp(i, t) {
  const e = [], { bounds: s, step: r, min: a, max: o, precision: l, count: c, maxTicks: d, maxDigits: h, includeBounds: u } = i, f = r || 1, g = d - 1, { min: m, max: v } = t, b = !B(a), x = !B(o), w = !B(c), k = (v - m) / (h + 1);
  let _ = na((v - m) / g / f) * f, D, C, $, T;
  if (_ < 1e-14 && !b && !x)
    return [
      {
        value: m
      },
      {
        value: v
      }
    ];
  T = Math.ceil(v / _) - Math.floor(m / _), T > g && (_ = na(T * _ / g / f) * f), B(l) || (D = Math.pow(10, l), _ = Math.ceil(_ * D) / D), s === "ticks" ? (C = Math.floor(m / _) * _, $ = Math.ceil(v / _) * _) : (C = m, $ = v), b && x && r && Ld((o - a) / r, _ / 1e3) ? (T = Math.round(Math.min((o - a) / _, d)), _ = (o - a) / T, C = a, $ = o) : w ? (C = b ? a : C, $ = x ? o : $, T = c - 1, _ = ($ - C) / T) : (T = ($ - C) / _, Di(T, Math.round(T), _ / 1e3) ? T = Math.round(T) : T = Math.ceil(T));
  const E = Math.max(sa(_), sa(C));
  D = Math.pow(10, B(l) ? E : l), C = Math.round(C * D) / D, $ = Math.round($ * D) / D;
  let L = 0;
  for (b && (u && C !== a ? (e.push({
    value: a
  }), C < a && L++, Di(Math.round((C + L * _) * D) / D, a, co(a, k, i)) && L++) : C < a && L++); L < T; ++L) {
    const z = Math.round((C + L * _) * D) / D;
    if (x && z > o)
      break;
    e.push({
      value: z
    });
  }
  return x && u && $ !== o ? e.length && Di(e[e.length - 1].value, o, co(o, k, i)) ? e[e.length - 1].value = o : e.push({
    value: o
  }) : (!x || $ === o) && e.push({
    value: $
  }), e;
}
function co(i, t, { horizontal: e, minRotation: n }) {
  const s = Ut(n), r = (e ? Math.sin(s) : Math.cos(s)) || 1e-3, a = 0.75 * t * ("" + i).length;
  return Math.min(t / r, a);
}
class Vn extends Ye {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    return B(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: s, max: r } = this;
    const a = (l) => s = e ? s : l, o = (l) => r = n ? r : l;
    if (t) {
      const l = Kt(s), c = Kt(r);
      l < 0 && c < 0 ? o(0) : l > 0 && c > 0 && a(0);
    }
    if (s === r) {
      let l = r === 0 ? 1 : Math.abs(r * 0.05);
      o(r + l), t || a(s - l);
    }
    this.min = s, this.max = r;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: e, stepSize: n } = t, s;
    return n ? (s = Math.ceil(this.max / n) - Math.floor(this.min / n) + 1, s > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${n} would result generating up to ${s} ticks. Limiting to 1000.`), s = 1e3)) : (s = this.computeTickLimit(), e = e || 11), e && (s = Math.min(e, s)), s;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, e = t.ticks;
    let n = this.getTickLimit();
    n = Math.max(2, n);
    const s = {
      maxTicks: n,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: e.precision,
      step: e.stepSize,
      count: e.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: e.minRotation || 0,
      includeBounds: e.includeBounds !== !1
    }, r = this._range || this, a = jp(s, r);
    return t.bounds === "ticks" && Bo(a, this, "value"), t.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const t = this.ticks;
    let e = this.min, n = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const s = (n - e) / Math.max(t.length - 1, 1) / 2;
      e -= s, n += s;
    }
    this._startValue = e, this._endValue = n, this._valueRange = n - e;
  }
  getLabelForValue(t) {
    return Ji(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class js extends Vn {
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = ht(t) ? t : 0, this.max = ht(e) ? e : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), e = t ? this.width : this.height, n = Ut(this.options.ticks.minRotation), s = (t ? Math.sin(n) : Math.cos(n)) || 1e-3, r = this._resolveTickFontOptions(0);
    return Math.ceil(e / Math.min(40, r.lineHeight / s));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
P(js, "id", "linear"), P(js, "defaults", {
  ticks: {
    callback: Kn.formatters.numeric
  }
});
const ji = (i) => Math.floor(ve(i)), Te = (i, t) => Math.pow(10, ji(i) + t);
function ho(i) {
  return i / Math.pow(10, ji(i)) === 1;
}
function uo(i, t, e) {
  const n = Math.pow(10, e), s = Math.floor(i / n);
  return Math.ceil(t / n) - s;
}
function Vp(i, t) {
  const e = t - i;
  let n = ji(e);
  for (; uo(i, t, n) > 10; )
    n++;
  for (; uo(i, t, n) < 10; )
    n--;
  return Math.min(n, ji(i));
}
function Yp(i, { min: t, max: e }) {
  t = Rt(i.min, t);
  const n = [], s = ji(t);
  let r = Vp(t, e), a = r < 0 ? Math.pow(10, Math.abs(r)) : 1;
  const o = Math.pow(10, r), l = s > r ? Math.pow(10, s) : 0, c = Math.round((t - l) * a) / a, d = Math.floor((t - l) / o / 10) * o * 10;
  let h = Math.floor((c - d) / Math.pow(10, r)), u = Rt(i.min, Math.round((l + d + h * Math.pow(10, r)) * a) / a);
  for (; u < e; )
    n.push({
      value: u,
      major: ho(u),
      significand: h
    }), h >= 10 ? h = h < 15 ? 15 : 20 : h++, h >= 20 && (r++, h = 2, a = r >= 0 ? 1 : a), u = Math.round((l + d + h * Math.pow(10, r)) * a) / a;
  const f = Rt(i.max, u);
  return n.push({
    value: f,
    major: ho(f),
    significand: h
  }), n;
}
class Vs extends Ye {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    const n = Vn.prototype.parse.apply(this, [
      t,
      e
    ]);
    if (n === 0) {
      this._zero = !0;
      return;
    }
    return ht(n) && n > 0 ? n : null;
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = ht(t) ? Math.max(0, t) : null, this.max = ht(e) ? Math.max(0, e) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !ht(this._userMin) && (this.min = t === Te(this.min, 0) ? Te(this.min, -1) : Te(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let n = this.min, s = this.max;
    const r = (o) => n = t ? n : o, a = (o) => s = e ? s : o;
    n === s && (n <= 0 ? (r(1), a(10)) : (r(Te(n, -1)), a(Te(s, 1)))), n <= 0 && r(Te(s, -1)), s <= 0 && a(Te(n, 1)), this.min = n, this.max = s;
  }
  buildTicks() {
    const t = this.options, e = {
      min: this._userMin,
      max: this._userMax
    }, n = Yp(e, this);
    return t.bounds === "ticks" && Bo(n, this, "value"), t.reverse ? (n.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), n;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : Ji(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = ve(t), this._valueRange = ve(this.max) - ve(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (ve(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const e = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + e * this._valueRange);
  }
}
P(Vs, "id", "logarithmic"), P(Vs, "defaults", {
  ticks: {
    callback: Kn.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Ys(i) {
  const t = i.ticks;
  if (t.display && i.display) {
    const e = St(t.backdropPadding);
    return N(t.font && t.font.size, st.font.size) + e.height;
  }
  return 0;
}
function qp(i, t, e) {
  return e = et(e) ? e : [
    e
  ], {
    w: th(i, t.string, e),
    h: e.length * t.lineHeight
  };
}
function fo(i, t, e, n, s) {
  return i === n || i === s ? {
    start: t - e / 2,
    end: t + e / 2
  } : i < n || i > s ? {
    start: t - e,
    end: t
  } : {
    start: t,
    end: t + e
  };
}
function Xp(i) {
  const t = {
    l: i.left + i._padding.left,
    r: i.right - i._padding.right,
    t: i.top + i._padding.top,
    b: i.bottom - i._padding.bottom
  }, e = Object.assign({}, t), n = [], s = [], r = i._pointLabels.length, a = i.options.pointLabels, o = a.centerPointLabels ? nt / r : 0;
  for (let l = 0; l < r; l++) {
    const c = a.setContext(i.getPointLabelContext(l));
    s[l] = c.padding;
    const d = i.getPointPosition(l, i.drawingArea + s[l], o), h = vt(c.font), u = qp(i.ctx, h, i._pointLabels[l]);
    n[l] = u;
    const f = Ft(i.getIndexAngle(l) + o), g = Math.round(hr(f)), m = fo(g, d.x, u.w, 0, 180), v = fo(g, d.y, u.h, 90, 270);
    Qp(e, t, f, m, v);
  }
  i.setCenterPoint(t.l - e.l, e.r - t.r, t.t - e.t, e.b - t.b), i._pointLabelItems = Zp(i, n, s);
}
function Qp(i, t, e, n, s) {
  const r = Math.abs(Math.sin(e)), a = Math.abs(Math.cos(e));
  let o = 0, l = 0;
  n.start < t.l ? (o = (t.l - n.start) / r, i.l = Math.min(i.l, t.l - o)) : n.end > t.r && (o = (n.end - t.r) / r, i.r = Math.max(i.r, t.r + o)), s.start < t.t ? (l = (t.t - s.start) / a, i.t = Math.min(i.t, t.t - l)) : s.end > t.b && (l = (s.end - t.b) / a, i.b = Math.max(i.b, t.b + l));
}
function Gp(i, t, e) {
  const n = i.drawingArea, { extra: s, additionalAngle: r, padding: a, size: o } = e, l = i.getPointPosition(t, n + s + a, r), c = Math.round(hr(Ft(l.angle + ft))), d = eg(l.y, o.h, c), h = Jp(c), u = tg(l.x, o.w, h);
  return {
    visible: !0,
    x: l.x,
    y: d,
    textAlign: h,
    left: u,
    top: d,
    right: u + o.w,
    bottom: d + o.h
  };
}
function Kp(i, t) {
  if (!t)
    return !0;
  const { left: e, top: n, right: s, bottom: r } = i;
  return !(oe({
    x: e,
    y: n
  }, t) || oe({
    x: e,
    y: r
  }, t) || oe({
    x: s,
    y: n
  }, t) || oe({
    x: s,
    y: r
  }, t));
}
function Zp(i, t, e) {
  const n = [], s = i._pointLabels.length, r = i.options, { centerPointLabels: a, display: o } = r.pointLabels, l = {
    extra: Ys(r) / 2,
    additionalAngle: a ? nt / s : 0
  };
  let c;
  for (let d = 0; d < s; d++) {
    l.padding = e[d], l.size = t[d];
    const h = Gp(i, d, l);
    n.push(h), o === "auto" && (h.visible = Kp(h, c), h.visible && (c = h));
  }
  return n;
}
function Jp(i) {
  return i === 0 || i === 180 ? "center" : i < 180 ? "left" : "right";
}
function tg(i, t, e) {
  return e === "right" ? i -= t : e === "center" && (i -= t / 2), i;
}
function eg(i, t, e) {
  return e === 90 || e === 270 ? i -= t / 2 : (e > 270 || e < 90) && (i -= t), i;
}
function ig(i, t, e) {
  const { left: n, top: s, right: r, bottom: a } = e, { backdropColor: o } = t;
  if (!B(o)) {
    const l = Fe(t.borderRadius), c = St(t.backdropPadding);
    i.fillStyle = o;
    const d = n - c.left, h = s - c.top, u = r - n + c.width, f = a - s + c.height;
    Object.values(l).some((g) => g !== 0) ? (i.beginPath(), Wi(i, {
      x: d,
      y: h,
      w: u,
      h: f,
      radius: l
    }), i.fill()) : i.fillRect(d, h, u, f);
  }
}
function ng(i, t) {
  const { ctx: e, options: { pointLabels: n } } = i;
  for (let s = t - 1; s >= 0; s--) {
    const r = i._pointLabelItems[s];
    if (!r.visible)
      continue;
    const a = n.setContext(i.getPointLabelContext(s));
    ig(e, a, r);
    const o = vt(a.font), { x: l, y: c, textAlign: d } = r;
    Be(e, i._pointLabels[s], l, c + o.lineHeight / 2, o, {
      color: a.color,
      textAlign: d,
      textBaseline: "middle"
    });
  }
}
function Al(i, t, e, n) {
  const { ctx: s } = i;
  if (e)
    s.arc(i.xCenter, i.yCenter, t, 0, it);
  else {
    let r = i.getPointPosition(0, t);
    s.moveTo(r.x, r.y);
    for (let a = 1; a < n; a++)
      r = i.getPointPosition(a, t), s.lineTo(r.x, r.y);
  }
}
function sg(i, t, e, n, s) {
  const r = i.ctx, a = t.circular, { color: o, lineWidth: l } = t;
  !a && !n || !o || !l || e < 0 || (r.save(), r.strokeStyle = o, r.lineWidth = l, r.setLineDash(s.dash || []), r.lineDashOffset = s.dashOffset, r.beginPath(), Al(i, e, a, n), r.closePath(), r.stroke(), r.restore());
}
function rg(i, t, e) {
  return ke(i, {
    label: e,
    index: t,
    type: "pointLabel"
  });
}
class wi extends Vn {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = St(Ys(this.options) / 2), e = this.width = this.maxWidth - t.width, n = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + e / 2 + t.left), this.yCenter = Math.floor(this.top + n / 2 + t.top), this.drawingArea = Math.floor(Math.min(e, n) / 2);
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!1);
    this.min = ht(t) && !isNaN(t) ? t : 0, this.max = ht(e) && !isNaN(e) ? e : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Ys(this.options));
  }
  generateTickLabels(t) {
    Vn.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((e, n) => {
      const s = tt(this.options.pointLabels.callback, [
        e,
        n
      ], this);
      return s || s === 0 ? s : "";
    }).filter((e, n) => this.chart.getDataVisibility(n));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? Xp(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, e, n, s) {
    this.xCenter += Math.floor((t - e) / 2), this.yCenter += Math.floor((n - s) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, e, n, s));
  }
  getIndexAngle(t) {
    const e = it / (this._pointLabels.length || 1), n = this.options.startAngle || 0;
    return Ft(t * e + Ut(n));
  }
  getDistanceFromCenterForValue(t) {
    if (B(t))
      return NaN;
    const e = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * e : (t - this.min) * e;
  }
  getValueForDistanceFromCenter(t) {
    if (B(t))
      return NaN;
    const e = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - e : this.min + e;
  }
  getPointLabelContext(t) {
    const e = this._pointLabels || [];
    if (t >= 0 && t < e.length) {
      const n = e[t];
      return rg(this.getContext(), t, n);
    }
  }
  getPointPosition(t, e, n = 0) {
    const s = this.getIndexAngle(t) - ft + n;
    return {
      x: Math.cos(s) * e + this.xCenter,
      y: Math.sin(s) * e + this.yCenter,
      angle: s
    };
  }
  getPointPositionForValue(t, e) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(e));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: e, top: n, right: s, bottom: r } = this._pointLabelItems[t];
    return {
      left: e,
      top: n,
      right: s,
      bottom: r
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: e } } = this.options;
    if (t) {
      const n = this.ctx;
      n.save(), n.beginPath(), Al(this, this.getDistanceFromCenterForValue(this._endValue), e, this._pointLabels.length), n.closePath(), n.fillStyle = t, n.fill(), n.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, e = this.options, { angleLines: n, grid: s, border: r } = e, a = this._pointLabels.length;
    let o, l, c;
    if (e.pointLabels.display && ng(this, a), s.display && this.ticks.forEach((d, h) => {
      if (h !== 0 || h === 0 && this.min < 0) {
        l = this.getDistanceFromCenterForValue(d.value);
        const u = this.getContext(h), f = s.setContext(u), g = r.setContext(u);
        sg(this, f, l, a, g);
      }
    }), n.display) {
      for (t.save(), o = a - 1; o >= 0; o--) {
        const d = n.setContext(this.getPointLabelContext(o)), { color: h, lineWidth: u } = d;
        !u || !h || (t.lineWidth = u, t.strokeStyle = h, t.setLineDash(d.borderDash), t.lineDashOffset = d.borderDashOffset, l = this.getDistanceFromCenterForValue(e.reverse ? this.min : this.max), c = this.getPointPosition(o, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, e = this.options, n = e.ticks;
    if (!n.display)
      return;
    const s = this.getIndexAngle(0);
    let r, a;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(s), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((o, l) => {
      if (l === 0 && this.min >= 0 && !e.reverse)
        return;
      const c = n.setContext(this.getContext(l)), d = vt(c.font);
      if (r = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = d.string, a = t.measureText(o.label).width, t.fillStyle = c.backdropColor;
        const h = St(c.backdropPadding);
        t.fillRect(-a / 2 - h.left, -r - d.size / 2 - h.top, a + h.width, d.size + h.height);
      }
      Be(t, o.label, 0, -r, d, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
P(wi, "id", "radialLinear"), P(wi, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Kn.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), P(wi, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), P(wi, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const es = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, It = /* @__PURE__ */ Object.keys(es);
function po(i, t) {
  return i - t;
}
function go(i, t) {
  if (B(t))
    return null;
  const e = i._adapter, { parser: n, round: s, isoWeekday: r } = i._parseOpts;
  let a = t;
  return typeof n == "function" && (a = n(a)), ht(a) || (a = typeof n == "string" ? e.parse(a, n) : e.parse(a)), a === null ? null : (s && (a = s === "week" && (ii(r) || r === !0) ? e.startOf(a, "isoWeek", r) : e.startOf(a, s)), +a);
}
function mo(i, t, e, n) {
  const s = It.length;
  for (let r = It.indexOf(i); r < s - 1; ++r) {
    const a = es[It[r]], o = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((e - t) / (o * a.size)) <= n)
      return It[r];
  }
  return It[s - 1];
}
function ag(i, t, e, n, s) {
  for (let r = It.length - 1; r >= It.indexOf(e); r--) {
    const a = It[r];
    if (es[a].common && i._adapter.diff(s, n, a) >= t - 1)
      return a;
  }
  return It[e ? It.indexOf(e) : 0];
}
function og(i) {
  for (let t = It.indexOf(i) + 1, e = It.length; t < e; ++t)
    if (es[It[t]].common)
      return It[t];
}
function vo(i, t, e) {
  if (!e)
    i[t] = !0;
  else if (e.length) {
    const { lo: n, hi: s } = ur(e, t), r = e[n] >= t ? e[n] : e[s];
    i[r] = !0;
  }
}
function lg(i, t, e, n) {
  const s = i._adapter, r = +s.startOf(t[0].value, n), a = t[t.length - 1].value;
  let o, l;
  for (o = r; o <= a; o = +s.add(o, 1, n))
    l = e[o], l >= 0 && (t[l].major = !0);
  return t;
}
function bo(i, t, e) {
  const n = [], s = {}, r = t.length;
  let a, o;
  for (a = 0; a < r; ++a)
    o = t[a], s[o] = a, n.push({
      value: o,
      major: !1
    });
  return r === 0 || !e ? n : lg(i, n, s, e);
}
class Vi extends Ye {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, e = {}) {
    const n = t.time || (t.time = {}), s = this._adapter = new ul._date(t.adapters.date);
    s.init(e), ki(n.displayFormats, s.formats()), this._parseOpts = {
      parser: n.parser,
      round: n.round,
      isoWeekday: n.isoWeekday
    }, super.init(t), this._normalized = e.normalized;
  }
  parse(t, e) {
    return t === void 0 ? null : go(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, e = this._adapter, n = t.time.unit || "day";
    let { min: s, max: r, minDefined: a, maxDefined: o } = this.getUserBounds();
    function l(c) {
      !a && !isNaN(c.min) && (s = Math.min(s, c.min)), !o && !isNaN(c.max) && (r = Math.max(r, c.max));
    }
    (!a || !o) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), s = ht(s) && !isNaN(s) ? s : +e.startOf(Date.now(), n), r = ht(r) && !isNaN(r) ? r : +e.endOf(Date.now(), n) + 1, this.min = Math.min(s, r - 1), this.max = Math.max(s + 1, r);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let e = Number.POSITIVE_INFINITY, n = Number.NEGATIVE_INFINITY;
    return t.length && (e = t[0], n = t[t.length - 1]), {
      min: e,
      max: n
    };
  }
  buildTicks() {
    const t = this.options, e = t.time, n = t.ticks, s = n.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && s.length && (this.min = this._userMin || s[0], this.max = this._userMax || s[s.length - 1]);
    const r = this.min, a = this.max, o = Bd(s, r, a);
    return this._unit = e.unit || (n.autoSkip ? mo(e.minUnit, this.min, this.max, this._getLabelCapacity(r)) : ag(this, o.length, e.minUnit, this.min, this.max)), this._majorUnit = !n.major.enabled || this._unit === "year" ? void 0 : og(this._unit), this.initOffsets(s), t.reverse && o.reverse(), bo(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let e = 0, n = 0, s, r;
    this.options.offset && t.length && (s = this.getDecimalForValue(t[0]), t.length === 1 ? e = 1 - s : e = (this.getDecimalForValue(t[1]) - s) / 2, r = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? n = r : n = (r - this.getDecimalForValue(t[t.length - 2])) / 2);
    const a = t.length < 3 ? 0.5 : 0.25;
    e = wt(e, 0, a), n = wt(n, 0, a), this._offsets = {
      start: e,
      end: n,
      factor: 1 / (e + 1 + n)
    };
  }
  _generate() {
    const t = this._adapter, e = this.min, n = this.max, s = this.options, r = s.time, a = r.unit || mo(r.minUnit, e, n, this._getLabelCapacity(e)), o = N(s.ticks.stepSize, 1), l = a === "week" ? r.isoWeekday : !1, c = ii(l) || l === !0, d = {};
    let h = e, u, f;
    if (c && (h = +t.startOf(h, "isoWeek", l)), h = +t.startOf(h, c ? "day" : a), t.diff(n, e, a) > 1e5 * o)
      throw new Error(e + " and " + n + " are too far apart with stepSize of " + o + " " + a);
    const g = s.ticks.source === "data" && this.getDataTimestamps();
    for (u = h, f = 0; u < n; u = +t.add(u, o, a), f++)
      vo(d, u, g);
    return (u === n || s.bounds === "ticks" || f === 1) && vo(d, u, g), Object.keys(d).sort(po).map((m) => +m);
  }
  getLabelForValue(t) {
    const e = this._adapter, n = this.options.time;
    return n.tooltipFormat ? e.format(t, n.tooltipFormat) : e.format(t, n.displayFormats.datetime);
  }
  format(t, e) {
    const s = this.options.time.displayFormats, r = this._unit, a = e || s[r];
    return this._adapter.format(t, a);
  }
  _tickFormatFunction(t, e, n, s) {
    const r = this.options, a = r.ticks.callback;
    if (a)
      return tt(a, [
        t,
        e,
        n
      ], this);
    const o = r.time.displayFormats, l = this._unit, c = this._majorUnit, d = l && o[l], h = c && o[c], u = n[e], f = c && h && u && u.major;
    return this._adapter.format(t, s || (f ? h : d));
  }
  generateTickLabels(t) {
    let e, n, s;
    for (e = 0, n = t.length; e < n; ++e)
      s = t[e], s.label = this._tickFormatFunction(s.value, e, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const e = this._offsets, n = this.getDecimalForValue(t);
    return this.getPixelForDecimal((e.start + n) * e.factor);
  }
  getValueForPixel(t) {
    const e = this._offsets, n = this.getDecimalForPixel(t) / e.factor - e.end;
    return this.min + n * (this.max - this.min);
  }
  _getLabelSize(t) {
    const e = this.options.ticks, n = this.ctx.measureText(t).width, s = Ut(this.isHorizontal() ? e.maxRotation : e.minRotation), r = Math.cos(s), a = Math.sin(s), o = this._resolveTickFontOptions(0).size;
    return {
      w: n * r + o * a,
      h: n * a + o * r
    };
  }
  _getLabelCapacity(t) {
    const e = this.options.time, n = e.displayFormats, s = n[e.unit] || n.millisecond, r = this._tickFormatFunction(t, 0, bo(this, [
      t
    ], this._majorUnit), s), a = this._getLabelSize(r), o = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], e, n;
    if (t.length)
      return t;
    const s = this.getMatchingVisibleMetas();
    if (this._normalized && s.length)
      return this._cache.data = s[0].controller.getAllParsedValues(this);
    for (e = 0, n = s.length; e < n; ++e)
      t = t.concat(s[e].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let e, n;
    if (t.length)
      return t;
    const s = this.getLabels();
    for (e = 0, n = s.length; e < n; ++e)
      t.push(go(this, s[e]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return jo(t.sort(po));
  }
}
P(Vi, "id", "time"), P(Vi, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function wn(i, t, e) {
  let n = 0, s = i.length - 1, r, a, o, l;
  e ? (t >= i[n].pos && t <= i[s].pos && ({ lo: n, hi: s } = ae(i, "pos", t)), { pos: r, time: o } = i[n], { pos: a, time: l } = i[s]) : (t >= i[n].time && t <= i[s].time && ({ lo: n, hi: s } = ae(i, "time", t)), { time: r, pos: o } = i[n], { time: a, pos: l } = i[s]);
  const c = a - r;
  return c ? o + (l - o) * (t - r) / c : o;
}
class qs extends Vi {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), e = this._table = this.buildLookupTable(t);
    this._minPos = wn(e, this.min), this._tableRange = wn(e, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: e, max: n } = this, s = [], r = [];
    let a, o, l, c, d;
    for (a = 0, o = t.length; a < o; ++a)
      c = t[a], c >= e && c <= n && s.push(c);
    if (s.length < 2)
      return [
        {
          time: e,
          pos: 0
        },
        {
          time: n,
          pos: 1
        }
      ];
    for (a = 0, o = s.length; a < o; ++a)
      d = s[a + 1], l = s[a - 1], c = s[a], Math.round((d + l) / 2) !== c && r.push({
        time: c,
        pos: a / (o - 1)
      });
    return r;
  }
  _generate() {
    const t = this.min, e = this.max;
    let n = super.getDataTimestamps();
    return (!n.includes(t) || !n.length) && n.splice(0, 0, t), (!n.includes(e) || n.length === 1) && n.push(e), n.sort((s, r) => s - r);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const e = this.getDataTimestamps(), n = this.getLabelTimestamps();
    return e.length && n.length ? t = this.normalize(e.concat(n)) : t = e.length ? e : n, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (wn(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const e = this._offsets, n = this.getDecimalForPixel(t) / e.factor - e.end;
    return wn(this._table, n * this._tableRange + this._minPos, !0);
  }
}
P(qs, "id", "timeseries"), P(qs, "defaults", Vi.defaults);
var cg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: Us,
  LinearScale: js,
  LogarithmicScale: Vs,
  RadialLinearScale: wi,
  TimeScale: Vi,
  TimeSeriesScale: qs
});
const Dr = [
  gu,
  Vf,
  Hp,
  cg
];
function le(i) {
  "@babel/helpers - typeof";
  return le = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, le(i);
}
function Z(i) {
  if (i === null || i === !0 || i === !1)
    return NaN;
  var t = Number(i);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function A(i, t) {
  if (t.length < i)
    throw new TypeError(i + " argument" + (i > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function I(i) {
  A(1, arguments);
  var t = Object.prototype.toString.call(i);
  return i instanceof Date || le(i) === "object" && t === "[object Date]" ? new Date(i.getTime()) : typeof i == "number" || t === "[object Number]" ? new Date(i) : ((typeof i == "string" || t === "[object String]") && typeof console != "undefined" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Il(i, t) {
  A(2, arguments);
  var e = I(i), n = Z(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && e.setDate(e.getDate() + n), e);
}
function Cr(i, t) {
  A(2, arguments);
  var e = I(i), n = Z(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return e;
  var s = e.getDate(), r = new Date(e.getTime());
  r.setMonth(e.getMonth() + n + 1, 0);
  var a = r.getDate();
  return s >= a ? r : (e.setFullYear(r.getFullYear(), r.getMonth(), s), e);
}
function en(i, t) {
  A(2, arguments);
  var e = I(i).getTime(), n = Z(t);
  return new Date(e + n);
}
var dg = 36e5;
function hg(i, t) {
  A(2, arguments);
  var e = Z(t);
  return en(i, e * dg);
}
var ug = {};
function te() {
  return ug;
}
function We(i, t) {
  var e, n, s, r, a, o, l, c;
  A(1, arguments);
  var d = te(), h = Z((e = (n = (s = (r = t == null ? void 0 : t.weekStartsOn) !== null && r !== void 0 ? r : t == null || (a = t.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && e !== void 0 ? e : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var u = I(i), f = u.getDay(), g = (f < h ? 7 : 0) + f - h;
  return u.setDate(u.getDate() - g), u.setHours(0, 0, 0, 0), u;
}
function Yn(i) {
  var t = new Date(Date.UTC(i.getFullYear(), i.getMonth(), i.getDate(), i.getHours(), i.getMinutes(), i.getSeconds(), i.getMilliseconds()));
  return t.setUTCFullYear(i.getFullYear()), i.getTime() - t.getTime();
}
function Xs(i) {
  A(1, arguments);
  var t = I(i);
  return t.setHours(0, 0, 0, 0), t;
}
var fg = 864e5;
function pg(i, t) {
  A(2, arguments);
  var e = Xs(i), n = Xs(t), s = e.getTime() - Yn(e), r = n.getTime() - Yn(n);
  return Math.round((s - r) / fg);
}
var gg = 6e4;
function mg(i, t) {
  A(2, arguments);
  var e = Z(t);
  return en(i, e * gg);
}
function vg(i, t) {
  A(2, arguments);
  var e = Z(t), n = e * 3;
  return Cr(i, n);
}
function bg(i, t) {
  A(2, arguments);
  var e = Z(t);
  return en(i, e * 1e3);
}
function yg(i, t) {
  A(2, arguments);
  var e = Z(t), n = e * 7;
  return Il(i, n);
}
function xg(i, t) {
  A(2, arguments);
  var e = Z(t);
  return Cr(i, e * 12);
}
function Mi(i, t) {
  A(2, arguments);
  var e = I(i), n = I(t), s = e.getTime() - n.getTime();
  return s < 0 ? -1 : s > 0 ? 1 : s;
}
var is = 6e4, ns = 36e5, wg = 1e3;
function _g(i) {
  return A(1, arguments), i instanceof Date || le(i) === "object" && Object.prototype.toString.call(i) === "[object Date]";
}
function El(i) {
  if (A(1, arguments), !_g(i) && typeof i != "number")
    return !1;
  var t = I(i);
  return !isNaN(Number(t));
}
function kg(i, t) {
  A(2, arguments);
  var e = I(i), n = I(t), s = e.getFullYear() - n.getFullYear(), r = e.getMonth() - n.getMonth();
  return s * 12 + r;
}
function Dg(i, t) {
  A(2, arguments);
  var e = I(i), n = I(t);
  return e.getFullYear() - n.getFullYear();
}
function yo(i, t) {
  var e = i.getFullYear() - t.getFullYear() || i.getMonth() - t.getMonth() || i.getDate() - t.getDate() || i.getHours() - t.getHours() || i.getMinutes() - t.getMinutes() || i.getSeconds() - t.getSeconds() || i.getMilliseconds() - t.getMilliseconds();
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
function Rl(i, t) {
  A(2, arguments);
  var e = I(i), n = I(t), s = yo(e, n), r = Math.abs(pg(e, n));
  e.setDate(e.getDate() - s * r);
  var a = +(yo(e, n) === -s), o = s * (r - a);
  return o === 0 ? 0 : o;
}
function ss(i, t) {
  return A(2, arguments), I(i).getTime() - I(t).getTime();
}
var xo = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, Cg = "trunc";
function nn(i) {
  return i ? xo[i] : xo[Cg];
}
function $g(i, t, e) {
  A(2, arguments);
  var n = ss(i, t) / ns;
  return nn(e == null ? void 0 : e.roundingMethod)(n);
}
function Pg(i, t, e) {
  A(2, arguments);
  var n = ss(i, t) / is;
  return nn(e == null ? void 0 : e.roundingMethod)(n);
}
function Fl(i) {
  A(1, arguments);
  var t = I(i);
  return t.setHours(23, 59, 59, 999), t;
}
function Ll(i) {
  A(1, arguments);
  var t = I(i), e = t.getMonth();
  return t.setFullYear(t.getFullYear(), e + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Mg(i) {
  A(1, arguments);
  var t = I(i);
  return Fl(t).getTime() === Ll(t).getTime();
}
function Nl(i, t) {
  A(2, arguments);
  var e = I(i), n = I(t), s = Mi(e, n), r = Math.abs(kg(e, n)), a;
  if (r < 1)
    a = 0;
  else {
    e.getMonth() === 1 && e.getDate() > 27 && e.setDate(30), e.setMonth(e.getMonth() - s * r);
    var o = Mi(e, n) === -s;
    Mg(I(i)) && r === 1 && Mi(i, n) === 1 && (o = !1), a = s * (r - Number(o));
  }
  return a === 0 ? 0 : a;
}
function Sg(i, t, e) {
  A(2, arguments);
  var n = Nl(i, t) / 3;
  return nn(e == null ? void 0 : e.roundingMethod)(n);
}
function Tg(i, t, e) {
  A(2, arguments);
  var n = ss(i, t) / 1e3;
  return nn(e == null ? void 0 : e.roundingMethod)(n);
}
function Og(i, t, e) {
  A(2, arguments);
  var n = Rl(i, t) / 7;
  return nn(e == null ? void 0 : e.roundingMethod)(n);
}
function Ag(i, t) {
  A(2, arguments);
  var e = I(i), n = I(t), s = Mi(e, n), r = Math.abs(Dg(e, n));
  e.setFullYear(1584), n.setFullYear(1584);
  var a = Mi(e, n) === -s, o = s * (r - Number(a));
  return o === 0 ? 0 : o;
}
function Ig(i) {
  A(1, arguments);
  var t = I(i);
  return t.setSeconds(0, 0), t;
}
function Eg(i) {
  A(1, arguments);
  var t = I(i), e = t.getMonth(), n = e - e % 3;
  return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
}
function Rg(i) {
  A(1, arguments);
  var t = I(i);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Fg(i) {
  A(1, arguments);
  var t = I(i), e = t.getFullYear();
  return t.setFullYear(e + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Lg(i) {
  A(1, arguments);
  var t = I(i), e = /* @__PURE__ */ new Date(0);
  return e.setFullYear(t.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
function Ng(i) {
  A(1, arguments);
  var t = I(i);
  return t.setMinutes(59, 59, 999), t;
}
function zg(i, t) {
  var e, n, s, r, a, o, l, c;
  A(1, arguments);
  var d = te(), h = Z((e = (n = (s = (r = t == null ? void 0 : t.weekStartsOn) !== null && r !== void 0 ? r : t == null || (a = t.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && e !== void 0 ? e : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var u = I(i), f = u.getDay(), g = (f < h ? -7 : 0) + 6 - (f - h);
  return u.setDate(u.getDate() + g), u.setHours(23, 59, 59, 999), u;
}
function Hg(i) {
  A(1, arguments);
  var t = I(i);
  return t.setSeconds(59, 999), t;
}
function Bg(i) {
  A(1, arguments);
  var t = I(i), e = t.getMonth(), n = e - e % 3 + 3;
  return t.setMonth(n, 0), t.setHours(23, 59, 59, 999), t;
}
function Wg(i) {
  A(1, arguments);
  var t = I(i);
  return t.setMilliseconds(999), t;
}
function zl(i, t) {
  A(2, arguments);
  var e = Z(t);
  return en(i, -e);
}
var Ug = 864e5;
function jg(i) {
  A(1, arguments);
  var t = I(i), e = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), s = e - n;
  return Math.floor(s / Ug) + 1;
}
function ri(i) {
  A(1, arguments);
  var t = 1, e = I(i), n = e.getUTCDay(), s = (n < t ? 7 : 0) + n - t;
  return e.setUTCDate(e.getUTCDate() - s), e.setUTCHours(0, 0, 0, 0), e;
}
function Hl(i) {
  A(1, arguments);
  var t = I(i), e = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var s = ri(n), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = ri(r);
  return t.getTime() >= s.getTime() ? e + 1 : t.getTime() >= a.getTime() ? e : e - 1;
}
function Vg(i) {
  A(1, arguments);
  var t = Hl(i), e = /* @__PURE__ */ new Date(0);
  e.setUTCFullYear(t, 0, 4), e.setUTCHours(0, 0, 0, 0);
  var n = ri(e);
  return n;
}
var Yg = 6048e5;
function Bl(i) {
  A(1, arguments);
  var t = I(i), e = ri(t).getTime() - Vg(t).getTime();
  return Math.round(e / Yg) + 1;
}
function Ue(i, t) {
  var e, n, s, r, a, o, l, c;
  A(1, arguments);
  var d = te(), h = Z((e = (n = (s = (r = t == null ? void 0 : t.weekStartsOn) !== null && r !== void 0 ? r : t == null || (a = t.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && s !== void 0 ? s : d.weekStartsOn) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && e !== void 0 ? e : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var u = I(i), f = u.getUTCDay(), g = (f < h ? 7 : 0) + f - h;
  return u.setUTCDate(u.getUTCDate() - g), u.setUTCHours(0, 0, 0, 0), u;
}
function $r(i, t) {
  var e, n, s, r, a, o, l, c;
  A(1, arguments);
  var d = I(i), h = d.getUTCFullYear(), u = te(), f = Z((e = (n = (s = (r = t == null ? void 0 : t.firstWeekContainsDate) !== null && r !== void 0 ? r : t == null || (a = t.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && s !== void 0 ? s : u.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && e !== void 0 ? e : 1);
  if (!(f >= 1 && f <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(h + 1, 0, f), g.setUTCHours(0, 0, 0, 0);
  var m = Ue(g, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(h, 0, f), v.setUTCHours(0, 0, 0, 0);
  var b = Ue(v, t);
  return d.getTime() >= m.getTime() ? h + 1 : d.getTime() >= b.getTime() ? h : h - 1;
}
function qg(i, t) {
  var e, n, s, r, a, o, l, c;
  A(1, arguments);
  var d = te(), h = Z((e = (n = (s = (r = t == null ? void 0 : t.firstWeekContainsDate) !== null && r !== void 0 ? r : t == null || (a = t.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && s !== void 0 ? s : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && e !== void 0 ? e : 1), u = $r(i, t), f = /* @__PURE__ */ new Date(0);
  f.setUTCFullYear(u, 0, h), f.setUTCHours(0, 0, 0, 0);
  var g = Ue(f, t);
  return g;
}
var Xg = 6048e5;
function Wl(i, t) {
  A(1, arguments);
  var e = I(i), n = Ue(e, t).getTime() - qg(e, t).getTime();
  return Math.round(n / Xg) + 1;
}
function G(i, t) {
  for (var e = i < 0 ? "-" : "", n = Math.abs(i).toString(); n.length < t; )
    n = "0" + n;
  return e + n;
}
var Qg = {
  // Year
  y: function(t, e) {
    var n = t.getUTCFullYear(), s = n > 0 ? n : 1 - n;
    return G(e === "yy" ? s % 100 : s, e.length);
  },
  // Month
  M: function(t, e) {
    var n = t.getUTCMonth();
    return e === "M" ? String(n + 1) : G(n + 1, 2);
  },
  // Day of the month
  d: function(t, e) {
    return G(t.getUTCDate(), e.length);
  },
  // AM or PM
  a: function(t, e) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, e) {
    return G(t.getUTCHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H: function(t, e) {
    return G(t.getUTCHours(), e.length);
  },
  // Minute
  m: function(t, e) {
    return G(t.getUTCMinutes(), e.length);
  },
  // Second
  s: function(t, e) {
    return G(t.getUTCSeconds(), e.length);
  },
  // Fraction of second
  S: function(t, e) {
    var n = e.length, s = t.getUTCMilliseconds(), r = Math.floor(s * Math.pow(10, n - 3));
    return G(r, e.length);
  }
};
const pe = Qg;
var Qe = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Gg = {
  // Era
  G: function(t, e, n) {
    var s = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(s, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(s, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(s, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      var s = t.getUTCFullYear(), r = s > 0 ? s : 1 - s;
      return n.ordinalNumber(r, {
        unit: "year"
      });
    }
    return pe.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, s) {
    var r = $r(t, s), a = r > 0 ? r : 1 - r;
    if (e === "YY") {
      var o = a % 100;
      return G(o, 2);
    }
    return e === "Yo" ? n.ordinalNumber(a, {
      unit: "year"
    }) : G(a, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    var n = Hl(t);
    return G(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    var n = t.getUTCFullYear();
    return G(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    var s = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(s);
      case "QQ":
        return G(s, 2);
      case "Qo":
        return n.ordinalNumber(s, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    var s = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(s);
      case "qq":
        return G(s, 2);
      case "qo":
        return n.ordinalNumber(s, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    var s = t.getUTCMonth();
    switch (e) {
      case "M":
      case "MM":
        return pe.M(t, e);
      case "Mo":
        return n.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    var s = t.getUTCMonth();
    switch (e) {
      case "L":
        return String(s + 1);
      case "LL":
        return G(s + 1, 2);
      case "Lo":
        return n.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, e, n, s) {
    var r = Wl(t, s);
    return e === "wo" ? n.ordinalNumber(r, {
      unit: "week"
    }) : G(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    var s = Bl(t);
    return e === "Io" ? n.ordinalNumber(s, {
      unit: "week"
    }) : G(s, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : pe.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    var s = jg(t);
    return e === "Do" ? n.ordinalNumber(s, {
      unit: "dayOfYear"
    }) : G(s, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    var s = t.getUTCDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, s) {
    var r = t.getUTCDay(), a = (r - s.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(a);
      case "ee":
        return G(a, 2);
      case "eo":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, s) {
    var r = t.getUTCDay(), a = (r - s.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(a);
      case "cc":
        return G(a, e.length);
      case "co":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    var s = t.getUTCDay(), r = s === 0 ? 7 : s;
    switch (e) {
      case "i":
        return String(r);
      case "ii":
        return G(r, e.length);
      case "io":
        return n.ordinalNumber(r, {
          unit: "day"
        });
      case "iii":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    var s = t.getUTCHours(), r = s / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    var s = t.getUTCHours(), r;
    switch (s === 12 ? r = Qe.noon : s === 0 ? r = Qe.midnight : r = s / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    var s = t.getUTCHours(), r;
    switch (s >= 17 ? r = Qe.evening : s >= 12 ? r = Qe.afternoon : s >= 4 ? r = Qe.morning : r = Qe.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      var s = t.getUTCHours() % 12;
      return s === 0 && (s = 12), n.ordinalNumber(s, {
        unit: "hour"
      });
    }
    return pe.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : pe.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    var s = t.getUTCHours() % 12;
    return e === "Ko" ? n.ordinalNumber(s, {
      unit: "hour"
    }) : G(s, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    var s = t.getUTCHours();
    return s === 0 && (s = 24), e === "ko" ? n.ordinalNumber(s, {
      unit: "hour"
    }) : G(s, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : pe.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : pe.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return pe.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n, s) {
    var r = s._originalDate || t, a = r.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return _o(a);
      case "XXXX":
      case "XX":
        return Ie(a);
      case "XXXXX":
      case "XXX":
      default:
        return Ie(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n, s) {
    var r = s._originalDate || t, a = r.getTimezoneOffset();
    switch (e) {
      case "x":
        return _o(a);
      case "xxxx":
      case "xx":
        return Ie(a);
      case "xxxxx":
      case "xxx":
      default:
        return Ie(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n, s) {
    var r = s._originalDate || t, a = r.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + wo(a, ":");
      case "OOOO":
      default:
        return "GMT" + Ie(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n, s) {
    var r = s._originalDate || t, a = r.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + wo(a, ":");
      case "zzzz":
      default:
        return "GMT" + Ie(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n, s) {
    var r = s._originalDate || t, a = Math.floor(r.getTime() / 1e3);
    return G(a, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n, s) {
    var r = s._originalDate || t, a = r.getTime();
    return G(a, e.length);
  }
};
function wo(i, t) {
  var e = i > 0 ? "-" : "+", n = Math.abs(i), s = Math.floor(n / 60), r = n % 60;
  if (r === 0)
    return e + String(s);
  var a = t || "";
  return e + String(s) + a + G(r, 2);
}
function _o(i, t) {
  if (i % 60 === 0) {
    var e = i > 0 ? "-" : "+";
    return e + G(Math.abs(i) / 60, 2);
  }
  return Ie(i, t);
}
function Ie(i, t) {
  var e = t || "", n = i > 0 ? "-" : "+", s = Math.abs(i), r = G(Math.floor(s / 60), 2), a = G(s % 60, 2);
  return n + r + e + a;
}
const Kg = Gg;
var ko = function(t, e) {
  switch (t) {
    case "P":
      return e.date({
        width: "short"
      });
    case "PP":
      return e.date({
        width: "medium"
      });
    case "PPP":
      return e.date({
        width: "long"
      });
    case "PPPP":
    default:
      return e.date({
        width: "full"
      });
  }
}, Ul = function(t, e) {
  switch (t) {
    case "p":
      return e.time({
        width: "short"
      });
    case "pp":
      return e.time({
        width: "medium"
      });
    case "ppp":
      return e.time({
        width: "long"
      });
    case "pppp":
    default:
      return e.time({
        width: "full"
      });
  }
}, Zg = function(t, e) {
  var n = t.match(/(P+)(p+)?/) || [], s = n[1], r = n[2];
  if (!r)
    return ko(t, e);
  var a;
  switch (s) {
    case "P":
      a = e.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = e.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = e.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = e.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", ko(s, e)).replace("{{time}}", Ul(r, e));
}, Jg = {
  p: Ul,
  P: Zg
};
const Qs = Jg;
var tm = ["D", "DD"], em = ["YY", "YYYY"];
function jl(i) {
  return tm.indexOf(i) !== -1;
}
function Vl(i) {
  return em.indexOf(i) !== -1;
}
function qn(i, t, e) {
  if (i === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(e, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (i === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(e, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (i === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(e, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (i === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(e, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var im = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, nm = function(t, e, n) {
  var s, r = im[t];
  return typeof r == "string" ? s = r : e === 1 ? s = r.one : s = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + s : s + " ago" : s;
};
const sm = nm;
function Ps(i) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = t.width ? String(t.width) : i.defaultWidth, n = i.formats[e] || i.formats[i.defaultWidth];
    return n;
  };
}
var rm = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, am = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, om = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lm = {
  date: Ps({
    formats: rm,
    defaultWidth: "full"
  }),
  time: Ps({
    formats: am,
    defaultWidth: "full"
  }),
  dateTime: Ps({
    formats: om,
    defaultWidth: "full"
  })
};
const cm = lm;
var dm = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, hm = function(t, e, n, s) {
  return dm[t];
};
const um = hm;
function fi(i) {
  return function(t, e) {
    var n = e != null && e.context ? String(e.context) : "standalone", s;
    if (n === "formatting" && i.formattingValues) {
      var r = i.defaultFormattingWidth || i.defaultWidth, a = e != null && e.width ? String(e.width) : r;
      s = i.formattingValues[a] || i.formattingValues[r];
    } else {
      var o = i.defaultWidth, l = e != null && e.width ? String(e.width) : i.defaultWidth;
      s = i.values[l] || i.values[o];
    }
    var c = i.argumentCallback ? i.argumentCallback(t) : t;
    return s[c];
  };
}
var fm = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, pm = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, gm = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, mm = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, vm = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, bm = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ym = function(t, e) {
  var n = Number(t), s = n % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, xm = {
  ordinalNumber: ym,
  era: fi({
    values: fm,
    defaultWidth: "wide"
  }),
  quarter: fi({
    values: pm,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: fi({
    values: gm,
    defaultWidth: "wide"
  }),
  day: fi({
    values: mm,
    defaultWidth: "wide"
  }),
  dayPeriod: fi({
    values: vm,
    defaultWidth: "wide",
    formattingValues: bm,
    defaultFormattingWidth: "wide"
  })
};
const wm = xm;
function pi(i) {
  return function(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.width, s = n && i.matchPatterns[n] || i.matchPatterns[i.defaultMatchWidth], r = t.match(s);
    if (!r)
      return null;
    var a = r[0], o = n && i.parsePatterns[n] || i.parsePatterns[i.defaultParseWidth], l = Array.isArray(o) ? km(o, function(h) {
      return h.test(a);
    }) : _m(o, function(h) {
      return h.test(a);
    }), c;
    c = i.valueCallback ? i.valueCallback(l) : l, c = e.valueCallback ? e.valueCallback(c) : c;
    var d = t.slice(a.length);
    return {
      value: c,
      rest: d
    };
  };
}
function _m(i, t) {
  for (var e in i)
    if (i.hasOwnProperty(e) && t(i[e]))
      return e;
}
function km(i, t) {
  for (var e = 0; e < i.length; e++)
    if (t(i[e]))
      return e;
}
function Dm(i) {
  return function(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(i.matchPattern);
    if (!n)
      return null;
    var s = n[0], r = t.match(i.parsePattern);
    if (!r)
      return null;
    var a = i.valueCallback ? i.valueCallback(r[0]) : r[0];
    a = e.valueCallback ? e.valueCallback(a) : a;
    var o = t.slice(s.length);
    return {
      value: a,
      rest: o
    };
  };
}
var Cm = /^(\d+)(th|st|nd|rd)?/i, $m = /\d+/i, Pm = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Mm = {
  any: [/^b/i, /^(a|c)/i]
}, Sm = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Tm = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Om = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Am = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Im = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Em = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Rm = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Fm = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Lm = {
  ordinalNumber: Dm({
    matchPattern: Cm,
    parsePattern: $m,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: pi({
    matchPatterns: Pm,
    defaultMatchWidth: "wide",
    parsePatterns: Mm,
    defaultParseWidth: "any"
  }),
  quarter: pi({
    matchPatterns: Sm,
    defaultMatchWidth: "wide",
    parsePatterns: Tm,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: pi({
    matchPatterns: Om,
    defaultMatchWidth: "wide",
    parsePatterns: Am,
    defaultParseWidth: "any"
  }),
  day: pi({
    matchPatterns: Im,
    defaultMatchWidth: "wide",
    parsePatterns: Em,
    defaultParseWidth: "any"
  }),
  dayPeriod: pi({
    matchPatterns: Rm,
    defaultMatchWidth: "any",
    parsePatterns: Fm,
    defaultParseWidth: "any"
  })
};
const Nm = Lm;
var zm = {
  code: "en-US",
  formatDistance: sm,
  formatLong: cm,
  formatRelative: um,
  localize: wm,
  match: Nm,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Yl = zm;
var Hm = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Bm = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Wm = /^'([^]*?)'?$/, Um = /''/g, jm = /[a-zA-Z]/;
function Vm(i, t, e) {
  var n, s, r, a, o, l, c, d, h, u, f, g, m, v, b, x, w, k;
  A(2, arguments);
  var _ = String(t), D = te(), C = (n = (s = e == null ? void 0 : e.locale) !== null && s !== void 0 ? s : D.locale) !== null && n !== void 0 ? n : Yl, $ = Z((r = (a = (o = (l = e == null ? void 0 : e.firstWeekContainsDate) !== null && l !== void 0 ? l : e == null || (c = e.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && o !== void 0 ? o : D.firstWeekContainsDate) !== null && a !== void 0 ? a : (h = D.locale) === null || h === void 0 || (u = h.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!($ >= 1 && $ <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T = Z((f = (g = (m = (v = e == null ? void 0 : e.weekStartsOn) !== null && v !== void 0 ? v : e == null || (b = e.locale) === null || b === void 0 || (x = b.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && m !== void 0 ? m : D.weekStartsOn) !== null && g !== void 0 ? g : (w = D.locale) === null || w === void 0 || (k = w.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && f !== void 0 ? f : 0);
  if (!(T >= 0 && T <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!C.localize)
    throw new RangeError("locale must contain localize property");
  if (!C.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var E = I(i);
  if (!El(E))
    throw new RangeError("Invalid time value");
  var L = Yn(E), z = zl(E, L), rt = {
    firstWeekContainsDate: $,
    weekStartsOn: T,
    locale: C,
    _originalDate: E
  }, Dt = _.match(Bm).map(function(F) {
    var H = F[0];
    if (H === "p" || H === "P") {
      var Q = Qs[H];
      return Q(F, C.formatLong);
    }
    return F;
  }).join("").match(Hm).map(function(F) {
    if (F === "''")
      return "'";
    var H = F[0];
    if (H === "'")
      return Ym(F);
    var Q = Kg[H];
    if (Q)
      return !(e != null && e.useAdditionalWeekYearTokens) && Vl(F) && qn(F, t, String(i)), !(e != null && e.useAdditionalDayOfYearTokens) && jl(F) && qn(F, t, String(i)), Q(z, F, C.localize, rt);
    if (H.match(jm))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + H + "`");
    return F;
  }).join("");
  return Dt;
}
function Ym(i) {
  var t = i.match(Wm);
  return t ? t[1].replace(Um, "'") : i;
}
function qm(i, t) {
  if (i == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var e in t)
    Object.prototype.hasOwnProperty.call(t, e) && (i[e] = t[e]);
  return i;
}
function Xm(i, t) {
  var e, n, s, r, a, o, l, c;
  A(1, arguments);
  var d = I(i), h = d.getFullYear(), u = te(), f = Z((e = (n = (s = (r = t == null ? void 0 : t.firstWeekContainsDate) !== null && r !== void 0 ? r : t == null || (a = t.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && s !== void 0 ? s : u.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && e !== void 0 ? e : 1);
  if (!(f >= 1 && f <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setFullYear(h + 1, 0, f), g.setHours(0, 0, 0, 0);
  var m = We(g, t), v = /* @__PURE__ */ new Date(0);
  v.setFullYear(h, 0, f), v.setHours(0, 0, 0, 0);
  var b = We(v, t);
  return d.getTime() >= m.getTime() ? h + 1 : d.getTime() >= b.getTime() ? h : h - 1;
}
function Qm(i, t) {
  var e, n, s, r, a, o, l, c;
  A(1, arguments);
  var d = te(), h = Z((e = (n = (s = (r = t == null ? void 0 : t.firstWeekContainsDate) !== null && r !== void 0 ? r : t == null || (a = t.locale) === null || a === void 0 || (o = a.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && s !== void 0 ? s : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && e !== void 0 ? e : 1), u = Xm(i, t), f = /* @__PURE__ */ new Date(0);
  f.setFullYear(u, 0, h), f.setHours(0, 0, 0, 0);
  var g = We(f, t);
  return g;
}
var Gm = 6048e5;
function Km(i, t) {
  A(1, arguments);
  var e = I(i), n = We(e, t).getTime() - Qm(e, t).getTime();
  return Math.round(n / Gm) + 1;
}
function Do(i, t) {
  (t == null || t > i.length) && (t = i.length);
  for (var e = 0, n = Array(t); e < t; e++)
    n[e] = i[e];
  return n;
}
function Zm(i, t) {
  if (i) {
    if (typeof i == "string")
      return Do(i, t);
    var e = {}.toString.call(i).slice(8, -1);
    return e === "Object" && i.constructor && (e = i.constructor.name), e === "Map" || e === "Set" ? Array.from(i) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? Do(i, t) : void 0;
  }
}
function Co(i, t) {
  var e = typeof Symbol != "undefined" && i[Symbol.iterator] || i["@@iterator"];
  if (!e) {
    if (Array.isArray(i) || (e = Zm(i)) || t && i && typeof i.length == "number") {
      e && (i = e);
      var n = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return n >= i.length ? {
            done: !0
          } : {
            done: !1,
            value: i[n++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var r, a = !0, o = !1;
  return {
    s: function() {
      e = e.call(i);
    },
    n: function() {
      var c = e.next();
      return a = c.done, c;
    },
    e: function(c) {
      o = !0, r = c;
    },
    f: function() {
      try {
        a || e.return == null || e.return();
      } finally {
        if (o)
          throw r;
      }
    }
  };
}
function S(i) {
  if (i === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i;
}
function Gs(i, t) {
  return Gs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, n) {
    return e.__proto__ = n, e;
  }, Gs(i, t);
}
function V(i, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  i.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: i,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(i, "prototype", {
    writable: !1
  }), t && Gs(i, t);
}
function Xn(i) {
  return Xn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Xn(i);
}
function ql() {
  try {
    var i = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t) {
  }
  return (ql = function() {
    return !!i;
  })();
}
function Jm(i, t) {
  if (t && (le(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return S(i);
}
function Y(i) {
  var t = ql();
  return function() {
    var e, n = Xn(i);
    if (t) {
      var s = Xn(this).constructor;
      e = Reflect.construct(n, arguments, s);
    } else
      e = n.apply(this, arguments);
    return Jm(this, e);
  };
}
function U(i, t) {
  if (!(i instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function tv(i, t) {
  if (le(i) != "object" || !i)
    return i;
  var e = i[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(i, t || "default");
    if (le(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(i);
}
function Xl(i) {
  var t = tv(i, "string");
  return le(t) == "symbol" ? t : t + "";
}
function $o(i, t) {
  for (var e = 0; e < t.length; e++) {
    var n = t[e];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(i, Xl(n.key), n);
  }
}
function j(i, t, e) {
  return t && $o(i.prototype, t), e && $o(i, e), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function M(i, t, e) {
  return (t = Xl(t)) in i ? Object.defineProperty(i, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[t] = e, i;
}
var ev = 10, Ql = /* @__PURE__ */ function() {
  function i() {
    U(this, i), M(this, "priority", void 0), M(this, "subPriority", 0);
  }
  return j(i, [{
    key: "validate",
    value: function(e, n) {
      return !0;
    }
  }]), i;
}(), iv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e(n, s, r, a, o) {
    var l;
    return U(this, e), l = t.call(this), l.value = n, l.validateValue = s, l.setValue = r, l.priority = a, o && (l.subPriority = o), l;
  }
  return j(e, [{
    key: "validate",
    value: function(s, r) {
      return this.validateValue(s, this.value, r);
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return this.setValue(s, r, this.value, a);
    }
  }]), e;
}(Ql), nv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", ev), M(S(n), "subPriority", -1), n;
  }
  return j(e, [{
    key: "set",
    value: function(s, r) {
      if (r.timestampIsSet)
        return s;
      var a = /* @__PURE__ */ new Date(0);
      return a.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), a.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), a;
    }
  }]), e;
}(Ql), X = /* @__PURE__ */ function() {
  function i() {
    U(this, i), M(this, "incompatibleTokens", void 0), M(this, "priority", void 0), M(this, "subPriority", void 0);
  }
  return j(i, [{
    key: "run",
    value: function(e, n, s, r) {
      var a = this.parse(e, n, s, r);
      return a ? {
        setter: new iv(a.value, this.validate, this.set, this.priority, this.subPriority),
        rest: a.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(e, n, s) {
      return !0;
    }
  }]), i;
}(), sv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 140), M(S(n), "incompatibleTokens", ["R", "u", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "G":
        case "GG":
        case "GGG":
          return a.era(s, {
            width: "abbreviated"
          }) || a.era(s, {
            width: "narrow"
          });
        case "GGGGG":
          return a.era(s, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return a.era(s, {
            width: "wide"
          }) || a.era(s, {
            width: "abbreviated"
          }) || a.era(s, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return r.era = a, s.setUTCFullYear(a, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), pt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Qt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function gt(i, t) {
  return i && {
    value: t(i.value),
    rest: i.rest
  };
}
function lt(i, t) {
  var e = t.match(i);
  return e ? {
    value: parseInt(e[0], 10),
    rest: t.slice(e[0].length)
  } : null;
}
function Gt(i, t) {
  var e = t.match(i);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var n = e[1] === "+" ? 1 : -1, s = e[2] ? parseInt(e[2], 10) : 0, r = e[3] ? parseInt(e[3], 10) : 0, a = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: n * (s * ns + r * is + a * wg),
    rest: t.slice(e[0].length)
  };
}
function Gl(i) {
  return lt(pt.anyDigitsSigned, i);
}
function ut(i, t) {
  switch (i) {
    case 1:
      return lt(pt.singleDigit, t);
    case 2:
      return lt(pt.twoDigits, t);
    case 3:
      return lt(pt.threeDigits, t);
    case 4:
      return lt(pt.fourDigits, t);
    default:
      return lt(new RegExp("^\\d{1," + i + "}"), t);
  }
}
function Qn(i, t) {
  switch (i) {
    case 1:
      return lt(pt.singleDigitSigned, t);
    case 2:
      return lt(pt.twoDigitsSigned, t);
    case 3:
      return lt(pt.threeDigitsSigned, t);
    case 4:
      return lt(pt.fourDigitsSigned, t);
    default:
      return lt(new RegExp("^-?\\d{1," + i + "}"), t);
  }
}
function Pr(i) {
  switch (i) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Kl(i, t) {
  var e = t > 0, n = e ? t : 1 - t, s;
  if (n <= 50)
    s = i || 100;
  else {
    var r = n + 50, a = Math.floor(r / 100) * 100, o = i >= r % 100;
    s = i + a - (o ? 100 : 0);
  }
  return e ? s : 1 - s;
}
function Zl(i) {
  return i % 400 === 0 || i % 4 === 0 && i % 100 !== 0;
}
var rv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 130), M(S(n), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      var o = function(c) {
        return {
          year: c,
          isTwoDigitYear: r === "yy"
        };
      };
      switch (r) {
        case "y":
          return gt(ut(4, s), o);
        case "yo":
          return gt(a.ordinalNumber(s, {
            unit: "year"
          }), o);
        default:
          return gt(ut(r.length, s), o);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r.isTwoDigitYear || r.year > 0;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      var o = s.getUTCFullYear();
      if (a.isTwoDigitYear) {
        var l = Kl(a.year, o);
        return s.setUTCFullYear(l, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
      }
      var c = !("era" in r) || r.era === 1 ? a.year : 1 - a.year;
      return s.setUTCFullYear(c, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), av = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 130), M(S(n), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      var o = function(c) {
        return {
          year: c,
          isTwoDigitYear: r === "YY"
        };
      };
      switch (r) {
        case "Y":
          return gt(ut(4, s), o);
        case "Yo":
          return gt(a.ordinalNumber(s, {
            unit: "year"
          }), o);
        default:
          return gt(ut(r.length, s), o);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r.isTwoDigitYear || r.year > 0;
    }
  }, {
    key: "set",
    value: function(s, r, a, o) {
      var l = $r(s, o);
      if (a.isTwoDigitYear) {
        var c = Kl(a.year, l);
        return s.setUTCFullYear(c, 0, o.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), Ue(s, o);
      }
      var d = !("era" in r) || r.era === 1 ? a.year : 1 - a.year;
      return s.setUTCFullYear(d, 0, o.firstWeekContainsDate), s.setUTCHours(0, 0, 0, 0), Ue(s, o);
    }
  }]), e;
}(X), ov = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 130), M(S(n), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r) {
      return Qn(r === "R" ? 4 : r.length, s);
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(a, 0, 4), o.setUTCHours(0, 0, 0, 0), ri(o);
    }
  }]), e;
}(X), lv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 130), M(S(n), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r) {
      return Qn(r === "u" ? 4 : r.length, s);
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCFullYear(a, 0, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), cv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 120), M(S(n), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "Q":
        case "QQ":
          return ut(r.length, s);
        case "Qo":
          return a.ordinalNumber(s, {
            unit: "quarter"
          });
        case "QQQ":
          return a.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return a.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return a.quarter(s, {
            width: "wide",
            context: "formatting"
          }) || a.quarter(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.quarter(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 1 && r <= 4;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCMonth((a - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), dv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 120), M(S(n), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "q":
        case "qq":
          return ut(r.length, s);
        case "qo":
          return a.ordinalNumber(s, {
            unit: "quarter"
          });
        case "qqq":
          return a.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || a.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return a.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return a.quarter(s, {
            width: "wide",
            context: "standalone"
          }) || a.quarter(s, {
            width: "abbreviated",
            context: "standalone"
          }) || a.quarter(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 1 && r <= 4;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCMonth((a - 1) * 3, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), hv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), M(S(n), "priority", 110), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      var o = function(c) {
        return c - 1;
      };
      switch (r) {
        case "M":
          return gt(lt(pt.month, s), o);
        case "MM":
          return gt(ut(2, s), o);
        case "Mo":
          return gt(a.ordinalNumber(s, {
            unit: "month"
          }), o);
        case "MMM":
          return a.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return a.month(s, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return a.month(s, {
            width: "wide",
            context: "formatting"
          }) || a.month(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.month(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 11;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCMonth(a, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), uv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 110), M(S(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      var o = function(c) {
        return c - 1;
      };
      switch (r) {
        case "L":
          return gt(lt(pt.month, s), o);
        case "LL":
          return gt(ut(2, s), o);
        case "Lo":
          return gt(a.ordinalNumber(s, {
            unit: "month"
          }), o);
        case "LLL":
          return a.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || a.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return a.month(s, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return a.month(s, {
            width: "wide",
            context: "standalone"
          }) || a.month(s, {
            width: "abbreviated",
            context: "standalone"
          }) || a.month(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 11;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCMonth(a, 1), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X);
function fv(i, t, e) {
  A(2, arguments);
  var n = I(i), s = Z(t), r = Wl(n, e) - s;
  return n.setUTCDate(n.getUTCDate() - r * 7), n;
}
var pv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 100), M(S(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "w":
          return lt(pt.week, s);
        case "wo":
          return a.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 1 && r <= 53;
    }
  }, {
    key: "set",
    value: function(s, r, a, o) {
      return Ue(fv(s, a, o), o);
    }
  }]), e;
}(X);
function gv(i, t) {
  A(2, arguments);
  var e = I(i), n = Z(t), s = Bl(e) - n;
  return e.setUTCDate(e.getUTCDate() - s * 7), e;
}
var mv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 100), M(S(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "I":
          return lt(pt.week, s);
        case "Io":
          return a.ordinalNumber(s, {
            unit: "week"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 1 && r <= 53;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return ri(gv(s, a));
    }
  }]), e;
}(X), vv = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], bv = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], yv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 90), M(S(n), "subPriority", 1), M(S(n), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "d":
          return lt(pt.date, s);
        case "do":
          return a.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      var a = s.getUTCFullYear(), o = Zl(a), l = s.getUTCMonth();
      return o ? r >= 1 && r <= bv[l] : r >= 1 && r <= vv[l];
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCDate(a), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), xv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 90), M(S(n), "subpriority", 1), M(S(n), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "D":
        case "DD":
          return lt(pt.dayOfYear, s);
        case "Do":
          return a.ordinalNumber(s, {
            unit: "date"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      var a = s.getUTCFullYear(), o = Zl(a);
      return o ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCMonth(0, a), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X);
function Mr(i, t, e) {
  var n, s, r, a, o, l, c, d;
  A(2, arguments);
  var h = te(), u = Z((n = (s = (r = (a = e == null ? void 0 : e.weekStartsOn) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && r !== void 0 ? r : h.weekStartsOn) !== null && s !== void 0 ? s : (c = h.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(u >= 0 && u <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = I(i), g = Z(t), m = f.getUTCDay(), v = g % 7, b = (v + 7) % 7, x = (b < u ? 7 : 0) + g - m;
  return f.setUTCDate(f.getUTCDate() + x), f;
}
var wv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 90), M(S(n), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "E":
        case "EE":
        case "EEE":
          return a.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return a.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return a.day(s, {
            width: "wide",
            context: "formatting"
          }) || a.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 6;
    }
  }, {
    key: "set",
    value: function(s, r, a, o) {
      return s = Mr(s, a, o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), _v = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 90), M(S(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a, o) {
      var l = function(d) {
        var h = Math.floor((d - 1) / 7) * 7;
        return (d + o.weekStartsOn + 6) % 7 + h;
      };
      switch (r) {
        case "e":
        case "ee":
          return gt(ut(r.length, s), l);
        case "eo":
          return gt(a.ordinalNumber(s, {
            unit: "day"
          }), l);
        case "eee":
          return a.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return a.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return a.day(s, {
            width: "wide",
            context: "formatting"
          }) || a.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 6;
    }
  }, {
    key: "set",
    value: function(s, r, a, o) {
      return s = Mr(s, a, o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), kv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 90), M(S(n), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a, o) {
      var l = function(d) {
        var h = Math.floor((d - 1) / 7) * 7;
        return (d + o.weekStartsOn + 6) % 7 + h;
      };
      switch (r) {
        case "c":
        case "cc":
          return gt(ut(r.length, s), l);
        case "co":
          return gt(a.ordinalNumber(s, {
            unit: "day"
          }), l);
        case "ccc":
          return a.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || a.day(s, {
            width: "short",
            context: "standalone"
          }) || a.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return a.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return a.day(s, {
            width: "short",
            context: "standalone"
          }) || a.day(s, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return a.day(s, {
            width: "wide",
            context: "standalone"
          }) || a.day(s, {
            width: "abbreviated",
            context: "standalone"
          }) || a.day(s, {
            width: "short",
            context: "standalone"
          }) || a.day(s, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 6;
    }
  }, {
    key: "set",
    value: function(s, r, a, o) {
      return s = Mr(s, a, o), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X);
function Dv(i, t) {
  A(2, arguments);
  var e = Z(t);
  e % 7 === 0 && (e = e - 7);
  var n = 1, s = I(i), r = s.getUTCDay(), a = e % 7, o = (a + 7) % 7, l = (o < n ? 7 : 0) + e - r;
  return s.setUTCDate(s.getUTCDate() + l), s;
}
var Cv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 90), M(S(n), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      var o = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (r) {
        case "i":
        case "ii":
          return ut(r.length, s);
        case "io":
          return a.ordinalNumber(s, {
            unit: "day"
          });
        case "iii":
          return gt(a.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiii":
          return gt(a.day(s, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiiii":
          return gt(a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiii":
        default:
          return gt(a.day(s, {
            width: "wide",
            context: "formatting"
          }) || a.day(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(s, {
            width: "short",
            context: "formatting"
          }) || a.day(s, {
            width: "narrow",
            context: "formatting"
          }), o);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 1 && r <= 7;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s = Dv(s, a), s.setUTCHours(0, 0, 0, 0), s;
    }
  }]), e;
}(X), $v = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 80), M(S(n), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "a":
        case "aa":
        case "aaa":
          return a.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return a.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCHours(Pr(a), 0, 0, 0), s;
    }
  }]), e;
}(X), Pv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 80), M(S(n), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "b":
        case "bb":
        case "bbb":
          return a.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return a.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCHours(Pr(a), 0, 0, 0), s;
    }
  }]), e;
}(X), Mv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 80), M(S(n), "incompatibleTokens", ["a", "b", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "B":
        case "BB":
        case "BBB":
          return a.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return a.dayPeriod(s, {
            width: "wide",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "abbreviated",
            context: "formatting"
          }) || a.dayPeriod(s, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCHours(Pr(a), 0, 0, 0), s;
    }
  }]), e;
}(X), Sv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 70), M(S(n), "incompatibleTokens", ["H", "K", "k", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "h":
          return lt(pt.hour12h, s);
        case "ho":
          return a.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 1 && r <= 12;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      var o = s.getUTCHours() >= 12;
      return o && a < 12 ? s.setUTCHours(a + 12, 0, 0, 0) : !o && a === 12 ? s.setUTCHours(0, 0, 0, 0) : s.setUTCHours(a, 0, 0, 0), s;
    }
  }]), e;
}(X), Tv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 70), M(S(n), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "H":
          return lt(pt.hour23h, s);
        case "Ho":
          return a.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 23;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCHours(a, 0, 0, 0), s;
    }
  }]), e;
}(X), Ov = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 70), M(S(n), "incompatibleTokens", ["h", "H", "k", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "K":
          return lt(pt.hour11h, s);
        case "Ko":
          return a.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 11;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      var o = s.getUTCHours() >= 12;
      return o && a < 12 ? s.setUTCHours(a + 12, 0, 0, 0) : s.setUTCHours(a, 0, 0, 0), s;
    }
  }]), e;
}(X), Av = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 70), M(S(n), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "k":
          return lt(pt.hour24h, s);
        case "ko":
          return a.ordinalNumber(s, {
            unit: "hour"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 1 && r <= 24;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      var o = a <= 24 ? a % 24 : a;
      return s.setUTCHours(o, 0, 0, 0), s;
    }
  }]), e;
}(X), Iv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 60), M(S(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "m":
          return lt(pt.minute, s);
        case "mo":
          return a.ordinalNumber(s, {
            unit: "minute"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 59;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCMinutes(a, 0, 0), s;
    }
  }]), e;
}(X), Ev = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 50), M(S(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r, a) {
      switch (r) {
        case "s":
          return lt(pt.second, s);
        case "so":
          return a.ordinalNumber(s, {
            unit: "second"
          });
        default:
          return ut(r.length, s);
      }
    }
  }, {
    key: "validate",
    value: function(s, r) {
      return r >= 0 && r <= 59;
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCSeconds(a, 0), s;
    }
  }]), e;
}(X), Rv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 30), M(S(n), "incompatibleTokens", ["t", "T"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r) {
      var a = function(l) {
        return Math.floor(l * Math.pow(10, -r.length + 3));
      };
      return gt(ut(r.length, s), a);
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return s.setUTCMilliseconds(a), s;
    }
  }]), e;
}(X), Fv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 10), M(S(n), "incompatibleTokens", ["t", "T", "x"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r) {
      switch (r) {
        case "X":
          return Gt(Qt.basicOptionalMinutes, s);
        case "XX":
          return Gt(Qt.basic, s);
        case "XXXX":
          return Gt(Qt.basicOptionalSeconds, s);
        case "XXXXX":
          return Gt(Qt.extendedOptionalSeconds, s);
        case "XXX":
        default:
          return Gt(Qt.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return r.timestampIsSet ? s : new Date(s.getTime() - a);
    }
  }]), e;
}(X), Lv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 10), M(S(n), "incompatibleTokens", ["t", "T", "X"]), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s, r) {
      switch (r) {
        case "x":
          return Gt(Qt.basicOptionalMinutes, s);
        case "xx":
          return Gt(Qt.basic, s);
        case "xxxx":
          return Gt(Qt.basicOptionalSeconds, s);
        case "xxxxx":
          return Gt(Qt.extendedOptionalSeconds, s);
        case "xxx":
        default:
          return Gt(Qt.extended, s);
      }
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return r.timestampIsSet ? s : new Date(s.getTime() - a);
    }
  }]), e;
}(X), Nv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 40), M(S(n), "incompatibleTokens", "*"), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s) {
      return Gl(s);
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return [new Date(a * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), e;
}(X), zv = /* @__PURE__ */ function(i) {
  V(e, i);
  var t = Y(e);
  function e() {
    var n;
    U(this, e);
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return n = t.call.apply(t, [this].concat(r)), M(S(n), "priority", 20), M(S(n), "incompatibleTokens", "*"), n;
  }
  return j(e, [{
    key: "parse",
    value: function(s) {
      return Gl(s);
    }
  }, {
    key: "set",
    value: function(s, r, a) {
      return [new Date(a), {
        timestampIsSet: !0
      }];
    }
  }]), e;
}(X), Hv = {
  G: new sv(),
  y: new rv(),
  Y: new av(),
  R: new ov(),
  u: new lv(),
  Q: new cv(),
  q: new dv(),
  M: new hv(),
  L: new uv(),
  w: new pv(),
  I: new mv(),
  d: new yv(),
  D: new xv(),
  E: new wv(),
  e: new _v(),
  c: new kv(),
  i: new Cv(),
  a: new $v(),
  b: new Pv(),
  B: new Mv(),
  h: new Sv(),
  H: new Tv(),
  K: new Ov(),
  k: new Av(),
  m: new Iv(),
  s: new Ev(),
  S: new Rv(),
  X: new Fv(),
  x: new Lv(),
  t: new Nv(),
  T: new zv()
}, Bv = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Wv = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Uv = /^'([^]*?)'?$/, jv = /''/g, Vv = /\S/, Yv = /[a-zA-Z]/;
function qv(i, t, e, n) {
  var s, r, a, o, l, c, d, h, u, f, g, m, v, b, x, w, k, _;
  A(3, arguments);
  var D = String(i), C = String(t), $ = te(), T = (s = (r = n == null ? void 0 : n.locale) !== null && r !== void 0 ? r : $.locale) !== null && s !== void 0 ? s : Yl;
  if (!T.match)
    throw new RangeError("locale must contain match property");
  var E = Z((a = (o = (l = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (d = n.locale) === null || d === void 0 || (h = d.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && l !== void 0 ? l : $.firstWeekContainsDate) !== null && o !== void 0 ? o : (u = $.locale) === null || u === void 0 || (f = u.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(E >= 1 && E <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var L = Z((g = (m = (v = (b = n == null ? void 0 : n.weekStartsOn) !== null && b !== void 0 ? b : n == null || (x = n.locale) === null || x === void 0 || (w = x.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && v !== void 0 ? v : $.weekStartsOn) !== null && m !== void 0 ? m : (k = $.locale) === null || k === void 0 || (_ = k.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(L >= 0 && L <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (C === "")
    return D === "" ? I(e) : /* @__PURE__ */ new Date(NaN);
  var z = {
    firstWeekContainsDate: E,
    weekStartsOn: L,
    locale: T
  }, rt = [new nv()], Dt = C.match(Wv).map(function(bt) {
    var J = bt[0];
    if (J in Qs) {
      var zt = Qs[J];
      return zt(bt, T.formatLong);
    }
    return bt;
  }).join("").match(Bv), F = [], H = Co(Dt), Q;
  try {
    var Et = function() {
      var J = Q.value;
      !(n != null && n.useAdditionalWeekYearTokens) && Vl(J) && qn(J, C, i), !(n != null && n.useAdditionalDayOfYearTokens) && jl(J) && qn(J, C, i);
      var zt = J[0], on = Hv[zt];
      if (on) {
        var Ir = on.incompatibleTokens;
        if (Array.isArray(Ir)) {
          var Er = F.find(function(Rr) {
            return Ir.includes(Rr.token) || Rr.token === zt;
          });
          if (Er)
            throw new RangeError("The format string mustn't contain `".concat(Er.fullToken, "` and `").concat(J, "` at the same time"));
        } else if (on.incompatibleTokens === "*" && F.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(J, "` and any other token at the same time"));
        F.push({
          token: zt,
          fullToken: J
        });
        var rs = on.run(D, J, T.match, z);
        if (!rs)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        rt.push(rs.setter), D = rs.rest;
      } else {
        if (zt.match(Yv))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + zt + "`");
        if (J === "''" ? J = "'" : zt === "'" && (J = Xv(J)), D.indexOf(J) === 0)
          D = D.slice(J.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (H.s(); !(Q = H.n()).done; ) {
      var mt = Et();
      if (le(mt) === "object")
        return mt.v;
    }
  } catch (bt) {
    H.e(bt);
  } finally {
    H.f();
  }
  if (D.length > 0 && Vv.test(D))
    return /* @__PURE__ */ new Date(NaN);
  var de = rt.map(function(bt) {
    return bt.priority;
  }).sort(function(bt, J) {
    return J - bt;
  }).filter(function(bt, J, zt) {
    return zt.indexOf(bt) === J;
  }).map(function(bt) {
    return rt.filter(function(J) {
      return J.priority === bt;
    }).sort(function(J, zt) {
      return zt.subPriority - J.subPriority;
    });
  }).map(function(bt) {
    return bt[0];
  }), he = I(e);
  if (isNaN(he.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var Lt = zl(he, Yn(he)), ue = {}, Nt = Co(de), fe;
  try {
    for (Nt.s(); !(fe = Nt.n()).done; ) {
      var Yt = fe.value;
      if (!Yt.validate(Lt, z))
        return /* @__PURE__ */ new Date(NaN);
      var an = Yt.set(Lt, ue, z);
      Array.isArray(an) ? (Lt = an[0], qm(ue, an[1])) : Lt = an;
    }
  } catch (bt) {
    Nt.e(bt);
  } finally {
    Nt.f();
  }
  return Lt;
}
function Xv(i) {
  return i.match(Uv)[1].replace(jv, "'");
}
function Qv(i) {
  A(1, arguments);
  var t = I(i);
  return t.setMinutes(0, 0, 0), t;
}
function Gv(i) {
  A(1, arguments);
  var t = I(i);
  return t.setMilliseconds(0), t;
}
function Kv(i, t) {
  var e;
  A(1, arguments);
  var n = Z((e = t == null ? void 0 : t.additionalDigits) !== null && e !== void 0 ? e : 2);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof i == "string" || Object.prototype.toString.call(i) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var s = eb(i), r;
  if (s.date) {
    var a = ib(s.date, n);
    r = nb(a.restDateString, a.year);
  }
  if (!r || isNaN(r.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var o = r.getTime(), l = 0, c;
  if (s.time && (l = sb(s.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (s.timezone) {
    if (c = rb(s.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var d = new Date(o + l), h = /* @__PURE__ */ new Date(0);
    return h.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), h.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), h;
  }
  return new Date(o + l + c);
}
var _n = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Zv = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Jv = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, tb = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function eb(i) {
  var t = {}, e = i.split(_n.dateTimeDelimiter), n;
  if (e.length > 2)
    return t;
  if (/:/.test(e[0]) ? n = e[0] : (t.date = e[0], n = e[1], _n.timeZoneDelimiter.test(t.date) && (t.date = i.split(_n.timeZoneDelimiter)[0], n = i.substr(t.date.length, i.length))), n) {
    var s = _n.timezone.exec(n);
    s ? (t.time = n.replace(s[1], ""), t.timezone = s[1]) : t.time = n;
  }
  return t;
}
function ib(i, t) {
  var e = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), n = i.match(e);
  if (!n)
    return {
      year: NaN,
      restDateString: ""
    };
  var s = n[1] ? parseInt(n[1]) : null, r = n[2] ? parseInt(n[2]) : null;
  return {
    year: r === null ? s : r * 100,
    restDateString: i.slice((n[1] || n[2]).length)
  };
}
function nb(i, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var e = i.match(Zv);
  if (!e)
    return /* @__PURE__ */ new Date(NaN);
  var n = !!e[4], s = gi(e[1]), r = gi(e[2]) - 1, a = gi(e[3]), o = gi(e[4]), l = gi(e[5]) - 1;
  if (n)
    return db(t, o, l) ? ab(t, o, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !lb(t, r, a) || !cb(t, s) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, r, Math.max(s, a)), c);
}
function gi(i) {
  return i ? parseInt(i) : 1;
}
function sb(i) {
  var t = i.match(Jv);
  if (!t)
    return NaN;
  var e = Ms(t[1]), n = Ms(t[2]), s = Ms(t[3]);
  return hb(e, n, s) ? e * ns + n * is + s * 1e3 : NaN;
}
function Ms(i) {
  return i && parseFloat(i.replace(",", ".")) || 0;
}
function rb(i) {
  if (i === "Z")
    return 0;
  var t = i.match(tb);
  if (!t)
    return 0;
  var e = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), s = t[3] && parseInt(t[3]) || 0;
  return ub(n, s) ? e * (n * ns + s * is) : NaN;
}
function ab(i, t, e) {
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(i, 0, 4);
  var s = n.getUTCDay() || 7, r = (t - 1) * 7 + e + 1 - s;
  return n.setUTCDate(n.getUTCDate() + r), n;
}
var ob = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Jl(i) {
  return i % 400 === 0 || i % 4 === 0 && i % 100 !== 0;
}
function lb(i, t, e) {
  return t >= 0 && t <= 11 && e >= 1 && e <= (ob[t] || (Jl(i) ? 29 : 28));
}
function cb(i, t) {
  return t >= 1 && t <= (Jl(i) ? 366 : 365);
}
function db(i, t, e) {
  return t >= 1 && t <= 53 && e >= 0 && e <= 6;
}
function hb(i, t, e) {
  return i === 24 ? t === 0 && e === 0 : e >= 0 && e < 60 && t >= 0 && t < 60 && i >= 0 && i < 25;
}
function ub(i, t) {
  return t >= 0 && t <= 59;
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const fb = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
ul._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return fb;
  },
  parse: function(i, t) {
    if (i === null || typeof i == "undefined")
      return null;
    const e = typeof i;
    return e === "number" || i instanceof Date ? i = I(i) : e === "string" && (typeof t == "string" ? i = qv(i, t, /* @__PURE__ */ new Date(), this.options) : i = Kv(i, this.options)), El(i) ? i.getTime() : null;
  },
  format: function(i, t) {
    return Vm(i, t, this.options);
  },
  add: function(i, t, e) {
    switch (e) {
      case "millisecond":
        return en(i, t);
      case "second":
        return bg(i, t);
      case "minute":
        return mg(i, t);
      case "hour":
        return hg(i, t);
      case "day":
        return Il(i, t);
      case "week":
        return yg(i, t);
      case "month":
        return Cr(i, t);
      case "quarter":
        return vg(i, t);
      case "year":
        return xg(i, t);
      default:
        return i;
    }
  },
  diff: function(i, t, e) {
    switch (e) {
      case "millisecond":
        return ss(i, t);
      case "second":
        return Tg(i, t);
      case "minute":
        return Pg(i, t);
      case "hour":
        return $g(i, t);
      case "day":
        return Rl(i, t);
      case "week":
        return Og(i, t);
      case "month":
        return Nl(i, t);
      case "quarter":
        return Sg(i, t);
      case "year":
        return Ag(i, t);
      default:
        return 0;
    }
  },
  startOf: function(i, t, e) {
    switch (t) {
      case "second":
        return Gv(i);
      case "minute":
        return Ig(i);
      case "hour":
        return Qv(i);
      case "day":
        return Xs(i);
      case "week":
        return We(i);
      case "isoWeek":
        return We(i, { weekStartsOn: +e });
      case "month":
        return Rg(i);
      case "quarter":
        return Eg(i);
      case "year":
        return Lg(i);
      default:
        return i;
    }
  },
  endOf: function(i, t) {
    switch (t) {
      case "second":
        return Wg(i);
      case "minute":
        return Hg(i);
      case "hour":
        return Ng(i);
      case "day":
        return Fl(i);
      case "week":
        return zg(i);
      case "month":
        return Ll(i);
      case "quarter":
        return Bg(i);
      case "year":
        return Fg(i);
      default:
        return i;
    }
  }
});
class pb {
  /**
   * Constructor del servicio
   * @param baseUrl URL base para las peticiones
   */
  constructor(t) {
    this.baseUrl = t;
  }
  /**
   * Filtra los datos según el timeframe y modo seleccionado
   * @param data Datos completos
   * @param timeframe Período seleccionado
   * @param customIntervalMode Si está en modo de intervalo personalizado
   * @returns Datos filtrados y posible error
   */
  filterDataByTimeframe(t, e, n) {
    if (!t.length)
      return {
        filteredData: [],
        error: null
      };
    const s = /* @__PURE__ */ new Date();
    let r = /* @__PURE__ */ new Date(), a = [];
    if (n)
      a = [...t];
    else {
      const o = new Date(Math.min(
        s.getTime(),
        Math.max(...t.map((l) => new Date(l.date).getTime()))
      ));
      switch (e) {
        case "1d":
          r = new Date(o), r.setDate(o.getDate() - 1);
          break;
        case "1w":
          r = new Date(o.getTime() - 7 * 24 * 60 * 60 * 1e3);
          break;
        case "1m":
          r = new Date(o), r.setMonth(o.getMonth() - 1);
          break;
        case "3m":
          r = new Date(o), r.setMonth(o.getMonth() - 3);
          break;
        case "6m":
          r = new Date(o), r.setMonth(o.getMonth() - 6);
          break;
        case "1y":
          r = new Date(o), r.setFullYear(o.getFullYear() - 1);
          break;
        case "5y":
          r = new Date(o), r.setFullYear(o.getFullYear() - 5);
          break;
        default:
          r = new Date(o), r.setMonth(o.getMonth() - 1);
      }
      a = t.filter((l) => {
        const c = new Date(l.date);
        return c >= r && c <= o;
      });
    }
    return a.length === 0 ? {
      filteredData: [],
      error: p("No hay datos disponibles para el período seleccionado")
    } : {
      filteredData: a,
      error: null
    };
  }
  /**
   * Comprueba si una empresa ha dejado de cotizar
   * @param data Datos de cotización
   * @returns Boolean indicando si la empresa ha dejado de cotizar
   */
  isDelistedCompany(t) {
    if (t.length === 0)
      return !1;
    const e = new Date(Math.max(...t.map((a) => new Date(a.date).getTime()))), s = Math.abs((/* @__PURE__ */ new Date()).getTime() - e.getTime());
    return Math.ceil(s / (1e3 * 60 * 60 * 24)) > 30;
  }
  /**
   * Obtiene los datos históricos para empresas que han dejado de cotizar
   * @param symbol Símbolo de la acción
   * @returns Promesa con los datos históricos
   */
  fetchDelistedCompanyData(t) {
    return q(this, null, function* () {
      const e = `${this.baseUrl}/asset-data/stock-price-volume-data?symbol=${encodeURIComponent(t)}`, n = yield fetch(e);
      if (!n.ok)
        throw new Error(p(O`Error al obtener datos: ${n.statusText}`));
      const s = yield n.json();
      return !s || s.length === 0 ? (console.warn(`No hay datos disponibles para la empresa deslistada ${t}`), []) : s.sort((r, a) => new Date(r.date).getTime() - new Date(a.date).getTime()).slice(-60);
    });
  }
  /**
   * Obtiene los datos de acciones desde la API
   * @param options Opciones para la petición
   * @returns Datos obtenidos
   */
  fetchChartData(t) {
    return q(this, null, function* () {
      const { symbol: e, interval: n, timeframe: s, customIntervalMode: r, showHeader: a } = t, o = [], l = /* @__PURE__ */ new Date();
      let c = new Date(l), d = this.calculateDaysToRequest(n, s, r);
      d > 0 && c.setDate(c.getDate() - d);
      const h = this.buildEndpoint(e, n, c, l, d), u = fetch(h).then((w) => q(this, null, function* () {
        if (!w.ok)
          throw new Error(p(O`Error al obtener datos: ${w.statusText}`));
        return w.json();
      }));
      o.push(u);
      let f = null;
      a && (f = fetch(`${this.baseUrl}/asset-data/stock-details?symbol=${encodeURIComponent(e)}`).then((w) => q(this, null, function* () {
        return w.ok ? w.json() : (console.warn(`No se pudieron obtener los detalles de la acción ${e}`), null);
      })).catch((w) => (console.warn("Error al obtener los detalles de la acción:", w), null)), o.push(f));
      const g = yield Promise.all(o);
      let m = g[0], v = f ? g[1] : null, b = !1, x = !1;
      if (m.length === 0 || this.isDelistedCompany(m))
        try {
          console.log("Detectada empresa que posiblemente dejó de cotizar. Obteniendo datos históricos específicos."), m = yield this.fetchDelistedCompanyData(e), m.length === 0 ? v && (b = !0, x = !0) : x = !0;
        } catch (w) {
          console.error("Error al obtener datos para empresa que dejó de cotizar:", w);
        }
      return m.sort(
        (w, k) => new Date(w.date).getTime() - new Date(k.date).getTime()
      ), ["1min", "5min", "15min", "30min", "1hour", "4hour"].includes(n) && d === 0 && m.length > 100 && (m = m.slice(-100)), {
        chartData: m,
        stockInfo: v,
        isDelistedCompany: x,
        isDelistedWithNoData: b
      };
    });
  }
  /**
   * Calcula el número de días a solicitar
   * @param interval Intervalo seleccionado
   * @param timeframe Período seleccionado
   * @param customIntervalMode Si está en modo personalizado
   * @returns Número de días a solicitar
   */
  calculateDaysToRequest(t, e, n) {
    return n ? t === "1month" ? 1e3 : t === "1week" ? 500 : t === "1day" ? 100 : 0 : {
      "1d": 1,
      "1w": 7,
      "1m": 31,
      "3m": 92,
      "6m": 183,
      "1y": 366,
      "5y": 1830
    }[e] || 31;
  }
  /**
   * Construye la URL del endpoint
   * @param symbol Símbolo de la acción
   * @param interval Intervalo seleccionado
   * @param fromDate Fecha de inicio
   * @param toDate Fecha de fin
   * @param daysToRequest Días a solicitar
   * @returns URL del endpoint
   */
  buildEndpoint(t, e, n, s, r) {
    let a = "";
    return ["1min", "5min", "15min", "30min", "1hour", "4hour"].includes(e) ? (a = `${this.baseUrl}/asset-data/historical-interval?symbol=${encodeURIComponent(t)}&interval=${e}`, r > 0 && (a += `&from_date=${n.toISOString().split("T")[0]}`, a += `&to_date=${s.toISOString().split("T")[0]}`)) : (a = `${this.baseUrl}/asset-data/stock-price-volume-data?symbol=${encodeURIComponent(t)}`, r > 0 && (a += `&from_date=${n.toISOString().split("T")[0]}`, a += `&to_date=${s.toISOString().split("T")[0]}`)), a;
  }
}
class Ge {
  /**
   * Formatea un número para su visualización
   * @param value Número a formatear
   * @returns Cadena formateada
   */
  static formatNumber(t) {
    return t === void 0 || isNaN(t) ? "N/A" : t >= 1e9 ? `${(t / 1e9).toFixed(2)}${p("B")}` : t >= 1e6 ? `${(t / 1e6).toFixed(2)}${p("M")}` : t >= 1e3 ? `${(t / 1e3).toFixed(2)}${p("K")}` : t.toString();
  }
  /**
   * Formatea una fecha según el intervalo y locale
   * @param date Fecha a formatear
   * @param interval Intervalo de tiempo
   * @param locale Configuración regional
   * @returns Cadena de fecha formateada
   */
  static formatDate(t, e, n) {
    return e === "1month" ? t.toLocaleDateString(n, { month: "short", year: "numeric" }) : e === "1week" ? t.toLocaleDateString(n, { day: "2-digit", month: "short" }) : ["1min", "5min", "15min", "30min", "1hour", "4hour"].includes(e) ? t.toLocaleTimeString(n, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: !1
    }) : t.toLocaleDateString(n, { day: "2-digit", month: "2-digit" });
  }
  /**
   * Formatea una fecha para tooltips
   * @param date Fecha a formatear
   * @param interval Intervalo de tiempo
   * @param locale Configuración regional
   * @returns Cadena de fecha formateada
   */
  static formatTooltipDate(t, e, n) {
    return e === "1month" ? t.toLocaleDateString(n, { month: "short", year: "numeric" }) : ["1min", "5min", "15min", "30min", "1hour", "4hour"].includes(e) ? `${t.toLocaleDateString(n)} ${t.toLocaleTimeString(n, { hour: "2-digit", minute: "2-digit" })}` : t.toLocaleDateString(n);
  }
}
class gb {
  /**
   * Crea los gráficos de precios y volumen (método para stocks - retrocompatibilidad)
   * @param options Opciones para crear los gráficos
   * @returns Objetos de los gráficos creados
   */
  createCharts(t) {
    const {
      priceCanvas: e,
      volumeCanvas: n,
      chartData: s,
      chartType: r,
      interval: a,
      locale: o,
      showVolume: l,
      syncTooltips: c
    } = t;
    this.clearCanvases(e, n);
    const { dates: d, closePrices: h, volumes: u } = this.prepareChartData(s, a, o), f = this.createPriceChart(
      e,
      d,
      h,
      s,
      r,
      a,
      o,
      c
    );
    let g = null;
    return l && n && (g = this.createVolumeChart(
      n,
      d,
      u,
      s,
      a,
      o,
      c,
      f
    )), { priceChart: f, volumeChart: g };
  }
  /**
   * Crea los gráficos genéricos (stocks o fondos)
   * @param options Opciones genéricas para crear los gráficos
   * @returns Objetos de los gráficos creados
   */
  createGenericCharts(t) {
    const {
      priceCanvas: e,
      volumeCanvas: n,
      chartData: s,
      chartType: r,
      interval: a,
      locale: o,
      showVolume: l,
      syncTooltips: c,
      instrumentType: d
    } = t;
    this.clearCanvases(e, n);
    const { dates: h, prices: u, volumes: f } = this.prepareGenericChartData(s, a, o, d), g = this.createGenericPriceChart(
      e,
      h,
      u,
      s,
      r,
      a,
      o,
      c,
      d
    );
    let m = null;
    return l && n && d === "stock" && (m = this.createVolumeChart(
      n,
      h,
      f,
      s,
      // Safe cast ya que sabemos que es stock
      a,
      o,
      c,
      g
    )), { priceChart: g, volumeChart: m };
  }
  /**
   * Limpia los canvases antes de crear nuevos gráficos
   * @param priceCanvas Canvas para el gráfico de precios
   * @param volumeCanvas Canvas para el gráfico de volumen
   */
  clearCanvases(t, e) {
    const n = t.getContext("2d");
    if (n && n.clearRect(0, 0, t.width, t.height), e) {
      const s = e.getContext("2d");
      s && s.clearRect(0, 0, e.width, e.height);
    }
  }
  /**
   * Prepara los datos para los gráficos (método genérico para stocks y fondos)
   * @param chartData Datos del gráfico
   * @param interval Intervalo seleccionado
   * @param locale Configuración regional
   * @param instrumentType Tipo de instrumento financiero
   * @returns Datos preparados para los gráficos
   */
  prepareGenericChartData(t, e, n, s) {
    const r = t.map((l) => {
      const c = new Date(l.date);
      return Ge.formatDate(c, e, n);
    });
    let a = [], o = [];
    if (s === "stock") {
      const l = t;
      a = l.map((c) => c.close), o = l.map((c) => c.volume);
    } else
      s === "fund" && (a = t.map((c) => c.nav), o = []);
    return { dates: r, prices: a, volumes: o };
  }
  /**
   * Prepara los datos para los gráficos (método original para retrocompatibilidad)
   * @param chartData Datos del gráfico
   * @param interval Intervalo seleccionado
   * @param locale Configuración regional
   * @returns Datos preparados para los gráficos
   */
  prepareChartData(t, e, n) {
    const s = t.map((o) => {
      const l = new Date(o.date);
      return Ge.formatDate(l, e, n);
    }), r = t.map((o) => o.close), a = t.map((o) => o.volume);
    return { dates: s, closePrices: r, volumes: a };
  }
  /**
   * Crea el gráfico de precios genérico (stocks y fondos)
   * @param canvas Canvas para el gráfico
   * @param dates Fechas formateadas
   * @param prices Precios (close para stocks, nav para fondos)
   * @param chartData Datos completos del gráfico
   * @param chartType Tipo de gráfico
   * @param interval Intervalo seleccionado
   * @param locale Configuración regional
   * @param syncTooltips Si se deben sincronizar los tooltips
   * @param instrumentType Tipo de instrumento financiero
   * @returns Gráfico de precios creado
   */
  createGenericPriceChart(t, e, n, s, r, a, o, l, c) {
    const d = c === "fund" ? "line" : r, h = this.createCommonChartConfig(), u = window.innerWidth <= 768, f = u ? 60 : 100, g = p(c === "fund" ? "NAV (Valor Liquidativo)" : "Precio de cierre");
    if (d === "line") {
      const m = {
        type: "line",
        data: {
          labels: e,
          datasets: [{
            label: g,
            data: n,
            borderColor: "#007bff",
            backgroundColor: "rgba(0, 123, 255, 0.1)",
            borderWidth: 2,
            fill: !0,
            tension: 0,
            pointRadius: 0,
            pointHoverRadius: 5,
            pointHitRadius: 15
          }]
        },
        options: ot(at({}, h), {
          interaction: {
            mode: "index",
            intersect: !1
          },
          hover: {
            mode: "index",
            intersect: !1
          },
          scales: ot(at({}, h.scales), {
            x: {
              type: "category",
              grid: {
                display: !0,
                drawOnChartArea: !0
              },
              ticks: {
                maxTicksLimit: u ? 6 : 10,
                maxRotation: 0,
                minRotation: 0
              }
            },
            y: {
              position: "right",
              beginAtZero: !1,
              afterFit: function(v) {
                v.width = f;
              },
              ticks: {
                padding: u ? 5 : 10,
                maxRotation: 0,
                minRotation: 0
              },
              grid: {
                display: !0
              }
            }
          }),
          plugins: ot(at({}, h.plugins), {
            tooltip: {
              mode: "index",
              intersect: !1,
              enabled: !0,
              displayColors: !1,
              callbacks: {
                title: (v) => this.createGenericTooltipTitle(v, s, a, o, c),
                label: (v) => this.createGenericTooltipLabel(v, s, a, c)
              }
            }
          }),
          onHover: (v, b) => this.handleGenericPriceChartHover(v, b, s, l, c)
        })
      };
      return new xt(t, m);
    } else {
      const m = s, v = {
        type: "line",
        data: {
          labels: e,
          datasets: [
            {
              label: g,
              data: n,
              borderColor: "rgba(0, 0, 0, 0.05)",
              borderWidth: 0,
              pointRadius: 0,
              tension: 0,
              fill: !1
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          animation: !1,
          interaction: {
            mode: "index",
            intersect: !1
          },
          hover: {
            mode: "index",
            intersect: !1
          },
          scales: {
            x: {
              type: "category",
              grid: {
                display: !0,
                drawOnChartArea: !0
              },
              ticks: {
                maxTicksLimit: u ? 6 : 10,
                maxRotation: 0,
                minRotation: 0
              }
            },
            y: {
              position: "right",
              beginAtZero: !1,
              afterFit: function(b) {
                b.width = f;
              },
              ticks: {
                padding: u ? 5 : 10,
                maxRotation: 0,
                minRotation: 0
              },
              grid: {
                display: !0
              }
            }
          },
          plugins: ot(at({}, h.plugins), {
            tooltip: {
              mode: "index",
              intersect: !1,
              enabled: !0,
              displayColors: !1,
              callbacks: {
                title: (b) => this.createGenericTooltipTitle(b, s, a, o, c),
                label: (b) => this.createGenericTooltipLabel(b, s, a, c)
              }
            },
            candlestick: this.createCandlestickPlugin(d, m)
          }),
          onHover: (b, x) => this.handleGenericPriceChartHover(b, x, s, l, c)
        }
      };
      return new xt(t, v);
    }
  }
  /**
   * Crea el gráfico de precios (método original para retrocompatibilidad)
   * @param canvas Canvas para el gráfico
   * @param dates Fechas formateadas
   * @param closePrices Precios de cierre
   * @param chartData Datos completos del gráfico
   * @param chartType Tipo de gráfico
   * @param interval Intervalo seleccionado
   * @param locale Configuración regional
   * @param syncTooltips Si se deben sincronizar los tooltips
   * @returns Gráfico de precios creado
   */
  createPriceChart(t, e, n, s, r, a, o, l) {
    const c = this.createCommonChartConfig(), d = window.innerWidth <= 768, h = d ? 60 : 100;
    if (r === "line") {
      const u = {
        type: "line",
        data: {
          labels: e,
          datasets: [{
            label: p("Precio de cierre"),
            data: n,
            borderColor: "#007bff",
            backgroundColor: "rgba(0, 123, 255, 0.1)",
            borderWidth: 2,
            fill: !0,
            tension: 0,
            pointRadius: 0,
            pointHoverRadius: 5,
            pointHitRadius: 15
          }]
        },
        options: ot(at({}, c), {
          interaction: {
            mode: "index",
            intersect: !1
          },
          hover: {
            mode: "index",
            intersect: !1
          },
          scales: ot(at({}, c.scales), {
            x: {
              // Usar la misma configuración que en el gráfico de precios para alineación perfecta
              type: "category",
              grid: {
                display: !0,
                drawOnChartArea: !0
              },
              ticks: {
                maxTicksLimit: d ? 6 : 10,
                maxRotation: 0,
                minRotation: 0
              }
            },
            y: {
              position: "right",
              beginAtZero: !1,
              afterFit: function(f) {
                f.width = h;
              },
              ticks: {
                padding: d ? 5 : 10,
                maxRotation: 0,
                minRotation: 0
              },
              grid: {
                display: !0
              }
            }
          }),
          plugins: ot(at({}, c.plugins), {
            tooltip: {
              mode: "index",
              intersect: !1,
              enabled: !0,
              displayColors: !1,
              callbacks: {
                title: (f) => this.createTooltipTitle(f, s, a, o),
                label: (f) => this.createTooltipLabel(f, s, a)
              }
            }
          }),
          onHover: (f, g) => this.handlePriceChartHover(f, g, s, l)
        })
      };
      return new xt(t, u);
    } else {
      const u = {
        type: "line",
        data: {
          labels: e,
          datasets: [
            {
              label: p("Precio de cierre"),
              data: n,
              borderColor: "rgba(0, 0, 0, 0.05)",
              // Casi invisible
              borderWidth: 0,
              // Sin borde
              pointRadius: 0,
              tension: 0,
              fill: !1
            }
          ]
        },
        options: {
          responsive: !0,
          maintainAspectRatio: !1,
          animation: !1,
          // Mejor rendimiento sin animaciones
          interaction: {
            mode: "index",
            intersect: !1
          },
          hover: {
            mode: "index",
            intersect: !1
          },
          scales: {
            x: {
              // Usar la misma configuración que en el gráfico de líneas para mantener la alineación
              type: "category",
              grid: {
                display: !0,
                drawOnChartArea: !0
              },
              ticks: {
                maxTicksLimit: d ? 6 : 10,
                maxRotation: 0,
                minRotation: 0
              }
            },
            y: {
              position: "right",
              beginAtZero: !1,
              afterFit: function(f) {
                f.width = h;
              },
              ticks: {
                padding: d ? 5 : 10,
                maxRotation: 0,
                minRotation: 0
              },
              grid: {
                display: !0,
                color: function() {
                  return "rgba(0, 0, 0, 0.1)";
                }
              }
            }
          },
          plugins: {
            legend: {
              display: !1
            },
            tooltip: {
              mode: "index",
              intersect: !1,
              displayColors: !1,
              enabled: !0,
              callbacks: {
                title: (f) => this.createTooltipTitle(f, s, a, o),
                label: (f) => this.createTooltipLabel(f, s, a)
              }
            }
          },
          onHover: (f, g) => this.handlePriceChartHover(f, g, s, l)
        },
        plugins: [this.createCandlestickPlugin(r, s)]
      };
      return new xt(t, u);
    }
  }
  /**
   * Crea el gráfico de volumen
   * @param canvas Canvas para el gráfico
   * @param dates Fechas formateadas
   * @param volumes Volúmenes de operación
   * @param chartData Datos completos del gráfico
   * @param interval Intervalo seleccionado
   * @param locale Configuración regional
   * @param syncTooltips Si se deben sincronizar los tooltips
   * @param priceChart Gráfico de precios (para sincronizar tooltips)
   * @returns Gráfico de volumen creado
   */
  createVolumeChart(t, e, n, s, r, a, o, l) {
    const c = this.createCommonChartConfig(), d = window.innerWidth <= 768, h = d ? 60 : 100, u = s.map((g, m, v) => m === 0 ? g.close >= g.open ? "rgba(0, 128, 0, 0.7)" : "rgba(255, 0, 0, 0.7)" : g.close >= v[m - 1].close ? "rgba(0, 128, 0, 0.7)" : "rgba(255, 0, 0, 0.7)"), f = {
      type: "bar",
      data: {
        labels: e,
        datasets: [{
          label: p("Volumen"),
          data: n,
          backgroundColor: u,
          borderWidth: 0
        }]
      },
      options: ot(at({}, c), {
        interaction: {
          mode: "index",
          intersect: !1
        },
        hover: {
          mode: "index",
          intersect: !1
        },
        scales: ot(at({}, c.scales), {
          x: {
            // Usar la misma configuración que en el gráfico de precios para alineación perfecta
            type: "category",
            grid: {
              display: !1,
              drawOnChartArea: !1
            },
            ticks: {
              maxTicksLimit: d ? 6 : 10,
              maxRotation: 0,
              minRotation: 0
            }
          },
          y: {
            position: "right",
            beginAtZero: !0,
            afterFit: function(g) {
              g.width = h;
            },
            ticks: {
              padding: d ? 5 : 10,
              maxRotation: 0,
              minRotation: 0,
              callback: function(g) {
                return Ge.formatNumber(g);
              }
            },
            grid: {
              display: !0
            }
          }
        }),
        plugins: ot(at({}, c.plugins), {
          tooltip: {
            mode: "index",
            intersect: !1,
            displayColors: !1,
            enabled: !0,
            callbacks: {
              title: (g) => this.createTooltipTitle(g, s, r, a),
              label: (g) => {
                const m = g.dataIndex;
                if (m === void 0 || m < 0 || m >= s.length || !s[m])
                  return p("Datos no disponibles");
                const v = s[m].volume;
                return v !== void 0 ? `${p("Volumen")}: ${Ge.formatNumber(v)}` : "";
              }
            }
          }
        }),
        onHover: (g, m) => {
          var v;
          if (!(!g || !m || m.length === 0 || !l || !o))
            try {
              const b = m[0].index;
              if (b === void 0 || b < 0 || b >= s.length)
                return;
              (v = l.tooltip) == null || v.setActiveElements([{
                datasetIndex: 0,
                index: b
              }], { x: 0, y: 0 }), l.update();
            } catch (b) {
              console.error("Error en onHover del gráfico de volumen:", b);
            }
        }
      })
    };
    return new xt(t, f);
  }
  /**
   * Maneja el evento hover en el gráfico de precios para sincronizar tooltips
   * @param event Evento hover
   * @param elements Elementos sobre los que ocurre el hover
   * @param chartData Datos del gráfico
   * @param syncTooltips Si se deben sincronizar los tooltips
   */
  handlePriceChartHover(t, e, n, s) {
    if (!(!t || !e || e.length === 0 || !s))
      try {
        const r = e[0].index;
        if (r === void 0 || r < 0 || r >= n.length)
          return;
        const a = new CustomEvent("price-chart-hover", {
          detail: { index: r }
        });
        t.chart.canvas.dispatchEvent(a);
      } catch (r) {
        console.error("Error en onHover del gráfico de precios:", r);
      }
  }
  /**
   * Crea la configuración común para todos los gráficos
   * @returns Configuración común
   */
  createCommonChartConfig() {
    const t = window.innerWidth <= 768;
    return {
      responsive: !0,
      maintainAspectRatio: !1,
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 5,
          bottom: 5
        }
      },
      scales: {
        x: {
          display: !0,
          grid: {
            display: !1
          },
          ticks: {
            maxTicksLimit: t ? 6 : 10,
            maxRotation: 0,
            minRotation: 0
          }
        }
      },
      plugins: {
        legend: {
          display: !1
        }
      }
    };
  }
  /**
   * Crea el título para el tooltip
   * @param tooltipItems Elementos del tooltip
   * @param chartData Datos del gráfico
   * @param interval Intervalo seleccionado
   * @param locale Configuración regional
   * @returns Título del tooltip
   */
  createTooltipTitle(t, e, n, s) {
    const r = t[0].dataIndex;
    if (r === void 0 || r < 0 || r >= e.length || !e[r])
      return "";
    const a = e[r], o = new Date(a.date);
    return Ge.formatTooltipDate(o, n, s);
  }
  /**
   * Crea el cuerpo del tooltip para el gráfico de precios
   * @param context Contexto del tooltip
   * @param chartData Datos del gráfico
   * @param interval Intervalo seleccionado
   * @returns Texto del tooltip
   */
  createTooltipLabel(t, e, n) {
    const s = t.dataIndex;
    if (s === void 0 || s < 0 || s >= e.length || !e[s])
      return [p("Datos no disponibles")];
    const r = e[s], a = [];
    return r.open !== void 0 && a.push(`${p("Apertura")}: ${r.open.toFixed(2)}`), r.high !== void 0 && a.push(`${p("Máximo")}: ${r.high.toFixed(2)}`), r.low !== void 0 && a.push(`${p("Mínimo")}: ${r.low.toFixed(2)}`), r.close !== void 0 && a.push(`${p("Cierre")}: ${r.close.toFixed(2)}`), ["1min", "5min", "15min", "30min", "1hour", "4hour"].includes(n) || r.change !== void 0 && r.changePercent !== void 0 && a.push(`${p("Cambio")}: ${r.change > 0 ? "+" : ""}${r.change.toFixed(2)} (${r.changePercent.toFixed(2)}%)`), a;
  }
  /**
   * Crea el plugin para dibujar velas o gráficos OHLC
   * @param chartType Tipo de gráfico ('candlestick' u 'ohlc')
   * @param chartData Datos completos del gráfico con valores OHLC
   * @returns Plugin para el gráfico
   */
  createCandlestickPlugin(t, e) {
    return {
      id: "candlestick",
      beforeDatasetsDraw: (n) => {
        if (t === "line")
          return;
        const { ctx: s, data: r, chartArea: a, scales: o } = n, { width: l } = a, { x: c, y: d } = o;
        if (!r.datasets || !c || !d)
          return;
        s.save();
        const h = t === "ohlc", f = (r.labels || []).length, g = window.innerWidth <= 768;
        for (let m = 0; m < f && m < e.length; m++) {
          const v = c.getPixelForValue(m), b = e[m];
          if (!b)
            continue;
          const x = d.getPixelForValue(b.open), w = d.getPixelForValue(b.close), k = d.getPixelForValue(b.high), _ = d.getPixelForValue(b.low), D = b.close > b.open, $ = Math.max(g ? 2 : 6, l / (f * (g ? 4.5 : 1.5))), T = D ? "rgba(0, 128, 0, 1)" : "rgba(255, 0, 0, 1)", E = D ? "rgba(0, 128, 0, 0.7)" : "rgba(255, 0, 0, 0.7)";
          h ? this.drawOHLCBar(s, v, x, k, _, w, $, T) : this.drawCandlestick(s, v, x, k, _, w, $, T, E);
        }
        s.restore();
      }
    };
  }
  /**
   * Crea el título genérico para el tooltip (stocks y fondos)
   * @param tooltipItems Elementos del tooltip
   * @param chartData Datos del gráfico
   * @param interval Intervalo seleccionado
   * @param locale Configuración regional
   * @param _instrumentType Tipo de instrumento financiero
   * @returns Título del tooltip
   */
  createGenericTooltipTitle(t, e, n, s, r) {
    const a = t[0].dataIndex;
    if (a === void 0 || a < 0 || a >= e.length || !e[a])
      return "";
    const o = e[a], l = new Date(o.date);
    return Ge.formatTooltipDate(l, n, s);
  }
  /**
   * Crea el cuerpo genérico del tooltip (stocks y fondos)
   * @param context Contexto del tooltip
   * @param chartData Datos del gráfico
   * @param interval Intervalo seleccionado
   * @param instrumentType Tipo de instrumento financiero
   * @returns Texto del tooltip
   */
  createGenericTooltipLabel(t, e, n, s) {
    const r = t.dataIndex;
    if (r === void 0 || r < 0 || r >= e.length || !e[r])
      return [p("Datos no disponibles")];
    const a = e[r], o = [];
    if (s === "stock") {
      const l = a;
      l.open !== void 0 && o.push(`${p("Apertura")}: ${l.open.toFixed(2)}`), l.high !== void 0 && o.push(`${p("Máximo")}: ${l.high.toFixed(2)}`), l.low !== void 0 && o.push(`${p("Mínimo")}: ${l.low.toFixed(2)}`), l.close !== void 0 && o.push(`${p("Cierre")}: ${l.close.toFixed(2)}`), ["1min", "5min", "15min", "30min", "1hour", "4hour"].includes(n) || l.change !== void 0 && l.changePercent !== void 0 && o.push(`${p("Cambio")}: ${l.change > 0 ? "+" : ""}${l.change.toFixed(2)} (${l.changePercent.toFixed(2)}%)`);
    } else if (s === "fund") {
      const l = a;
      l.nav !== void 0 && o.push(`${p("NAV")}: ${l.nav.toFixed(4)}`), l.aum !== void 0 && o.push(`${p("Patrimonio")}: ${l.aum.toLocaleString()}`), l.change !== void 0 && l.changePercent !== void 0 && o.push(`${p("Cambio")}: ${l.change > 0 ? "+" : ""}${l.change.toFixed(4)} (${l.changePercent.toFixed(2)}%)`);
    }
    return o;
  }
  /**
   * Maneja el hover genérico del gráfico de precios (stocks y fondos)
   * @param event Evento del hover
   * @param elements Elementos del gráfico
   * @param chartData Datos del gráfico
   * @param syncTooltips Si se deben sincronizar los tooltips
   * @param instrumentType Tipo de instrumento financiero
   */
  handleGenericPriceChartHover(t, e, n, s, r) {
    if (!(!s || r !== "stock"))
      try {
        let a = -1;
        if (e.length > 0)
          a = e[0].index;
        else if (t.x !== void 0) {
          const o = t.chart.getElementsAtEventForMode(t, "nearest", { intersect: !1 }, !0);
          o.length > 0 && (a = o[0].index);
        }
        if (a >= 0 && a < n.length) {
          const o = new CustomEvent("price-chart-hover", {
            detail: { index: a }
          });
          t.chart.canvas.dispatchEvent(o);
        }
      } catch (a) {
        console.error("Error en onHover del gráfico de precios:", a);
      }
  }
  /**
   * Dibuja una barra OHLC
   * @param ctx Contexto del canvas
   * @param xPos Posición X
   * @param openPos Posición Y del precio de apertura
   * @param highPos Posición Y del precio máximo
   * @param lowPos Posición Y del precio mínimo
   * @param closePos Posición Y del precio de cierre
   * @param candleWidth Ancho de la vela
   * @param strokeColor Color del trazo
   */
  drawOHLCBar(t, e, n, s, r, a, o, l) {
    t.beginPath(), t.strokeStyle = l, t.lineWidth = 1.5, t.moveTo(e, s), t.lineTo(e, r), t.stroke(), t.beginPath(), t.moveTo(e - o / 2, n), t.lineTo(e, n), t.stroke(), t.beginPath(), t.moveTo(e, a), t.lineTo(e + o / 2, a), t.stroke();
  }
  /**
   * Dibuja una vela (candlestick)
   * @param ctx Contexto del canvas
   * @param xPos Posición X
   * @param openPos Posición Y del precio de apertura
   * @param highPos Posición Y del precio máximo
   * @param lowPos Posición Y del precio mínimo
   * @param closePos Posición Y del precio de cierre
   * @param candleWidth Ancho de la vela
   * @param strokeColor Color del trazo
   * @param fillColor Color de relleno
   */
  drawCandlestick(t, e, n, s, r, a, o, l, c) {
    t.beginPath(), t.strokeStyle = l, t.lineWidth = 1.5, t.moveTo(e, s), t.lineTo(e, r), t.stroke();
    const d = Math.min(n, a), h = Math.max(Math.abs(a - n), 2);
    t.beginPath(), t.fillStyle = c, t.fillRect(
      e - o / 2,
      d,
      o,
      h
    ), t.strokeStyle = l, t.lineWidth = 1, t.strokeRect(
      e - o / 2,
      d,
      o,
      h
    );
  }
}
class mb {
  /**
   * Agrupa los datos por el periodo especificado (semana o mes)
   * @param data Los datos a agrupar
   * @param periodType El tipo de periodo ('week' o 'month')
   * @returns Los datos agrupados
   */
  aggregateDataByPeriod(t, e) {
    if (!t.length)
      return [];
    const n = [...t].sort((o, l) => new Date(o.date).getTime() - new Date(l.date).getTime()), s = [];
    let r = [], a = "";
    for (const o of n) {
      const l = this.getPeriodKey(o.date, e);
      a !== l ? (r.length > 0 && s.push(this.aggregatePeriodData(r, e)), a = l, r = [o]) : r.push(o);
    }
    return r.length > 0 && s.push(this.aggregatePeriodData(r, e)), s;
  }
  /**
   * Obtiene la clave del periodo para agrupar
   * @param dateStr Cadena de fecha
   * @param periodType Tipo de periodo ('week' o 'month')
   * @returns Clave del periodo
   */
  getPeriodKey(t, e) {
    const n = new Date(t);
    if (e === "week") {
      const s = Km(n);
      return `${n.getFullYear()}-W${s}`;
    } else
      return `${n.getFullYear()}-${n.getMonth() + 1}`;
  }
  /**
   * Agrega los datos de un periodo en un solo registro
   * @param periodData Los datos del periodo a agregar
   * @param periodType Tipo de periodo ('week' o 'month')
   * @returns Un registro agregado para el periodo
   */
  aggregatePeriodData(t, e) {
    const n = [...t].sort((g, m) => new Date(g.date).getTime() - new Date(m.date).getTime()), s = n[0], r = n[n.length - 1];
    let a = -1 / 0, o = 1 / 0, l = 0, c = 0;
    for (const g of n)
      a = Math.max(a, g.high), o = Math.min(o, g.low), l += g.volume, c += g.vwap || 0;
    const d = r.close - s.open, h = d / s.open * 100, u = new Date(s.date);
    let f;
    if (e === "month") {
      const g = u.getFullYear(), m = u.getMonth();
      f = new Date(g, m, 15).toISOString().split("T")[0];
    } else
      f = We(u, { weekStartsOn: 1 }).toISOString().split("T")[0];
    return {
      symbol: s.symbol,
      date: f,
      // Usar la fecha representativa
      open: s.open,
      // Apertura del primer día
      high: a,
      // Máximo del periodo
      low: o,
      // Mínimo del periodo
      close: r.close,
      // Cierre del último día
      volume: l,
      // Volumen total del periodo
      change: d,
      changePercent: h,
      vwap: c / n.length
      // Promedio del VWAP
    };
  }
}
var vb = Object.defineProperty, bb = Object.getOwnPropertyDescriptor, Ot = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? bb(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && vb(t, e, s), s;
};
xt.register(...Dr);
let Ct = class extends $t {
  // Control de carga inicial
  constructor() {
    super(), this.timeframe = "3m", this.interval = "1day", this.showVolume = !0, this.syncTooltips = !0, this.showHeader = !0, this.chartType = "candlestick", this.chartData = [], this.filteredChartData = [], this.stockInfo = null, this.isDelistedCompany = !1, this.isDelistedWithNoData = !1, this.priceChart = null, this.volumeChart = null, this.fullChartData = [], this.customIntervalMode = !1, this.displayInterval = "1day", this.isInitializing = !0, this.fetchInProgress = !1, this.initialFetchCompleted = !1, this.dataService = new pb(ct.API_BASE_URL), this.chartFactory = new gb(), this.dataAggregator = new mb();
  }
  connectedCallback() {
    super.connectedCallback(), this.isInitializing = !0, this.setIntervalByTimeframe(), this.customIntervalMode = !1, this.symbol && !this.initialFetchCompleted && this.fetchData().then(() => {
      this.isInitializing = !1, this.initialFetchCompleted = !0;
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroyCharts();
  }
  updated(i) {
    super.updated(i), (i.has("timeframe") || i.has("interval") || i.has("chartType")) && this.fullChartData.length > 0 && !i.has("chartData") && this.filterDataByTimeframe();
  }
  destroyCharts() {
    this.priceChart && (this.priceChart.destroy(), this.priceChart = null), this.volumeChart && (this.volumeChart.destroy(), this.volumeChart = null);
  }
  setIntervalByTimeframe() {
    const i = {
      "1d": "5min",
      "1w": "30min",
      "1m": "4hour",
      "3m": "1day",
      "6m": "1day",
      "1y": "1week",
      "5y": "1month"
    };
    this.displayInterval = i[this.timeframe] || "1day";
  }
  filterDataByTimeframe() {
    if (!this.fullChartData.length)
      return;
    const { filteredData: i, error: t } = this.dataService.filterDataByTimeframe(
      this.fullChartData,
      this.timeframe,
      this.customIntervalMode
    );
    if (t) {
      this.error = t;
      return;
    }
    this.interval === "1month" ? this.chartData = this.dataAggregator.aggregateDataByPeriod(i, "month") : this.interval === "1week" ? this.chartData = this.dataAggregator.aggregateDataByPeriod(i, "week") : this.chartData = i, this.error = null, this.createCharts();
  }
  createCharts() {
    var s, r;
    if (!this.chartData.length)
      return;
    const i = (s = this.shadowRoot) == null ? void 0 : s.querySelector("#price-chart"), t = (r = this.shadowRoot) == null ? void 0 : r.querySelector("#volume-chart");
    if (!i || this.showVolume && !t)
      return;
    this.destroyCharts(), this.chartData.sort((a, o) => new Date(a.date).getTime() - new Date(o.date).getTime());
    const { priceChart: e, volumeChart: n } = this.chartFactory.createCharts({
      priceCanvas: i,
      volumeCanvas: t,
      chartData: this.chartData,
      chartType: this.chartType,
      interval: this.interval,
      locale: this.locale,
      showVolume: this.showVolume,
      syncTooltips: this.syncTooltips
    });
    this.priceChart = e, this.volumeChart = n, this.priceChart && this.volumeChart && this.syncTooltips && i.addEventListener("price-chart-hover", (a) => {
      var l, c;
      const o = (l = a.detail) == null ? void 0 : l.index;
      o !== void 0 && this.volumeChart && ((c = this.volumeChart.tooltip) == null || c.setActiveElements([{
        datasetIndex: 0,
        index: o
      }], { x: 0, y: 0 }), this.volumeChart.update());
    });
  }
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol && !this.fetchInProgress) {
        this.fetchInProgress = !0, this.loading = !0, this.error = null, this.isDelistedWithNoData = !1;
        try {
          const i = yield this.dataService.fetchChartData({
            symbol: this.symbol,
            interval: this.interval,
            timeframe: this.timeframe,
            customIntervalMode: this.customIntervalMode,
            showHeader: this.showHeader
          });
          if (this.fullChartData = i.chartData, i.stockInfo && (this.stockInfo = i.stockInfo), i.isDelistedWithNoData) {
            this.isDelistedWithNoData = !0, this.isDelistedCompany = !0, this.loading = !1, this.fetchInProgress = !1;
            return;
          }
          i.isDelistedCompany ? (this.isDelistedCompany = !0, this.interval = "1day", this.timeframe = "3m", this.customIntervalMode = !1) : this.isDelistedCompany = !1, this.processData({
            symbol: this.symbol,
            chartData: this.fullChartData
          }), setTimeout(() => {
            this.filterDataByTimeframe();
          }, 0);
        } catch (i) {
          this.error = i instanceof Error ? i.message : String(i), console.error("Error al cargar datos de precio y volumen:", i);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  handleTimeframeChange(i) {
    this.timeframe === i || this.isInitializing || this.fetchInProgress || this.isDelistedCompany || (this.timeframe = i, this.customIntervalMode = !1, this.setIntervalByTimeframe(), this.interval = this.displayInterval, setTimeout(() => {
      this.fetchData();
    }, 0));
  }
  handleChartTypeChange(i) {
    this.chartType !== i && (this.chartType = i, this.chartData.length > 0 && this.createCharts());
  }
  handleIntervalChange(i) {
    if (this.interval === i || this.isInitializing || this.fetchInProgress || this.isDelistedCompany)
      return;
    const t = this.interval, e = this.customIntervalMode;
    this.interval = i, this.displayInterval = i, this.customIntervalMode = !0, (t !== i || !e) && setTimeout(() => {
      this.fetchData();
    }, 0);
  }
  processData(i) {
    this.ratioData = i;
  }
  /**
   * Implementación del método abstracto getNoDataMessage
   */
  getNoDataMessage() {
    return p("No hay datos del mercado disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  renderContent() {
    if (this.loading)
      return y`<div class="loading">${p("Cargando datos del gráfico...")}</div>`;
    if (this.error)
      return y`<div class="error">${this.error}</div>`;
    if (this.isDelistedWithNoData)
      return y`
        <div class="delisted-notice">
          ${p("Esta empresa está deslistada y no hay datos disponibles para mostrar.")}
        </div>
      `;
    if (this.fullChartData.length === 0)
      return y`
        <div class="delisted-notice">
          ${p("No hay datos disponibles para este símbolo.")}
        </div>
      `;
    const i = [
      { value: "1d", label: p("1D") },
      { value: "1w", label: p("1S") },
      { value: "1m", label: p("1M") },
      { value: "3m", label: p("3M") },
      { value: "6m", label: p("6M") },
      { value: "1y", label: p("1A") },
      { value: "5y", label: p("5A") }
    ], t = [
      { value: "1min", label: p("1Min") },
      { value: "5min", label: p("5Min") },
      { value: "15min", label: p("15Min") },
      { value: "30min", label: p("30Min") },
      { value: "1hour", label: p("1H") },
      { value: "4hour", label: p("4H") },
      { value: "1day", label: p("1D") },
      { value: "1week", label: p("1S") },
      { value: "1month", label: p("1M") }
    ], e = [
      { value: "line", label: p("Línea") },
      { value: "candlestick", label: p("Velas") },
      { value: "ohlc", label: p("OHLC") }
    ];
    return y`
      <div>
        ${this.showHeader && this.stockInfo ? y`
        <div class="info-header">
          ${this.stockInfo.image ? y`
            <img class="stock-image" src="${this.stockInfo.image}" alt="${p(O`${this.stockInfo.name} logo`)}" onerror="this.style.display='none'" />
          ` : ""}
          <div>
            <h3 class="stock-name">${this.stockInfo.name}</h3>
            <p class="stock-symbol">${this.stockInfo.symbol}</p>
          </div>
        </div>
        ` : ""}

        ${this.isDelistedCompany ? y`
          <div class="delisted-notice">
            ${p("Esta empresa ya no cotiza en bolsa. Se muestran los últimos 60 días de cotización disponibles.")}
          </div>
        ` : ""}

        <div class="chart-header">
          <div class="chart-type-selector">
            <div class="selector-title">${p("Tipo")}</div>
            ${e.map((n) => y`
              <button
                class="chart-option-button ${this.chartType === n.value ? "active" : ""}"
                @click=${() => this.handleChartTypeChange(n.value)}
              >
                ${n.label}
              </button>
            `)}
          </div>

          ${this.isDelistedCompany ? "" : y`
            <div class="interval-selector">
              <div class="selector-title">${p("Intervalo")}</div>
              ${t.map((n) => y`
                <button
                  class="interval-button ${this.displayInterval === n.value ? "active" : ""}"
                  @click=${() => this.handleIntervalChange(n.value)}
                >
                  ${n.label}
                </button>
              `)}
            </div>
          `}
        </div>

        <div class="charts-wrapper">
          <div class="chart-container">
            <canvas id="price-chart"></canvas>
          </div>

          ${this.showVolume ? y`
            <div class="volume-container">
              <canvas id="volume-chart"></canvas>
            </div>
          ` : ""}
        </div>

        ${this.isDelistedCompany ? "" : y`
          <div class="timeframe-selector">
            <div class="selector-title">${p("Período")}</div>
            ${i.map((n) => y`
              <button
                class="timeframe-button ${!this.customIntervalMode && this.timeframe === n.value ? "active" : ""} ${this.customIntervalMode ? "custom-mode" : ""}"
                @click=${() => this.handleTimeframeChange(n.value)}
              >
                ${n.label}
              </button>
            `)}
          </div>
        `}
      </div>
    `;
  }
};
Ct.styles = _t`
    ${Tt}

    .charts-wrapper {
      display: flex;
      flex-direction: column;
      height: 500px;
    }

    .chart-container {
      flex: 3; /* El gráfico de precios ocupa 3/4 del espacio disponible */
      position: relative;
      margin-bottom: 10px;
    }

    .volume-container {
      flex: 1; /* El gráfico de volumen ocupa 1/4 del espacio disponible */
      position: relative;
    }

    .chart-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      flex-wrap: wrap;
      gap: 15px;
    }

    .chart-title {
      margin: 0;
      font-size: 1.2rem;
      font-weight: 600;
    }

    .chart-type-selector, .interval-selector {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .timeframe-selector {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      margin-top: 15px;
    }

    .selector-title {
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--stock-muted-color, #64748b);
      margin-right: 8px;
    }

    .timeframe-button, .chart-option-button, .interval-button {
      padding: 5px 10px;
      border: 1px solid var(--stock-border-color, #e0e0e0);
      background-color: #f5f5f5;
      border-radius: 4px;
      font-size: 0.9rem;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .timeframe-button.active, .chart-option-button.active, .interval-button.active {
      background-color: var(--stock-accent-color, #3b82f6);
      color: white;
      border-color: var(--stock-accent-color, #3b82f6);
    }

    .timeframe-button:hover:not(.active), .chart-option-button:hover:not(.active), .interval-button:hover:not(.active) {
      background-color: #e0e0e0;
    }

    /* Añadir una barra o un indicativo de deshabilitar al timeframe cuando está en modo personalizado */
    .timeframe-button.disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .delisted-notice {
      background-color: var(--stock-notice-bg, #fff3cd);
      color: var(--stock-notice-color, #856404);
      padding: 10px 15px;
      border-radius: 4px;
      margin-bottom: 15px;
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    /* Estilos responsivos para móviles */
    @media (max-width: 768px) {
      .chart-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin-bottom: 15px;
      }

      .chart-type-selector, .interval-selector {
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        padding-bottom: 5px;
      }

      .timeframe-selector {
        margin-top: 5px;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        padding-bottom: 5px;
        justify-content: flex-start;
      }

      .timeframe-button, .chart-option-button, .interval-button {
        padding: 6px 10px;
        font-size: 0.8rem;
        flex-shrink: 0;
        text-align: center;
        white-space: nowrap;
      }

      .charts-wrapper {
        height: 500px;
        width: 100%;
        padding: 0;
        margin: 0;
      }

      .chart-container, .volume-container {
        width: 100%;
        margin: 0;
        padding: 0;
      }

      .selector-title {
        font-size: 0.8rem;
        margin-right: 5px;
      }
    }

    /* Estilos para los botones de período cuando están en modo personalizado */
    .timeframe-button.custom-mode {
      opacity: 0.7;
      border-style: dashed;
    }
  `;
Ot([
  dt({ type: String })
], Ct.prototype, "timeframe", 2);
Ot([
  dt({ type: String })
], Ct.prototype, "interval", 2);
Ot([
  dt({ type: Boolean })
], Ct.prototype, "showVolume", 2);
Ot([
  dt({ type: Boolean })
], Ct.prototype, "syncTooltips", 2);
Ot([
  dt({
    type: Boolean,
    attribute: "show-header",
    converter: {
      fromAttribute: (i) => i === "false" || i === !1 ? !1 : i === "true" || i === !0 ? !0 : i !== null
    }
  })
], Ct.prototype, "showHeader", 2);
Ot([
  dt({ type: String })
], Ct.prototype, "chartType", 2);
Ot([
  R()
], Ct.prototype, "chartData", 2);
Ot([
  R()
], Ct.prototype, "filteredChartData", 2);
Ot([
  R()
], Ct.prototype, "stockInfo", 2);
Ot([
  R()
], Ct.prototype, "isDelistedCompany", 2);
Ot([
  R()
], Ct.prototype, "isDelistedWithNoData", 2);
Ot([
  R()
], Ct.prototype, "customIntervalMode", 2);
Ot([
  R()
], Ct.prototype, "displayInterval", 2);
Ot([
  R()
], Ct.prototype, "isInitializing", 2);
Ct = Ot([
  Wt(),
  kt("stock-price-volume-chart")
], Ct);
class tc {
  /**
   * Constructor del servicio
   * @param baseUrl URL base para las peticiones
   */
  constructor(t) {
    this.baseUrl = t;
  }
  /**
   * Obtiene los datos de dividendos de una acción
   * @param options Opciones para la petición
   * @returns Resultado con los dividendos o un error
   */
  fetchDividends(t) {
    return q(this, null, function* () {
      const { symbol: e, limit: n, showHeader: s = !1 } = t;
      if (!e)
        return {
          dividends: [],
          error: p("Se requiere un símbolo de acción")
        };
      try {
        const r = [];
        let a = `${this.baseUrl}/asset-data/dividends?symbol=${encodeURIComponent(e)}`;
        n && (a += `&limit=${n}`);
        const o = fetch(a).then((h) => q(this, null, function* () {
          if (!h.ok)
            throw new Error(`${p("Error", {
              desc: "Error message prefix when API request fails"
            })}: ${h.statusText}`);
          return h.json();
        }));
        r.push(o);
        let l = null;
        s && (l = fetch(`${this.baseUrl}/asset-data/stock-details?symbol=${encodeURIComponent(e)}`).then((h) => q(this, null, function* () {
          return h.ok ? h.json() : (console.warn(`No se pudieron obtener los detalles de la acción ${e}`), null);
        })).catch((h) => (console.warn("Error al obtener los detalles de la acción:", h), null)), r.push(l));
        const c = yield Promise.all(r), d = c[0];
        return d.sort((h, u) => new Date(u.date).getTime() - new Date(h.date).getTime()), {
          dividends: d,
          stockInfo: s ? c[1] : null
        };
      } catch (r) {
        return {
          dividends: [],
          stockInfo: null,
          error: r instanceof Error ? r.message : String(r)
        };
      }
    });
  }
}
class yb {
  /**
   * Crea un gráfico de dividendos
   * @param options Opciones de configuración
   * @returns Instancia de Chart.js
   */
  createDividendChart(t) {
    const { chartCanvas: e, dividendData: n, locale: s } = t;
    if (!n || n.length === 0)
      return this.createEmptyChart(e);
    const r = [...n].sort(
      (d, h) => new Date(d.date).getTime() - new Date(h.date).getTime()
    ), a = r.map((d) => this.formatDate(d.date, s)), o = r.map((d) => d.dividend || 0), l = r.map((d) => d.yield || 0), c = {
      type: "bar",
      data: {
        labels: a,
        datasets: [
          {
            label: p("Dividendo"),
            data: o,
            backgroundColor: "rgba(75, 192, 192, 0.5)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
            order: 1
          },
          {
            label: p("Rendimiento (%)"),
            data: l,
            type: "line",
            yAxisID: "y1",
            borderColor: "rgba(255, 159, 64, 1)",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            borderWidth: 2,
            pointRadius: 3,
            order: 0
          }
        ]
      },
      options: {
        responsive: !0,
        maintainAspectRatio: !1,
        scales: {
          x: {
            grid: {
              display: !1
            },
            ticks: {
              maxRotation: 45,
              minRotation: 45
            }
          },
          y: {
            title: {
              display: !0,
              text: p("Dividendo")
            },
            ticks: {
              callback: (d) => new Intl.NumberFormat(s || "es", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(Number(d))
            }
          },
          y1: {
            position: "right",
            title: {
              display: !0,
              text: p("Rendimiento (%)")
            },
            ticks: {
              callback: (d) => `${new Intl.NumberFormat(s || "es", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(Number(d))}%`
            },
            grid: {
              drawOnChartArea: !1
            }
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (d) => {
                const h = d.dataset.label || "", u = d.raw;
                return h.includes("Rendimiento") ? `${h}: ${u.toFixed(2)}%` : `${h}: ${u.toFixed(4)}`;
              }
            }
          },
          legend: {
            position: "top"
          }
        }
      }
    };
    return new xt(e, c);
  }
  /**
   * Crea un gráfico vacío para mostrar cuando no hay datos
   * @param canvas Elemento canvas para el gráfico
   * @returns Instancia de Chart.js
   */
  createEmptyChart(t) {
    const e = {
      type: "bar",
      data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: !0,
        maintainAspectRatio: !1,
        plugins: {
          legend: {
            display: !1
          }
        }
      }
    };
    return new xt(t, e);
  }
  /**
   * Formatea una fecha para mostrarla en el gráfico
   * @param dateString Fecha en formato string
   * @param locale Configuración regional
   * @returns Fecha formateada
   */
  formatDate(t, e) {
    return new Date(t).toLocaleDateString(e || "es", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  }
}
var xb = Object.defineProperty, wb = Object.getOwnPropertyDescriptor, sn = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? wb(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && xb(t, e, s), s;
};
xt.register(...Dr);
let je = class extends $t {
  constructor() {
    super(), this.limit = 20, this.stockInfo = null, this.analysisData = null, this.chart = null, this.fetchInProgress = !1, this.lastFetchedSymbol = null, this.lastShowHeaderState = null, this.dividendService = new tc(ct.API_BASE_URL), this.chartFactory = new yb();
  }
  /**
   * Ciclo de vida: Al desconectar, destruir el gráfico
   */
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroyChart();
  }
  /**
   * Se llama cuando cambian las propiedades del componente
   */
  updated(i) {
    super.updated(i);
    const t = i.has("symbol"), e = i.has("showHeader");
    (t || e) && this.symbol && (t || e && this.lastShowHeaderState !== this.showHeader || this.lastFetchedSymbol !== this.symbol) && !this.fetchInProgress && this.fetchData();
  }
  /**
   * Procesa los datos recibidos de la API
   */
  processData(i, t) {
    this.ratioData = {
      symbol: this.symbol,
      dividends: i
    }, this.stockInfo = t || null, this.updateComplete.then(() => {
      this.createChart();
    });
  }
  /**
   * Obtiene los datos de la API
   */
  fetchData() {
    return q(this, null, function* () {
      if (!(!this.symbol || this.fetchInProgress)) {
        this.fetchInProgress = !0, this.loading = !0, this.error = null;
        try {
          const i = yield this.dividendService.fetchDividends({
            symbol: this.symbol,
            limit: this.limit,
            showHeader: this.showHeader
          });
          if (i.error)
            throw new Error(i.error);
          this.lastFetchedSymbol = this.symbol, this.lastShowHeaderState = this.showHeader, this.processData(i.dividends, i.stockInfo);
        } catch (i) {
          this.error = i instanceof Error ? i.message : String(i), console.error(`Error fetching dividend data: ${i}`);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  /**
   * Crea el gráfico
   */
  createChart() {
    var i;
    !this.chartCanvas || !((i = this.ratioData) != null && i.dividends.length) || (this.destroyChart(), this.chart = this.chartFactory.createDividendChart({
      chartCanvas: this.chartCanvas,
      dividendData: this.ratioData.dividends,
      locale: this.locale || "es"
    }));
  }
  /**
   * Destruye el gráfico existente
   */
  destroyChart() {
    this.chart && (this.chart.destroy(), this.chart = null);
  }
  /**
   * Renderiza el contenido del componente
   */
  renderContent() {
    var n, s, r;
    if (!((n = this.ratioData) != null && n.dividends.length))
      return y`
        <div class="no-data">
          ${p("No hay datos de dividendos disponibles para este símbolo")}
        </div>
      `;
    const { symbol: i } = this.ratioData, t = ((s = this.stockInfo) == null ? void 0 : s.name) || i, e = ((r = this.stockInfo) == null ? void 0 : r.image) || "";
    return y`
      ${this.showHeader ? y`
        <div class="info-header">
          ${e ? y`
            <img
              class="stock-image"
              src="${e}"
              alt="${p(O`${t} logo`)}"
              onerror="this.style.display='none'"
            />
          ` : ""}
          <div>
            <h3 class="stock-name">${t}</h3>
            <p class="stock-symbol">${i}</p>
          </div>
        </div>
      ` : ""}

      <div class="chart-container">
        <canvas id="dividend-chart"></canvas>
      </div>
    `;
  }
  /**
   * Implementación del método abstracto getNoDataMessage
   */
  getNoDataMessage() {
    return p("No hay datos de dividendos disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
};
je.styles = _t`
    ${Tt}

    .chart-container {
      position: relative;
      height: 400px;
      width: 100%;
    }

    .chart-title {
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 16px 0;
    }
  `;
sn([
  dt({ type: Number })
], je.prototype, "limit", 2);
sn([
  R()
], je.prototype, "stockInfo", 2);
sn([
  R()
], je.prototype, "analysisData", 2);
sn([
  _c("#dividend-chart")
], je.prototype, "chartCanvas", 2);
je = sn([
  Wt(),
  kt("stock-dividend-chart")
], je);
var _b = Object.defineProperty, kb = Object.getOwnPropertyDescriptor, De = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? kb(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && _b(t, e, s), s;
};
let Zt = class extends $t {
  constructor() {
    super(), this.pageSize = 10, this.limit = 100, this.currentPage = 0, this.paginatedDividends = [], this.stockInfo = null, this.lastFetchedSymbol = null, this.fetchInProgress = !1, this.dividendService = new tc(ct.API_BASE_URL);
  }
  /**
   * Se llama cuando cambian las propiedades del componente
   */
  updated(i) {
    super.updated(i), i.has("symbol") && this.symbol !== this.lastFetchedSymbol ? this.fetchData() : i.has("showHeader") && this.symbol && this.symbol === this.lastFetchedSymbol && this.fetchData();
  }
  /**
   * Procesa los datos recibidos de la API
   */
  processData(i, t) {
    this.ratioData = {
      symbol: this.symbol,
      dividends: i
    }, this.stockInfo = t || null, this.updatePagination();
  }
  /**
   * Obtiene los datos de la API
   */
  fetchData() {
    return q(this, null, function* () {
      if (this.symbol && !this.fetchInProgress) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const i = yield this.dividendService.fetchDividends({
            symbol: this.symbol,
            limit: this.limit,
            showHeader: this.showHeader
            // Pasar la propiedad showHeader para decidir si obtener información adicional
          });
          if (i.error)
            throw new Error(i.error);
          this.processData(i.dividends, i.stockInfo), this.lastFetchedSymbol = this.symbol;
        } catch (i) {
          this.error = i instanceof Error ? i.message : String(i), console.error(`Error fetching dividend data: ${i}`);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  /**
   * Actualiza la paginación
   */
  updatePagination() {
    var e;
    if (!((e = this.ratioData) != null && e.dividends)) {
      this.paginatedDividends = [];
      return;
    }
    const i = this.currentPage * this.pageSize, t = i + this.pageSize;
    this.paginatedDividends = this.ratioData.dividends.slice(i, t);
  }
  /**
   * Maneja el cambio de página
   */
  handlePageChange(i) {
    var n;
    if (!((n = this.ratioData) != null && n.dividends))
      return;
    const t = this.currentPage + i, e = Math.ceil(this.ratioData.dividends.length / this.pageSize) - 1;
    t >= 0 && t <= e && (this.currentPage = t, this.updatePagination());
  }
  /**
   * Maneja el cambio de tamaño de página
   */
  handlePageSizeChange(i) {
    const t = i.target;
    this.pageSize = Number(t.value), this.currentPage = 0, this.updatePagination();
  }
  /**
   * Renderiza el contenido del componente
   */
  renderContent() {
    var l, c, d;
    if (!((l = this.ratioData) != null && l.dividends.length))
      return y`
        <div class="no-data">
          ${this.getNoDataMessage()}
        </div>
      `;
    const { symbol: i, dividends: t } = this.ratioData, e = t.length, n = Math.ceil(e / this.pageSize), s = this.currentPage * this.pageSize + 1, r = Math.min(s + this.pageSize - 1, e), a = ((c = this.stockInfo) == null ? void 0 : c.name) || i, o = ((d = this.stockInfo) == null ? void 0 : d.image) || "";
    return y`
      ${this.showHeader ? y`
        <div class="info-header">
          ${o ? y`
            <img
              class="stock-image"
              src="${o}"
              alt="${p(O`${a} logo`)}"
              onerror="this.style.display='none'"
            />
          ` : ""}
          <div>
            <h3 class="stock-name">${a}</h3>
            <p class="stock-symbol">${i}</p>
          </div>
        </div>
      ` : ""}


      <div class="dividend-table-container">
        <table class="dividend-table">
          <thead>
            <tr>
              <th>${p("Fecha")}</th>
              <th>${p("Dividendo")}</th>
              <th>${p("Yield")}</th>
              <th>${p("Fecha de registro")}</th>
              <th>${p("Fecha de pago")}</th>
            </tr>
          </thead>
          <tbody>
            ${this.paginatedDividends.map((h) => y`
              <tr>
                <td>${this.formatDate(h.date)}</td>
                <td class="dividend-amount">${this.formatDecimal(h.dividend || h.adjDividend, 4)}</td>
                <td class="dividend-yield">${h.yield ? this.formatPercentage(h.yield / 100) : "-"}</td>
                <td>${h.recordDate ? this.formatDate(h.recordDate) : "-"}</td>
                <td>${h.paymentDate ? this.formatDate(h.paymentDate) : "-"}</td>
              </tr>
            `)}
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <div class="pagination-info">
          ${p(O`Mostrando ${s} a ${r} de ${e} registros`)}
        </div>

        <div class="rows-per-page">
          <label for="page-size">
            ${p("Filas por página:")}
          </label>
          <select
            id="page-size"
            class="rows-per-page-select"
            @change=${this.handlePageSizeChange}
            .value=${this.pageSize.toString()}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
          </select>
        </div>

        <div class="pagination-controls">
          <button
            class="pagination-button"
            @click=${() => this.handlePageChange(-1)}
            ?disabled=${this.currentPage === 0}
          >
            ${p("Anterior")}
          </button>
          <button
            class="pagination-button"
            @click=${() => this.handlePageChange(1)}
            ?disabled=${this.currentPage >= n - 1}
          >
            ${p("Siguiente")}
          </button>
        </div>
      </div>
    `;
  }
  /**
   * Implementación del método abstracto getNoDataMessage
   */
  getNoDataMessage() {
    return p("No hay datos de dividendos disponibles. Por favor, proporcione un símbolo de acción válido.");
  }
  /**
   * Formatea una fecha en formato legible
   */
  formatDate(i) {
    try {
      return new Date(i).toLocaleDateString(this.locale || "es", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });
    } catch (t) {
      return i;
    }
  }
};
Zt.styles = _t`
    ${Tt}

    .dividend-table-container {
      overflow-x: auto;
      margin-bottom: 20px;
    }

    .dividend-table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      font-size: 14px;
    }

    .dividend-table th {
      background-color: var(--stock-table-header-bg, #f1f5f9);
      color: var(--stock-table-header-color, #475569);
      font-weight: 600;
      text-align: left;
      padding: 12px 16px;
      border-bottom: 1px solid var(--stock-border-color, #e2e8f0);
      position: sticky;
      top: 0;
    }

    .dividend-table td {
      padding: 12px 16px;
      border-bottom: 1px solid var(--stock-border-color, #e2e8f0);
      color: var(--stock-text-color, #1e293b);
    }

    .dividend-table tr:hover td {
      background-color: var(--stock-table-hover-bg, #f8fafc);
    }

    .dividend-table tr:last-child td {
      border-bottom: none;
    }

    .pagination {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
    }

    .pagination-info {
      font-size: 14px;
      color: var(--stock-muted-color, #64748b);
    }

    .pagination-controls {
      display: flex;
      gap: 8px;
    }

    .pagination-button {
      padding: 8px 12px;
      border: 1px solid var(--stock-border-color, #e2e8f0);
      background-color: white;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      color: var(--stock-text-color, #1e293b);
      transition: all 0.2s ease;
    }

    .pagination-button:hover:not(:disabled) {
      background-color: var(--stock-accent-color, #3b82f6);
      color: white;
    }

    .pagination-button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .table-title {
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 16px 0;
    }

    .dividend-amount {
      font-weight: 600;
    }

    .dividend-yield {
      font-weight: 600;
    }

    .rows-per-page {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .rows-per-page-select {
      padding: 6px 8px;
      border: 1px solid var(--stock-border-color, #e2e8f0);
      border-radius: 4px;
      background-color: white;
      font-size: 14px;
      appearance: auto;
      -webkit-appearance: menulist;
      -moz-appearance: menulist;
    }

    /* Estilos responsivos para dispositivos móviles */
    @media (max-width: 768px) {
      .pagination {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
      }

      .rows-per-page {
        width: 100%;
        justify-content: space-between;
      }

      .rows-per-page-select {
        min-width: 80px;
      }

      .pagination-controls {
        width: 100%;
        justify-content: space-between;
      }

      .pagination-button {
        min-width: 100px;
      }
    }
  `;
De([
  dt({ type: Number })
], Zt.prototype, "pageSize", 2);
De([
  dt({ type: Number })
], Zt.prototype, "limit", 2);
De([
  R()
], Zt.prototype, "currentPage", 2);
De([
  R()
], Zt.prototype, "paginatedDividends", 2);
De([
  R()
], Zt.prototype, "stockInfo", 2);
De([
  R()
], Zt.prototype, "lastFetchedSymbol", 2);
De([
  R()
], Zt.prototype, "fetchInProgress", 2);
Zt = De([
  Wt(),
  kt("stock-dividend-table")
], Zt);
class Db {
  /**
   * Constructor del servicio
   * @param baseUrl URL base para las peticiones
   */
  constructor(t) {
    this.baseUrl = t;
  }
  /**
   * Transforma los datos de la API de fondos al formato esperado por el componente
   * @param apiResponse Respuesta de la API
   * @returns Datos transformados para el componente
   */
  transformFundData(t) {
    if (!t.historic || t.historic.length === 0)
      return [];
    const e = t.historic.filter(
      (s) => s.date && s.value !== null && s.value !== void 0
    );
    return e.length === 0 ? [] : (e.sort((s, r) => new Date(s.date).getTime() - new Date(r.date).getTime()), e.map((s, r) => {
      const a = s.value, o = r > 0 ? e[r - 1].value : a, l = a - o, c = o !== 0 ? l / o * 100 : 0;
      return {
        symbol: t.isin,
        date: s.date,
        nav: a,
        aum: s.aum,
        change: l,
        changePercent: c
      };
    }));
  }
  /**
   * Filtra los datos de fondos según el timeframe seleccionado
   * @param data Datos completos del fondo
   * @param timeframe Período seleccionado
   * @returns Datos filtrados y posible error
   */
  filterFundDataByTimeframe(t, e) {
    if (!t.length)
      return {
        filteredData: [],
        error: null
      };
    const n = /* @__PURE__ */ new Date();
    let s = /* @__PURE__ */ new Date(), r = [];
    const a = new Date(Math.min(
      n.getTime(),
      Math.max(...t.map((o) => new Date(o.date).getTime()))
    ));
    switch (e) {
      case "1d":
        s = new Date(a), s.setDate(a.getDate() - 1);
        break;
      case "1w":
        s = new Date(a.getTime() - 7 * 24 * 60 * 60 * 1e3);
        break;
      case "1m":
        s = new Date(a), s.setMonth(a.getMonth() - 1);
        break;
      case "3m":
        s = new Date(a), s.setMonth(a.getMonth() - 3);
        break;
      case "6m":
        s = new Date(a), s.setMonth(a.getMonth() - 6);
        break;
      case "1y":
        s = new Date(a), s.setFullYear(a.getFullYear() - 1);
        break;
      case "5y":
        s = new Date(a), s.setFullYear(a.getFullYear() - 5);
        break;
      default:
        s = new Date(a), s.setMonth(a.getMonth() - 3);
    }
    return r = t.filter((o) => {
      const l = new Date(o.date);
      return l >= s && l <= a;
    }), r.length === 0 ? {
      filteredData: [],
      error: p("No hay datos disponibles para el período seleccionado")
    } : {
      filteredData: r,
      error: null
    };
  }
  /**
   * Obtiene la información del producto para conocer la moneda y otros detalles
   * @param isin ISIN del producto
   * @returns Información del producto
   */
  fetchProductInfo(t) {
    return q(this, null, function* () {
      const e = `${this.baseUrl}/funds/product/${encodeURIComponent(t)}`, n = yield fetch(e);
      if (!n.ok)
        throw new Error(p(O`Error al obtener información del producto: ${n.statusText}`));
      return yield n.json();
    });
  }
  /**
   * Obtiene los datos históricos de un fondo desde la API
   * @param options Opciones para la petición
   * @returns Datos del fondo obtenidos
   */
  fetchFundData(t) {
    return q(this, null, function* () {
      var s, r;
      const { isin: e, showHeader: n } = t;
      try {
        const a = yield this.fetchProductInfo(e), o = `${this.baseUrl}/funds/product/${encodeURIComponent(e)}/historic/nav?currency=${encodeURIComponent(a.currency)}`, l = yield fetch(o);
        if (!l.ok)
          throw new Error(p(O`Error al obtener datos históricos del fondo: ${l.statusText}`, {
            desc: "Error message when fund historic API request fails"
          }));
        const c = yield l.json(), d = this.transformFundData(c);
        if (d.length === 0)
          return {
            fundData: [],
            fundInfo: null
          };
        let h = null;
        return n && (h = {
          isin: a.isin,
          name: a.name,
          description: ((s = a.fund) == null ? void 0 : s.investmentObjective) || "Fondo de inversión",
          category: (r = a.mainCategory) == null ? void 0 : r.name,
          currency: a.currency,
          launchDate: a.launchDate,
          aum: a.aum,
          company: a.company,
          fees: a.fees
        }), {
          fundData: d,
          fundInfo: h
        };
      } catch (a) {
        throw console.error("Error al obtener datos del fondo:", a), a;
      }
    });
  }
  /**
   * Obtiene información detallada de un fondo
   * @param isin ISIN del fondo
   * @returns Información del fondo o null si no está disponible
   */
  fetchFundInfo(t) {
    return q(this, null, function* () {
      var e, n;
      try {
        const s = yield this.fetchProductInfo(t);
        return {
          isin: s.isin,
          name: s.name,
          description: ((e = s.fund) == null ? void 0 : e.investmentObjective) || "Fondo de inversión",
          category: (n = s.mainCategory) == null ? void 0 : n.name,
          currency: s.currency,
          launchDate: s.launchDate,
          aum: s.aum,
          company: s.company,
          fees: s.fees
        };
      } catch (s) {
        return console.warn("No se pudo obtener información detallada del fondo:", s), null;
      }
    });
  }
}
var Cb = Object.defineProperty, $b = Object.getOwnPropertyDescriptor, Ce = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? $b(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Cb(t, e, s), s;
};
xt.register(...Dr);
let Jt = class extends $t {
  constructor() {
    super(), this.isin = "", this.timeframe = "3m", this.showHeader = !0, this.fundData = [], this.filteredFundData = [], this.fundInfo = null, this.priceChart = null, this.fullFundData = [], this.isInitializing = !0, this.fetchInProgress = !1, this.initialFetchCompleted = !1, this.fundDataService = new Db(ct.API_BASE_URL);
  }
  connectedCallback() {
    super.connectedCallback(), this.isInitializing = !0, this.isin && !this.initialFetchCompleted && this.fetchData().then(() => {
      this.isInitializing = !1, this.initialFetchCompleted = !0;
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroyChart();
  }
  updated(i) {
    super.updated(i), i.has("timeframe") && this.fullFundData.length > 0 && this.filterDataByTimeframe();
  }
  destroyChart() {
    this.priceChart && (this.priceChart.destroy(), this.priceChart = null);
  }
  filterDataByTimeframe() {
    if (!this.fullFundData.length)
      return;
    const { filteredData: i, error: t } = this.fundDataService.filterFundDataByTimeframe(
      this.fullFundData,
      this.timeframe
    );
    if (t) {
      this.error = t;
      return;
    }
    this.fundData = i, this.filteredFundData = i, this.error = null, this.createChart();
  }
  createChart() {
    var r;
    if (!this.fundData.length)
      return;
    const i = (r = this.shadowRoot) == null ? void 0 : r.querySelector("#fund-chart");
    if (!i)
      return;
    this.destroyChart(), this.fundData.sort((a, o) => new Date(a.date).getTime() - new Date(o.date).getTime());
    const t = this.fundData.map((a) => new Date(a.date).toLocaleDateString(this.locale, {
      month: "short",
      day: "numeric",
      year: this.timeframe.includes("y") ? "numeric" : void 0
    })), e = this.fundData.map((a) => a.nav), n = this.fundData, s = this.locale;
    this.priceChart = new xt(i, {
      type: "line",
      data: {
        labels: t,
        datasets: [{
          label: p("NAV (Valor Liquidativo)"),
          data: e,
          borderColor: "#007bff",
          backgroundColor: "rgba(0, 123, 255, 0.1)",
          borderWidth: 2,
          fill: !0,
          tension: 0,
          pointRadius: 0,
          pointHoverRadius: 5,
          pointHitRadius: 15
        }]
      },
      options: {
        responsive: !0,
        maintainAspectRatio: !1,
        animation: { duration: 0 },
        interaction: {
          mode: "index",
          intersect: !1
        },
        hover: {
          mode: "index",
          intersect: !1
        },
        scales: {
          x: {
            type: "category",
            grid: {
              display: !0,
              drawOnChartArea: !0
            },
            ticks: {
              maxTicksLimit: window.innerWidth <= 768 ? 6 : 10,
              maxRotation: 0,
              minRotation: 0
            }
          },
          y: {
            position: "right",
            beginAtZero: !1,
            grid: {
              display: !0
            },
            ticks: {
              padding: window.innerWidth <= 768 ? 5 : 10,
              callback: function(a) {
                return parseFloat(a).toFixed(4);
              }
            }
          }
        },
        plugins: {
          legend: {
            display: !1
          },
          tooltip: {
            mode: "index",
            intersect: !1,
            enabled: !0,
            displayColors: !1,
            callbacks: {
              title: (a) => {
                var l;
                const o = (l = a[0]) == null ? void 0 : l.dataIndex;
                if (o !== void 0 && o >= 0 && o < n.length) {
                  const c = n[o];
                  if (c && c.date)
                    return new Date(c.date).toLocaleDateString(s, {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric"
                    });
                }
                return "";
              },
              label: (a) => {
                const o = a.dataIndex;
                if (o !== void 0 && o >= 0 && o < n.length) {
                  const l = n[o];
                  return !l || l.nav === void 0 ? p("Datos no disponibles") : `${p("NAV")}: ${l.nav.toFixed(4)}`;
                }
                return p("Datos no disponibles");
              },
              afterLabel: (a) => {
                const o = a.dataIndex;
                if (o !== void 0 && o >= 0 && o < n.length) {
                  const l = n[o];
                  if (!l)
                    return [];
                  const c = [];
                  return l.aum !== void 0 && c.push(`${p("Patrimonio")}: ${l.aum.toLocaleString()}`), l.change !== void 0 && l.changePercent !== void 0 && c.push(`${p("Cambio")}: ${l.change > 0 ? "+" : ""}${l.change.toFixed(4)} (${l.changePercent.toFixed(2)}%)`), c;
                }
                return [];
              }
            }
          }
        }
      }
    });
  }
  fetchData() {
    return q(this, null, function* () {
      if (!(!this.isin || this.fetchInProgress)) {
        this.fetchInProgress = !0, this.loading = !0, this.error = null;
        try {
          const i = yield this.fundDataService.fetchFundData({
            isin: this.isin,
            timeframe: this.timeframe,
            showHeader: this.showHeader
          });
          this.fullFundData = i.fundData, i.fundInfo && (this.fundInfo = i.fundInfo), this.processData({
            isin: this.isin,
            fundData: this.fullFundData,
            symbol: this.isin
            // Usar ISIN como symbol para compatibilidad
          }), setTimeout(() => {
            this.filterDataByTimeframe();
          }, 0);
        } catch (i) {
          this.error = i instanceof Error ? i.message : String(i), console.error("Error al cargar datos del fondo:", i);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  handleTimeframeChange(i) {
    this.timeframe === i || this.isInitializing || this.fetchInProgress || (this.timeframe = i, setTimeout(() => {
      this.fetchData();
    }, 0));
  }
  processData(i) {
    this.ratioData = i;
  }
  /**
   * Implementación del método abstracto getNoDataMessage
   */
  getNoDataMessage() {
    return p("No hay datos de fondo disponibles. Por favor, proporcione un ISIN válido.");
  }
  renderContent() {
    if (this.loading)
      return y`<div class="loading">${p("Cargando datos del fondo...")}</div>`;
    if (this.error)
      return y`<div class="error">${this.error}</div>`;
    if (this.fullFundData.length === 0)
      return y`
        <div class="fund-notice">
          ${this.getNoDataMessage()}
        </div>
      `;
    const i = [
      { value: "1w", label: p("1S") },
      { value: "1m", label: p("1M") },
      { value: "3m", label: p("3M") },
      { value: "6m", label: p("6M") },
      { value: "1y", label: p("1A") },
      { value: "5y", label: p("5A") }
    ];
    return y`
      <div>
        ${this.showHeader && this.fundInfo ? y`
        <div class="info-header">
          <div>
            <h3 class="stock-name">${this.fundInfo.name}</h3>
            <p class="stock-symbol">${this.fundInfo.isin}</p>
            ${this.fundInfo.category ? y`
              <p class="stock-description">${this.fundInfo.category}</p>
            ` : ""}
          </div>
        </div>
        ` : ""}


        <div class="chart-wrapper">
          <div class="chart-container">
            <canvas id="fund-chart"></canvas>
          </div>
        </div>

        <div class="timeframe-selector">
          <div class="selector-title">${p("Período")}</div>
          ${i.map((t) => y`
            <button
              class="timeframe-button ${this.timeframe === t.value ? "active" : ""}"
              @click=${() => this.handleTimeframeChange(t.value)}
            >
              ${t.label}
            </button>
          `)}
        </div>
      </div>
    `;
  }
};
Jt.styles = _t`
    ${Tt}

    .chart-wrapper {
      display: flex;
      flex-direction: column;
      height: 400px;
    }

    .chart-container {
      flex: 1;
      position: relative;
    }

    .chart-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      flex-wrap: wrap;
      gap: 15px;
    }

    .timeframe-selector {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      margin-top: 15px;
    }

    .selector-title {
      font-size: 0.9rem;
      font-weight: 600;
      color: var(--stock-muted-color, #64748b);
      margin-right: 8px;
    }

    .timeframe-button {
      padding: 5px 10px;
      border: 1px solid var(--stock-border-color, #e0e0e0);
      background-color: #f5f5f5;
      border-radius: 4px;
      font-size: 0.9rem;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .timeframe-button.active {
      background-color: var(--stock-accent-color, #3b82f6);
      color: white;
      border-color: var(--stock-accent-color, #3b82f6);
    }

    .timeframe-button:hover:not(.active) {
      background-color: #e0e0e0;
    }

    .fund-notice {
      background-color: var(--stock-detail-background, #f8fafc);
      color: var(--stock-accent-color, #3b82f6);
      padding: 10px 15px;
      border-radius: 4px;
      margin-bottom: 15px;
      font-size: var(--stock-text-size, 0.9rem);
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }

    /* Estilos responsivos para móviles */
    @media (max-width: 768px) {
      .chart-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        margin-bottom: 15px;
      }

      .timeframe-selector {
        margin-top: 5px;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        padding-bottom: 5px;
        justify-content: flex-start;
      }

      .timeframe-button {
        padding: 6px 10px;
        font-size: 0.8rem;
        flex-shrink: 0;
        text-align: center;
        white-space: nowrap;
      }

      .chart-wrapper {
        height: 350px;
        width: 100%;
        padding: 0;
        margin: 0;
      }

      .chart-container {
        width: 100%;
        margin: 0;
        padding: 0;
      }

      .selector-title {
        font-size: 0.8rem;
        margin-right: 5px;
      }
    }
  `;
Ce([
  dt({ type: String })
], Jt.prototype, "isin", 2);
Ce([
  dt({ type: String })
], Jt.prototype, "timeframe", 2);
Ce([
  dt({
    type: Boolean,
    attribute: "show-header",
    converter: {
      fromAttribute: (i) => i === "false" || i === !1 ? !1 : i === "true" || i === !0 ? !0 : i !== null
    }
  })
], Jt.prototype, "showHeader", 2);
Ce([
  R()
], Jt.prototype, "fundData", 2);
Ce([
  R()
], Jt.prototype, "filteredFundData", 2);
Ce([
  R()
], Jt.prototype, "fundInfo", 2);
Ce([
  R()
], Jt.prototype, "isInitializing", 2);
Jt = Ce([
  Wt(),
  kt("fund-price-chart")
], Jt);
var Pb = Object.defineProperty, Mb = Object.getOwnPropertyDescriptor, Sr = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Mb(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Pb(t, e, s), s;
};
class ai extends ce {
  constructor() {
    super(...arguments), this.isin = "", this.locale = "", this.showHeader = !0;
  }
  /**
   * Datos del fondo (alias para mantener compatibilidad)
   */
  get fundData() {
    return this.data;
  }
  set fundData(t) {
    this.data = t;
  }
  /**
   * Verifica si se debe obtener los datos
   */
  shouldFetchData() {
    return !!this.isin;
  }
  /**
   * Verifica si una propiedad clave ha cambiado
   */
  hasKeyPropertyChanged(t) {
    return t.has("isin") && !!this.isin;
  }
  /**
   * Obtiene el mensaje de "no hay datos"
   */
  getNoDataMessage() {
    return p("No hay datos disponibles. Por favor, proporcione un código ISIN válido.");
  }
  /**
   * Renderiza el encabezado con información básica del fondo
   * Este método es compartido por todos los componentes
   */
  renderHeader() {
    if (!this.showHeader)
      return y``;
    if (!this.fundData)
      return this.isin ? y`
        <div class="info-header">
          <div>
            <h3 class="stock-name">${this.isin}</h3>
            <p class="stock-symbol">${p(O`ISIN: ${this.isin}`)}</p>
          </div>
        </div>
      ` : y``;
    const { isin: t } = this.fundData;
    let e;
    return "name" in this.fundData && (e = this.fundData.name), y`
      <div class="info-header">
        <div>
          <h3 class="stock-name">${e || t}</h3>
          <p class="stock-symbol">${p(O`ISIN: ${t}`)}</p>
        </div>
      </div>
    `;
  }
  /**
   * Renderiza el componente
   */
  render() {
    return this.loading ? this.renderLoading() : this.error ? this.renderError() : this.fundData ? this.renderContent() : this.renderNoData();
  }
}
Sr([
  dt({ type: String })
], ai.prototype, "isin", 2);
Sr([
  dt({ type: String })
], ai.prototype, "locale", 2);
Sr([
  dt({
    type: Boolean,
    attribute: "show-header",
    converter: {
      fromAttribute: (i) => i === "false" || i === !1 ? !1 : i === "true" || i === !0 ? !0 : i !== null
    },
    reflect: !0
  })
], ai.prototype, "showHeader", 2);
var Sb = Object.defineProperty, Tb = Object.getOwnPropertyDescriptor, Tr = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Tb(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Sb(t, e, s), s;
};
let Yi = class extends ai {
  constructor() {
    super(...arguments), this.lastFetchedIsin = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      if (this.isin && !(this.fetchInProgress || this.lastFetchedIsin === this.isin && this.fundData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const i = ct.API_BASE_URL, t = yield fetch(`${i}/funds/product/${encodeURIComponent(this.isin)}`);
          if (!t.ok)
            throw new Error(p(O`Error al obtener datos del fondo: ${t.statusText}`, {
              desc: "Error message when API request fails"
            }));
          const e = yield t.json();
          this.processData(e), this.lastFetchedIsin = this.isin;
        } catch (i) {
          this.error = i instanceof Error ? i.message : p("Error desconocido"), console.error(p("Error al obtener datos del fondo:"), i);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  updated(i) {
    super.updated(i), i.has("isin") && this.isin !== this.lastFetchedIsin && this.fetchData();
  }
  processData(i) {
    this.fundData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando información del fondo...")}</div>`;
  }
  renderContent() {
    var e, n, s, r, a, o, l, c, d, h;
    if (!this.fundData)
      return null;
    const i = this.fundData, t = (n = (e = i.fund) == null ? void 0 : e.investmentObjective) == null ? void 0 : n.find(
      (u) => u.language === (this.locale || "es") || u.language === "es"
    );
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        ${(s = i.nav) != null && s.value ? y`
          <div class="nav-highlight">
            <div class="nav-title">${p("Valor Liquidativo (NAV)")}</div>
            <div class="nav-value">${this.formatCurrency(i.nav.value, 4, i.currency)}</div>
            ${i.nav.date ? y`<div class="nav-date">${p("Actualizado el")} ${this.formatDate(i.nav.date)}</div>` : ""}
          </div>
        ` : ""}

        <div class="section-title">${p("Información General")}</div>

        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label">${p("Nombre")}</div>
            <div class="detail-value">${i.name}</div>
          </div>

          <div class="detail-item">
            <div class="detail-label">${p("Moneda")}</div>
            <div class="detail-value">${i.currency}</div>
          </div>

          ${i.launchDate ? y`
            <div class="detail-item">
              <div class="detail-label">${p("Fecha de Lanzamiento")}</div>
              <div class="detail-value">${this.formatDate(i.launchDate)}</div>
            </div>
          ` : ""}

          ${(r = i.mainCategory) != null && r.name ? y`
            <div class="detail-item">
              <div class="detail-label">${p("Categoría Principal")}</div>
              <div class="detail-value">${i.mainCategory.name}</div>
            </div>
          ` : ""}

          ${(a = i.company) != null && a.name ? y`
            <div class="detail-item">
              <div class="detail-label">${p("Gestora")}</div>
              <div class="detail-value">${i.company.name}</div>
            </div>
          ` : ""}

          ${(l = (o = i.fund) == null ? void 0 : o.assetClass) != null && l.name ? y`
            <div class="detail-item">
              <div class="detail-label">${p("Clase de Activo")}</div>
              <div class="detail-value">${i.fund.assetClass.name}</div>
            </div>
          ` : ""}
        </div>

        <div class="section-title">${p("Características")}</div>

        <div style="margin: 10px 0;">
          ${i.isETF ? y`<span class="tag etf">${p("ETF")}</span>` : ""}
          ${(c = i.fund) != null && c.isPassive ? y`<span class="tag passive">${p("Gestión Pasiva")}</span>` : ""}
          ${i.isCurrencyHedge ? y`<span class="tag hedged">${p("Cobertura de Divisa")}</span>` : ""}
        </div>

        <div class="detail-grid">
          ${(d = i.aum) != null && d.value ? y`
            <div class="detail-item">
              <div class="detail-label">${p("Patrimonio (AUM)")}</div>
              <div class="detail-value">${this.formatCurrency(i.aum.value, 0, i.currency)}</div>
            </div>
          ` : ""}

          ${i.distributionPolicy ? y`
            <div class="detail-item">
              <div class="detail-label">${p("Política de Distribución")}</div>
              <div class="detail-value">${i.distributionPolicy}</div>
            </div>
          ` : ""}

          ${(h = i.srri) != null && h.value ? y`
            <div class="detail-item">
              <div class="detail-label">${p("SRRI (Riesgo)")}</div>
              <div class="detail-value">${i.srri.value}/7</div>
            </div>
          ` : ""}
        </div>

        ${i.fees ? y`
          <div class="section-title">${p("Comisiones")}</div>

          <div class="detail-grid">
            ${i.fees.managementFee ? y`
              <div class="detail-item">
                <div class="detail-label">${p("Comisión de Gestión")}</div>
                <div class="detail-value">${this.formatPercentage(i.fees.managementFee)}</div>
              </div>
            ` : ""}

            ${i.fees.ongoingCharges ? y`
              <div class="detail-item">
                <div class="detail-label">${p("Gastos Corrientes (TER)")}</div>
                <div class="detail-value">${this.formatPercentage(i.fees.ongoingCharges)}</div>
              </div>
            ` : ""}

            ${i.fees.performanceFee ? y`
              <div class="detail-item">
                <div class="detail-label">${p("Comisión de Éxito")}</div>
                <div class="detail-value">${this.formatPercentage(i.fees.performanceFee)}</div>
              </div>
            ` : ""}

            ${i.fees.minimalInitialSubscriptionAmount ? y`
              <div class="detail-item">
                <div class="detail-label">${p("Inversión Mínima Inicial")}</div>
                <div class="detail-value">${this.formatCurrency(i.fees.minimalInitialSubscriptionAmount, 0, i.currency)}</div>
              </div>
            ` : ""}
          </div>
        ` : ""}

        ${t != null && t.text ? y`
          <div class="section-title">${p("Objetivo de Inversión")}</div>
          <div class="investment-objective">
            ${t.text}
          </div>
        ` : ""}
      </div>
    `;
  }
};
Yi.styles = _t`
    ${Bt(Tt)}

    .info-container {
      width: 100%;
      display: block;
    }

    .nav-highlight {
      background-color: var(--stock-detail-background, #f8fafc);
      border: 1px solid var(--stock-border-color, #e0e0e0);
      padding: 16px;
      border-radius: 8px;
      margin: 16px 0 24px 0;
      text-align: center;
    }

    .nav-title {
      font-size: var(--stock-text-size, 14px);
      color: var(--stock-muted-color, #64748b);
      margin-bottom: 8px;
      font-weight: 500;
    }

    .nav-value {
      font-size: 1.8rem;
      font-weight: 700;
      color: var(--stock-title-color, #1e293b);
      margin-bottom: 4px;
      line-height: 1.1;
    }

    .nav-date {
      font-size: var(--stock-small-text-size, 12px);
      color: var(--stock-muted-color, #64748b);
    }

    .detail-item {
      width: 100%;
      display: block;
      box-sizing: border-box;
      margin-bottom: 16px;
    }

    .detail-value {
      font-weight: normal;
    }

    .detail-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 1rem;
      margin-top: 20px;
    }

    .section-title {
      font-size: var(--stock-section-title-font-size, 1.1rem);
      font-weight: var(--stock-title-weight, 700);
      color: var(--stock-title-color, #1e293b);
      margin: 20px 0 10px 0;
      border-bottom: 1px solid var(--stock-border-color, #e0e0e0);
      padding-bottom: 5px;
    }

    .investment-objective {
      background-color: var(--stock-detail-background, #f8fafc);
      padding: 12px;
      border-radius: 4px;
      border-left: 3px solid var(--stock-accent-color, #3b82f6);
      margin: 10px 0;
      font-size: var(--stock-text-size, 14px);
      line-height: 1.4;
    }

    .tag {
      display: inline-block;
      background-color: var(--stock-symbol-bg, rgba(226, 232, 240, 0.5));
      color: var(--stock-accent-color, #3b82f6);
      padding: 4px 8px;
      border-radius: 12px;
      font-size: var(--stock-small-text-size, 12px);
      margin: 2px 4px 2px 0;
    }

    .tag.etf {
      background-color: rgba(56, 142, 60, 0.1);
      color: var(--stock-positive-color, #388e3c);
    }

    .tag.passive {
      background-color: rgba(245, 124, 0, 0.1);
      color: var(--stock-warning-color, #f57c00);
    }

    .tag.hedged {
      background-color: rgba(194, 24, 91, 0.1);
      color: var(--stock-negative-color, #d32f2f);
    }

    @media (max-width: 600px) {
      .detail-grid {
        grid-template-columns: 1fr;
      }

      .nav-value {
        font-size: 1.5rem;
      }
    }
  `;
Tr([
  R()
], Yi.prototype, "lastFetchedIsin", 2);
Tr([
  R()
], Yi.prototype, "fetchInProgress", 2);
Yi = Tr([
  Wt(),
  kt("fund-description")
], Yi);
var Ob = Object.defineProperty, Ab = Object.getOwnPropertyDescriptor, Or = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Ab(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Ob(t, e, s), s;
};
let qi = class extends ai {
  constructor() {
    super(...arguments), this.lastFetchedIsin = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      var i;
      if (this.isin && !(this.fetchInProgress || this.lastFetchedIsin === this.isin && this.fundData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const t = ct.API_BASE_URL, e = `${t}/funds/product/${encodeURIComponent(this.isin)}/statistic`, n = this.showHeader ? [
            fetch(e),
            fetch(`${t}/funds/product/${encodeURIComponent(this.isin)}`)
          ] : [fetch(e)], s = yield Promise.all(n);
          if (!s[0].ok)
            throw new Error(p(O`Error al obtener estadísticas del fondo: ${s[0].statusText}`, {
              desc: "Error message when statistics API request fails"
            }));
          const r = yield s[0].json();
          if (this.showHeader && ((i = s[1]) != null && i.ok)) {
            const a = yield s[1].json();
            this.processData(ot(at({}, r), {
              name: a == null ? void 0 : a.name
            }));
          } else
            this.processData(r);
          this.lastFetchedIsin = this.isin;
        } catch (t) {
          this.error = t instanceof Error ? t.message : p("Error desconocido"), console.error(p("Error al obtener estadísticas del fondo:"), t);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  updated(i) {
    super.updated(i), i.has("isin") && this.isin !== this.lastFetchedIsin && this.fetchData();
  }
  processData(i) {
    this.fundData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando estadísticas del fondo...")}</div>`;
  }
  getQuartileIndicator(i) {
    return i ? i <= 1 ? "quartile-1" : i <= 2 ? "quartile-2" : i <= 3 ? "quartile-3" : "quartile-4" : "";
  }
  getRiskLevel(i) {
    return i ? i < 0.1 ? "risk-low" : i < 0.2 ? "risk-medium" : "risk-high" : "";
  }
  getRiskLabel(i) {
    return i ? i < 0.1 ? p("Bajo") : i < 0.2 ? p("Medio") : p("Alto") : "";
  }
  renderContent() {
    var t, e, n;
    if (!this.fundData)
      return null;
    const i = this.fundData.stats;
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        <div class="section-title">${p("Rentabilidades por Periodo")}</div>

        <div class="returns-period-grid">
          ${i.return1m !== void 0 ? y`
            <div class="period-return">
              <div class="period-label">${p("1 Mes")}</div>
              <div class="period-value ${this.getValueClass(i.return1m)}">${this.formatPercentage(i.return1m)}</div>
            </div>
          ` : ""}

          ${i.return3m !== void 0 ? y`
            <div class="period-return">
              <div class="period-label">${p("3 Meses")}</div>
              <div class="period-value ${this.getValueClass(i.return3m)}">${this.formatPercentage(i.return3m)}</div>
            </div>
          ` : ""}

          ${i.return6m !== void 0 ? y`
            <div class="period-return">
              <div class="period-label">${p("6 Meses")}</div>
              <div class="period-value ${this.getValueClass(i.return6m)}">${this.formatPercentage(i.return6m)}</div>
            </div>
          ` : ""}

          ${i.return1y !== void 0 ? y`
            <div class="period-return">
              <div class="period-label">${p("1 Año")}</div>
              <div class="period-value ${this.getValueClass(i.return1y)}">${this.formatPercentage(i.return1y)}</div>
            </div>
          ` : ""}

          ${i.return3y !== void 0 ? y`
            <div class="period-return">
              <div class="period-label">${p("3 Años")}</div>
              <div class="period-value ${this.getValueClass(i.return3y)}">${this.formatPercentage(i.return3y)}</div>
            </div>
          ` : ""}

          ${i.return5y !== void 0 ? y`
            <div class="period-return">
              <div class="period-label">${p("5 Años")}</div>
              <div class="period-value ${this.getValueClass(i.return5y)}">${this.formatPercentage(i.return5y)}</div>
            </div>
          ` : ""}

          ${i.return10y !== void 0 ? y`
            <div class="period-return">
              <div class="period-label">${p("10 Años")}</div>
              <div class="period-value ${this.getValueClass(i.return10y)}">${this.formatPercentage(i.return10y)}</div>
            </div>
          ` : ""}

          ${((t = i.returnYtd) == null ? void 0 : t.value) !== void 0 ? y`
            <div class="period-return">
              <div class="period-label">
                ${i.returnYtd.date && new Date(i.returnYtd.date).getFullYear() === (/* @__PURE__ */ new Date()).getFullYear() ? p(`YTD (${this.formatDate(i.returnYtd.date)})`) : p("YTD")}
              </div>
              <div class="period-value ${this.getValueClass(i.returnYtd.value)}">
                ${i.returnYtd.date && new Date(i.returnYtd.date).getFullYear() === (/* @__PURE__ */ new Date()).getFullYear() ? this.formatPercentage(i.returnYtd.value) : "-"}
              </div>
            </div>
          ` : ""}
        </div>

        <div class="section-title">${p("Análisis de Riesgo")}</div>

        <div class="stats-grid">
          ${i.deviation1y !== void 0 ? y`
            <div class="stat-item">
              <div class="stat-label">${p("Desviación Estándar (1 año)")}</div>
              <div class="stat-value">
                ${this.formatPercentage(i.deviation1y)}
                <span class="risk-indicator ${this.getRiskLevel(i.deviation1y)}">
                  ${this.getRiskLabel(i.deviation1y)}
                </span>
              </div>
            </div>
          ` : ""}

          ${i.deviation3y !== void 0 ? y`
            <div class="stat-item">
              <div class="stat-label">${p("Desviación Estándar (3 años)")}</div>
              <div class="stat-value">
                ${this.formatPercentage(i.deviation3y)}
                <span class="risk-indicator ${this.getRiskLevel(i.deviation3y)}">
                  ${this.getRiskLabel(i.deviation3y)}
                </span>
              </div>
            </div>
          ` : ""}

          ${((e = i.maxDrawdownRatio5y) == null ? void 0 : e.value) !== void 0 ? y`
            <div class="stat-item">
              <div class="stat-label">${p("Máxima Caída (5 años)")}</div>
              <div class="stat-value negative">${this.formatPercentage(i.maxDrawdownRatio5y.value)}</div>
            </div>
          ` : ""}

          ${((n = i.maxDrawdownDuration5yInMonths) == null ? void 0 : n.value) !== void 0 ? y`
            <div class="stat-item">
              <div class="stat-label">${p("Duración Máxima Caída (meses)")}</div>
              <div class="stat-value">${this.formatDecimal(i.maxDrawdownDuration5yInMonths.value, 0)}</div>
            </div>
          ` : ""}
        </div>

        <div class="section-title">${p("Ratio de Sharpe")}</div>

        <div class="stats-grid">
          ${i.sharpeRatio1y !== void 0 ? y`
            <div class="stat-item">
              <div class="stat-label">${p("Ratio de Sharpe (1 año)")}</div>
              <div class="stat-value ${this.getValueClass(i.sharpeRatio1y)}">${this.formatDecimal(i.sharpeRatio1y, 3)}</div>
            </div>
          ` : ""}

          ${i.sharpeRatio3y !== void 0 ? y`
            <div class="stat-item">
              <div class="stat-label">${p("Ratio de Sharpe (3 años)")}</div>
              <div class="stat-value ${this.getValueClass(i.sharpeRatio3y)}">${this.formatDecimal(i.sharpeRatio3y, 3)}</div>
            </div>
          ` : ""}

          ${i.sharpeRatio5y !== void 0 ? y`
            <div class="stat-item">
              <div class="stat-label">${p("Ratio de Sharpe (5 años)")}</div>
              <div class="stat-value ${this.getValueClass(i.sharpeRatio5y)}">${this.formatDecimal(i.sharpeRatio5y, 3)}</div>
            </div>
          ` : ""}
        </div>

        ${i.performanceAcc1yQuartile !== void 0 || i.performanceAcc3yQuartile !== void 0 || i.performanceAcc5yQuartile !== void 0 ? y`
          <div class="section-title">${p("Ranking de Rendimiento")}</div>

          <div class="stats-grid">
            ${i.performanceAcc1yQuartile !== void 0 ? y`
              <div class="stat-item">
                <div class="stat-label">${p("Cuartil (1 año)")}</div>
                <div class="stat-value">
                  ${i.performanceAcc1yQuartile}
                  <span class="quartile-indicator ${this.getQuartileIndicator(i.performanceAcc1yQuartile)}">
                    Q${Math.ceil(i.performanceAcc1yQuartile)}
                  </span>
                </div>
              </div>
            ` : ""}

            ${i.performanceAcc3yQuartile !== void 0 ? y`
              <div class="stat-item">
                <div class="stat-label">${p("Cuartil (3 años)")}</div>
                <div class="stat-value">
                  ${i.performanceAcc3yQuartile}
                  <span class="quartile-indicator ${this.getQuartileIndicator(i.performanceAcc3yQuartile)}">
                    Q${Math.ceil(i.performanceAcc3yQuartile)}
                  </span>
                </div>
              </div>
            ` : ""}

            ${i.performanceAcc5yQuartile !== void 0 ? y`
              <div class="stat-item">
                <div class="stat-label">${p("Cuartil (5 años)")}</div>
                <div class="stat-value">
                  ${i.performanceAcc5yQuartile}
                  <span class="quartile-indicator ${this.getQuartileIndicator(i.performanceAcc5yQuartile)}">
                    Q${Math.ceil(i.performanceAcc5yQuartile)}
                  </span>
                </div>
              </div>
            ` : ""}
          </div>
        ` : ""}
      </div>
    `;
  }
};
qi.styles = _t`
    ${Bt(Tt)}

    .info-container {
      width: 100%;
      display: block;
    }

    .stats-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 1rem;
      margin-top: 20px;
    }

    .section-title {
      font-size: var(--stock-section-title-font-size, 1.1rem);
      font-weight: var(--stock-title-weight, 700);
      color: var(--stock-title-color, #1e293b);
      margin: 25px 0 15px 0;
      border-bottom: 1px solid var(--stock-border-color, #e0e0e0);
      padding-bottom: 5px;
    }

    .section-title:first-of-type {
      margin-top: 15px;
    }

    .stat-item {
      background: var(--stock-detail-background, #f8fafc);
      border: 1px solid var(--stock-detail-border, rgba(226, 232, 240, 0.6));
      border-radius: 12px;
      padding: 16px;
      transition: box-shadow 0.2s ease;
    }

    .stat-item:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .stat-label {
      font-size: var(--stock-text-size, 14px);
      color: var(--stock-muted-color, #64748b);
      margin-bottom: 8px;
      font-weight: var(--stock-value-weight, 500);
    }

    .stat-value {
      font-size: var(--stock-value-size, 18px);
      font-weight: var(--stock-title-weight, 600);
      color: var(--stock-value-color, #334155);
    }

    .stat-value.positive {
      color: var(--stock-positive-color, #388e3c);
    }

    .stat-value.negative {
      color: var(--stock-negative-color, #d32f2f);
    }

    .quartile-indicator {
      font-size: var(--stock-small-text-size, 12px);
      padding: 2px 6px;
      border-radius: 10px;
      margin-left: 8px;
    }

    .quartile-1 {
      background-color: rgba(56, 142, 60, 0.1);
      color: var(--stock-positive-color, #388e3c);
    }

    .quartile-2 {
      background-color: rgba(245, 124, 0, 0.1);
      color: var(--stock-warning-color, #f57c00);
    }

    .quartile-3 {
      background-color: rgba(194, 24, 91, 0.1);
      color: var(--stock-negative-color, #d32f2f);
    }

    .quartile-4 {
      background-color: rgba(211, 47, 47, 0.1);
      color: var(--stock-negative-color, #d32f2f);
    }

    .risk-indicator {
      display: inline-block;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: var(--stock-small-text-size, 12px);
      font-weight: var(--stock-value-weight, 500);
      margin-left: 8px;
    }

    .risk-low {
      background-color: rgba(56, 142, 60, 0.1);
      color: var(--stock-positive-color, #388e3c);
    }

    .risk-medium {
      background-color: rgba(245, 124, 0, 0.1);
      color: var(--stock-warning-color, #f57c00);
    }

    .risk-high {
      background-color: rgba(211, 47, 47, 0.1);
      color: var(--stock-negative-color, #d32f2f);
    }

    .returns-period-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      gap: 0.8rem;
      margin-top: 15px;
    }

    .period-return {
      text-align: center;
      padding: 12px 8px;
      background: var(--stock-detail-background, #f8fafc);
      border: 1px solid var(--stock-detail-border, rgba(226, 232, 240, 0.6));
      border-radius: 6px;
    }

    .period-label {
      font-size: var(--stock-small-text-size, 12px);
      color: var(--stock-muted-color, #64748b);
      margin-bottom: 4px;
      font-weight: var(--stock-value-weight, 500);
    }

    .period-value {
      font-size: var(--stock-value-size, 16px);
      font-weight: var(--stock-title-weight, 600);
    }

    @media (max-width: 600px) {
      .stats-grid {
        grid-template-columns: 1fr;
      }

      .returns-period-grid {
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
      }
    }
  `;
Or([
  R()
], qi.prototype, "lastFetchedIsin", 2);
Or([
  R()
], qi.prototype, "fetchInProgress", 2);
qi = Or([
  Wt(),
  kt("fund-statistics")
], qi);
var Ib = Object.defineProperty, Eb = Object.getOwnPropertyDescriptor, Ar = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Eb(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Ib(t, e, s), s;
};
let Xi = class extends ai {
  constructor() {
    super(...arguments), this.lastFetchedIsin = null, this.fetchInProgress = !1;
  }
  fetchData() {
    return q(this, null, function* () {
      var i;
      if (this.isin && !(this.fetchInProgress || this.lastFetchedIsin === this.isin && this.fundData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const t = ct.API_BASE_URL, n = (this.locale || "es").startsWith("es") ? "es" : "en", s = `${t}/funds/product/${encodeURIComponent(this.isin)}/breakdown?language=${n}`, r = this.showHeader ? [
            fetch(s),
            fetch(`${t}/funds/product/${encodeURIComponent(this.isin)}`)
          ] : [fetch(s)], a = yield Promise.all(r);
          if (!a[0].ok)
            throw new Error(p(O`Error al obtener desglose del fondo: ${a[0].statusText}`, {
              desc: "Error message when breakdown API request fails"
            }));
          const o = yield a[0].json();
          if (this.showHeader && ((i = a[1]) != null && i.ok)) {
            const l = yield a[1].json();
            this.processData(ot(at({}, o), {
              name: l == null ? void 0 : l.name
            }));
          } else
            this.processData(o);
          this.lastFetchedIsin = this.isin;
        } catch (t) {
          this.error = t instanceof Error ? t.message : p("Error desconocido"), console.error(p("Error al obtener desglose del fondo:"), t);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  updated(i) {
    super.updated(i), i.has("isin") && this.isin !== this.lastFetchedIsin && this.fetchData();
  }
  processData(i) {
    this.fundData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando desglose del fondo...")}</div>`;
  }
  renderBreakdownSection(i, t, e) {
    if (!t || !t.breakdown || t.breakdown.length === 0)
      return y`
        <div class="breakdown-section">
          <div class="section-title">
            ${i}
          </div>
          <div class="no-data">${p("No hay datos disponibles")}</div>
        </div>
      `;
    const n = Math.max(...t.breakdown.map((r) => r.value)), s = [...t.breakdown].sort((r, a) => a.value - r.value);
    return y`
      <div class="breakdown-section">
        <div class="section-title">
          ${i}
          ${t.date ? y`<span class="section-date">${this.formatDate(t.date)}</span>` : ""}
        </div>
        <div class="chart-container">
          ${s.map((r) => e(r, n))}
        </div>
      </div>
    `;
  }
  renderStandardBreakdownItem(i, t) {
    const e = t > 0 ? i.value / t * 100 : 0;
    return y`
      <div class="breakdown-item">
        <div class="breakdown-name">${i.name}</div>
        <div class="breakdown-value">${this.formatPercentage(i.value)}</div>
        <div class="breakdown-bar">
          <div class="breakdown-progress" style="width: ${e}%"></div>
        </div>
      </div>
    `;
  }
  renderCountryBreakdownItem(i, t) {
    const e = t > 0 ? i.value / t * 100 : 0;
    return y`
      <div class="breakdown-item">
        <div class="breakdown-name">${i.name} (${i.code})</div>
        <div class="breakdown-value">${this.formatPercentage(i.value)}</div>
        <div class="breakdown-bar">
          <div class="breakdown-progress" style="width: ${e}%"></div>
        </div>
      </div>
    `;
  }
  renderTop10Item(i) {
    return y`
      <div class="holding-item">
        <div class="holding-info">
          <div class="holding-name">${i.name}</div>
          ${i.code ? y`<div class="holding-code">${i.code}</div>` : ""}
        </div>
        <div class="holding-value">${this.formatPercentage(i.value)}</div>
      </div>
    `;
  }
  renderContent() {
    if (!this.fundData)
      return null;
    const i = this.fundData;
    return y`
      <div class="info-container">
        ${this.renderHeader()}

        <div class="breakdown-grid">
          ${i.assetBreakdown ? this.renderBreakdownSection(
      p("Desglose por Tipo de Activo"),
      i.assetBreakdown,
      (t, e) => this.renderStandardBreakdownItem(t, e)
    ) : ""}

          ${i.sectorBreakdown ? this.renderBreakdownSection(
      p("Desglose por Sector"),
      i.sectorBreakdown,
      (t, e) => this.renderStandardBreakdownItem(t, e)
    ) : ""}

          ${i.countryBreakdown ? this.renderBreakdownSection(
      p("Desglose por País"),
      i.countryBreakdown,
      (t, e) => this.renderCountryBreakdownItem(t, e)
    ) : ""}

          ${i.regionBreakdown ? this.renderBreakdownSection(
      p("Desglose por Región"),
      i.regionBreakdown,
      (t, e) => this.renderCountryBreakdownItem(t, e)
    ) : ""}

          ${i.currencyBreakdown ? this.renderBreakdownSection(
      p("Desglose por Moneda"),
      i.currencyBreakdown,
      (t, e) => this.renderCountryBreakdownItem(t, e)
    ) : ""}

          ${i.creditRatingBreakdown ? this.renderBreakdownSection(
      p("Desglose por Calificación Crediticia"),
      i.creditRatingBreakdown,
      (t, e) => this.renderStandardBreakdownItem(t, e)
    ) : ""}
        </div>

        ${i.top10 && i.top10.breakdown && i.top10.breakdown.length > 0 ? y`
          <div class="top-holdings">
            <div class="section-title">
              ${p("Top 10 Posiciones")}
              ${i.top10.date ? y`<span class="section-date">${this.formatDate(i.top10.date)}</span>` : ""}
            </div>
            <div class="breakdown-section">
              ${[...i.top10.breakdown].sort((t, e) => e.value - t.value).map((t) => this.renderTop10Item(t))}
            </div>
          </div>
        ` : ""}
      </div>
    `;
  }
};
Xi.styles = _t`
    ${Bt(Tt)}

    .info-container {
      width: 100%;
      display: block;
    }

    .section-title {
      font-size: var(--stock-section-title-font-size, 1.1rem);
      font-weight: var(--stock-title-weight, 700);
      color: var(--stock-title-color, #1e293b);
      margin: 25px 0 15px 0;
      border-bottom: 1px solid var(--stock-border-color, #e0e0e0);
      padding-bottom: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .section-title:first-of-type {
      margin-top: 15px;
    }

    .section-date {
      font-size: var(--stock-small-text-size, 12px);
      color: var(--stock-muted-color, #64748b);
      font-weight: normal;
    }

    .breakdown-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
      gap: 20px;
      margin-top: 20px;
    }

    .breakdown-section {
      background: var(--stock-detail-background, #f8fafc);
      border: 1px solid var(--stock-detail-border, rgba(226, 232, 240, 0.6));
      border-radius: 12px;
      padding: 20px;
      transition: box-shadow 0.2s ease;
    }

    .breakdown-section:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .breakdown-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      border-bottom: 1px solid var(--stock-divider-color, rgba(226, 232, 240, 0.8));
    }

    .breakdown-item:last-child {
      border-bottom: none;
    }

    .breakdown-name {
      font-size: var(--stock-text-size, 14px);
      color: var(--stock-value-color, #334155);
      flex: 1;
      margin-right: 16px;
    }

    .breakdown-value {
      font-size: var(--stock-text-size, 14px);
      font-weight: var(--stock-value-weight, 600);
      color: var(--stock-value-color, #334155);
      min-width: 60px;
      text-align: right;
    }

    .breakdown-bar {
      width: 100%;
      height: 4px;
      background-color: var(--stock-border-color, #e0e0e0);
      border-radius: 2px;
      margin-top: 4px;
      overflow: hidden;
    }

    .breakdown-progress {
      height: 100%;
      background: linear-gradient(45deg, var(--stock-accent-color, #3b82f6), var(--stock-positive-color, #388e3c));
      border-radius: 2px;
      transition: width 0.3s ease;
    }

    .top-holdings {
      grid-column: 1 / -1;
    }

    .top-holdings .breakdown-grid {
      grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    }

    .holding-item {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 12px 0;
      border-bottom: 1px solid var(--stock-divider-color, rgba(226, 232, 240, 0.8));
    }

    .holding-item:last-child {
      border-bottom: none;
    }

    .holding-info {
      flex: 1;
      margin-right: 16px;
    }

    .holding-name {
      font-size: var(--stock-text-size, 14px);
      color: var(--stock-value-color, #334155);
      font-weight: var(--stock-value-weight, 500);
      line-height: 1.3;
    }

    .holding-code {
      font-size: 12px;
      color: var(--text-secondary-color, #666);
      margin-top: 2px;
    }

    .holding-value {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-primary-color, #333);
      min-width: 70px;
      text-align: right;
    }

    .no-data {
      text-align: center;
      color: var(--text-secondary-color, #666);
      font-style: italic;
      padding: 20px;
    }

    .chart-container {
      margin-top: 15px;
      max-height: 300px;
      overflow-y: auto;
    }

    @media (max-width: 600px) {
      .breakdown-grid {
        grid-template-columns: 1fr;
      }

      .top-holdings .breakdown-grid {
        grid-template-columns: 1fr;
      }
    }
  `;
Ar([
  R()
], Xi.prototype, "lastFetchedIsin", 2);
Ar([
  R()
], Xi.prototype, "fetchInProgress", 2);
Xi = Ar([
  Wt(),
  kt("fund-breakdown")
], Xi);
var Rb = Object.defineProperty, Fb = Object.getOwnPropertyDescriptor, rn = (i, t, e, n) => {
  for (var s = n > 1 ? void 0 : n ? Fb(t, e) : t, r = i.length - 1, a; r >= 0; r--)
    (a = i[r]) && (s = (n ? a(t, e, s) : a(s)) || s);
  return n && s && Rb(t, e, s), s;
};
let Ve = class extends ce {
  constructor() {
    super(...arguments), this.isin = "", this.locale = "", this.lastFetchedIsin = null, this.fetchInProgress = !1;
  }
  /**
   * Datos del fondo (alias para mantener compatibilidad)
   */
  get fundData() {
    return this.data;
  }
  set fundData(i) {
    this.data = i;
  }
  /**
   * Verifica si se debe obtener los datos
   */
  shouldFetchData() {
    return !!this.isin;
  }
  /**
   * Verifica si una propiedad clave ha cambiado
   */
  hasKeyPropertyChanged(i) {
    return i.has("isin") && !!this.isin;
  }
  /**
   * Este componente no usa header
   */
  renderHeader() {
    return y``;
  }
  fetchData() {
    return q(this, null, function* () {
      if (this.isin && !(this.fetchInProgress || this.lastFetchedIsin === this.isin && this.fundData)) {
        this.loading = !0, this.error = null, this.fetchInProgress = !0;
        try {
          const i = ct.API_BASE_URL, t = yield fetch(`${i}/funds/product/${encodeURIComponent(this.isin)}`);
          if (!t.ok)
            throw new Error(p(O`Error al obtener datos del fondo: ${t.statusText}`, {
              desc: "Error message when fund API request fails",
              id: "fund-quote-card.api-error"
            }));
          const e = yield t.json();
          this.processData(e), this.lastFetchedIsin = this.isin;
        } catch (i) {
          this.error = i instanceof Error ? i.message : p("Error desconocido"), console.error(p("Error al obtener datos del fondo:"), i);
        } finally {
          this.loading = !1, this.fetchInProgress = !1;
        }
      }
    });
  }
  // Sobrescribir el método updated para controlar cuando se debe volver a cargar
  updated(i) {
    super.updated(i), i.has("isin") && this.isin !== this.lastFetchedIsin && this.fetchData();
  }
  processData(i) {
    this.fundData = i;
  }
  renderLoading() {
    return y`<div class="loading">${p("Cargando información del fondo...")}</div>`;
  }
  getNoDataMessage() {
    return p("No hay datos del fondo disponibles. Por favor, proporcione un ISIN válido.");
  }
  formatNumber(i, t = {}) {
    return new Intl.NumberFormat(this.locale || void 0, t).format(i);
  }
  formatPercentage(i) {
    return new Intl.NumberFormat(this.locale || void 0, {
      style: "percent",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(i / 100);
  }
  renderContent() {
    if (!this.fundData)
      return null;
    const { isin: i, name: t, currency: e, nav: n } = this.fundData;
    return y`
      <div class="fund-card">
        <div class="name-container">
          <h3 class="fund-name">${t}</h3>
          <p class="fund-isin">${p("ISIN:")} ${i}</p>
        </div>

        <div class="nav-container">
          <p class="fund-nav">
            ${n != null && n.value ? this.formatNumber(n.value, { minimumFractionDigits: 2, maximumFractionDigits: 4 }) : p("N/A")}
            ${e}
          </p>
          ${n != null && n.date ? y`
            <p class="fund-nav-date">
              ${this.formatDate(n.date)}
            </p>
          ` : ""}
        </div>
      </div>
    `;
  }
};
Ve.styles = _t`
    :host {
      display: block;
      font-family: var(--fund-font-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif);
      --fund-card-bg: rgba(248, 250, 252, 0.6);
      --fund-name-color: var(--fund-title-color, #1e293b);
      --fund-isin-color: var(--fund-muted-color, #64748b);
      --fund-isin-bg: var(--fund-symbol-bg, rgba(226, 232, 240, 0.7));
      --fund-nav-color: var(--fund-text-color, #0f172a);
      --fund-positive-color: var(--fund-positive-color, #16a34a);
      --fund-positive-bg: rgba(22, 163, 74, 0.1);
      --fund-negative-color: var(--fund-negative-color, #dc2626);
      --fund-negative-bg: rgba(220, 38, 38, 0.1);
      --fund-date-color: var(--fund-muted-color, #94a3b8);
      background: none;
      padding: 0;
      margin: 0;
      box-sizing: border-box;
    }

    .fund-card {
      display: grid;
      grid-template-columns: 1fr auto;
      grid-template-areas:
        "name nav";
      gap: 12px;
      align-items: center;
      padding: 0.75rem;
      background-color: var(--fund-card-bg);
      border-radius: 12px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
      transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
      margin: 0;
      overflow: hidden;
      width: 80%;
      border: none;
      box-sizing: border-box;
    }

    .fund-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    }

    .name-container {
      grid-area: name;
      padding-right: 8px;
    }

    .fund-name {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: var(--fund-name-color);
      line-height: 1.2;
    }

    .fund-isin {
      margin: 2px 0 0;
      display: inline-block;
      font-size: 0.85rem;
      font-weight: 500;
      color: var(--fund-isin-color);
      background-color: var(--fund-isin-bg);
      padding: 2px 8px;
      border-radius: 4px;
    }

    .nav-container {
      grid-area: nav;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .fund-nav {
      margin: 0;
      font-size: 1.2rem;
      font-weight: 700;
      color: var(--fund-nav-color);
    }

    .fund-change {
      margin-top: 4px;
      font-size: 0.85rem;
      font-weight: 600;
      padding: 2px 8px;
      border-radius: 4px;
      display: inline-block;
    }

    .fund-change.positive {
      color: var(--fund-positive-color);
      background-color: var(--fund-positive-bg);
    }

    .fund-change.negative {
      color: var(--fund-negative-color);
      background-color: var(--fund-negative-bg);
    }

    .fund-nav-date {
      margin: 4px 0 0;
      font-size: 0.75rem;
      color: var(--fund-date-color);
      text-align: right;
      font-style: italic;
    }

    @media (max-width: 600px) {
      .fund-card {
        grid-template-columns: 1fr;
        grid-template-areas:
          "name"
          "nav";
        text-align: center;
      }

      .name-container {
        text-align: center;
        padding-right: 0;
      }

      .nav-container {
        margin-top: 8px;
        align-items: center;
        text-align: center;
      }

      .fund-nav-date {
        text-align: center;
      }
    }
  `;
rn([
  dt({ type: String })
], Ve.prototype, "isin", 2);
rn([
  dt({ type: String })
], Ve.prototype, "locale", 2);
rn([
  R()
], Ve.prototype, "lastFetchedIsin", 2);
rn([
  R()
], Ve.prototype, "fetchInProgress", 2);
Ve = rn([
  Wt(),
  kt("fund-quote-card")
], Ve);
export {
  gb as ChartFactory,
  mb as DataAggregator,
  Ge as FormatUtils,
  Xi as FundBreakdown,
  Db as FundDataService,
  Yi as FundDescription,
  Jt as FundPriceChart,
  Ve as FundQuoteCard,
  qi as FundStatistics,
  Ri as StockCashflowRatios,
  pb as StockDataService,
  Ii as StockDebtRatios,
  Ai as StockDescription,
  je as StockDividendChart,
  Zt as StockDividendTable,
  Li as StockFAQ,
  Rn as StockInfo,
  Ei as StockLiquidityRatios,
  Fi as StockMetricsPerShare,
  Ct as StockPriceVolumeChart,
  Fn as StockProfitabilityMargins,
  ze as StockQuoteCard,
  Ln as StockRatiosPeriod
};
